/* eslint-disable */
import Long from "long";
import _m0 from "protobufjs/minimal";
import { TransPb } from "../../gen/body/trans";
import { VehicleFault_Enum, vehicleFault_EnumFromJSON, vehicleFault_EnumToJSON } from "../../gen/common/fault";
import {
  FlightPhaseEnum_Enum,
  flightPhaseEnum_EnumFromJSON,
  flightPhaseEnum_EnumToJSON,
} from "../../gen/common/flight_phase_enum";
import { AwbMode_Enum, awbMode_EnumFromJSON, awbMode_EnumToJSON } from "../../gen/user_camera/awb_mode";
import {
  CompensationMode_Enum,
  compensationMode_EnumFromJSON,
  compensationMode_EnumToJSON,
} from "../../gen/user_camera/compensation_mode";
import {
  ExposureMode_Enum,
  exposureMode_EnumFromJSON,
  exposureMode_EnumToJSON,
} from "../../gen/user_camera/exposure_mode";
import { IsoMode_Enum, isoMode_EnumFromJSON, isoMode_EnumToJSON } from "../../gen/user_camera/iso_mode";
import {
  RecordingMode_Enum,
  recordingMode_EnumFromJSON,
  recordingMode_EnumToJSON,
} from "../../gen/user_camera/recording_mode";
import { Uuid } from "../../gen/uuid_util/uuid";
import {
  NavigationMode_Mode,
  navigationMode_ModeFromJSON,
  navigationMode_ModeToJSON,
} from "../infrastructure/flight_deck/navigation_mode";
import { ReturnSettings } from "../infrastructure/flight_deck/return_settings";
import { PoseIdPb } from "../nav_cam_reconstruction/pose_id";
import {
  AcquireGpsActionArgs,
  AcquireGpsActionStateData,
  AcquireGpsResultData,
} from "./actions/acquire_gps/acquire_gps";
import {
  ApriltagSetIdActionArgs,
  ApriltagSetIdActionStateData,
  ApriltagSetIdResultData,
} from "./actions/apriltag_set_id/apriltag_set_id";
import {
  ConditionalActionArgs,
  SubjectDetectedActionStateData,
  SubjectDetectedResultData,
} from "./actions/conditional/conditional";
import {
  AtvSubjectSpoofActionArgs,
  AtvSubjectSpoofActionStateData,
  AtvSubjectSpoofResultData,
  PrecomputedSubjectSpoofActionArgs,
  PrecomputedSubjectSpoofActionStateData,
  PrecomputedSubjectSpoofResultData,
  SetGimbalOrientationActionStateData,
  SetGimbalOrientationArgs,
  SetGimbalOrientationResultData,
  SkiSubjectSpoofActionArgs,
  SkiSubjectSpoofActionStateData,
  SkiSubjectSpoofResultData,
  TestDesiredVelocityActionArgs,
  TestDesiredVelocityActionStateData,
  TestDesiredVelocityResultData,
  TestTrackTrajectoryActionArgs,
  TestTrackTrajectoryActionStateData,
  TestTrackTrajectoryResultData,
} from "./actions/controls_test/controls_test";
import {
  DancingDroneActionArgs,
  DancingDroneActionStateData,
  DancingDroneResultData,
  DancingDroneSplineActionArgs,
  DancingDroneSplineActionStateData,
  DancingDroneSplineResultData,
  WaitForPreciseFaultActionArgs,
  WaitForPreciseFaultActionStateData,
  WaitForPreciseFaultResultData,
} from "./actions/dancing_drone/dancing_drone";
import {
  DockGpsEstimatorActionArgs,
  DockGpsEstimatorActionStateData,
  DockGpsEstimatorResultData,
} from "./actions/dock_gps_estimator/dock_gps_estimator";
import { DummyActionArgs, DummyActionStateData, DummyResultData } from "./actions/dummy_action/dummy_action";
import { ELandActionArgs, ELandActionStateData, ELandResultData } from "./actions/e_land/e_land";
import {
  G47CommandOverrideActionArgs,
  G47CommandOverrideActionStateData,
  G47CommandOverrideResultData,
} from "./actions/g47_command_override/g47_command_override";
import {
  GeofenceConfigActionArgs,
  GeofenceConfigActionStateData,
  GeofenceConfigResultData,
} from "./actions/geofence_config/geofence_config";
import {
  GlobalGraphControlActionArgs,
  GlobalGraphControlActionStateData,
  GlobalGraphControlResultData,
} from "./actions/global_graph_control/global_graph_control";
import {
  GlobalPlannerRequestActionArgs,
  GlobalPlannerRequestActionResultData,
  GlobalPlannerRequestActionStateData,
} from "./actions/global_planner_request/global_planner_request";
import {
  GotoGpsWaypointActionArgs,
  GotoGpsWaypointActionStateData,
  GotoGpsWaypointResultData,
  GotoNavWaypointActionArgs,
  GotoNavWaypointActionStateData,
  GotoNavWaypointResultData,
  GotoWaypointActionArgs,
  GotoWaypointActionStateData,
  GotoWaypointResultData,
} from "./actions/goto_waypoint/goto_waypoint";
import {
  InitGlobalMapActionArgs,
  InitGlobalMapActionStateData,
  InitGlobalMapResultData,
} from "./actions/init_global_map/init_global_map";
import {
  InitializeGpsActionArgs,
  InitializeGpsActionStateData,
  InitializeGpsResultData,
} from "./actions/initialize_gps/initialize_gps";
import { InverterActionStateData, InverterResultData } from "./actions/inverter/inverter";
import {
  ControlNodeTypeEnum_Enum,
  controlNodeTypeEnum_EnumFromJSON,
  controlNodeTypeEnum_EnumToJSON,
  LooperActionStateData,
  LooperResultData,
} from "./actions/looper/looper";
import {
  MissionPlannerServiceControlActionArgs,
  MissionPlannerServiceControlActionStateData,
  MissionPlannerServiceControlResultData,
} from "./actions/mission_planner_service_control/mission_planner_service_control";
import {
  ModifySimStateEstimationActionArgs,
  ModifySimStateEstimationActionStateData,
  ModifySimStateEstimationResultData,
} from "./actions/modify_sim_state_estimation/modify_sim_state_estimation";
import {
  NcpgControlActionArgs,
  NcpgControlActionStateData,
  NcpgControlResultData,
} from "./actions/ncpg_control/ncpg_control";
import {
  NightsenseActionArgs,
  NightsenseActionResultData,
  NightsenseActionStateData,
} from "./actions/nightsense_action/nightsense_action";
import {
  GotoAndOrbitPoiActionArgs,
  GotoAndOrbitPoiResultData,
  OrbitPoiActionArgs,
  OrbitPoiActionStateData,
  OrbitPoiResultData,
} from "./actions/orbit_poi/orbit_poi";
import {
  OverrideGpsQualityActionArgs,
  OverrideGpsQualityActionStateData,
  OverrideGpsQualityResultData,
} from "./actions/override_gps_quality/override_gps_quality";
import {
  ParachuteControlActionArgs,
  ParachuteControlActionStateData,
  ParachuteControlResultData,
} from "./actions/parachute_control/parachute_control";
import { ParallelActionStateData, ParallelResultData } from "./actions/parallel/parallel";
import { PlayAudioActionArgs, PlayAudioActionStateData, PlayAudioResultData } from "./actions/play_audio/play_audio";
import {
  RegisterComplimentaryActionsActionArgs,
  RegisterComplimentaryActionsActionStateData,
  RegisterComplimentaryActionsResultData,
} from "./actions/register_complimentary_actions/register_complimentary_actions";
import {
  RequestTakeoffProfileActionArgs,
  RequestTakeoffProfileActionStateData,
  RequestTakeoffProfileResultData,
} from "./actions/request_takeoff_profile/request_takeoff_profile";
import {
  ScoutActionActionArgs,
  ScoutActionActionStateData,
  ScoutActionResultData,
} from "./actions/scout_action/scout_action";
import {
  SendDynamicScenarioActionArgs,
  SendDynamicScenarioActionStateData,
  SendDynamicScenarioResultData,
} from "./actions/send_dynamic_scenario/send_dynamic_scenario";
import {
  SendMotionCommandActionArgs,
  SendMotionCommandActionStateData,
  SendMotionCommandResultData,
} from "./actions/send_motion_command/send_motion_command";
import {
  SequenceConfigResultData,
  SequencePretakeoffResultData,
  SequenceResultData,
  SequenceUntilFailureResultData,
  SequenceUntilSuccessResultData,
} from "./actions/sequence/sequence";
import {
  SetCameraSettingsActionArgs,
  SetCameraSettingsActionStateData,
  SetCameraSettingsResultData,
} from "./actions/set_camera_settings/set_camera_settings";
import {
  SetDesiredGpsSourceActionArgs,
  SetDesiredGpsSourceActionStateData,
  SetDesiredGpsSourceResultData,
} from "./actions/set_desired_gps_source/set_desired_gps_source";
import {
  SetDesiredImuSourceActionArgs,
  SetDesiredImuSourceActionStateData,
  SetDesiredImuSourceResultData,
} from "./actions/set_desired_imu_source/set_desired_imu_source";
import {
  SetFaultOverrideActionArgs,
  SetFaultOverrideActionStateData,
  SetFaultOverrideResultData,
} from "./actions/set_fault_override/set_fault_override";
import {
  SetGnssSolverQualityActionArgs,
  SetGnssSolverQualityActionStateData,
  SetGnssSolverQualityResultData,
} from "./actions/set_gnss_solver_quality/set_gnss_solver_quality";
import {
  SetMovementCommandActionArgs,
  SetMovementCommandActionStateData,
  SetMovementCommandResultData,
} from "./actions/set_movement_command/set_movement_command";
import {
  SetObstacleAvoidanceActionArgs,
  SetObstacleAvoidanceActionStateData,
  SetObstacleAvoidanceResultData,
} from "./actions/set_obstacle_avoidance/set_obstacle_avoidance";
import {
  SetSubjectFollowerSettingsActionArgs,
  SetSubjectFollowerSettingsActionStateData,
  SetSubjectFollowerSettingsResultData,
} from "./actions/set_subject_follower_settings/set_subject_follower_settings";
import { SetZoomActionArgs, SetZoomActionStateData, SetZoomResultData } from "./actions/set_zoom/set_zoom";
import {
  SpoofBatteryLevelActionArgs,
  SpoofBatteryLevelActionStateData,
  SpoofBatteryLevelResultData,
} from "./actions/spoof_battery_level/spoof_battery_level";
import {
  SpoofDisturbanceActionActionArgs,
  SpoofDisturbanceActionStateData,
  SpoofDisturbanceResultData,
} from "./actions/spoof_disturbance_action/spoof_disturbance_action";
import {
  SpoofFlightEnvelopeLimitsActionArgs,
  SpoofFlightEnvelopeLimitsActionStateData,
  SpoofFlightEnvelopeLimitsResultData,
} from "./actions/spoof_flight_envelope_limits/spoof_flight_envelope_limits";
import {
  SpoofInitialGpsHeadingActionArgs,
  SpoofInitialGpsHeadingActionStateData,
  SpoofInitialGpsHeadingResultData,
} from "./actions/spoof_initial_gps_heading/spoof_initial_gps_heading";
import {
  SpoofJoysticksInputsActionArgs,
  SpoofJoysticksInputsActionStateData,
  SpoofJoysticksInputsResultData,
} from "./actions/spoof_joysticks_inputs/spoof_joysticks_inputs";
import {
  SpoofManualGpsActionArgs,
  SpoofManualGpsActionStateData,
  SpoofManualGpsResultData,
} from "./actions/spoof_manual_gps/spoof_manual_gps";
import {
  SpoofMultiDroneActionArgs,
  SpoofMultiDroneActionStateData,
  SpoofMultiDroneResultData,
} from "./actions/spoof_multi_drone/spoof_multi_drone";
import {
  SpoofObstacleActionArgs,
  SpoofObstacleActionStateData,
  SpoofObstacleResultData,
} from "./actions/spoof_obstacle/spoof_obstacle";
import {
  SpoofPhoneUiVariablesActionArgs,
  SpoofPhoneUiVariablesActionStateData,
  SpoofPhoneUiVariablesResultData,
} from "./actions/spoof_phone_ui_variables/spoof_phone_ui_variables";
import {
  SpoofSubjectScenarioActionArgs,
  SpoofSubjectScenarioActionStateData,
  SpoofSubjectScenarioResultData,
} from "./actions/spoof_subject_scenario/spoof_subject_scenario";
import {
  SpoofTrackingDeviceActionArgs,
  SpoofTrackingDeviceActionStateData,
  SpoofTrackingDeviceResultData,
} from "./actions/spoof_tracking_device/spoof_tracking_device";
import {
  SpotlightActionArgs,
  SpotlightActionResultData,
  SpotlightActionStateData,
} from "./actions/spotlight_action/spotlight_action";
import {
  StartVideoActionArgs,
  StartVideoActionStateData,
  StartVideoResultData,
} from "./actions/start_video/start_video";
import {
  StopForPhotoInspectActionArgs,
  StopForPhotoInspectActionStateData,
  StopForPhotoInspectResultData,
} from "./actions/stop_for_photo_inspect/stop_for_photo_inspect";
import { StopVideoActionArgs, StopVideoActionStateData, StopVideoResultData } from "./actions/stop_video/stop_video";
import {
  SwitchRecordingModeActionArgs,
  SwitchRecordingModeActionStateData,
  SwitchRecordingModeResultData,
} from "./actions/switch_recording_mode/switch_recording_mode";
import {
  TakePanoramaActionArgs,
  TakePanoramaActionStateData,
  TakePanoramaResultData,
} from "./actions/take_panorama/take_panorama";
import { TakePhotoActionArgs, TakePhotoActionStateData, TakePhotoResultData } from "./actions/take_photo/take_photo";
import { TimedWaitActionArgs, TimedWaitActionStateData, TimedWaitResultData } from "./actions/timed_wait/timed_wait";
import {
  TogglePhotoIntervalModeActionArgs,
  TogglePhotoIntervalModeActionStateData,
  TogglePhotoIntervalModeResultData,
} from "./actions/toggle_photo_interval_mode/toggle_photo_interval_mode";
import {
  ToggleSemanticAimActionArgs,
  ToggleSemanticAimActionStateData,
  ToggleSemanticAimResultData,
} from "./actions/toggle_semantic_aim/toggle_semantic_aim";
import {
  ToggleSubjectDetectionActionArgs,
  ToggleSubjectDetectionActionStateData,
  ToggleSubjectDetectionResultData,
} from "./actions/toggle_subject_detection/toggle_subject_detection";
import {
  ToggleTargetPointExposureActionArgs,
  ToggleTargetPointExposureActionStateData,
  ToggleTargetPointExposureResultData,
} from "./actions/toggle_target_point_exposure/toggle_target_point_exposure";
import {
  TrackInPlaceActionArgs,
  TrackInPlaceActionStateData,
  TrackInPlaceResultData,
} from "./actions/track_in_place/track_in_place";
import {
  TrackLandingPadRequestActionArgs,
  TrackLandingPadRequestActionStateData,
  TrackLandingPadRequestResultData,
} from "./actions/track_landing_pad_request/track_landing_pad_request";
import {
  TrajectoryInspectActionArgs,
  TrajectoryInspectActionStateData,
  TrajectoryInspectResultData,
} from "./actions/trajectory_inspect/trajectory_inspect";
import { TurntableActionArgs, TurntableActionStateData, TurntableResultData } from "./actions/turntable/turntable";
import {
  UnifiedFollowActionArgs,
  UnifiedFollowActionStateData,
  UnifiedFollowResultData,
} from "./actions/unified_follow/unified_follow";
import {
  UpdateDockLocationActionArgs,
  UpdateDockLocationActionResultData,
  UpdateDockLocationActionStateData,
} from "./actions/update_dock_location/update_dock_location";
import {
  UpdateJoysticksSettingsActionArgs,
  UpdateJoysticksSettingsActionStateData,
  UpdateJoysticksSettingsResultData,
} from "./actions/update_joysticks_settings/update_joysticks_settings";
import {
  UpdateShapeMapActionArgs,
  UpdateShapeMapActionStateData,
  UpdateShapeMapResultData,
} from "./actions/update_shape_map/update_shape_map";
import {
  UpdateVehicleSettingsActionArgs,
  UpdateVehicleSettingsActionStateData,
  UpdateVehicleSettingsResultData,
} from "./actions/update_vehicle_settings/update_vehicle_settings";
import {
  WaitForRtkActionArgs,
  WaitForRtkActionStateData,
  WaitForRtkResultData,
} from "./actions/wait_for_rtk/wait_for_rtk";
import {
  WaitForVehicleStopActionArgs,
  WaitForVehicleStopActionStateData,
  WaitForVehicleStopResultData,
} from "./actions/wait_for_vehicle_stop/wait_for_vehicle_stop";
import {
  WeatherActionArgs,
  WeatherActionResultData,
  WeatherActionStateData,
} from "./actions/weather_action/weather_action";
import { WifiScanActionArgs, WifiScanActionStateData, WifiScanResultData } from "./actions/wifi_scan/wifi_scan";
import {
  WingWaypointsCommandActionArgs,
  WingWaypointsCommandActionStateData,
  WingWaypointsCommandResultData,
} from "./actions/wing_waypoints_command/wing_waypoints_command";
import {
  WithinDistanceActionArgs,
  WithinDistanceActionStateData,
  WithinDistanceResultData,
} from "./actions/within_distance/within_distance";
import { KeyframeActionArgs, KeyframeActionStateData, KeyframeResultData } from "./builtin_skills/keyframe/keyframe";
import {
  SurfaceScanActionArgs,
  SurfaceScanActionStateData,
  SurfaceScanResultData,
} from "./builtin_skills/surface_scan/surface_scan";
import { FreeLookMode_Enum, freeLookMode_EnumFromJSON, freeLookMode_EnumToJSON, Waypoint } from "./waypoints";

export const protobufPackage = "skills";

/**
 * The Missions API implements a method by which clients can send a list of autonomous
 * actions for the vehicle to execute.
 *
 * A "Mission" is the specification for a list of "Actions" that the vehicle should execute.
 *
 * - A client can send a Mission over the MISSION_REQUEST_PB channel.
 * - A response to the request will be send back over
 *
 * - While running, updates to the Mission can be made via the MISSION_UPDATE_PB channel,
 * with a MissionUpdate message type.
 * - A response to the request will be send back over MISSION_UPDATE_RESPONSE_PB
 *
 * - The mission can be started and stopped via the MISSION_CONTROL_PB channel with a
 * MissionControl message type. The client can also request the current running mission over
 * this channel
 *
 * - After a mission finishes, it publishes via the MISSION_RESULT_PB channel with a
 * MissionResult message.
 *
 * An "Action" is a single logical unit of work that the vehicle can complete.
 * Specifically, an "Action" is a Skill that implements the MissionAction interface.
 *
 * The action can define three specific types:
 *
 * ActionArgs - Typed arguments passed into the action to initialize it. Interfaces can
 * parse the elements of an ActionArgs type to generate general interface
 * implementations.
 * ActionState - A response type from the currently running Action to give the client
 * enough data and context to visualize its current state.
 * ActionResult - A response type from the Mission that is sent once, at the end of a
 * Mission, containing data about the execution of that Action.
 */

/**
 * Sent from Client->Vehicle at runtime on MISSION_REQUEST_PB channel,
 * This is sent once whenever the Mobile App wants to initiate a new mission @exclude
 */
export interface Mission {
  /**
   * Unix timestamp of when the mission was created. This is used to determine the age of the
   * mission, but isn't necessary for the customer to specify.
   */
  utime: number;
  /**
   * Set by the Client to uniquely identify this Mission request
   * in post-flight logs, in cloud databases, for linking media, etc.
   * Must follow UUID4 protocol and sent in lower-case HEX format
   * so we can do string-comparisons e.g. "d1665ee05bb9431cad6d6188478e553e"
   */
  uuid: string;
  /** Name of the mission */
  displayName: string;
  /**
   * UUID of the Template that generated this mission. May be empty if the mission was not generated
   * from a template.
   */
  templateUuid: string;
  /**
   * List of actions to be executed. The top-level action must be a single-element array with a
   * sequence action named 'root_sequence'.
   */
  actions: Action[];
  /** Action to perform after the mission completes. */
  postMissionAction: PostMissionActionEnum_Enum;
  /** Action to take if mission fails. */
  postFailureAction: PostMissionActionEnum_Enum;
  /** Desired lost connection action */
  lostConnectionAction: LostConnectionActionEnum_Enum;
  /** If the mission is launched by a schedule, the scheduler will fill this out */
  scheduledMissionUuid: string;
  /**
   * The mission skill to use to execute the mission. Default will use MissionRunner.
   * 3DS (surface_scan) is the only other option right now, but there could be more.
   */
  missionRunnerSkill: MissionSkillEnum_Enum;
  /** Flight ID under which the mission was generated. */
  flightId: string;
  /** FlightDataFile where the Navcam Pose Graph is stored. */
  ncpgFileId: string;
  /** UUID of the global graph in lower-case HEX format without hyphens */
  globalGraphFileId: string;
  /** This is a dock mission. */
  dockMission: boolean;
  /** The Mission will automatically start after launch. */
  autoStart: boolean;
  /**
   * WARNING: This behavior is deprecated. Waypoint actions will auto initialize
   * True if the vehicle should perform a GPS initialization move before executing the mission.
   * If the GPS acquisition fails, the mission will abort.
   */
  needsGpsInitializationMove: boolean;
  /** WARNING: This field is deprecated and was never actually used. */
  returnToPathOnResume: boolean;
  /**
   * If true, mission runner will display ui to skip to other actions in the mission. Note
   * that some actions are not skippable
   */
  showSkipUi: boolean;
  /** TODO(Jose): Block mission start if vehicle position is not near expected_gps_origin @exclude */
  expectedGpsOrigin:
    | GpsOriginInfo
    | undefined;
  /**
   * If true, switch to the specified recording mode upon starting the mission.
   * NOTE(jose): This field is deprecated and will be removed. Use action specific camera settings
   */
  useRecordingMode: boolean;
  recordingMode: RecordingMode_Enum;
  /** NOTE(jose): This field is deprecated and will be removed. Use action specific camera settings */
  useIsoMode: boolean;
  isoMode: IsoMode_Enum;
  /** NOTE(jose): This field is deprecated and will be removed. Use action specific camera settings */
  useExposureMode: boolean;
  exposureMode: ExposureMode_Enum;
  /** NOTE(jose): This field is deprecated and will be removed. Use action specific camera settings */
  useAwbMode: boolean;
  awbMode: AwbMode_Enum;
  /** NOTE(jose): This field is deprecated and will be removed. Use action specific camera settings */
  useCompensationMode: boolean;
  compensationMode: CompensationMode_Enum;
  /**
   * Autonomous abort the mission when an action fails. Autonomous abort still runs the post mission
   * action
   */
  autonomousAbortMissionOnFailedAction: boolean;
  /** If true, perform a direct return to dock rather than backtracking for any fault based rtd */
  enableFaultBasedDirectRtd: boolean;
  /** True if the mission needs NCPG initialization i.e. has any NCPG info. */
  needsNcpgInitialization: boolean;
  /** Set a custom video bitrate. Has no effect if set to 0. */
  videoBitrateOverride: number;
  /** Enable to set a different navigation mode. */
  navigationModeOverrideEnabled: boolean;
  /** Overrides the navigation mode with the specified setting. */
  navigationModeOverride: NavigationMode_Mode;
  /** If true, update current vehicle settings with the specified rtx settings */
  useRtxSettings: boolean;
  /** Settings for return-to-home or dock behavior. */
  rtxSettings:
    | ReturnSettings
    | undefined;
  /** If true, the mission needs to load a global graph, i.e. the mission has graph tasks. */
  needsGlobalGraph: boolean;
  /**
   * Estimate of the takeoff frame in the NCPG frame. Used when computing the reference_nav_T_nav
   * transform used by the Localizer's so that it can localize successfully when the mission does
   * not start near the pose graph origin.
   */
  estimateReferenceNavTNavTakeoff:
    | TransPb
    | undefined;
  /**
   * Whether the vehicle should disable strobe lights for the duration of the mission. Strobe lights
   * are only available on Skydio X2 vehicle and enabled by default in DRO flights.
   */
  disableStrobeLights: boolean;
  /**
   * Use this flag if your mission is not present in the cloud database, as is the case with fly
   * to point missions. It prevents the vehicle from uploading mission related information, like
   * alerts and results to the cloud.
   */
  skipUpload: boolean;
  /** Skip the mission PAUSED state and transition directly into ABORTED. */
  skipPausedState: boolean;
}

export interface GpsOriginInfo {
  /** The latitude of the mission's starting point. */
  lat: number;
  /** The longitude of the mission's starting point. */
  lon: number;
  /** The altitude of the mission's starting point in meters. */
  gpsAltitude: number;
  /** The heading of the mission's starting point in radians. */
  gpsHeading: number;
}

/**
 * NOTE(sam): These are stored by NAME in the Cloud API database.
 * Any changes to this enum will require a migration.
 *
 * Mission completion behavior options. If a mission is successfully completed, the vehicle will
 * do this
 */
export interface PostMissionActionEnum {
}

export enum PostMissionActionEnum_Enum {
  UNKNOWN = 0,
  UNSPECIFIED = 0,
  /** LAND_IN_PLACE - Land where the mission completed. (Risky business) */
  LAND_IN_PLACE = 1,
  /** LAND_AT_HOME - Land at home, if no home is registered, the vehicle will land at takeoff point */
  LAND_AT_HOME = 2,
  /**
   * RETURN_TO_HOME - Deprecated: Use DEFAULT_RETURN instead
   * Return to home, if no home is registered, the vehicle will return to takeoff point
   */
  RETURN_TO_HOME = 3,
  /**
   * LAND_AT_DOCK - Deprecated: Use DEFAULT_RETURN instead
   * Land at the dock, if no dock is registered, the vehicle will land at takeoff point
   */
  LAND_AT_DOCK = 4,
  /**
   * DIRECT_RETURN_AND_LAND_AT_DOCK - Deprecated: Use DIRECT_DEFAULT_RETURN instead
   * Return to the dock in a straight line, if no dock is registered, the vehicle will
   * land at takeoff point
   */
  DIRECT_RETURN_AND_LAND_AT_DOCK = 7,
  /**
   * RETURN_TO_START - Deprecated: Use DEFAULT_RETURN instead
   * Return to starting point of mission
   */
  RETURN_TO_START = 5,
  /** HOVER - Hover in place */
  HOVER = 6,
  /** HAND_CARRY_DISABLE - Finish hand carry */
  HAND_CARRY_DISABLE = 8,
  /**
   * RETURN_TO_DOCK - Deprecated: This still exists but now will remap to DEFAULT_RETURN
   * Return to dock and hover -- for dockless teleop, where there is no "dock" so it will return
   * to takeoff point and not land
   */
  RETURN_TO_DOCK = 9,
  /**
   * DIRECT_RETURN_TO_DOCK - Deprecated: Use DIRECT_DEFAULT_RETURN instead
   * Return to dock in straight line and hover -- for dockless teleop, where there is no "dock" so
   * it will return to takeoff point and not land
   */
  DIRECT_RETURN_TO_DOCK = 10,
  /**
   * DEFAULT_RETURN - Return to home/dock based on whether vehicle is assigned to a dock. If docked, land at dock.
   * If not docked, return to takeoff point and wait for operator command to land.
   * This replaces RETURN_TO_HOME and LAND_AT_DOCK
   */
  DEFAULT_RETURN = 11,
  /**
   * DIRECT_DEFAULT_RETURN - Return to home/dock in straight line based on whether vehicle is assigned to a dock.
   * If docked, land at dock. If not docked, return to takeoff point and wait for operator command
   * to land. This replaces DIRECT_RETURN_AND_LAND_AT_DOCK and adds support for direct returns
   * without a dock
   */
  DIRECT_DEFAULT_RETURN = 12,
  UNRECOGNIZED = -1,
}

export function postMissionActionEnum_EnumFromJSON(object: any): PostMissionActionEnum_Enum {
  switch (object) {
    case 0:
    case "UNKNOWN":
      return PostMissionActionEnum_Enum.UNKNOWN;
    case 0:
    case "UNSPECIFIED":
      return PostMissionActionEnum_Enum.UNSPECIFIED;
    case 1:
    case "LAND_IN_PLACE":
      return PostMissionActionEnum_Enum.LAND_IN_PLACE;
    case 2:
    case "LAND_AT_HOME":
      return PostMissionActionEnum_Enum.LAND_AT_HOME;
    case 3:
    case "RETURN_TO_HOME":
      return PostMissionActionEnum_Enum.RETURN_TO_HOME;
    case 4:
    case "LAND_AT_DOCK":
      return PostMissionActionEnum_Enum.LAND_AT_DOCK;
    case 7:
    case "DIRECT_RETURN_AND_LAND_AT_DOCK":
      return PostMissionActionEnum_Enum.DIRECT_RETURN_AND_LAND_AT_DOCK;
    case 5:
    case "RETURN_TO_START":
      return PostMissionActionEnum_Enum.RETURN_TO_START;
    case 6:
    case "HOVER":
      return PostMissionActionEnum_Enum.HOVER;
    case 8:
    case "HAND_CARRY_DISABLE":
      return PostMissionActionEnum_Enum.HAND_CARRY_DISABLE;
    case 9:
    case "RETURN_TO_DOCK":
      return PostMissionActionEnum_Enum.RETURN_TO_DOCK;
    case 10:
    case "DIRECT_RETURN_TO_DOCK":
      return PostMissionActionEnum_Enum.DIRECT_RETURN_TO_DOCK;
    case 11:
    case "DEFAULT_RETURN":
      return PostMissionActionEnum_Enum.DEFAULT_RETURN;
    case 12:
    case "DIRECT_DEFAULT_RETURN":
      return PostMissionActionEnum_Enum.DIRECT_DEFAULT_RETURN;
    case -1:
    case "UNRECOGNIZED":
    default:
      return PostMissionActionEnum_Enum.UNRECOGNIZED;
  }
}

export function postMissionActionEnum_EnumToJSON(object: PostMissionActionEnum_Enum): string {
  switch (object) {
    case PostMissionActionEnum_Enum.UNKNOWN:
      return "UNKNOWN";
    case PostMissionActionEnum_Enum.UNSPECIFIED:
      return "UNSPECIFIED";
    case PostMissionActionEnum_Enum.LAND_IN_PLACE:
      return "LAND_IN_PLACE";
    case PostMissionActionEnum_Enum.LAND_AT_HOME:
      return "LAND_AT_HOME";
    case PostMissionActionEnum_Enum.RETURN_TO_HOME:
      return "RETURN_TO_HOME";
    case PostMissionActionEnum_Enum.LAND_AT_DOCK:
      return "LAND_AT_DOCK";
    case PostMissionActionEnum_Enum.DIRECT_RETURN_AND_LAND_AT_DOCK:
      return "DIRECT_RETURN_AND_LAND_AT_DOCK";
    case PostMissionActionEnum_Enum.RETURN_TO_START:
      return "RETURN_TO_START";
    case PostMissionActionEnum_Enum.HOVER:
      return "HOVER";
    case PostMissionActionEnum_Enum.HAND_CARRY_DISABLE:
      return "HAND_CARRY_DISABLE";
    case PostMissionActionEnum_Enum.RETURN_TO_DOCK:
      return "RETURN_TO_DOCK";
    case PostMissionActionEnum_Enum.DIRECT_RETURN_TO_DOCK:
      return "DIRECT_RETURN_TO_DOCK";
    case PostMissionActionEnum_Enum.DEFAULT_RETURN:
      return "DEFAULT_RETURN";
    case PostMissionActionEnum_Enum.DIRECT_DEFAULT_RETURN:
      return "DIRECT_DEFAULT_RETURN";
    case PostMissionActionEnum_Enum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/**
 * Mission completion behavior options. If a mission is successfully completed, the vehicle will
 * do this
 */
export interface MissionSkillEnum {
}

export enum MissionSkillEnum_Enum {
  /** MISSION_RUNNER - By default use the Mission Runner Skill */
  MISSION_RUNNER = 0,
  /**
   * SURFACE_SCAN - Use 3D Scan skill to load and run mission. This supports user-interaction with loaded mission
   * NOTE(Quentin): 3DS missions can be carried out as autonomous actions in the MissionRunner too
   */
  SURFACE_SCAN = 1,
  UNRECOGNIZED = -1,
}

export function missionSkillEnum_EnumFromJSON(object: any): MissionSkillEnum_Enum {
  switch (object) {
    case 0:
    case "MISSION_RUNNER":
      return MissionSkillEnum_Enum.MISSION_RUNNER;
    case 1:
    case "SURFACE_SCAN":
      return MissionSkillEnum_Enum.SURFACE_SCAN;
    case -1:
    case "UNRECOGNIZED":
    default:
      return MissionSkillEnum_Enum.UNRECOGNIZED;
  }
}

export function missionSkillEnum_EnumToJSON(object: MissionSkillEnum_Enum): string {
  switch (object) {
    case MissionSkillEnum_Enum.MISSION_RUNNER:
      return "MISSION_RUNNER";
    case MissionSkillEnum_Enum.SURFACE_SCAN:
      return "SURFACE_SCAN";
    case MissionSkillEnum_Enum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/**
 * NOTE(sam): These are stored by NAME in the Cloud API database.
 * Any changes to this enum will require a migration.
 *
 * Lost connection behavior. If the vehicle loses connection during a mission, the vehicle will
 * do this
 */
export interface LostConnectionActionEnum {
}

export enum LostConnectionActionEnum_Enum {
  UNKNOWN = 0,
  UNSPECIFIED = 0,
  /** RETURN_TO_HOME - End the mission and return to home (we will issue an ABORT command and enter a special state) */
  RETURN_TO_HOME = 1,
  /** CONTINUE - Keep executing the mission regardless of connectivity */
  CONTINUE = 2,
  /** HOVER - Pause the mission and hover (we will issue a PAUSE command) */
  HOVER = 3,
  UNRECOGNIZED = -1,
}

export function lostConnectionActionEnum_EnumFromJSON(object: any): LostConnectionActionEnum_Enum {
  switch (object) {
    case 0:
    case "UNKNOWN":
      return LostConnectionActionEnum_Enum.UNKNOWN;
    case 0:
    case "UNSPECIFIED":
      return LostConnectionActionEnum_Enum.UNSPECIFIED;
    case 1:
    case "RETURN_TO_HOME":
      return LostConnectionActionEnum_Enum.RETURN_TO_HOME;
    case 2:
    case "CONTINUE":
      return LostConnectionActionEnum_Enum.CONTINUE;
    case 3:
    case "HOVER":
      return LostConnectionActionEnum_Enum.HOVER;
    case -1:
    case "UNRECOGNIZED":
    default:
      return LostConnectionActionEnum_Enum.UNRECOGNIZED;
  }
}

export function lostConnectionActionEnum_EnumToJSON(object: LostConnectionActionEnum_Enum): string {
  switch (object) {
    case LostConnectionActionEnum_Enum.UNKNOWN:
      return "UNKNOWN";
    case LostConnectionActionEnum_Enum.UNSPECIFIED:
      return "UNSPECIFIED";
    case LostConnectionActionEnum_Enum.RETURN_TO_HOME:
      return "RETURN_TO_HOME";
    case LostConnectionActionEnum_Enum.CONTINUE:
      return "CONTINUE";
    case LostConnectionActionEnum_Enum.HOVER:
      return "HOVER";
    case LostConnectionActionEnum_Enum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface MissionTierTypeEnum {
}

export enum MissionTierTypeEnum_Enum {
  NONE = 0,
  PREPLANNED = 1,
  ON_DEMAND = 2,
  UNRECOGNIZED = -1,
}

export function missionTierTypeEnum_EnumFromJSON(object: any): MissionTierTypeEnum_Enum {
  switch (object) {
    case 0:
    case "NONE":
      return MissionTierTypeEnum_Enum.NONE;
    case 1:
    case "PREPLANNED":
      return MissionTierTypeEnum_Enum.PREPLANNED;
    case 2:
    case "ON_DEMAND":
      return MissionTierTypeEnum_Enum.ON_DEMAND;
    case -1:
    case "UNRECOGNIZED":
    default:
      return MissionTierTypeEnum_Enum.UNRECOGNIZED;
  }
}

export function missionTierTypeEnum_EnumToJSON(object: MissionTierTypeEnum_Enum): string {
  switch (object) {
    case MissionTierTypeEnum_Enum.NONE:
      return "NONE";
    case MissionTierTypeEnum_Enum.PREPLANNED:
      return "PREPLANNED";
    case MissionTierTypeEnum_Enum.ON_DEMAND:
      return "ON_DEMAND";
    case MissionTierTypeEnum_Enum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/**
 * Ack message to be sent back to mobile to acknowledge that the mission request was correctly
 * recieved
 */
export interface MissionResponse {
  utime: number;
  /** uuid of the mission request we are responding to */
  uuid: string;
  /** True if the request was valid and saved by the actionn manager */
  requestAccepted: boolean;
}

/** A single operation done by the vehicle. There are sequence actions and unit actions. */
export interface Action {
  /**
   * Uniquely identifies this action
   * Must follow UUID4 protocol and sent in lower-case HEX format
   * so we can do string-comparisons e.g. "d1665ee05bb9431cad6d6188478e553e"
   */
  actionUuid: string;
  /**
   * Identifies the type of action the vehicle should execute. Generally, this is a key of the
   * args with the first letter capitalized.
   */
  actionKey: string;
  /** Arguments to pass to the action. */
  args: ActionArgs | undefined;
}

/**
 * Typed arguments passed into the action to initialize it. Interfaces can
 * parse the elements of an ActionArgs type to generate general interface
 * implementations.
 */
export interface ActionArgs {
  /**
   * String-encoded JSON of arguments.
   * NOTE: This type will not be compatible with the Skydio App UI, and is not recommended
   * for use by Skydio developers. This is meant to serve as a possibility for 3rd party
   * mobile-apps and skills coordinating using JSON args, since they can't define protobufs
   * in the Skydio system.
   */
  json?:
    | string
    | undefined;
  /**
   * DEPRECATED: do not use. Add `[ deprecated = true ]` once this has been fully removed from
   * mobile code. Use `goto_waypoint` instead.
   */
  gotoGpsWaypoint?:
    | GotoGpsWaypointActionArgs
    | undefined;
  /**
   * DEPRECATED: do not use. Add `[ deprecated = true ]` once this has been fully removed from
   * mobile code. Use `goto_waypoint` instead.
   */
  gotoNavWaypoint?: GotoNavWaypointActionArgs | undefined;
  takePhoto?: TakePhotoActionArgs | undefined;
  surfaceScanSkill?: SurfaceScanActionArgs | undefined;
  startVideo?: StartVideoActionArgs | undefined;
  stopVideo?: StopVideoActionArgs | undefined;
  switchRecordingMode?: SwitchRecordingModeActionArgs | undefined;
  timedWait?: TimedWaitActionArgs | undefined;
  sequence?: SequenceActionArgs | undefined;
  orbitPoiAction?: OrbitPoiActionArgs | undefined;
  takePanorama?:
    | TakePanoramaActionArgs
    | undefined;
  /** @deprecated */
  keyframeAction?: KeyframeActionArgs | undefined;
  gotoWaypoint?: GotoWaypointActionArgs | undefined;
  setObstacleAvoidance?: SetObstacleAvoidanceActionArgs | undefined;
  initializeGps?: InitializeGpsActionArgs | undefined;
  conditional?: ConditionalActionArgs | undefined;
  looper?: LooperActionArgs | undefined;
  withinDistance?:
    | WithinDistanceActionArgs
    | undefined;
  /** @deprecated */
  unifiedFollow?: UnifiedFollowActionArgs | undefined;
  inverter?: InverterActionArgs | undefined;
  togglePhotoIntervalMode?: TogglePhotoIntervalModeActionArgs | undefined;
  wifiScan?: WifiScanActionArgs | undefined;
  enableStrobeLights?: EnableStrobeLightsActionArgs | undefined;
  disableStrobeLights?: DisableStrobeLightsActionArgs | undefined;
  spoofJoysticksInputs?: SpoofJoysticksInputsActionArgs | undefined;
  updateJoysticksSettings?: UpdateJoysticksSettingsActionArgs | undefined;
  updateShapeMap?: UpdateShapeMapActionArgs | undefined;
  spoofObstacle?: SpoofObstacleActionArgs | undefined;
  spoofDisturbanceAction?: SpoofDisturbanceActionActionArgs | undefined;
  updateVehicleSettings?: UpdateVehicleSettingsActionArgs | undefined;
  waitForVehicleStop?:
    | WaitForVehicleStopActionArgs
    | undefined;
  /** @deprecated */
  precomputedSubjectSpoofAction?: PrecomputedSubjectSpoofActionArgs | undefined;
  modifySimStateEstimation?: ModifySimStateEstimationActionArgs | undefined;
  gotoAndOrbitPoi?: GotoAndOrbitPoiActionArgs | undefined;
  acquireGps?: AcquireGpsActionArgs | undefined;
  setFaultOverride?: SetFaultOverrideActionArgs | undefined;
  eLand?: ELandActionArgs | undefined;
  trajectoryInspect?: TrajectoryInspectActionArgs | undefined;
  toggleTargetPointExposure?: ToggleTargetPointExposureActionArgs | undefined;
  toggleSemanticAim?: ToggleSemanticAimActionArgs | undefined;
  spoofBatteryLevel?: SpoofBatteryLevelActionArgs | undefined;
  ncpgControl?: NcpgControlActionArgs | undefined;
  registerComplimentaryActions?: RegisterComplimentaryActionsActionArgs | undefined;
  trackInPlace?: TrackInPlaceActionArgs | undefined;
  globalGraphControl?: GlobalGraphControlActionArgs | undefined;
  overrideGpsQuality?: OverrideGpsQualityActionArgs | undefined;
  initGlobalMap?: InitGlobalMapActionArgs | undefined;
  stopForPhotoInspect?: StopForPhotoInspectActionArgs | undefined;
  spoofInitialGpsHeading?: SpoofInitialGpsHeadingActionArgs | undefined;
  trackLandingPadRequest?: TrackLandingPadRequestActionArgs | undefined;
  apriltagSetId?: ApriltagSetIdActionArgs | undefined;
  dockGpsEstimator?: DockGpsEstimatorActionArgs | undefined;
  g47CommandOverride?: G47CommandOverrideActionArgs | undefined;
  requestTakeoffProfile?: RequestTakeoffProfileActionArgs | undefined;
  setDesiredGpsSource?: SetDesiredGpsSourceActionArgs | undefined;
  spoofManualGps?: SpoofManualGpsActionArgs | undefined;
  weatherAction?: WeatherActionArgs | undefined;
  setZoom?: SetZoomActionArgs | undefined;
  missionPlannerServiceControl?: MissionPlannerServiceControlActionArgs | undefined;
  spotlightAction?: SpotlightActionArgs | undefined;
  setCameraSettings?: SetCameraSettingsActionArgs | undefined;
  parachuteControl?: ParachuteControlActionArgs | undefined;
  nightsenseAction?: NightsenseActionArgs | undefined;
  spoofMultiDrone?: SpoofMultiDroneActionArgs | undefined;
  setMovementCommand?: SetMovementCommandActionArgs | undefined;
  spoofFlightEnvelopeLimits?: SpoofFlightEnvelopeLimitsActionArgs | undefined;
  turntable?: TurntableActionArgs | undefined;
  waitForRtk?: WaitForRtkActionArgs | undefined;
  wingWaypointsCommand?: WingWaypointsCommandActionArgs | undefined;
  dancingDrone?: DancingDroneActionArgs | undefined;
  waitForPreciseFault?: WaitForPreciseFaultActionArgs | undefined;
  dancingDroneSpline?: DancingDroneSplineActionArgs | undefined;
  sendDynamicScenario?: SendDynamicScenarioActionArgs | undefined;
  globalPlannerRequest?: GlobalPlannerRequestActionArgs | undefined;
  toggleSubjectDetection?: ToggleSubjectDetectionActionArgs | undefined;
  spoofSubjectScenario?: SpoofSubjectScenarioActionArgs | undefined;
  setSubjectFollowerSettings?: SetSubjectFollowerSettingsActionArgs | undefined;
  scoutAction?: ScoutActionActionArgs | undefined;
  spoofTrackingDevice?: SpoofTrackingDeviceActionArgs | undefined;
  geofenceConfig?: GeofenceConfigActionArgs | undefined;
  setDesiredImuSource?: SetDesiredImuSourceActionArgs | undefined;
  setGnssSolverQuality?: SetGnssSolverQualityActionArgs | undefined;
  sendMotionCommand?: SendMotionCommandActionArgs | undefined;
  spoofPhoneUiVariablesAction?: SpoofPhoneUiVariablesActionArgs | undefined;
  playAudio?:
    | PlayAudioActionArgs
    | undefined;
  /**
   * Test actions
   * Note(Ayush, Duncan): do not use 900 series for test actions. Use continuous range of numbers
   * as prod actions.
   */
  dummy?: DummyActionArgs | undefined;
  testDesiredVelocity?: TestDesiredVelocityActionArgs | undefined;
  testTrackTrajectory?:
    | TestTrackTrajectoryActionArgs
    | undefined;
  /** @deprecated */
  atvSubjectSpoofAction?:
    | AtvSubjectSpoofActionArgs
    | undefined;
  /** @deprecated */
  skiSubjectSpoofAction?: SkiSubjectSpoofActionArgs | undefined;
  setGimbal?: SetGimbalOrientationArgs | undefined;
  updateDockLocationAction?:
    | UpdateDockLocationActionArgs
    | undefined;
  /** DEPRECATED: Add a TakePhoto action after your action instead. */
  photoOnCompletion: boolean;
  /**
   * Allow mission runner to move to the next action without completing this action. Currently
   * required for any Photo, Panorama, or Timed Wait actions.
   */
  isSkippable: boolean;
}

/**
 * Emitted by the Mission at steady rate via the MISSION_STATE_PB channel,
 * contains all info for visualization and state management of client.
 */
export interface MissionState {
  utime: number;
  /** Current state of the Missions */
  stateEnum: MissionState_MissionStateEnum;
  /** Mission name, spec uuid, and template uuid fields copied from the Mission request. */
  missionName: string;
  missionUuid: string;
  templateUuid: string;
  /** Execution uuid generated by the mission runner */
  executionUuid: string;
  /** If the mission is launched by a schedule, the scheduler will fill this out */
  scheduledMissionUuid: string;
  /** Index in the list of Actions that the currently executing Mission is on. */
  actionIndex: number;
  /** Data from the current Action necessary for the visualization of its state. */
  actionState:
    | ActionState
    | undefined;
  /** If running a waypoint action, the index of this waypoint compared to other waypoint actions */
  waypointIndex: number;
  /** Total number of waypoint actions in a mission */
  numWaypoints: number;
  flightInfo:
    | FlightInfo
    | undefined;
  /**
   * The list of MissionUpdates, identified by their `nonce` fields,
   * that were applied successfully to the running Mission. This allows the
   * Client to confirm that any MissionUpdate message it sent was applied.
   */
  updateNonceHistory: string[];
  /** Status of vehicle gps */
  gpsStatus: MissionState_GpsStatusEnum;
  /** Action to take after mission completion. */
  postMissionAction: PostMissionActionEnum_Enum;
  /** Action to take when connection is lost. */
  lostConnectionAction: LostConnectionActionEnum_Enum;
  /** If true, the vehicle should direct rtd when triggered by a fault during the mission */
  faultBasedDirectRtdEnabled: boolean;
  /** How long the current action is estimated to take [in seconds] */
  actionTimeEstimate: number;
  /** How much distance the vehicle needs to fly to run the current action [in seconds] */
  actionDistanceEstimate: number;
  /** How long will it take for the current mission to finish [in seconds] */
  remainingTimeEstimate: number;
  /** How much distance the vehicle still needs to fly to complete the mission [in meters] */
  remainingDistanceEstimate: number;
  /** Optional mission-specified rtx settings to use */
  useRtxSettings: boolean;
  rtxSettings:
    | ReturnSettings
    | undefined;
  /**
   * Number of completed waypoints.
   * Note: this will not stay consistent with action_index or waypoint_index. This field will
   * continue to increment each time we successfully complete a GotoWaypoint action. It is possible
   * this will exceed the number of waypoints in the mission if the user is skipping around.
   */
  waypointsCompleted: number;
  /** Optional mission-specified navigation mode override */
  navigationModeOverrideEnabled: boolean;
  navigationModeOverride: NavigationMode_Mode;
  /** The expected mission result based on the current state of the mission */
  expectedMissionResult: MissionResult_Result;
  /** The action result from the last finished action */
  lastActionResult:
    | ActionResult
    | undefined;
  /** whether free look is active */
  freeLookActive: boolean;
  /** the free look mode for the current action */
  supportedFreeLookMode: FreeLookMode_Enum;
  /** If true we don't include the mission state as part of alerts */
  skipAlert: boolean;
  /** Reason why the mission is paused and cannot be resumed */
  pausedUnresumableReason: MissionState_PausedUnresumableReason;
  /** The tier type of the currently active mission */
  activeMissionTierType: MissionTierTypeEnum_Enum;
  /** Summaries of queued (inactive) missions in the TieredMissionManager */
  queuedMissions: MissionSummary[];
}

export enum MissionState_MissionStateEnum {
  /** UNINITIALIZED - Should never be in this state, something is wrong. */
  UNINITIALIZED = 0,
  /** IDLE - Ready to recieve a Mission request. */
  IDLE = 1,
  /** READY - Ready to execute a mission */
  READY = 2,
  /**
   * IN_PROGRESS - The mission is executing. action_index is the index of the currently
   * executing Action.
   */
  IN_PROGRESS = 3,
  /**
   * PAUSED - The mission has recieved a PAUSE request from the client, and is not
   * currently running the Action.
   */
  PAUSED = 4,
  /**
   * COMPLETED - The mission has completed, and the vehicle is executing the specified
   * post-mission behavior.
   */
  COMPLETED = 5,
  /** ABORTED - The client requested ABORT, and execution was stopped. */
  ABORTED = 6,
  /** ERROR - There was an error; check error_string for details. */
  ERROR = 7,
  /** POST_MISSION_ACTION - The mission is running the post mission action (vehicle actions). */
  POST_MISSION_ACTION = 8,
  /** POST_MISSION_TASK - Deprecated */
  POST_MISSION_TASK = 9,
  /**
   * RETURNING_TO_FLIGHT_PATH - DEPRECATED: Cannot remove due to compatibility issues.
   * The mission is returning to the flight path before resuming.
   */
  RETURNING_TO_FLIGHT_PATH = 11,
  /**
   * LOST_CONNECTION - Special state for lost connection to make handling phone defined lost connection behavior
   * easier
   */
  LOST_CONNECTION = 12,
  /** LOST_CONNECTION_PAUSED - Special state for losing connection with HOVER lost connection action */
  LOST_CONNECTION_PAUSED = 13,
  /** LOW_BATTERY_RETURN - Special state for mission initiated low battery return to home */
  LOW_BATTERY_RETURN = 14,
  /** VEHICLE_PREP - Change vehicle config to match mission parameters. Currently only recording mode */
  VEHICLE_PREP = 16,
  /** PRETAKEOFF_SEQUENCE - Pretakeoff sequence is running */
  PRETAKEOFF_SEQUENCE = 18,
  /** CONFIGURING_SEQUENCE - Configuring sequence is running */
  CONFIGURING_SEQUENCE = 19,
  UNRECOGNIZED = -1,
}

export function missionState_MissionStateEnumFromJSON(object: any): MissionState_MissionStateEnum {
  switch (object) {
    case 0:
    case "UNINITIALIZED":
      return MissionState_MissionStateEnum.UNINITIALIZED;
    case 1:
    case "IDLE":
      return MissionState_MissionStateEnum.IDLE;
    case 2:
    case "READY":
      return MissionState_MissionStateEnum.READY;
    case 3:
    case "IN_PROGRESS":
      return MissionState_MissionStateEnum.IN_PROGRESS;
    case 4:
    case "PAUSED":
      return MissionState_MissionStateEnum.PAUSED;
    case 5:
    case "COMPLETED":
      return MissionState_MissionStateEnum.COMPLETED;
    case 6:
    case "ABORTED":
      return MissionState_MissionStateEnum.ABORTED;
    case 7:
    case "ERROR":
      return MissionState_MissionStateEnum.ERROR;
    case 8:
    case "POST_MISSION_ACTION":
      return MissionState_MissionStateEnum.POST_MISSION_ACTION;
    case 9:
    case "POST_MISSION_TASK":
      return MissionState_MissionStateEnum.POST_MISSION_TASK;
    case 11:
    case "RETURNING_TO_FLIGHT_PATH":
      return MissionState_MissionStateEnum.RETURNING_TO_FLIGHT_PATH;
    case 12:
    case "LOST_CONNECTION":
      return MissionState_MissionStateEnum.LOST_CONNECTION;
    case 13:
    case "LOST_CONNECTION_PAUSED":
      return MissionState_MissionStateEnum.LOST_CONNECTION_PAUSED;
    case 14:
    case "LOW_BATTERY_RETURN":
      return MissionState_MissionStateEnum.LOW_BATTERY_RETURN;
    case 16:
    case "VEHICLE_PREP":
      return MissionState_MissionStateEnum.VEHICLE_PREP;
    case 18:
    case "PRETAKEOFF_SEQUENCE":
      return MissionState_MissionStateEnum.PRETAKEOFF_SEQUENCE;
    case 19:
    case "CONFIGURING_SEQUENCE":
      return MissionState_MissionStateEnum.CONFIGURING_SEQUENCE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return MissionState_MissionStateEnum.UNRECOGNIZED;
  }
}

export function missionState_MissionStateEnumToJSON(object: MissionState_MissionStateEnum): string {
  switch (object) {
    case MissionState_MissionStateEnum.UNINITIALIZED:
      return "UNINITIALIZED";
    case MissionState_MissionStateEnum.IDLE:
      return "IDLE";
    case MissionState_MissionStateEnum.READY:
      return "READY";
    case MissionState_MissionStateEnum.IN_PROGRESS:
      return "IN_PROGRESS";
    case MissionState_MissionStateEnum.PAUSED:
      return "PAUSED";
    case MissionState_MissionStateEnum.COMPLETED:
      return "COMPLETED";
    case MissionState_MissionStateEnum.ABORTED:
      return "ABORTED";
    case MissionState_MissionStateEnum.ERROR:
      return "ERROR";
    case MissionState_MissionStateEnum.POST_MISSION_ACTION:
      return "POST_MISSION_ACTION";
    case MissionState_MissionStateEnum.POST_MISSION_TASK:
      return "POST_MISSION_TASK";
    case MissionState_MissionStateEnum.RETURNING_TO_FLIGHT_PATH:
      return "RETURNING_TO_FLIGHT_PATH";
    case MissionState_MissionStateEnum.LOST_CONNECTION:
      return "LOST_CONNECTION";
    case MissionState_MissionStateEnum.LOST_CONNECTION_PAUSED:
      return "LOST_CONNECTION_PAUSED";
    case MissionState_MissionStateEnum.LOW_BATTERY_RETURN:
      return "LOW_BATTERY_RETURN";
    case MissionState_MissionStateEnum.VEHICLE_PREP:
      return "VEHICLE_PREP";
    case MissionState_MissionStateEnum.PRETAKEOFF_SEQUENCE:
      return "PRETAKEOFF_SEQUENCE";
    case MissionState_MissionStateEnum.CONFIGURING_SEQUENCE:
      return "CONFIGURING_SEQUENCE";
    case MissionState_MissionStateEnum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Reasons why the mission is paused and cannot be resumed */
export enum MissionState_PausedUnresumableReason {
  /** NONE - No reason to block resume */
  NONE = 0,
  /** SUBJECT_TRACKER_ACTIVE - Subject tracker is active */
  SUBJECT_TRACKER_ACTIVE = 1,
  UNRECOGNIZED = -1,
}

export function missionState_PausedUnresumableReasonFromJSON(object: any): MissionState_PausedUnresumableReason {
  switch (object) {
    case 0:
    case "NONE":
      return MissionState_PausedUnresumableReason.NONE;
    case 1:
    case "SUBJECT_TRACKER_ACTIVE":
      return MissionState_PausedUnresumableReason.SUBJECT_TRACKER_ACTIVE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return MissionState_PausedUnresumableReason.UNRECOGNIZED;
  }
}

export function missionState_PausedUnresumableReasonToJSON(object: MissionState_PausedUnresumableReason): string {
  switch (object) {
    case MissionState_PausedUnresumableReason.NONE:
      return "NONE";
    case MissionState_PausedUnresumableReason.SUBJECT_TRACKER_ACTIVE:
      return "SUBJECT_TRACKER_ACTIVE";
    case MissionState_PausedUnresumableReason.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum MissionState_GpsStatusEnum {
  /** GPS_UNKNOWN - This is for backwards compatibility */
  GPS_UNKNOWN = 0,
  /** GPS_INITIALIZING - GPS is still initializing */
  GPS_INITIALIZING = 1,
  /** GPS_READY - GPS is ready on vehicle side */
  GPS_READY = 2,
  UNRECOGNIZED = -1,
}

export function missionState_GpsStatusEnumFromJSON(object: any): MissionState_GpsStatusEnum {
  switch (object) {
    case 0:
    case "GPS_UNKNOWN":
      return MissionState_GpsStatusEnum.GPS_UNKNOWN;
    case 1:
    case "GPS_INITIALIZING":
      return MissionState_GpsStatusEnum.GPS_INITIALIZING;
    case 2:
    case "GPS_READY":
      return MissionState_GpsStatusEnum.GPS_READY;
    case -1:
    case "UNRECOGNIZED":
    default:
      return MissionState_GpsStatusEnum.UNRECOGNIZED;
  }
}

export function missionState_GpsStatusEnumToJSON(object: MissionState_GpsStatusEnum): string {
  switch (object) {
    case MissionState_GpsStatusEnum.GPS_UNKNOWN:
      return "GPS_UNKNOWN";
    case MissionState_GpsStatusEnum.GPS_INITIALIZING:
      return "GPS_INITIALIZING";
    case MissionState_GpsStatusEnum.GPS_READY:
      return "GPS_READY";
    case MissionState_GpsStatusEnum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface MissionSummary {
  missionTierType: MissionTierTypeEnum_Enum;
  stateEnum: MissionState_MissionStateEnum;
  missionName: string;
  templateUuid: Uuid | undefined;
  executionUuid: Uuid | undefined;
  progressRatio: number;
}

export interface SequenceEstimate {
  /** Name of the sequence or action this estimate belong to */
  name: string;
  /** UUID of sequence or action this estimate belongs to */
  actionUuid: string;
  /** Total time taken to execute the sequence */
  duration: number;
  /** Total distance traveled during the sequence */
  distanceTraveled: number;
  /** Final position when the sequence has finished */
  finalPosition:
    | Waypoint
    | undefined;
  /**
   * If this is a sequence, child_sequence_estimates contains estimates for specific actions or
   * sequences contained in it. If this is an action, child_sequence_estimates is empty
   */
  childSequenceEstimates: SequenceEstimate[];
}

/**
 * A modification made to the running Mission.
 * Sent from Client->Vehicle on MISSION_UPDATE_PB channel
 */
export interface MissionUpdate {
  utime: number;
  /**
   * A random string that identifies this unique 'request' and should be reflected in
   * MissionStatus so that the Mobile App knows that its most recent request was accepted
   */
  nonce: string;
  /** The UUID of the running Mission */
  missionUuid: string;
  type: MissionUpdate_UpdateType;
  /** List of action data (See UpdateType Enum descriptions) */
  actions: Action[];
  /** An existing action_uuid to insert actions relative-to (See UpdateType Enum descriptions) */
  relativeActionUuid: string;
  /** If true, insert the actions before the relative action, otherwise insert after */
  insertBefore: boolean;
}

export enum MissionUpdate_UpdateType {
  UNKNOWN = 0,
  /**
   * INSERT - Insert one or more actions into the mission
   * Specify a 'relative_action_uuid' to insert these actions after or before that action,
   * depending on the value of 'insert_before'.
   * An empty 'relative_action_uuid' indicates these should be appended to the end or beginning
   * of the list depending on the value of 'insert_before'.
   */
  INSERT = 1,
  /**
   * UPDATE - Find-by-uuid each action specified in 'actions' in the running Mission
   * and replace with the new Action
   * 'relative_action_uuid' is empty in this case
   */
  UPDATE = 2,
  /**
   * DELETE_ALL_AFTER - Delete all actions after the 'relative_action_uuid' specified
   * In this case the 'actions' field is empty
   */
  DELETE_ALL_AFTER = 3,
  /**
   * DELETE_MULTIPLE - Find-by-uuid each action specified in 'actions' in the running Mission
   * and delete them
   * 'relative_action_uuid' is empty in this case
   */
  DELETE_MULTIPLE = 4,
  /**
   * REVERSE - Reverse the whole mission, pivoting around the current action
   * Both 'relative_action_uuid' and 'actions' are empty
   */
  REVERSE = 5,
  UNRECOGNIZED = -1,
}

export function missionUpdate_UpdateTypeFromJSON(object: any): MissionUpdate_UpdateType {
  switch (object) {
    case 0:
    case "UNKNOWN":
      return MissionUpdate_UpdateType.UNKNOWN;
    case 1:
    case "INSERT":
      return MissionUpdate_UpdateType.INSERT;
    case 2:
    case "UPDATE":
      return MissionUpdate_UpdateType.UPDATE;
    case 3:
    case "DELETE_ALL_AFTER":
      return MissionUpdate_UpdateType.DELETE_ALL_AFTER;
    case 4:
    case "DELETE_MULTIPLE":
      return MissionUpdate_UpdateType.DELETE_MULTIPLE;
    case 5:
    case "REVERSE":
      return MissionUpdate_UpdateType.REVERSE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return MissionUpdate_UpdateType.UNRECOGNIZED;
  }
}

export function missionUpdate_UpdateTypeToJSON(object: MissionUpdate_UpdateType): string {
  switch (object) {
    case MissionUpdate_UpdateType.UNKNOWN:
      return "UNKNOWN";
    case MissionUpdate_UpdateType.INSERT:
      return "INSERT";
    case MissionUpdate_UpdateType.UPDATE:
      return "UPDATE";
    case MissionUpdate_UpdateType.DELETE_ALL_AFTER:
      return "DELETE_ALL_AFTER";
    case MissionUpdate_UpdateType.DELETE_MULTIPLE:
      return "DELETE_MULTIPLE";
    case MissionUpdate_UpdateType.REVERSE:
      return "REVERSE";
    case MissionUpdate_UpdateType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface MissionUpdateResponse {
  utime: number;
  /** Echo back nonce to ensure sync */
  nonce: string;
  /** Current mission uuid */
  uuid: string;
  /** True if the update was valid and saved by the action manager */
  updateAccepted: boolean;
}

/** Sent from the client to modify Mission execution state */
export interface MissionControl {
  utime: number;
  command: MissionControl_ControlType;
  /** Uuid of the action affected by this control. Currently used for SKIP_TO_WAYPOINT */
  actionUuid: string;
}

export enum MissionControl_ControlType {
  INVALID = 0,
  /** START - Start the mission if the mission is paused, or hasn't started yet. */
  START = 1,
  /** PAUSE - Pause the mission (stops the vehicle) */
  PAUSE = 2,
  /** ABORT - Cancel the mission and execute the completed mission behavior. */
  ABORT = 3,
  /** RESUME - Resume the current mission */
  RESUME = 5,
  /** REQUEST_MISSION - Request the current mission definition */
  REQUEST_MISSION = 6,
  /**
   * ABORT_AUTONOMOUS - Autonomous abort that comes from an internal system, not user commanded
   * Note: an autonomous abort only marks IN_PROGRESS as finished. This means that
   * the mission will still complete the post mission action if possible
   */
  ABORT_AUTONOMOUS = 7,
  /** LAND_IN_PLACE - Ends the mission and lands in place */
  LAND_IN_PLACE = 8,
  /** SKIP_TO_WAYPOINT - Skips to a given waypoint in the current mission */
  SKIP_TO_WAYPOINT = 9,
  UNRECOGNIZED = -1,
}

export function missionControl_ControlTypeFromJSON(object: any): MissionControl_ControlType {
  switch (object) {
    case 0:
    case "INVALID":
      return MissionControl_ControlType.INVALID;
    case 1:
    case "START":
      return MissionControl_ControlType.START;
    case 2:
    case "PAUSE":
      return MissionControl_ControlType.PAUSE;
    case 3:
    case "ABORT":
      return MissionControl_ControlType.ABORT;
    case 5:
    case "RESUME":
      return MissionControl_ControlType.RESUME;
    case 6:
    case "REQUEST_MISSION":
      return MissionControl_ControlType.REQUEST_MISSION;
    case 7:
    case "ABORT_AUTONOMOUS":
      return MissionControl_ControlType.ABORT_AUTONOMOUS;
    case 8:
    case "LAND_IN_PLACE":
      return MissionControl_ControlType.LAND_IN_PLACE;
    case 9:
    case "SKIP_TO_WAYPOINT":
      return MissionControl_ControlType.SKIP_TO_WAYPOINT;
    case -1:
    case "UNRECOGNIZED":
    default:
      return MissionControl_ControlType.UNRECOGNIZED;
  }
}

export function missionControl_ControlTypeToJSON(object: MissionControl_ControlType): string {
  switch (object) {
    case MissionControl_ControlType.INVALID:
      return "INVALID";
    case MissionControl_ControlType.START:
      return "START";
    case MissionControl_ControlType.PAUSE:
      return "PAUSE";
    case MissionControl_ControlType.ABORT:
      return "ABORT";
    case MissionControl_ControlType.RESUME:
      return "RESUME";
    case MissionControl_ControlType.REQUEST_MISSION:
      return "REQUEST_MISSION";
    case MissionControl_ControlType.ABORT_AUTONOMOUS:
      return "ABORT_AUTONOMOUS";
    case MissionControl_ControlType.LAND_IN_PLACE:
      return "LAND_IN_PLACE";
    case MissionControl_ControlType.SKIP_TO_WAYPOINT:
      return "SKIP_TO_WAYPOINT";
    case MissionControl_ControlType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Light information regarding the current flight, useful for bookeeping. */
export interface FlightInfo {
  /** Vehicle name, for example: 'Skydio2-xyzw' */
  vehicleName: string;
  /** Vehicle ID, unique vehicle identifier */
  vehicleId: string;
  /** Flight ID of the current flight. */
  flightId: string;
  /** Unix time of the actual start time of the mission. */
  startUclock: number;
}

/**
 * A response type from the currently running Action to give the client
 * enough data and context to visualize its current state.
 */
export interface ActionState {
  /** Copied from the action_uuid sent in the Mission definition by the client. */
  actionUuid: string;
  /**
   * Ratio, from 0 to 1, of the progress of the Action. Used only for
   * visualization.
   */
  progressRatio: number;
  /** Unix time of when the action started. */
  startUclock: number;
  /** String message to return to the client. */
  displayMessage: string;
  sequence?: SequenceActionStateData | undefined;
  gotoAndOrbitPoi?: GotoAndOrbitPoiActionStateData | undefined;
  orbitPoiAction?: OrbitPoiActionStateData | undefined;
  gotoGpsWaypoint?: GotoGpsWaypointActionStateData | undefined;
  gotoNavWaypoint?: GotoNavWaypointActionStateData | undefined;
  takePhoto?: TakePhotoActionStateData | undefined;
  surfaceScanSkill?: SurfaceScanActionStateData | undefined;
  startVideo?: StartVideoActionStateData | undefined;
  stopVideo?: StopVideoActionStateData | undefined;
  switchRecordingMode?: SwitchRecordingModeActionStateData | undefined;
  timedWait?: TimedWaitActionStateData | undefined;
  takePanorama?: TakePanoramaActionStateData | undefined;
  keyframeSkill?: KeyframeActionStateData | undefined;
  gotoWaypoint?: GotoWaypointActionStateData | undefined;
  setObstacleAvoidance?: SetObstacleAvoidanceActionStateData | undefined;
  initializeGps?: InitializeGpsActionStateData | undefined;
  subjectDetected?: SubjectDetectedActionStateData | undefined;
  looper?: LooperActionStateData | undefined;
  withinDistance?: WithinDistanceActionStateData | undefined;
  unifiedFollowAction?: UnifiedFollowActionStateData | undefined;
  inverter?: InverterActionStateData | undefined;
  togglePhotoIntervalMode?: TogglePhotoIntervalModeActionStateData | undefined;
  wifiScan?: WifiScanActionStateData | undefined;
  enableStrobeLights?: EnableStrobeLightsActionStateData | undefined;
  disableStrobeLights?: DisableStrobeLightsActionStateData | undefined;
  spoofJoysticksInputs?: SpoofJoysticksInputsActionStateData | undefined;
  updateJoysticksSettings?: UpdateJoysticksSettingsActionStateData | undefined;
  updateShapeMap?: UpdateShapeMapActionStateData | undefined;
  spoofObstacle?: SpoofObstacleActionStateData | undefined;
  dummyAction?: DummyActionStateData | undefined;
  testDesiredVelocityAction?: TestDesiredVelocityActionStateData | undefined;
  testTrackTrajectory?: TestTrackTrajectoryActionStateData | undefined;
  atvSubjectSpoofAction?: AtvSubjectSpoofActionStateData | undefined;
  skiSubjectSpoofAction?: SkiSubjectSpoofActionStateData | undefined;
  setGimbalOrientation?: SetGimbalOrientationActionStateData | undefined;
  parallel?: ParallelActionStateData | undefined;
  sequenceUntilSuccess?: SequenceUntilSuccessActionStateData | undefined;
  sequenceUntilFailure?: SequenceUntilFailureActionStateData | undefined;
  sequencePretakeoff?: SequencePretakeoffActionStateData | undefined;
  sequenceConfig?: SequenceConfigActionStateData | undefined;
  waitForRtk?: WaitForRtkActionStateData | undefined;
  wingWaypointsCommand?: WingWaypointsCommandActionStateData | undefined;
  sendDynamicScenario?: SendDynamicScenarioActionStateData | undefined;
  scoutAction?: ScoutActionActionStateData | undefined;
  spoofTrackingDevice?: SpoofTrackingDeviceActionStateData | undefined;
  spoofDisturbanceAction?: SpoofDisturbanceActionStateData | undefined;
  updateVehicleSettings?: UpdateVehicleSettingsActionStateData | undefined;
  waitForVehicleStop?: WaitForVehicleStopActionStateData | undefined;
  precomputedSubjectSpoofAction?: PrecomputedSubjectSpoofActionStateData | undefined;
  modifySimStateEstimation?: ModifySimStateEstimationActionStateData | undefined;
  acquireGps?: AcquireGpsActionStateData | undefined;
  setFaultOverride?: SetFaultOverrideActionStateData | undefined;
  eLand?: ELandActionStateData | undefined;
  trajectoryInspect?: TrajectoryInspectActionStateData | undefined;
  toggleTargetPointExposure?: ToggleTargetPointExposureActionStateData | undefined;
  toggleSemanticAim?: ToggleSemanticAimActionStateData | undefined;
  spoofBatteryLevel?: SpoofBatteryLevelActionStateData | undefined;
  ncpgControl?: NcpgControlActionStateData | undefined;
  registerComplimentaryActions?: RegisterComplimentaryActionsActionStateData | undefined;
  trackInPlace?: TrackInPlaceActionStateData | undefined;
  globalGraphControl?: GlobalGraphControlActionStateData | undefined;
  overrideGpsQuality?: OverrideGpsQualityActionStateData | undefined;
  initGlobalMap?: InitGlobalMapActionStateData | undefined;
  stopForPhotoInspect?: StopForPhotoInspectActionStateData | undefined;
  spoofInitialGpsHeading?: SpoofInitialGpsHeadingActionStateData | undefined;
  trackLandingPadRequest?: TrackLandingPadRequestActionStateData | undefined;
  apriltagSetId?: ApriltagSetIdActionStateData | undefined;
  dockGpsEstimator?: DockGpsEstimatorActionStateData | undefined;
  g47CommandOverride?: G47CommandOverrideActionStateData | undefined;
  requestTakeoffProfile?: RequestTakeoffProfileActionStateData | undefined;
  updateDockLocationAction?: UpdateDockLocationActionStateData | undefined;
  setDesiredGpsSource?: SetDesiredGpsSourceActionStateData | undefined;
  spoofManualGps?: SpoofManualGpsActionStateData | undefined;
  weatherAction?: WeatherActionStateData | undefined;
  setZoom?: SetZoomActionStateData | undefined;
  missionPlannerServiceControl?: MissionPlannerServiceControlActionStateData | undefined;
  spotlightAction?: SpotlightActionStateData | undefined;
  setCameraSettings?: SetCameraSettingsActionStateData | undefined;
  parachuteControl?: ParachuteControlActionStateData | undefined;
  nightsenseAction?: NightsenseActionStateData | undefined;
  spoofMultiDrone?: SpoofMultiDroneActionStateData | undefined;
  setMovementCommand?: SetMovementCommandActionStateData | undefined;
  spoofFlightEnvelopeLimits?: SpoofFlightEnvelopeLimitsActionStateData | undefined;
  turntable?: TurntableActionStateData | undefined;
  dancingDrone?: DancingDroneActionStateData | undefined;
  waitForPreciseFault?: WaitForPreciseFaultActionStateData | undefined;
  dancingDroneSpline?: DancingDroneSplineActionStateData | undefined;
  globalPlannerRequest?: GlobalPlannerRequestActionStateData | undefined;
  toggleSubjectDetection?: ToggleSubjectDetectionActionStateData | undefined;
  spoofSubjectScenario?: SpoofSubjectScenarioActionStateData | undefined;
  setSubjectFollowerSettings?: SetSubjectFollowerSettingsActionStateData | undefined;
  geofenceConfig?: GeofenceConfigActionStateData | undefined;
  setDesiredImuSource?: SetDesiredImuSourceActionStateData | undefined;
  sendMotionCommand?: SendMotionCommandActionStateData | undefined;
  setGnssSolverQuality?: SetGnssSolverQualityActionStateData | undefined;
  spoofPhoneUiVariablesAction?: SpoofPhoneUiVariablesActionStateData | undefined;
  playAudio?: PlayAudioActionStateData | undefined;
}

/** Summarizes information relevant for debugging failed mission takeoff */
export interface FailedTakeoffSummary {
  /** If takeoff failed, report which faults caused failure */
  blockingFaults: VehicleFault_Enum[];
  /** Indicates flight phase when mission failed takeoff */
  flightPhase: FlightPhaseEnum_Enum;
  /** Main indication of what prevented takeoff */
  reason: FailedTakeoffReason_Enum;
}

export interface FailedTakeoffReason {
}

export enum FailedTakeoffReason_Enum {
  /** UNINITIALIZED - Should indicate FailedTakeoffSummary is not initialized */
  UNINITIALIZED = 0,
  /** UNKNOWN - UNKNOWN reason */
  UNKNOWN = 1,
  /** BLOCKING_FAULTS - Deprecated. Blocking faults prevented takeoff */
  BLOCKING_FAULTS = 2,
  /** NOT_IN_DOCK_OR_PEDESTAL - Vehicle not in dock (safety issue) */
  NOT_IN_DOCK_OR_PEDESTAL = 3,
  /** POSE_GRAPH_NOT_AVAILABLE - Missing pose graph for mission */
  POSE_GRAPH_NOT_AVAILABLE = 4,
  /** IN_HAND - Safety concern that we are in a humans hand */
  IN_HAND = 5,
  /**
   * NO_ATTEMPT - We never attempted ot takeoff. Likely an external system requested removal of the launch
   * request before we attempted takeoff
   */
  NO_ATTEMPT = 6,
  /** LOST_PILOTSHIP - Drone was commandeered by another pilot before takeoff */
  LOST_PILOTSHIP = 7,
  /** ENTERED_POST_FLIGHT_BEFORE_TAKEOFF_COMPLETED - Vehicle entered post flight before entering subject focus policy */
  ENTERED_POST_FLIGHT_BEFORE_TAKEOFF_COMPLETED = 8,
  /** MISSION_REMOVED_BY_SCHEDULER_REASON_UNKNOWN - Mission was removed by scheduler, but we could not determine why */
  MISSION_REMOVED_BY_SCHEDULER_REASON_UNKNOWN = 9,
  /** TAKEOFF_CANCELED_REASON_UNKNOWN - The takeoff was canceled but a reason could not be determined */
  TAKEOFF_CANCELED_REASON_UNKNOWN = 10,
  /** TAKEOFF_CANCELED_BLOCKING_FAULTS - The takeoff was canceled with blocking faults */
  TAKEOFF_CANCELED_BLOCKING_FAULTS = 11,
  /** MISSION_REMOVED_BY_SCHEDULER_BLOCKING_FAULTS - The mission was removed by the scheduler with blocking faults being present */
  MISSION_REMOVED_BY_SCHEDULER_BLOCKING_FAULTS = 12,
  UNRECOGNIZED = -1,
}

export function failedTakeoffReason_EnumFromJSON(object: any): FailedTakeoffReason_Enum {
  switch (object) {
    case 0:
    case "UNINITIALIZED":
      return FailedTakeoffReason_Enum.UNINITIALIZED;
    case 1:
    case "UNKNOWN":
      return FailedTakeoffReason_Enum.UNKNOWN;
    case 2:
    case "BLOCKING_FAULTS":
      return FailedTakeoffReason_Enum.BLOCKING_FAULTS;
    case 3:
    case "NOT_IN_DOCK_OR_PEDESTAL":
      return FailedTakeoffReason_Enum.NOT_IN_DOCK_OR_PEDESTAL;
    case 4:
    case "POSE_GRAPH_NOT_AVAILABLE":
      return FailedTakeoffReason_Enum.POSE_GRAPH_NOT_AVAILABLE;
    case 5:
    case "IN_HAND":
      return FailedTakeoffReason_Enum.IN_HAND;
    case 6:
    case "NO_ATTEMPT":
      return FailedTakeoffReason_Enum.NO_ATTEMPT;
    case 7:
    case "LOST_PILOTSHIP":
      return FailedTakeoffReason_Enum.LOST_PILOTSHIP;
    case 8:
    case "ENTERED_POST_FLIGHT_BEFORE_TAKEOFF_COMPLETED":
      return FailedTakeoffReason_Enum.ENTERED_POST_FLIGHT_BEFORE_TAKEOFF_COMPLETED;
    case 9:
    case "MISSION_REMOVED_BY_SCHEDULER_REASON_UNKNOWN":
      return FailedTakeoffReason_Enum.MISSION_REMOVED_BY_SCHEDULER_REASON_UNKNOWN;
    case 10:
    case "TAKEOFF_CANCELED_REASON_UNKNOWN":
      return FailedTakeoffReason_Enum.TAKEOFF_CANCELED_REASON_UNKNOWN;
    case 11:
    case "TAKEOFF_CANCELED_BLOCKING_FAULTS":
      return FailedTakeoffReason_Enum.TAKEOFF_CANCELED_BLOCKING_FAULTS;
    case 12:
    case "MISSION_REMOVED_BY_SCHEDULER_BLOCKING_FAULTS":
      return FailedTakeoffReason_Enum.MISSION_REMOVED_BY_SCHEDULER_BLOCKING_FAULTS;
    case -1:
    case "UNRECOGNIZED":
    default:
      return FailedTakeoffReason_Enum.UNRECOGNIZED;
  }
}

export function failedTakeoffReason_EnumToJSON(object: FailedTakeoffReason_Enum): string {
  switch (object) {
    case FailedTakeoffReason_Enum.UNINITIALIZED:
      return "UNINITIALIZED";
    case FailedTakeoffReason_Enum.UNKNOWN:
      return "UNKNOWN";
    case FailedTakeoffReason_Enum.BLOCKING_FAULTS:
      return "BLOCKING_FAULTS";
    case FailedTakeoffReason_Enum.NOT_IN_DOCK_OR_PEDESTAL:
      return "NOT_IN_DOCK_OR_PEDESTAL";
    case FailedTakeoffReason_Enum.POSE_GRAPH_NOT_AVAILABLE:
      return "POSE_GRAPH_NOT_AVAILABLE";
    case FailedTakeoffReason_Enum.IN_HAND:
      return "IN_HAND";
    case FailedTakeoffReason_Enum.NO_ATTEMPT:
      return "NO_ATTEMPT";
    case FailedTakeoffReason_Enum.LOST_PILOTSHIP:
      return "LOST_PILOTSHIP";
    case FailedTakeoffReason_Enum.ENTERED_POST_FLIGHT_BEFORE_TAKEOFF_COMPLETED:
      return "ENTERED_POST_FLIGHT_BEFORE_TAKEOFF_COMPLETED";
    case FailedTakeoffReason_Enum.MISSION_REMOVED_BY_SCHEDULER_REASON_UNKNOWN:
      return "MISSION_REMOVED_BY_SCHEDULER_REASON_UNKNOWN";
    case FailedTakeoffReason_Enum.TAKEOFF_CANCELED_REASON_UNKNOWN:
      return "TAKEOFF_CANCELED_REASON_UNKNOWN";
    case FailedTakeoffReason_Enum.TAKEOFF_CANCELED_BLOCKING_FAULTS:
      return "TAKEOFF_CANCELED_BLOCKING_FAULTS";
    case FailedTakeoffReason_Enum.MISSION_REMOVED_BY_SCHEDULER_BLOCKING_FAULTS:
      return "MISSION_REMOVED_BY_SCHEDULER_BLOCKING_FAULTS";
    case FailedTakeoffReason_Enum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface PostMissionActionResultEnum {
}

export enum PostMissionActionResultEnum_Enum {
  /** UNKNOWN - Unknown result */
  UNKNOWN = 0,
  /** DID_NOT_RUN - Mission execution stopped before reaching post mission action */
  DID_NOT_RUN = 1,
  /** SUCCESS - Post mission action succeded */
  SUCCESS = 2,
  /** FAILURE - Post mission action failed */
  FAILURE = 3,
  UNRECOGNIZED = -1,
}

export function postMissionActionResultEnum_EnumFromJSON(object: any): PostMissionActionResultEnum_Enum {
  switch (object) {
    case 0:
    case "UNKNOWN":
      return PostMissionActionResultEnum_Enum.UNKNOWN;
    case 1:
    case "DID_NOT_RUN":
      return PostMissionActionResultEnum_Enum.DID_NOT_RUN;
    case 2:
    case "SUCCESS":
      return PostMissionActionResultEnum_Enum.SUCCESS;
    case 3:
    case "FAILURE":
      return PostMissionActionResultEnum_Enum.FAILURE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return PostMissionActionResultEnum_Enum.UNRECOGNIZED;
  }
}

export function postMissionActionResultEnum_EnumToJSON(object: PostMissionActionResultEnum_Enum): string {
  switch (object) {
    case PostMissionActionResultEnum_Enum.UNKNOWN:
      return "UNKNOWN";
    case PostMissionActionResultEnum_Enum.DID_NOT_RUN:
      return "DID_NOT_RUN";
    case PostMissionActionResultEnum_Enum.SUCCESS:
      return "SUCCESS";
    case PostMissionActionResultEnum_Enum.FAILURE:
      return "FAILURE";
    case PostMissionActionResultEnum_Enum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/**
 * State snapshot of a mission that can be used to resume execution.
 * Used by MissionResult to send state to cloud, and by MissionExecutionRequest to receive it back.
 */
export interface ResumableMissionState {
  /** The utime at which the state was saved (microseconds since epoch) */
  stateSavedUtime: number;
  /** The UUID of the mission execution that this state belongs to */
  missionExecutionUuid:
    | Uuid
    | undefined;
  /** The UUID of the mission spec that this state belongs to */
  missionSpecUuid:
    | Uuid
    | undefined;
  /** The root action state of the mission */
  rootActionState: ActionState | undefined;
}

/**
 * Sent from Vehicle->Client on MISSION_RESULT_PB channel
 * once a Mission has finished executing, including any post-flight
 * Action steps, or the vehicle received an invalid Mission request.
 * TODO(jack): We need to solidify the post-flight process a bit more thoroghly.
 * Let's treat MissionResult and ActionResult as TBD for now.
 */
export interface MissionResult {
  utime: number;
  /** The UUID of this specific execution of the mission */
  executionUuid: string;
  startUclock: number;
  endUclock: number;
  /** The UUID of the scheduled mission that triggered this execution */
  scheduledMissionUuid: string;
  /** The UUID of the Mission */
  missionUuid: string;
  /** The UUID of the Mission Template (if any) that the Mission came from. */
  templateUuid: string;
  /** The ID of the flight during which this mission execution took place */
  flightId: string;
  /** The ID fo the vehicle on which tis mission was executed */
  vehicleId: string;
  /** Enum encoding the result of the mission execution. */
  result: MissionResult_Result;
  /**
   * Optional string that encodes information to debug a failure one
   * the client.
   * TODO: Potentially want a more defined error type for REJECT_ARGUMENTS.
   */
  errorString: string;
  /** A list of results that can be optionally be provided by each action. */
  actionResults: ActionResult[];
  /** Deprecated */
  postMissionTaskRuntimeSeconds: number;
  /** Deprecated */
  postMissionActionRuntimeSeconds: number;
  failedTakeoffSummary: FailedTakeoffSummary | undefined;
  postMissionActionResult: PostMissionActionResultEnum_Enum;
  /** The ID of the dock from where the vehicle took off for this mission; */
  takeoffDockId: string;
  /** If true and the mission fails, we don't send an alert */
  skipAlert: boolean;
  /** If true, the mission state was saved to the vehicle when the mission stopped running */
  savedMissionStateToVehicle: boolean;
  /**
   * The resumable mission state, if saved. Cloud can store this and send it back
   * when requesting a resume via MissionExecutionRequest.resume_state.
   */
  resumeState:
    | ResumableMissionState
    | undefined;
  /**
   * The execution group this execution belongs to. Echoed from
   * MissionExecutionRequest.mission_execution_group_uuid so the cloud can link
   * resumed executions to the same group. Empty for legacy / non-grouped executions.
   */
  missionExecutionGroupUuid: string;
}

/**
 * NOTE(sam): These enums are stored as strings in the Cloud API database.
 * Don't change their names! Adding a new enum requires a migration
 */
export enum MissionResult_Result {
  /** UNKNOWN - This should never be in this state, something is wrong. */
  UNKNOWN = 0,
  /** SUCCESS - All Actions completed successfully and the Mission hit COMPLETED state. */
  SUCCESS = 1,
  /** REJECT_ARGUMENTS - A set of arguments was malformed. Check result and error_string. */
  REJECT_ARGUMENTS = 2,
  /** ABORT_MANUAL - The mission was aborted by the client via ABORT or from a new mission request being received. */
  ABORT_MANUAL = 3,
  /** ABORT_MANUAL_RTX - The mission was aborted by the client by requesting a return to home or return to dock */
  ABORT_MANUAL_RTX = 13,
  /** ABORT_MANUAL_BUTTON_PRESSED - The user pressed the abort mission button in the mission runner UI */
  ABORT_MANUAL_BUTTON_PRESSED = 21,
  /** ABORT_MANUAL_LAND - The mission was aborted by the client by requesting a landing */
  ABORT_MANUAL_LAND = 14,
  /** ABORT_AUTONOMOUS - The mission was aborted without user intention */
  ABORT_AUTONOMOUS = 4,
  /**
   * FAILED_ACTIONS - The mission didn't complete every action successfully. Will need to check the action results
   * to see which actions failed.
   */
  FAILED_ACTIONS = 5,
  /** FAILED_TAKEOFF - The mission never took off even though we intended to launch a scheduled mission */
  FAILED_TAKEOFF = 6,
  /** FAILED_POST_MISSION_ACTION - The mission completed but failed the post mission action */
  FAILED_POST_MISSION_ACTION = 7,
  /** OFFLINE - The vehicle was offline at the time the mission should have taken off. */
  OFFLINE = 8,
  /** ABORT_LOW_BATTERY - The mission was aborted due to low battery */
  ABORT_LOW_BATTERY = 9,
  /** ABORT_LOST_CONNECTION - The mission was aborted due to lost connection */
  ABORT_LOST_CONNECTION = 10,
  /** ABORT_TOO_DARK - The mission was aborted due to a too dark environment */
  ABORT_TOO_DARK = 11,
  /**
   * ABORT_FAILED_ACTIONS - The mission was aborted due to failed actions with autonomous_abort_mission_on_failed_action
   * enabled
   */
  ABORT_FAILED_ACTIONS = 12,
  /** ABORT_AUTONOMOUS_MISSION_CONTROL - The mission was aborted due to an explicit ABORT_AUTONOMOUS command over MISSION_CONTROL_PB */
  ABORT_AUTONOMOUS_MISSION_CONTROL = 15,
  /** LAND_IN_PLACE_MISSION_CONTROL - The mission was aborted due to an explicit LAND_IN_PLACE command over MISSION_CONTROL_PB */
  LAND_IN_PLACE_MISSION_CONTROL = 16,
  /**
   * WAYPOINT_VALIDATION_FAILED - The mission failed the waypoint validation checks. Typical reason for this is the mission is
   * too long
   */
  WAYPOINT_VALIDATION_FAILED = 17,
  /** PERSISTENT_GLOBAL_GRAPH_DISABLED - Persistent global graph is disabled in parameters or cloud override */
  PERSISTENT_GLOBAL_GRAPH_DISABLED = 18,
  /** FAILED_TO_LOAD_GLOBAL_GRAPH - Waypoints failed to load global graph or could not find the file */
  FAILED_TO_LOAD_GLOBAL_GRAPH = 19,
  /** NEED_NCPG_TO_LOAD_GLOBAL_GRAPH - Persistent global graph missions require NCPG but NCPG is not enabled */
  NEED_NCPG_TO_LOAD_GLOBAL_GRAPH = 20,
  /** FAILED_TO_LOAD_NCPG - Timed out or failed to load ncpg */
  FAILED_TO_LOAD_NCPG = 22,
  /** ABORT_FAR_OUTSIDE_GEOFENCE - Vehicle was far outside geofence */
  ABORT_FAR_OUTSIDE_GEOFENCE = 24,
  /** ABORT_NCR_UNRELIABLE - NCR became unreliable while executing a mission with NCPG enabled */
  ABORT_NCR_UNRELIABLE = 25,
  UNRECOGNIZED = -1,
}

export function missionResult_ResultFromJSON(object: any): MissionResult_Result {
  switch (object) {
    case 0:
    case "UNKNOWN":
      return MissionResult_Result.UNKNOWN;
    case 1:
    case "SUCCESS":
      return MissionResult_Result.SUCCESS;
    case 2:
    case "REJECT_ARGUMENTS":
      return MissionResult_Result.REJECT_ARGUMENTS;
    case 3:
    case "ABORT_MANUAL":
      return MissionResult_Result.ABORT_MANUAL;
    case 13:
    case "ABORT_MANUAL_RTX":
      return MissionResult_Result.ABORT_MANUAL_RTX;
    case 21:
    case "ABORT_MANUAL_BUTTON_PRESSED":
      return MissionResult_Result.ABORT_MANUAL_BUTTON_PRESSED;
    case 14:
    case "ABORT_MANUAL_LAND":
      return MissionResult_Result.ABORT_MANUAL_LAND;
    case 4:
    case "ABORT_AUTONOMOUS":
      return MissionResult_Result.ABORT_AUTONOMOUS;
    case 5:
    case "FAILED_ACTIONS":
      return MissionResult_Result.FAILED_ACTIONS;
    case 6:
    case "FAILED_TAKEOFF":
      return MissionResult_Result.FAILED_TAKEOFF;
    case 7:
    case "FAILED_POST_MISSION_ACTION":
      return MissionResult_Result.FAILED_POST_MISSION_ACTION;
    case 8:
    case "OFFLINE":
      return MissionResult_Result.OFFLINE;
    case 9:
    case "ABORT_LOW_BATTERY":
      return MissionResult_Result.ABORT_LOW_BATTERY;
    case 10:
    case "ABORT_LOST_CONNECTION":
      return MissionResult_Result.ABORT_LOST_CONNECTION;
    case 11:
    case "ABORT_TOO_DARK":
      return MissionResult_Result.ABORT_TOO_DARK;
    case 12:
    case "ABORT_FAILED_ACTIONS":
      return MissionResult_Result.ABORT_FAILED_ACTIONS;
    case 15:
    case "ABORT_AUTONOMOUS_MISSION_CONTROL":
      return MissionResult_Result.ABORT_AUTONOMOUS_MISSION_CONTROL;
    case 16:
    case "LAND_IN_PLACE_MISSION_CONTROL":
      return MissionResult_Result.LAND_IN_PLACE_MISSION_CONTROL;
    case 17:
    case "WAYPOINT_VALIDATION_FAILED":
      return MissionResult_Result.WAYPOINT_VALIDATION_FAILED;
    case 18:
    case "PERSISTENT_GLOBAL_GRAPH_DISABLED":
      return MissionResult_Result.PERSISTENT_GLOBAL_GRAPH_DISABLED;
    case 19:
    case "FAILED_TO_LOAD_GLOBAL_GRAPH":
      return MissionResult_Result.FAILED_TO_LOAD_GLOBAL_GRAPH;
    case 20:
    case "NEED_NCPG_TO_LOAD_GLOBAL_GRAPH":
      return MissionResult_Result.NEED_NCPG_TO_LOAD_GLOBAL_GRAPH;
    case 22:
    case "FAILED_TO_LOAD_NCPG":
      return MissionResult_Result.FAILED_TO_LOAD_NCPG;
    case 24:
    case "ABORT_FAR_OUTSIDE_GEOFENCE":
      return MissionResult_Result.ABORT_FAR_OUTSIDE_GEOFENCE;
    case 25:
    case "ABORT_NCR_UNRELIABLE":
      return MissionResult_Result.ABORT_NCR_UNRELIABLE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return MissionResult_Result.UNRECOGNIZED;
  }
}

export function missionResult_ResultToJSON(object: MissionResult_Result): string {
  switch (object) {
    case MissionResult_Result.UNKNOWN:
      return "UNKNOWN";
    case MissionResult_Result.SUCCESS:
      return "SUCCESS";
    case MissionResult_Result.REJECT_ARGUMENTS:
      return "REJECT_ARGUMENTS";
    case MissionResult_Result.ABORT_MANUAL:
      return "ABORT_MANUAL";
    case MissionResult_Result.ABORT_MANUAL_RTX:
      return "ABORT_MANUAL_RTX";
    case MissionResult_Result.ABORT_MANUAL_BUTTON_PRESSED:
      return "ABORT_MANUAL_BUTTON_PRESSED";
    case MissionResult_Result.ABORT_MANUAL_LAND:
      return "ABORT_MANUAL_LAND";
    case MissionResult_Result.ABORT_AUTONOMOUS:
      return "ABORT_AUTONOMOUS";
    case MissionResult_Result.FAILED_ACTIONS:
      return "FAILED_ACTIONS";
    case MissionResult_Result.FAILED_TAKEOFF:
      return "FAILED_TAKEOFF";
    case MissionResult_Result.FAILED_POST_MISSION_ACTION:
      return "FAILED_POST_MISSION_ACTION";
    case MissionResult_Result.OFFLINE:
      return "OFFLINE";
    case MissionResult_Result.ABORT_LOW_BATTERY:
      return "ABORT_LOW_BATTERY";
    case MissionResult_Result.ABORT_LOST_CONNECTION:
      return "ABORT_LOST_CONNECTION";
    case MissionResult_Result.ABORT_TOO_DARK:
      return "ABORT_TOO_DARK";
    case MissionResult_Result.ABORT_FAILED_ACTIONS:
      return "ABORT_FAILED_ACTIONS";
    case MissionResult_Result.ABORT_AUTONOMOUS_MISSION_CONTROL:
      return "ABORT_AUTONOMOUS_MISSION_CONTROL";
    case MissionResult_Result.LAND_IN_PLACE_MISSION_CONTROL:
      return "LAND_IN_PLACE_MISSION_CONTROL";
    case MissionResult_Result.WAYPOINT_VALIDATION_FAILED:
      return "WAYPOINT_VALIDATION_FAILED";
    case MissionResult_Result.PERSISTENT_GLOBAL_GRAPH_DISABLED:
      return "PERSISTENT_GLOBAL_GRAPH_DISABLED";
    case MissionResult_Result.FAILED_TO_LOAD_GLOBAL_GRAPH:
      return "FAILED_TO_LOAD_GLOBAL_GRAPH";
    case MissionResult_Result.NEED_NCPG_TO_LOAD_GLOBAL_GRAPH:
      return "NEED_NCPG_TO_LOAD_GLOBAL_GRAPH";
    case MissionResult_Result.FAILED_TO_LOAD_NCPG:
      return "FAILED_TO_LOAD_NCPG";
    case MissionResult_Result.ABORT_FAR_OUTSIDE_GEOFENCE:
      return "ABORT_FAR_OUTSIDE_GEOFENCE";
    case MissionResult_Result.ABORT_NCR_UNRELIABLE:
      return "ABORT_NCR_UNRELIABLE";
    case MissionResult_Result.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/**
 * A response type from the Mission that is sent once, at the end of a
 * Mission, containing data about the execution of that Action.
 */
export interface ActionResult {
  /** Unique identifier for this action result - need this to link captured media */
  uuid: string;
  /** uuid of the action */
  actionUuid: string;
  /** Corresponds to action_key in the Action message */
  actionKey: string;
  /**
   * string message to the client about the results of this Action, meant to be
   * displayed to the user.
   */
  message: string;
  /** Unix time when the action started */
  startUclock: number;
  /** Unix time when the action ended, or left out if the action was skipped. */
  endUclock: number;
  /** Vehicle utime when the action started and stopped. */
  startUtime: number;
  endUtime: number;
  /**
   * NOTE: Until ActionData ucon support is fully implemented, we can use this to return
   * basic information and data to the client.
   */
  debugJson: string;
  /** Enum encoding the result of this action */
  result: ActionResult_Result;
  /**
   * More context on what went wrong, if this action failed to complete
   * NOTE(sam): maybe this should be an enum, we would need to enumerate the failure modes for each
   * type of action
   */
  errorCode: string;
  /**
   * uuid of the parent sequence action result
   * NOTE(jose): This is currently not being filled out correctly
   */
  parentActionResultUuid: string;
  gotoGpsWaypoint?: GotoGpsWaypointResultData | undefined;
  gotoNavWaypoint?: GotoNavWaypointResultData | undefined;
  takePhoto?: TakePhotoResultData | undefined;
  surfaceScanSkill?: SurfaceScanResultData | undefined;
  startVideo?: StartVideoResultData | undefined;
  stopVideo?: StopVideoResultData | undefined;
  switchRecordingMode?: SwitchRecordingModeResultData | undefined;
  timedWait?: TimedWaitResultData | undefined;
  sequence?: SequenceResultData | undefined;
  orbitPoiAction?: OrbitPoiResultData | undefined;
  takePanorama?: TakePanoramaResultData | undefined;
  keyframeSkill?: KeyframeResultData | undefined;
  gotoWaypoint?: GotoWaypointResultData | undefined;
  setObstacleAvoidance?: SetObstacleAvoidanceResultData | undefined;
  initializeGps?: InitializeGpsResultData | undefined;
  subjectDetected?: SubjectDetectedResultData | undefined;
  looper?: LooperResultData | undefined;
  withinDistance?: WithinDistanceResultData | undefined;
  unifiedFollowAction?: UnifiedFollowResultData | undefined;
  inverter?: InverterResultData | undefined;
  togglePhotoIntervalMode?: TogglePhotoIntervalModeResultData | undefined;
  wifiScan?: WifiScanResultData | undefined;
  enableStrobeLights?: EnableStrobeLightsResultData | undefined;
  disableStrobeLights?: DisableStrobeLightsResultData | undefined;
  spoofJoysticksInputs?: SpoofJoysticksInputsResultData | undefined;
  updateJoysticksSettings?: UpdateJoysticksSettingsResultData | undefined;
  updateShapeMap?: UpdateShapeMapResultData | undefined;
  spoofObstacle?: SpoofObstacleResultData | undefined;
  dummyAction?: DummyResultData | undefined;
  testDesiredVelocityAction?: TestDesiredVelocityResultData | undefined;
  testTrackTrajectory?: TestTrackTrajectoryResultData | undefined;
  atvSubjectSpoofAction?: AtvSubjectSpoofResultData | undefined;
  skiSubjectSpoofAction?: SkiSubjectSpoofResultData | undefined;
  setGimbalOrientation?: SetGimbalOrientationResultData | undefined;
  parallel?: ParallelResultData | undefined;
  sequenceUntilSuccess?: SequenceUntilSuccessResultData | undefined;
  sequenceUntilFailure?: SequenceUntilFailureResultData | undefined;
  sequencePretakeoff?: SequencePretakeoffResultData | undefined;
  sequenceConfig?: SequenceConfigResultData | undefined;
  waitForRtk?: WaitForRtkResultData | undefined;
  wingWaypointsCommand?: WingWaypointsCommandResultData | undefined;
  sendDynamicScenario?: SendDynamicScenarioResultData | undefined;
  scoutAction?: ScoutActionResultData | undefined;
  spoofTrackingDevice?: SpoofTrackingDeviceResultData | undefined;
  spoofDisturbanceAction?: SpoofDisturbanceResultData | undefined;
  updateVehicleSettings?: UpdateVehicleSettingsResultData | undefined;
  waitForVehicleStop?: WaitForVehicleStopResultData | undefined;
  precomputedSubjectSpoofAction?: PrecomputedSubjectSpoofResultData | undefined;
  modifySimStateEstimation?: ModifySimStateEstimationResultData | undefined;
  gotoAndOrbitPoi?: GotoAndOrbitPoiResultData | undefined;
  acquireGps?: AcquireGpsResultData | undefined;
  setFaultOverride?: SetFaultOverrideResultData | undefined;
  eLand?: ELandResultData | undefined;
  trajectoryInspect?: TrajectoryInspectResultData | undefined;
  toggleTargetPointExposure?: ToggleTargetPointExposureResultData | undefined;
  toggleSemanticAim?: ToggleSemanticAimResultData | undefined;
  spoofBatteryLevel?: SpoofBatteryLevelResultData | undefined;
  ncpgControl?: NcpgControlResultData | undefined;
  registerComplimentaryActions?: RegisterComplimentaryActionsResultData | undefined;
  trackInPlace?: TrackInPlaceResultData | undefined;
  globalGraphControl?: GlobalGraphControlResultData | undefined;
  overrideGpsQuality?: OverrideGpsQualityResultData | undefined;
  initGlobalMap?: InitGlobalMapResultData | undefined;
  stopForPhotoInspect?: StopForPhotoInspectResultData | undefined;
  spoofInitialGpsHeading?: SpoofInitialGpsHeadingResultData | undefined;
  trackLandingPadRequest?: TrackLandingPadRequestResultData | undefined;
  apriltagSetId?: ApriltagSetIdResultData | undefined;
  dockGpsEstimator?: DockGpsEstimatorResultData | undefined;
  g47CommandOverride?: G47CommandOverrideResultData | undefined;
  requestTakeoffProfile?: RequestTakeoffProfileResultData | undefined;
  updateDockLocationAction?: UpdateDockLocationActionResultData | undefined;
  setDesiredGpsSource?: SetDesiredGpsSourceResultData | undefined;
  spoofManualGps?: SpoofManualGpsResultData | undefined;
  weatherAction?: WeatherActionResultData | undefined;
  setZoom?: SetZoomResultData | undefined;
  missionPlannerServiceControl?: MissionPlannerServiceControlResultData | undefined;
  spotlightAction?: SpotlightActionResultData | undefined;
  setCameraSettings?: SetCameraSettingsResultData | undefined;
  parachuteControl?: ParachuteControlResultData | undefined;
  nightsenseAction?: NightsenseActionResultData | undefined;
  spoofMultiDrone?: SpoofMultiDroneResultData | undefined;
  setMovementCommand?: SetMovementCommandResultData | undefined;
  spoofFlightEnvelopeLimits?: SpoofFlightEnvelopeLimitsResultData | undefined;
  turntable?: TurntableResultData | undefined;
  dancingDrone?: DancingDroneResultData | undefined;
  waitForPreciseFault?: WaitForPreciseFaultResultData | undefined;
  dancingDroneSpline?: DancingDroneSplineResultData | undefined;
  globalPlannerRequest?: GlobalPlannerRequestActionResultData | undefined;
  toggleSubjectDetection?: ToggleSubjectDetectionResultData | undefined;
  spoofSubjectScenario?: SpoofSubjectScenarioResultData | undefined;
  setSubjectFollowerSettings?: SetSubjectFollowerSettingsResultData | undefined;
  geofenceConfig?: GeofenceConfigResultData | undefined;
  setDesiredImuSource?: SetDesiredImuSourceResultData | undefined;
  sendMotionCommand?: SendMotionCommandResultData | undefined;
  setGnssSolverQuality?: SetGnssSolverQualityResultData | undefined;
  spoofPhoneUiVariablesAction?: SpoofPhoneUiVariablesResultData | undefined;
  playAudio?: PlayAudioResultData | undefined;
}

/**
 * NOTE(sam): These enums are stored as strings in the Cloud API database.
 * Don't change their names! Adding a new enum requires a migration
 */
export enum ActionResult_Result {
  /** UNKNOWN - This should never be in this state, something is wrong. */
  UNKNOWN = 0,
  /** SUCCESS - Action completed successfully */
  SUCCESS = 1,
  /** DID_NOT_RUN - Mission execution stopped before action was reached */
  DID_NOT_RUN = 8,
  /** SKIPPED - Action was skipped */
  SKIPPED = 2,
  /** FAILURE - Action failed to execute */
  FAILURE = 3,
  /**
   * FAILED_CANNOT_REACH_WAYPOINT - Failed to reach waypoint. Includes issues with the waypoint task creation and issues with
   * vehicle being stuck
   */
  FAILED_CANNOT_REACH_WAYPOINT = 4,
  /** FAILED_GPS_INITIALIZATION - Failed to initialize GPS */
  FAILED_GPS_INITIALIZATION = 5,
  /** FAILED_SWITCHING_RECORDING_MODE - Failed switching recording modes */
  FAILED_SWITCHING_RECORDING_MODE = 6,
  /** FAILED_PHOTO_CAPTURE - Failed to capture a photo */
  FAILED_PHOTO_CAPTURE = 7,
  /** FAILED_WAYPOINT_GEOFENCE - Failed to reach waypoint due to geofence */
  FAILED_WAYPOINT_GEOFENCE = 9,
  FAILED_ENABLING_STROBES = 10,
  FAILED_DISABLING_STROBES = 11,
  /** FAILED_WAYPOINT_REJECTED - Waypoint request was rejected by the waypoint navigation front */
  FAILED_WAYPOINT_REJECTED = 12,
  UNRECOGNIZED = -1,
}

export function actionResult_ResultFromJSON(object: any): ActionResult_Result {
  switch (object) {
    case 0:
    case "UNKNOWN":
      return ActionResult_Result.UNKNOWN;
    case 1:
    case "SUCCESS":
      return ActionResult_Result.SUCCESS;
    case 8:
    case "DID_NOT_RUN":
      return ActionResult_Result.DID_NOT_RUN;
    case 2:
    case "SKIPPED":
      return ActionResult_Result.SKIPPED;
    case 3:
    case "FAILURE":
      return ActionResult_Result.FAILURE;
    case 4:
    case "FAILED_CANNOT_REACH_WAYPOINT":
      return ActionResult_Result.FAILED_CANNOT_REACH_WAYPOINT;
    case 5:
    case "FAILED_GPS_INITIALIZATION":
      return ActionResult_Result.FAILED_GPS_INITIALIZATION;
    case 6:
    case "FAILED_SWITCHING_RECORDING_MODE":
      return ActionResult_Result.FAILED_SWITCHING_RECORDING_MODE;
    case 7:
    case "FAILED_PHOTO_CAPTURE":
      return ActionResult_Result.FAILED_PHOTO_CAPTURE;
    case 9:
    case "FAILED_WAYPOINT_GEOFENCE":
      return ActionResult_Result.FAILED_WAYPOINT_GEOFENCE;
    case 10:
    case "FAILED_ENABLING_STROBES":
      return ActionResult_Result.FAILED_ENABLING_STROBES;
    case 11:
    case "FAILED_DISABLING_STROBES":
      return ActionResult_Result.FAILED_DISABLING_STROBES;
    case 12:
    case "FAILED_WAYPOINT_REJECTED":
      return ActionResult_Result.FAILED_WAYPOINT_REJECTED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ActionResult_Result.UNRECOGNIZED;
  }
}

export function actionResult_ResultToJSON(object: ActionResult_Result): string {
  switch (object) {
    case ActionResult_Result.UNKNOWN:
      return "UNKNOWN";
    case ActionResult_Result.SUCCESS:
      return "SUCCESS";
    case ActionResult_Result.DID_NOT_RUN:
      return "DID_NOT_RUN";
    case ActionResult_Result.SKIPPED:
      return "SKIPPED";
    case ActionResult_Result.FAILURE:
      return "FAILURE";
    case ActionResult_Result.FAILED_CANNOT_REACH_WAYPOINT:
      return "FAILED_CANNOT_REACH_WAYPOINT";
    case ActionResult_Result.FAILED_GPS_INITIALIZATION:
      return "FAILED_GPS_INITIALIZATION";
    case ActionResult_Result.FAILED_SWITCHING_RECORDING_MODE:
      return "FAILED_SWITCHING_RECORDING_MODE";
    case ActionResult_Result.FAILED_PHOTO_CAPTURE:
      return "FAILED_PHOTO_CAPTURE";
    case ActionResult_Result.FAILED_WAYPOINT_GEOFENCE:
      return "FAILED_WAYPOINT_GEOFENCE";
    case ActionResult_Result.FAILED_ENABLING_STROBES:
      return "FAILED_ENABLING_STROBES";
    case ActionResult_Result.FAILED_DISABLING_STROBES:
      return "FAILED_DISABLING_STROBES";
    case ActionResult_Result.FAILED_WAYPOINT_REJECTED:
      return "FAILED_WAYPOINT_REJECTED";
    case ActionResult_Result.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/**
 * Published by the vehicle in flight-deck VehicleConfig, this indicates supported
 * action_keys and is used by Mobile to know how to represent an action in the UI and what
 * actions this vehicle supports
 */
export interface VehicleSupportedActions {
  /**
   * This is also used by the Client to determine which types of Actions it should allow
   * the user to create and allows us to maintain backwards compatibility with older
   * vehicle releases.
   */
  actionKeysArgs: { [key: string]: ActionArgs };
}

export interface VehicleSupportedActions_ActionKeysArgsEntry {
  key: string;
  value: ActionArgs | undefined;
}

/**
 * A saved / templated list of actions
 * This currently is only used by the Mobile Apps to store waypoints that the user might
 * create ahead of connecting and flying a vehicle and want to reuse flight-to-flight
 */
export interface MissionTemplate {
  /**
   * Unique identifier, must follow UUID4 protocol and sent in lower-case HEX format
   * so we can do string-comparisons e.g. "d1665ee05bb9431cad6d6188478e553e"
   */
  uuid: string;
  /** Some display name of this template. */
  displayName: string;
  /** List of Actions to be executed. */
  actions: Action[];
  /** Used however it makes sense on the client side. */
  templateVersion: string;
}

/** Action-Specific Definitions for Sequence action arguments. */
export interface SequenceActionArgs {
  /** Sequence name */
  name: string;
  /** List of actions to be executed in sequence */
  actions: Action[];
  /** If true, the UI button to reverse a sequence will be hidden */
  hideReverseUi: boolean;
}

export interface SequenceActionStateData {
  currentActionState:
    | ActionState
    | undefined;
  /** Index of the currently executing action in the sequence */
  currentActionIndex: number;
}

export interface SequenceUntilFailureActionStateData {
  currentActionState:
    | ActionState
    | undefined;
  /** Index of the currently executing action in the sequence */
  currentActionIndex: number;
}

export interface SequenceUntilSuccessActionStateData {
  currentActionState:
    | ActionState
    | undefined;
  /** Index of the currently executing action in the sequence */
  currentActionIndex: number;
}

export interface SequencePretakeoffActionStateData {
  currentActionState:
    | ActionState
    | undefined;
  /** Index of the currently executing action in the sequence */
  currentActionIndex: number;
}

export interface SequenceConfigActionStateData {
  currentActionState:
    | ActionState
    | undefined;
  /** Index of the currently executing action in the sequence */
  currentActionIndex: number;
}

export interface GotoAndOrbitPoiActionStateData {
  sequenceState: SequenceActionStateData | undefined;
}

export interface LooperActionArgs {
  /** Looper type */
  type: ControlNodeTypeEnum_Enum;
  /** name */
  name: string;
  /** Number of loops */
  maxLoops: number;
  /** Child action to be looped */
  action: Action | undefined;
}

export interface InverterActionArgs {
  /** Child action to be inverted */
  action: Action | undefined;
}

export interface EnableStrobeLightsActionArgs {
  noArgs: boolean;
}

export interface DisableStrobeLightsActionArgs {
  noArgs: boolean;
}

export interface EnableStrobeLightsResultData {
}

export interface DisableStrobeLightsResultData {
}

export interface EnableStrobeLightsActionStateData {
}

export interface DisableStrobeLightsActionStateData {
}

export interface NcpgWaypointInfo {
  /** NCPG waypoint in default nav frame */
  waypoint:
    | Waypoint
    | undefined;
  /** PoseId of reference pose */
  poseId:
    | PoseIdPb
    | undefined;
  /** Transform of the reference pose of the waypoint */
  defaultNavTReferencePose: TransPb | undefined;
}

export interface NcpgWaypointsRequest {
  utime: number;
  /** Largest key: 3. */
  ncpgWaypointInfos: NcpgWaypointInfo[];
}

/**
 * See:
 * - `convert_mission_with_ncpg_info_into_site_mission` in
 *   `vehicle/nav_cam_reconstruction/mission_ncpg_task_util.py`
 * - `cloud/temporal/workflows/ingest_ncpg/pbtypes/ingest_ncpg.proto`
 */
export interface ConvertMissionWithNCPGInfoIntoSiteMissionResultCode {
}

export enum ConvertMissionWithNCPGInfoIntoSiteMissionResultCode_Enum {
  /**
   * UNKNOWN - Having this allows to use in cloud API db if we ever need to store
   * it there.
   */
  UNKNOWN = 0,
  /**
   * SUCCESS - The mission waypoints all had ncpg infos and they were converted to
   * SITE frame.
   */
  SUCCESS = 1,
  /** INVALID_ARGUMENTS - Something is wrong with the input arguments. */
  INVALID_ARGUMENTS = 2,
  /** NOT_ALL_WAYPOINTS_HAVE_NCPG_INFO - At least one waypoint is missing ncpg info. */
  NOT_ALL_WAYPOINTS_HAVE_NCPG_INFO = 3,
  /** RUNTIME_CONVERSION_ERROR - Something unexpected occurred during conversion. */
  RUNTIME_CONVERSION_ERROR = 4,
  UNRECOGNIZED = -1,
}

export function convertMissionWithNCPGInfoIntoSiteMissionResultCode_EnumFromJSON(
  object: any,
): ConvertMissionWithNCPGInfoIntoSiteMissionResultCode_Enum {
  switch (object) {
    case 0:
    case "UNKNOWN":
      return ConvertMissionWithNCPGInfoIntoSiteMissionResultCode_Enum.UNKNOWN;
    case 1:
    case "SUCCESS":
      return ConvertMissionWithNCPGInfoIntoSiteMissionResultCode_Enum.SUCCESS;
    case 2:
    case "INVALID_ARGUMENTS":
      return ConvertMissionWithNCPGInfoIntoSiteMissionResultCode_Enum.INVALID_ARGUMENTS;
    case 3:
    case "NOT_ALL_WAYPOINTS_HAVE_NCPG_INFO":
      return ConvertMissionWithNCPGInfoIntoSiteMissionResultCode_Enum.NOT_ALL_WAYPOINTS_HAVE_NCPG_INFO;
    case 4:
    case "RUNTIME_CONVERSION_ERROR":
      return ConvertMissionWithNCPGInfoIntoSiteMissionResultCode_Enum.RUNTIME_CONVERSION_ERROR;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ConvertMissionWithNCPGInfoIntoSiteMissionResultCode_Enum.UNRECOGNIZED;
  }
}

export function convertMissionWithNCPGInfoIntoSiteMissionResultCode_EnumToJSON(
  object: ConvertMissionWithNCPGInfoIntoSiteMissionResultCode_Enum,
): string {
  switch (object) {
    case ConvertMissionWithNCPGInfoIntoSiteMissionResultCode_Enum.UNKNOWN:
      return "UNKNOWN";
    case ConvertMissionWithNCPGInfoIntoSiteMissionResultCode_Enum.SUCCESS:
      return "SUCCESS";
    case ConvertMissionWithNCPGInfoIntoSiteMissionResultCode_Enum.INVALID_ARGUMENTS:
      return "INVALID_ARGUMENTS";
    case ConvertMissionWithNCPGInfoIntoSiteMissionResultCode_Enum.NOT_ALL_WAYPOINTS_HAVE_NCPG_INFO:
      return "NOT_ALL_WAYPOINTS_HAVE_NCPG_INFO";
    case ConvertMissionWithNCPGInfoIntoSiteMissionResultCode_Enum.RUNTIME_CONVERSION_ERROR:
      return "RUNTIME_CONVERSION_ERROR";
    case ConvertMissionWithNCPGInfoIntoSiteMissionResultCode_Enum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

function createBaseMission(): Mission {
  return {
    utime: 0,
    uuid: "",
    displayName: "",
    templateUuid: "",
    actions: [],
    postMissionAction: 0,
    postFailureAction: 0,
    lostConnectionAction: 0,
    scheduledMissionUuid: "",
    missionRunnerSkill: 0,
    flightId: "",
    ncpgFileId: "",
    globalGraphFileId: "",
    dockMission: false,
    autoStart: false,
    needsGpsInitializationMove: false,
    returnToPathOnResume: false,
    showSkipUi: false,
    expectedGpsOrigin: undefined,
    useRecordingMode: false,
    recordingMode: 0,
    useIsoMode: false,
    isoMode: 0,
    useExposureMode: false,
    exposureMode: 0,
    useAwbMode: false,
    awbMode: 0,
    useCompensationMode: false,
    compensationMode: 0,
    autonomousAbortMissionOnFailedAction: false,
    enableFaultBasedDirectRtd: false,
    needsNcpgInitialization: false,
    videoBitrateOverride: 0,
    navigationModeOverrideEnabled: false,
    navigationModeOverride: 0,
    useRtxSettings: false,
    rtxSettings: undefined,
    needsGlobalGraph: false,
    estimateReferenceNavTNavTakeoff: undefined,
    disableStrobeLights: false,
    skipUpload: false,
    skipPausedState: false,
  };
}

export const Mission = {
  encode(message: Mission, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.utime !== 0) {
      writer.uint32(56).int64(message.utime);
    }
    if (message.uuid !== "") {
      writer.uint32(10).string(message.uuid);
    }
    if (message.displayName !== "") {
      writer.uint32(18).string(message.displayName);
    }
    if (message.templateUuid !== "") {
      writer.uint32(26).string(message.templateUuid);
    }
    for (const v of message.actions) {
      Action.encode(v!, writer.uint32(34).fork()).ldelim();
    }
    if (message.postMissionAction !== 0) {
      writer.uint32(40).int32(message.postMissionAction);
    }
    if (message.postFailureAction !== 0) {
      writer.uint32(72).int32(message.postFailureAction);
    }
    if (message.lostConnectionAction !== 0) {
      writer.uint32(48).int32(message.lostConnectionAction);
    }
    if (message.scheduledMissionUuid !== "") {
      writer.uint32(66).string(message.scheduledMissionUuid);
    }
    if (message.missionRunnerSkill !== 0) {
      writer.uint32(80).int32(message.missionRunnerSkill);
    }
    if (message.flightId !== "") {
      writer.uint32(90).string(message.flightId);
    }
    if (message.ncpgFileId !== "") {
      writer.uint32(98).string(message.ncpgFileId);
    }
    if (message.globalGraphFileId !== "") {
      writer.uint32(106).string(message.globalGraphFileId);
    }
    if (message.dockMission === true) {
      writer.uint32(800).bool(message.dockMission);
    }
    if (message.autoStart === true) {
      writer.uint32(808).bool(message.autoStart);
    }
    if (message.needsGpsInitializationMove === true) {
      writer.uint32(816).bool(message.needsGpsInitializationMove);
    }
    if (message.returnToPathOnResume === true) {
      writer.uint32(824).bool(message.returnToPathOnResume);
    }
    if (message.showSkipUi === true) {
      writer.uint32(840).bool(message.showSkipUi);
    }
    if (message.expectedGpsOrigin !== undefined) {
      GpsOriginInfo.encode(message.expectedGpsOrigin, writer.uint32(850).fork()).ldelim();
    }
    if (message.useRecordingMode === true) {
      writer.uint32(936).bool(message.useRecordingMode);
    }
    if (message.recordingMode !== 0) {
      writer.uint32(856).int32(message.recordingMode);
    }
    if (message.useIsoMode === true) {
      writer.uint32(960).bool(message.useIsoMode);
    }
    if (message.isoMode !== 0) {
      writer.uint32(968).int32(message.isoMode);
    }
    if (message.useExposureMode === true) {
      writer.uint32(976).bool(message.useExposureMode);
    }
    if (message.exposureMode !== 0) {
      writer.uint32(984).int32(message.exposureMode);
    }
    if (message.useAwbMode === true) {
      writer.uint32(992).bool(message.useAwbMode);
    }
    if (message.awbMode !== 0) {
      writer.uint32(1000).int32(message.awbMode);
    }
    if (message.useCompensationMode === true) {
      writer.uint32(1008).bool(message.useCompensationMode);
    }
    if (message.compensationMode !== 0) {
      writer.uint32(1016).int32(message.compensationMode);
    }
    if (message.autonomousAbortMissionOnFailedAction === true) {
      writer.uint32(872).bool(message.autonomousAbortMissionOnFailedAction);
    }
    if (message.enableFaultBasedDirectRtd === true) {
      writer.uint32(880).bool(message.enableFaultBasedDirectRtd);
    }
    if (message.needsNcpgInitialization === true) {
      writer.uint32(888).bool(message.needsNcpgInitialization);
    }
    if (message.videoBitrateOverride !== 0) {
      writer.uint32(896).int32(message.videoBitrateOverride);
    }
    if (message.navigationModeOverrideEnabled === true) {
      writer.uint32(904).bool(message.navigationModeOverrideEnabled);
    }
    if (message.navigationModeOverride !== 0) {
      writer.uint32(912).int32(message.navigationModeOverride);
    }
    if (message.useRtxSettings === true) {
      writer.uint32(920).bool(message.useRtxSettings);
    }
    if (message.rtxSettings !== undefined) {
      ReturnSettings.encode(message.rtxSettings, writer.uint32(930).fork()).ldelim();
    }
    if (message.needsGlobalGraph === true) {
      writer.uint32(944).bool(message.needsGlobalGraph);
    }
    if (message.estimateReferenceNavTNavTakeoff !== undefined) {
      TransPb.encode(message.estimateReferenceNavTNavTakeoff, writer.uint32(954).fork()).ldelim();
    }
    if (message.disableStrobeLights === true) {
      writer.uint32(1024).bool(message.disableStrobeLights);
    }
    if (message.skipUpload === true) {
      writer.uint32(1032).bool(message.skipUpload);
    }
    if (message.skipPausedState === true) {
      writer.uint32(1040).bool(message.skipPausedState);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Mission {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMission();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 7:
          if (tag !== 56) {
            break;
          }

          message.utime = longToNumber(reader.int64() as Long);
          continue;
        case 1:
          if (tag !== 10) {
            break;
          }

          message.uuid = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.displayName = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.templateUuid = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.actions.push(Action.decode(reader, reader.uint32()));
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }

          message.postMissionAction = reader.int32() as any;
          continue;
        case 9:
          if (tag !== 72) {
            break;
          }

          message.postFailureAction = reader.int32() as any;
          continue;
        case 6:
          if (tag !== 48) {
            break;
          }

          message.lostConnectionAction = reader.int32() as any;
          continue;
        case 8:
          if (tag !== 66) {
            break;
          }

          message.scheduledMissionUuid = reader.string();
          continue;
        case 10:
          if (tag !== 80) {
            break;
          }

          message.missionRunnerSkill = reader.int32() as any;
          continue;
        case 11:
          if (tag !== 90) {
            break;
          }

          message.flightId = reader.string();
          continue;
        case 12:
          if (tag !== 98) {
            break;
          }

          message.ncpgFileId = reader.string();
          continue;
        case 13:
          if (tag !== 106) {
            break;
          }

          message.globalGraphFileId = reader.string();
          continue;
        case 100:
          if (tag !== 800) {
            break;
          }

          message.dockMission = reader.bool();
          continue;
        case 101:
          if (tag !== 808) {
            break;
          }

          message.autoStart = reader.bool();
          continue;
        case 102:
          if (tag !== 816) {
            break;
          }

          message.needsGpsInitializationMove = reader.bool();
          continue;
        case 103:
          if (tag !== 824) {
            break;
          }

          message.returnToPathOnResume = reader.bool();
          continue;
        case 105:
          if (tag !== 840) {
            break;
          }

          message.showSkipUi = reader.bool();
          continue;
        case 106:
          if (tag !== 850) {
            break;
          }

          message.expectedGpsOrigin = GpsOriginInfo.decode(reader, reader.uint32());
          continue;
        case 117:
          if (tag !== 936) {
            break;
          }

          message.useRecordingMode = reader.bool();
          continue;
        case 107:
          if (tag !== 856) {
            break;
          }

          message.recordingMode = reader.int32() as any;
          continue;
        case 120:
          if (tag !== 960) {
            break;
          }

          message.useIsoMode = reader.bool();
          continue;
        case 121:
          if (tag !== 968) {
            break;
          }

          message.isoMode = reader.int32() as any;
          continue;
        case 122:
          if (tag !== 976) {
            break;
          }

          message.useExposureMode = reader.bool();
          continue;
        case 123:
          if (tag !== 984) {
            break;
          }

          message.exposureMode = reader.int32() as any;
          continue;
        case 124:
          if (tag !== 992) {
            break;
          }

          message.useAwbMode = reader.bool();
          continue;
        case 125:
          if (tag !== 1000) {
            break;
          }

          message.awbMode = reader.int32() as any;
          continue;
        case 126:
          if (tag !== 1008) {
            break;
          }

          message.useCompensationMode = reader.bool();
          continue;
        case 127:
          if (tag !== 1016) {
            break;
          }

          message.compensationMode = reader.int32() as any;
          continue;
        case 109:
          if (tag !== 872) {
            break;
          }

          message.autonomousAbortMissionOnFailedAction = reader.bool();
          continue;
        case 110:
          if (tag !== 880) {
            break;
          }

          message.enableFaultBasedDirectRtd = reader.bool();
          continue;
        case 111:
          if (tag !== 888) {
            break;
          }

          message.needsNcpgInitialization = reader.bool();
          continue;
        case 112:
          if (tag !== 896) {
            break;
          }

          message.videoBitrateOverride = reader.int32();
          continue;
        case 113:
          if (tag !== 904) {
            break;
          }

          message.navigationModeOverrideEnabled = reader.bool();
          continue;
        case 114:
          if (tag !== 912) {
            break;
          }

          message.navigationModeOverride = reader.int32() as any;
          continue;
        case 115:
          if (tag !== 920) {
            break;
          }

          message.useRtxSettings = reader.bool();
          continue;
        case 116:
          if (tag !== 930) {
            break;
          }

          message.rtxSettings = ReturnSettings.decode(reader, reader.uint32());
          continue;
        case 118:
          if (tag !== 944) {
            break;
          }

          message.needsGlobalGraph = reader.bool();
          continue;
        case 119:
          if (tag !== 954) {
            break;
          }

          message.estimateReferenceNavTNavTakeoff = TransPb.decode(reader, reader.uint32());
          continue;
        case 128:
          if (tag !== 1024) {
            break;
          }

          message.disableStrobeLights = reader.bool();
          continue;
        case 129:
          if (tag !== 1032) {
            break;
          }

          message.skipUpload = reader.bool();
          continue;
        case 130:
          if (tag !== 1040) {
            break;
          }

          message.skipPausedState = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Mission {
    return {
      utime: isSet(object.utime) ? globalThis.Number(object.utime) : 0,
      uuid: isSet(object.uuid) ? globalThis.String(object.uuid) : "",
      displayName: isSet(object.displayName) ? globalThis.String(object.displayName) : "",
      templateUuid: isSet(object.templateUuid) ? globalThis.String(object.templateUuid) : "",
      actions: globalThis.Array.isArray(object?.actions) ? object.actions.map((e: any) => Action.fromJSON(e)) : [],
      postMissionAction: isSet(object.postMissionAction)
        ? postMissionActionEnum_EnumFromJSON(object.postMissionAction)
        : 0,
      postFailureAction: isSet(object.postFailureAction)
        ? postMissionActionEnum_EnumFromJSON(object.postFailureAction)
        : 0,
      lostConnectionAction: isSet(object.lostConnectionAction)
        ? lostConnectionActionEnum_EnumFromJSON(object.lostConnectionAction)
        : 0,
      scheduledMissionUuid: isSet(object.scheduledMissionUuid) ? globalThis.String(object.scheduledMissionUuid) : "",
      missionRunnerSkill: isSet(object.missionRunnerSkill)
        ? missionSkillEnum_EnumFromJSON(object.missionRunnerSkill)
        : 0,
      flightId: isSet(object.flightId) ? globalThis.String(object.flightId) : "",
      ncpgFileId: isSet(object.ncpgFileId) ? globalThis.String(object.ncpgFileId) : "",
      globalGraphFileId: isSet(object.globalGraphFileId) ? globalThis.String(object.globalGraphFileId) : "",
      dockMission: isSet(object.dockMission) ? globalThis.Boolean(object.dockMission) : false,
      autoStart: isSet(object.autoStart) ? globalThis.Boolean(object.autoStart) : false,
      needsGpsInitializationMove: isSet(object.needsGpsInitializationMove)
        ? globalThis.Boolean(object.needsGpsInitializationMove)
        : false,
      returnToPathOnResume: isSet(object.returnToPathOnResume)
        ? globalThis.Boolean(object.returnToPathOnResume)
        : false,
      showSkipUi: isSet(object.showSkipUi) ? globalThis.Boolean(object.showSkipUi) : false,
      expectedGpsOrigin: isSet(object.expectedGpsOrigin) ? GpsOriginInfo.fromJSON(object.expectedGpsOrigin) : undefined,
      useRecordingMode: isSet(object.useRecordingMode) ? globalThis.Boolean(object.useRecordingMode) : false,
      recordingMode: isSet(object.recordingMode) ? recordingMode_EnumFromJSON(object.recordingMode) : 0,
      useIsoMode: isSet(object.useIsoMode) ? globalThis.Boolean(object.useIsoMode) : false,
      isoMode: isSet(object.isoMode) ? isoMode_EnumFromJSON(object.isoMode) : 0,
      useExposureMode: isSet(object.useExposureMode) ? globalThis.Boolean(object.useExposureMode) : false,
      exposureMode: isSet(object.exposureMode) ? exposureMode_EnumFromJSON(object.exposureMode) : 0,
      useAwbMode: isSet(object.useAwbMode) ? globalThis.Boolean(object.useAwbMode) : false,
      awbMode: isSet(object.awbMode) ? awbMode_EnumFromJSON(object.awbMode) : 0,
      useCompensationMode: isSet(object.useCompensationMode) ? globalThis.Boolean(object.useCompensationMode) : false,
      compensationMode: isSet(object.compensationMode) ? compensationMode_EnumFromJSON(object.compensationMode) : 0,
      autonomousAbortMissionOnFailedAction: isSet(object.autonomousAbortMissionOnFailedAction)
        ? globalThis.Boolean(object.autonomousAbortMissionOnFailedAction)
        : false,
      enableFaultBasedDirectRtd: isSet(object.enableFaultBasedDirectRtd)
        ? globalThis.Boolean(object.enableFaultBasedDirectRtd)
        : false,
      needsNcpgInitialization: isSet(object.needsNcpgInitialization)
        ? globalThis.Boolean(object.needsNcpgInitialization)
        : false,
      videoBitrateOverride: isSet(object.videoBitrateOverride) ? globalThis.Number(object.videoBitrateOverride) : 0,
      navigationModeOverrideEnabled: isSet(object.navigationModeOverrideEnabled)
        ? globalThis.Boolean(object.navigationModeOverrideEnabled)
        : false,
      navigationModeOverride: isSet(object.navigationModeOverride)
        ? navigationMode_ModeFromJSON(object.navigationModeOverride)
        : 0,
      useRtxSettings: isSet(object.useRtxSettings) ? globalThis.Boolean(object.useRtxSettings) : false,
      rtxSettings: isSet(object.rtxSettings) ? ReturnSettings.fromJSON(object.rtxSettings) : undefined,
      needsGlobalGraph: isSet(object.needsGlobalGraph) ? globalThis.Boolean(object.needsGlobalGraph) : false,
      estimateReferenceNavTNavTakeoff: isSet(object.estimateReferenceNavTNavTakeoff)
        ? TransPb.fromJSON(object.estimateReferenceNavTNavTakeoff)
        : undefined,
      disableStrobeLights: isSet(object.disableStrobeLights) ? globalThis.Boolean(object.disableStrobeLights) : false,
      skipUpload: isSet(object.skipUpload) ? globalThis.Boolean(object.skipUpload) : false,
      skipPausedState: isSet(object.skipPausedState) ? globalThis.Boolean(object.skipPausedState) : false,
    };
  },

  toJSON(message: Mission): unknown {
    const obj: any = {};
    if (message.utime !== 0) {
      obj.utime = Math.round(message.utime);
    }
    if (message.uuid !== "") {
      obj.uuid = message.uuid;
    }
    if (message.displayName !== "") {
      obj.displayName = message.displayName;
    }
    if (message.templateUuid !== "") {
      obj.templateUuid = message.templateUuid;
    }
    if (message.actions?.length) {
      obj.actions = message.actions.map((e) => Action.toJSON(e));
    }
    if (message.postMissionAction !== 0) {
      obj.postMissionAction = postMissionActionEnum_EnumToJSON(message.postMissionAction);
    }
    if (message.postFailureAction !== 0) {
      obj.postFailureAction = postMissionActionEnum_EnumToJSON(message.postFailureAction);
    }
    if (message.lostConnectionAction !== 0) {
      obj.lostConnectionAction = lostConnectionActionEnum_EnumToJSON(message.lostConnectionAction);
    }
    if (message.scheduledMissionUuid !== "") {
      obj.scheduledMissionUuid = message.scheduledMissionUuid;
    }
    if (message.missionRunnerSkill !== 0) {
      obj.missionRunnerSkill = missionSkillEnum_EnumToJSON(message.missionRunnerSkill);
    }
    if (message.flightId !== "") {
      obj.flightId = message.flightId;
    }
    if (message.ncpgFileId !== "") {
      obj.ncpgFileId = message.ncpgFileId;
    }
    if (message.globalGraphFileId !== "") {
      obj.globalGraphFileId = message.globalGraphFileId;
    }
    if (message.dockMission === true) {
      obj.dockMission = message.dockMission;
    }
    if (message.autoStart === true) {
      obj.autoStart = message.autoStart;
    }
    if (message.needsGpsInitializationMove === true) {
      obj.needsGpsInitializationMove = message.needsGpsInitializationMove;
    }
    if (message.returnToPathOnResume === true) {
      obj.returnToPathOnResume = message.returnToPathOnResume;
    }
    if (message.showSkipUi === true) {
      obj.showSkipUi = message.showSkipUi;
    }
    if (message.expectedGpsOrigin !== undefined) {
      obj.expectedGpsOrigin = GpsOriginInfo.toJSON(message.expectedGpsOrigin);
    }
    if (message.useRecordingMode === true) {
      obj.useRecordingMode = message.useRecordingMode;
    }
    if (message.recordingMode !== 0) {
      obj.recordingMode = recordingMode_EnumToJSON(message.recordingMode);
    }
    if (message.useIsoMode === true) {
      obj.useIsoMode = message.useIsoMode;
    }
    if (message.isoMode !== 0) {
      obj.isoMode = isoMode_EnumToJSON(message.isoMode);
    }
    if (message.useExposureMode === true) {
      obj.useExposureMode = message.useExposureMode;
    }
    if (message.exposureMode !== 0) {
      obj.exposureMode = exposureMode_EnumToJSON(message.exposureMode);
    }
    if (message.useAwbMode === true) {
      obj.useAwbMode = message.useAwbMode;
    }
    if (message.awbMode !== 0) {
      obj.awbMode = awbMode_EnumToJSON(message.awbMode);
    }
    if (message.useCompensationMode === true) {
      obj.useCompensationMode = message.useCompensationMode;
    }
    if (message.compensationMode !== 0) {
      obj.compensationMode = compensationMode_EnumToJSON(message.compensationMode);
    }
    if (message.autonomousAbortMissionOnFailedAction === true) {
      obj.autonomousAbortMissionOnFailedAction = message.autonomousAbortMissionOnFailedAction;
    }
    if (message.enableFaultBasedDirectRtd === true) {
      obj.enableFaultBasedDirectRtd = message.enableFaultBasedDirectRtd;
    }
    if (message.needsNcpgInitialization === true) {
      obj.needsNcpgInitialization = message.needsNcpgInitialization;
    }
    if (message.videoBitrateOverride !== 0) {
      obj.videoBitrateOverride = Math.round(message.videoBitrateOverride);
    }
    if (message.navigationModeOverrideEnabled === true) {
      obj.navigationModeOverrideEnabled = message.navigationModeOverrideEnabled;
    }
    if (message.navigationModeOverride !== 0) {
      obj.navigationModeOverride = navigationMode_ModeToJSON(message.navigationModeOverride);
    }
    if (message.useRtxSettings === true) {
      obj.useRtxSettings = message.useRtxSettings;
    }
    if (message.rtxSettings !== undefined) {
      obj.rtxSettings = ReturnSettings.toJSON(message.rtxSettings);
    }
    if (message.needsGlobalGraph === true) {
      obj.needsGlobalGraph = message.needsGlobalGraph;
    }
    if (message.estimateReferenceNavTNavTakeoff !== undefined) {
      obj.estimateReferenceNavTNavTakeoff = TransPb.toJSON(message.estimateReferenceNavTNavTakeoff);
    }
    if (message.disableStrobeLights === true) {
      obj.disableStrobeLights = message.disableStrobeLights;
    }
    if (message.skipUpload === true) {
      obj.skipUpload = message.skipUpload;
    }
    if (message.skipPausedState === true) {
      obj.skipPausedState = message.skipPausedState;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Mission>, I>>(base?: I): Mission {
    return Mission.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Mission>, I>>(object: I): Mission {
    const message = createBaseMission();
    message.utime = object.utime ?? 0;
    message.uuid = object.uuid ?? "";
    message.displayName = object.displayName ?? "";
    message.templateUuid = object.templateUuid ?? "";
    message.actions = object.actions?.map((e) => Action.fromPartial(e)) || [];
    message.postMissionAction = object.postMissionAction ?? 0;
    message.postFailureAction = object.postFailureAction ?? 0;
    message.lostConnectionAction = object.lostConnectionAction ?? 0;
    message.scheduledMissionUuid = object.scheduledMissionUuid ?? "";
    message.missionRunnerSkill = object.missionRunnerSkill ?? 0;
    message.flightId = object.flightId ?? "";
    message.ncpgFileId = object.ncpgFileId ?? "";
    message.globalGraphFileId = object.globalGraphFileId ?? "";
    message.dockMission = object.dockMission ?? false;
    message.autoStart = object.autoStart ?? false;
    message.needsGpsInitializationMove = object.needsGpsInitializationMove ?? false;
    message.returnToPathOnResume = object.returnToPathOnResume ?? false;
    message.showSkipUi = object.showSkipUi ?? false;
    message.expectedGpsOrigin = (object.expectedGpsOrigin !== undefined && object.expectedGpsOrigin !== null)
      ? GpsOriginInfo.fromPartial(object.expectedGpsOrigin)
      : undefined;
    message.useRecordingMode = object.useRecordingMode ?? false;
    message.recordingMode = object.recordingMode ?? 0;
    message.useIsoMode = object.useIsoMode ?? false;
    message.isoMode = object.isoMode ?? 0;
    message.useExposureMode = object.useExposureMode ?? false;
    message.exposureMode = object.exposureMode ?? 0;
    message.useAwbMode = object.useAwbMode ?? false;
    message.awbMode = object.awbMode ?? 0;
    message.useCompensationMode = object.useCompensationMode ?? false;
    message.compensationMode = object.compensationMode ?? 0;
    message.autonomousAbortMissionOnFailedAction = object.autonomousAbortMissionOnFailedAction ?? false;
    message.enableFaultBasedDirectRtd = object.enableFaultBasedDirectRtd ?? false;
    message.needsNcpgInitialization = object.needsNcpgInitialization ?? false;
    message.videoBitrateOverride = object.videoBitrateOverride ?? 0;
    message.navigationModeOverrideEnabled = object.navigationModeOverrideEnabled ?? false;
    message.navigationModeOverride = object.navigationModeOverride ?? 0;
    message.useRtxSettings = object.useRtxSettings ?? false;
    message.rtxSettings = (object.rtxSettings !== undefined && object.rtxSettings !== null)
      ? ReturnSettings.fromPartial(object.rtxSettings)
      : undefined;
    message.needsGlobalGraph = object.needsGlobalGraph ?? false;
    message.estimateReferenceNavTNavTakeoff =
      (object.estimateReferenceNavTNavTakeoff !== undefined && object.estimateReferenceNavTNavTakeoff !== null)
        ? TransPb.fromPartial(object.estimateReferenceNavTNavTakeoff)
        : undefined;
    message.disableStrobeLights = object.disableStrobeLights ?? false;
    message.skipUpload = object.skipUpload ?? false;
    message.skipPausedState = object.skipPausedState ?? false;
    return message;
  },
};

function createBaseGpsOriginInfo(): GpsOriginInfo {
  return { lat: 0, lon: 0, gpsAltitude: 0, gpsHeading: 0 };
}

export const GpsOriginInfo = {
  encode(message: GpsOriginInfo, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.lat !== 0) {
      writer.uint32(9).double(message.lat);
    }
    if (message.lon !== 0) {
      writer.uint32(17).double(message.lon);
    }
    if (message.gpsAltitude !== 0) {
      writer.uint32(25).double(message.gpsAltitude);
    }
    if (message.gpsHeading !== 0) {
      writer.uint32(33).double(message.gpsHeading);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GpsOriginInfo {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGpsOriginInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 9) {
            break;
          }

          message.lat = reader.double();
          continue;
        case 2:
          if (tag !== 17) {
            break;
          }

          message.lon = reader.double();
          continue;
        case 3:
          if (tag !== 25) {
            break;
          }

          message.gpsAltitude = reader.double();
          continue;
        case 4:
          if (tag !== 33) {
            break;
          }

          message.gpsHeading = reader.double();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GpsOriginInfo {
    return {
      lat: isSet(object.lat) ? globalThis.Number(object.lat) : 0,
      lon: isSet(object.lon) ? globalThis.Number(object.lon) : 0,
      gpsAltitude: isSet(object.gpsAltitude) ? globalThis.Number(object.gpsAltitude) : 0,
      gpsHeading: isSet(object.gpsHeading) ? globalThis.Number(object.gpsHeading) : 0,
    };
  },

  toJSON(message: GpsOriginInfo): unknown {
    const obj: any = {};
    if (message.lat !== 0) {
      obj.lat = message.lat;
    }
    if (message.lon !== 0) {
      obj.lon = message.lon;
    }
    if (message.gpsAltitude !== 0) {
      obj.gpsAltitude = message.gpsAltitude;
    }
    if (message.gpsHeading !== 0) {
      obj.gpsHeading = message.gpsHeading;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GpsOriginInfo>, I>>(base?: I): GpsOriginInfo {
    return GpsOriginInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GpsOriginInfo>, I>>(object: I): GpsOriginInfo {
    const message = createBaseGpsOriginInfo();
    message.lat = object.lat ?? 0;
    message.lon = object.lon ?? 0;
    message.gpsAltitude = object.gpsAltitude ?? 0;
    message.gpsHeading = object.gpsHeading ?? 0;
    return message;
  },
};

function createBasePostMissionActionEnum(): PostMissionActionEnum {
  return {};
}

export const PostMissionActionEnum = {
  encode(_: PostMissionActionEnum, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): PostMissionActionEnum {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePostMissionActionEnum();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): PostMissionActionEnum {
    return {};
  },

  toJSON(_: PostMissionActionEnum): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<PostMissionActionEnum>, I>>(base?: I): PostMissionActionEnum {
    return PostMissionActionEnum.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PostMissionActionEnum>, I>>(_: I): PostMissionActionEnum {
    const message = createBasePostMissionActionEnum();
    return message;
  },
};

function createBaseMissionSkillEnum(): MissionSkillEnum {
  return {};
}

export const MissionSkillEnum = {
  encode(_: MissionSkillEnum, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): MissionSkillEnum {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMissionSkillEnum();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): MissionSkillEnum {
    return {};
  },

  toJSON(_: MissionSkillEnum): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<MissionSkillEnum>, I>>(base?: I): MissionSkillEnum {
    return MissionSkillEnum.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MissionSkillEnum>, I>>(_: I): MissionSkillEnum {
    const message = createBaseMissionSkillEnum();
    return message;
  },
};

function createBaseLostConnectionActionEnum(): LostConnectionActionEnum {
  return {};
}

export const LostConnectionActionEnum = {
  encode(_: LostConnectionActionEnum, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): LostConnectionActionEnum {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLostConnectionActionEnum();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): LostConnectionActionEnum {
    return {};
  },

  toJSON(_: LostConnectionActionEnum): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<LostConnectionActionEnum>, I>>(base?: I): LostConnectionActionEnum {
    return LostConnectionActionEnum.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LostConnectionActionEnum>, I>>(_: I): LostConnectionActionEnum {
    const message = createBaseLostConnectionActionEnum();
    return message;
  },
};

function createBaseMissionTierTypeEnum(): MissionTierTypeEnum {
  return {};
}

export const MissionTierTypeEnum = {
  encode(_: MissionTierTypeEnum, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): MissionTierTypeEnum {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMissionTierTypeEnum();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): MissionTierTypeEnum {
    return {};
  },

  toJSON(_: MissionTierTypeEnum): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<MissionTierTypeEnum>, I>>(base?: I): MissionTierTypeEnum {
    return MissionTierTypeEnum.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MissionTierTypeEnum>, I>>(_: I): MissionTierTypeEnum {
    const message = createBaseMissionTierTypeEnum();
    return message;
  },
};

function createBaseMissionResponse(): MissionResponse {
  return { utime: 0, uuid: "", requestAccepted: false };
}

export const MissionResponse = {
  encode(message: MissionResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.utime !== 0) {
      writer.uint32(8).int64(message.utime);
    }
    if (message.uuid !== "") {
      writer.uint32(18).string(message.uuid);
    }
    if (message.requestAccepted === true) {
      writer.uint32(24).bool(message.requestAccepted);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): MissionResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMissionResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.utime = longToNumber(reader.int64() as Long);
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.uuid = reader.string();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.requestAccepted = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MissionResponse {
    return {
      utime: isSet(object.utime) ? globalThis.Number(object.utime) : 0,
      uuid: isSet(object.uuid) ? globalThis.String(object.uuid) : "",
      requestAccepted: isSet(object.requestAccepted) ? globalThis.Boolean(object.requestAccepted) : false,
    };
  },

  toJSON(message: MissionResponse): unknown {
    const obj: any = {};
    if (message.utime !== 0) {
      obj.utime = Math.round(message.utime);
    }
    if (message.uuid !== "") {
      obj.uuid = message.uuid;
    }
    if (message.requestAccepted === true) {
      obj.requestAccepted = message.requestAccepted;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MissionResponse>, I>>(base?: I): MissionResponse {
    return MissionResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MissionResponse>, I>>(object: I): MissionResponse {
    const message = createBaseMissionResponse();
    message.utime = object.utime ?? 0;
    message.uuid = object.uuid ?? "";
    message.requestAccepted = object.requestAccepted ?? false;
    return message;
  },
};

function createBaseAction(): Action {
  return { actionUuid: "", actionKey: "", args: undefined };
}

export const Action = {
  encode(message: Action, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.actionUuid !== "") {
      writer.uint32(10).string(message.actionUuid);
    }
    if (message.actionKey !== "") {
      writer.uint32(18).string(message.actionKey);
    }
    if (message.args !== undefined) {
      ActionArgs.encode(message.args, writer.uint32(26).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Action {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAction();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.actionUuid = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.actionKey = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.args = ActionArgs.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Action {
    return {
      actionUuid: isSet(object.actionUuid) ? globalThis.String(object.actionUuid) : "",
      actionKey: isSet(object.actionKey) ? globalThis.String(object.actionKey) : "",
      args: isSet(object.args) ? ActionArgs.fromJSON(object.args) : undefined,
    };
  },

  toJSON(message: Action): unknown {
    const obj: any = {};
    if (message.actionUuid !== "") {
      obj.actionUuid = message.actionUuid;
    }
    if (message.actionKey !== "") {
      obj.actionKey = message.actionKey;
    }
    if (message.args !== undefined) {
      obj.args = ActionArgs.toJSON(message.args);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Action>, I>>(base?: I): Action {
    return Action.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Action>, I>>(object: I): Action {
    const message = createBaseAction();
    message.actionUuid = object.actionUuid ?? "";
    message.actionKey = object.actionKey ?? "";
    message.args = (object.args !== undefined && object.args !== null)
      ? ActionArgs.fromPartial(object.args)
      : undefined;
    return message;
  },
};

function createBaseActionArgs(): ActionArgs {
  return {
    json: undefined,
    gotoGpsWaypoint: undefined,
    gotoNavWaypoint: undefined,
    takePhoto: undefined,
    surfaceScanSkill: undefined,
    startVideo: undefined,
    stopVideo: undefined,
    switchRecordingMode: undefined,
    timedWait: undefined,
    sequence: undefined,
    orbitPoiAction: undefined,
    takePanorama: undefined,
    keyframeAction: undefined,
    gotoWaypoint: undefined,
    setObstacleAvoidance: undefined,
    initializeGps: undefined,
    conditional: undefined,
    looper: undefined,
    withinDistance: undefined,
    unifiedFollow: undefined,
    inverter: undefined,
    togglePhotoIntervalMode: undefined,
    wifiScan: undefined,
    enableStrobeLights: undefined,
    disableStrobeLights: undefined,
    spoofJoysticksInputs: undefined,
    updateJoysticksSettings: undefined,
    updateShapeMap: undefined,
    spoofObstacle: undefined,
    spoofDisturbanceAction: undefined,
    updateVehicleSettings: undefined,
    waitForVehicleStop: undefined,
    precomputedSubjectSpoofAction: undefined,
    modifySimStateEstimation: undefined,
    gotoAndOrbitPoi: undefined,
    acquireGps: undefined,
    setFaultOverride: undefined,
    eLand: undefined,
    trajectoryInspect: undefined,
    toggleTargetPointExposure: undefined,
    toggleSemanticAim: undefined,
    spoofBatteryLevel: undefined,
    ncpgControl: undefined,
    registerComplimentaryActions: undefined,
    trackInPlace: undefined,
    globalGraphControl: undefined,
    overrideGpsQuality: undefined,
    initGlobalMap: undefined,
    stopForPhotoInspect: undefined,
    spoofInitialGpsHeading: undefined,
    trackLandingPadRequest: undefined,
    apriltagSetId: undefined,
    dockGpsEstimator: undefined,
    g47CommandOverride: undefined,
    requestTakeoffProfile: undefined,
    setDesiredGpsSource: undefined,
    spoofManualGps: undefined,
    weatherAction: undefined,
    setZoom: undefined,
    missionPlannerServiceControl: undefined,
    spotlightAction: undefined,
    setCameraSettings: undefined,
    parachuteControl: undefined,
    nightsenseAction: undefined,
    spoofMultiDrone: undefined,
    setMovementCommand: undefined,
    spoofFlightEnvelopeLimits: undefined,
    turntable: undefined,
    waitForRtk: undefined,
    wingWaypointsCommand: undefined,
    dancingDrone: undefined,
    waitForPreciseFault: undefined,
    dancingDroneSpline: undefined,
    sendDynamicScenario: undefined,
    globalPlannerRequest: undefined,
    toggleSubjectDetection: undefined,
    spoofSubjectScenario: undefined,
    setSubjectFollowerSettings: undefined,
    scoutAction: undefined,
    spoofTrackingDevice: undefined,
    geofenceConfig: undefined,
    setDesiredImuSource: undefined,
    setGnssSolverQuality: undefined,
    sendMotionCommand: undefined,
    spoofPhoneUiVariablesAction: undefined,
    playAudio: undefined,
    dummy: undefined,
    testDesiredVelocity: undefined,
    testTrackTrajectory: undefined,
    atvSubjectSpoofAction: undefined,
    skiSubjectSpoofAction: undefined,
    setGimbal: undefined,
    updateDockLocationAction: undefined,
    photoOnCompletion: false,
    isSkippable: false,
  };
}

export const ActionArgs = {
  encode(message: ActionArgs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.json !== undefined) {
      writer.uint32(10).string(message.json);
    }
    if (message.gotoGpsWaypoint !== undefined) {
      GotoGpsWaypointActionArgs.encode(message.gotoGpsWaypoint, writer.uint32(18).fork()).ldelim();
    }
    if (message.gotoNavWaypoint !== undefined) {
      GotoNavWaypointActionArgs.encode(message.gotoNavWaypoint, writer.uint32(26).fork()).ldelim();
    }
    if (message.takePhoto !== undefined) {
      TakePhotoActionArgs.encode(message.takePhoto, writer.uint32(34).fork()).ldelim();
    }
    if (message.surfaceScanSkill !== undefined) {
      SurfaceScanActionArgs.encode(message.surfaceScanSkill, writer.uint32(42).fork()).ldelim();
    }
    if (message.startVideo !== undefined) {
      StartVideoActionArgs.encode(message.startVideo, writer.uint32(50).fork()).ldelim();
    }
    if (message.stopVideo !== undefined) {
      StopVideoActionArgs.encode(message.stopVideo, writer.uint32(58).fork()).ldelim();
    }
    if (message.switchRecordingMode !== undefined) {
      SwitchRecordingModeActionArgs.encode(message.switchRecordingMode, writer.uint32(66).fork()).ldelim();
    }
    if (message.timedWait !== undefined) {
      TimedWaitActionArgs.encode(message.timedWait, writer.uint32(74).fork()).ldelim();
    }
    if (message.sequence !== undefined) {
      SequenceActionArgs.encode(message.sequence, writer.uint32(82).fork()).ldelim();
    }
    if (message.orbitPoiAction !== undefined) {
      OrbitPoiActionArgs.encode(message.orbitPoiAction, writer.uint32(90).fork()).ldelim();
    }
    if (message.takePanorama !== undefined) {
      TakePanoramaActionArgs.encode(message.takePanorama, writer.uint32(98).fork()).ldelim();
    }
    if (message.keyframeAction !== undefined) {
      KeyframeActionArgs.encode(message.keyframeAction, writer.uint32(106).fork()).ldelim();
    }
    if (message.gotoWaypoint !== undefined) {
      GotoWaypointActionArgs.encode(message.gotoWaypoint, writer.uint32(114).fork()).ldelim();
    }
    if (message.setObstacleAvoidance !== undefined) {
      SetObstacleAvoidanceActionArgs.encode(message.setObstacleAvoidance, writer.uint32(122).fork()).ldelim();
    }
    if (message.initializeGps !== undefined) {
      InitializeGpsActionArgs.encode(message.initializeGps, writer.uint32(130).fork()).ldelim();
    }
    if (message.conditional !== undefined) {
      ConditionalActionArgs.encode(message.conditional, writer.uint32(138).fork()).ldelim();
    }
    if (message.looper !== undefined) {
      LooperActionArgs.encode(message.looper, writer.uint32(146).fork()).ldelim();
    }
    if (message.withinDistance !== undefined) {
      WithinDistanceActionArgs.encode(message.withinDistance, writer.uint32(154).fork()).ldelim();
    }
    if (message.unifiedFollow !== undefined) {
      UnifiedFollowActionArgs.encode(message.unifiedFollow, writer.uint32(162).fork()).ldelim();
    }
    if (message.inverter !== undefined) {
      InverterActionArgs.encode(message.inverter, writer.uint32(170).fork()).ldelim();
    }
    if (message.togglePhotoIntervalMode !== undefined) {
      TogglePhotoIntervalModeActionArgs.encode(message.togglePhotoIntervalMode, writer.uint32(178).fork()).ldelim();
    }
    if (message.wifiScan !== undefined) {
      WifiScanActionArgs.encode(message.wifiScan, writer.uint32(186).fork()).ldelim();
    }
    if (message.enableStrobeLights !== undefined) {
      EnableStrobeLightsActionArgs.encode(message.enableStrobeLights, writer.uint32(194).fork()).ldelim();
    }
    if (message.disableStrobeLights !== undefined) {
      DisableStrobeLightsActionArgs.encode(message.disableStrobeLights, writer.uint32(202).fork()).ldelim();
    }
    if (message.spoofJoysticksInputs !== undefined) {
      SpoofJoysticksInputsActionArgs.encode(message.spoofJoysticksInputs, writer.uint32(210).fork()).ldelim();
    }
    if (message.updateJoysticksSettings !== undefined) {
      UpdateJoysticksSettingsActionArgs.encode(message.updateJoysticksSettings, writer.uint32(218).fork()).ldelim();
    }
    if (message.updateShapeMap !== undefined) {
      UpdateShapeMapActionArgs.encode(message.updateShapeMap, writer.uint32(226).fork()).ldelim();
    }
    if (message.spoofObstacle !== undefined) {
      SpoofObstacleActionArgs.encode(message.spoofObstacle, writer.uint32(234).fork()).ldelim();
    }
    if (message.spoofDisturbanceAction !== undefined) {
      SpoofDisturbanceActionActionArgs.encode(message.spoofDisturbanceAction, writer.uint32(242).fork()).ldelim();
    }
    if (message.updateVehicleSettings !== undefined) {
      UpdateVehicleSettingsActionArgs.encode(message.updateVehicleSettings, writer.uint32(250).fork()).ldelim();
    }
    if (message.waitForVehicleStop !== undefined) {
      WaitForVehicleStopActionArgs.encode(message.waitForVehicleStop, writer.uint32(258).fork()).ldelim();
    }
    if (message.precomputedSubjectSpoofAction !== undefined) {
      PrecomputedSubjectSpoofActionArgs.encode(message.precomputedSubjectSpoofAction, writer.uint32(266).fork())
        .ldelim();
    }
    if (message.modifySimStateEstimation !== undefined) {
      ModifySimStateEstimationActionArgs.encode(message.modifySimStateEstimation, writer.uint32(274).fork()).ldelim();
    }
    if (message.gotoAndOrbitPoi !== undefined) {
      GotoAndOrbitPoiActionArgs.encode(message.gotoAndOrbitPoi, writer.uint32(282).fork()).ldelim();
    }
    if (message.acquireGps !== undefined) {
      AcquireGpsActionArgs.encode(message.acquireGps, writer.uint32(290).fork()).ldelim();
    }
    if (message.setFaultOverride !== undefined) {
      SetFaultOverrideActionArgs.encode(message.setFaultOverride, writer.uint32(298).fork()).ldelim();
    }
    if (message.eLand !== undefined) {
      ELandActionArgs.encode(message.eLand, writer.uint32(306).fork()).ldelim();
    }
    if (message.trajectoryInspect !== undefined) {
      TrajectoryInspectActionArgs.encode(message.trajectoryInspect, writer.uint32(314).fork()).ldelim();
    }
    if (message.toggleTargetPointExposure !== undefined) {
      ToggleTargetPointExposureActionArgs.encode(message.toggleTargetPointExposure, writer.uint32(322).fork()).ldelim();
    }
    if (message.toggleSemanticAim !== undefined) {
      ToggleSemanticAimActionArgs.encode(message.toggleSemanticAim, writer.uint32(330).fork()).ldelim();
    }
    if (message.spoofBatteryLevel !== undefined) {
      SpoofBatteryLevelActionArgs.encode(message.spoofBatteryLevel, writer.uint32(338).fork()).ldelim();
    }
    if (message.ncpgControl !== undefined) {
      NcpgControlActionArgs.encode(message.ncpgControl, writer.uint32(346).fork()).ldelim();
    }
    if (message.registerComplimentaryActions !== undefined) {
      RegisterComplimentaryActionsActionArgs.encode(message.registerComplimentaryActions, writer.uint32(354).fork())
        .ldelim();
    }
    if (message.trackInPlace !== undefined) {
      TrackInPlaceActionArgs.encode(message.trackInPlace, writer.uint32(362).fork()).ldelim();
    }
    if (message.globalGraphControl !== undefined) {
      GlobalGraphControlActionArgs.encode(message.globalGraphControl, writer.uint32(370).fork()).ldelim();
    }
    if (message.overrideGpsQuality !== undefined) {
      OverrideGpsQualityActionArgs.encode(message.overrideGpsQuality, writer.uint32(378).fork()).ldelim();
    }
    if (message.initGlobalMap !== undefined) {
      InitGlobalMapActionArgs.encode(message.initGlobalMap, writer.uint32(386).fork()).ldelim();
    }
    if (message.stopForPhotoInspect !== undefined) {
      StopForPhotoInspectActionArgs.encode(message.stopForPhotoInspect, writer.uint32(394).fork()).ldelim();
    }
    if (message.spoofInitialGpsHeading !== undefined) {
      SpoofInitialGpsHeadingActionArgs.encode(message.spoofInitialGpsHeading, writer.uint32(402).fork()).ldelim();
    }
    if (message.trackLandingPadRequest !== undefined) {
      TrackLandingPadRequestActionArgs.encode(message.trackLandingPadRequest, writer.uint32(410).fork()).ldelim();
    }
    if (message.apriltagSetId !== undefined) {
      ApriltagSetIdActionArgs.encode(message.apriltagSetId, writer.uint32(418).fork()).ldelim();
    }
    if (message.dockGpsEstimator !== undefined) {
      DockGpsEstimatorActionArgs.encode(message.dockGpsEstimator, writer.uint32(426).fork()).ldelim();
    }
    if (message.g47CommandOverride !== undefined) {
      G47CommandOverrideActionArgs.encode(message.g47CommandOverride, writer.uint32(434).fork()).ldelim();
    }
    if (message.requestTakeoffProfile !== undefined) {
      RequestTakeoffProfileActionArgs.encode(message.requestTakeoffProfile, writer.uint32(442).fork()).ldelim();
    }
    if (message.setDesiredGpsSource !== undefined) {
      SetDesiredGpsSourceActionArgs.encode(message.setDesiredGpsSource, writer.uint32(450).fork()).ldelim();
    }
    if (message.spoofManualGps !== undefined) {
      SpoofManualGpsActionArgs.encode(message.spoofManualGps, writer.uint32(458).fork()).ldelim();
    }
    if (message.weatherAction !== undefined) {
      WeatherActionArgs.encode(message.weatherAction, writer.uint32(466).fork()).ldelim();
    }
    if (message.setZoom !== undefined) {
      SetZoomActionArgs.encode(message.setZoom, writer.uint32(474).fork()).ldelim();
    }
    if (message.missionPlannerServiceControl !== undefined) {
      MissionPlannerServiceControlActionArgs.encode(message.missionPlannerServiceControl, writer.uint32(482).fork())
        .ldelim();
    }
    if (message.spotlightAction !== undefined) {
      SpotlightActionArgs.encode(message.spotlightAction, writer.uint32(490).fork()).ldelim();
    }
    if (message.setCameraSettings !== undefined) {
      SetCameraSettingsActionArgs.encode(message.setCameraSettings, writer.uint32(498).fork()).ldelim();
    }
    if (message.parachuteControl !== undefined) {
      ParachuteControlActionArgs.encode(message.parachuteControl, writer.uint32(506).fork()).ldelim();
    }
    if (message.nightsenseAction !== undefined) {
      NightsenseActionArgs.encode(message.nightsenseAction, writer.uint32(514).fork()).ldelim();
    }
    if (message.spoofMultiDrone !== undefined) {
      SpoofMultiDroneActionArgs.encode(message.spoofMultiDrone, writer.uint32(522).fork()).ldelim();
    }
    if (message.setMovementCommand !== undefined) {
      SetMovementCommandActionArgs.encode(message.setMovementCommand, writer.uint32(530).fork()).ldelim();
    }
    if (message.spoofFlightEnvelopeLimits !== undefined) {
      SpoofFlightEnvelopeLimitsActionArgs.encode(message.spoofFlightEnvelopeLimits, writer.uint32(538).fork()).ldelim();
    }
    if (message.turntable !== undefined) {
      TurntableActionArgs.encode(message.turntable, writer.uint32(546).fork()).ldelim();
    }
    if (message.waitForRtk !== undefined) {
      WaitForRtkActionArgs.encode(message.waitForRtk, writer.uint32(554).fork()).ldelim();
    }
    if (message.wingWaypointsCommand !== undefined) {
      WingWaypointsCommandActionArgs.encode(message.wingWaypointsCommand, writer.uint32(562).fork()).ldelim();
    }
    if (message.dancingDrone !== undefined) {
      DancingDroneActionArgs.encode(message.dancingDrone, writer.uint32(570).fork()).ldelim();
    }
    if (message.waitForPreciseFault !== undefined) {
      WaitForPreciseFaultActionArgs.encode(message.waitForPreciseFault, writer.uint32(578).fork()).ldelim();
    }
    if (message.dancingDroneSpline !== undefined) {
      DancingDroneSplineActionArgs.encode(message.dancingDroneSpline, writer.uint32(586).fork()).ldelim();
    }
    if (message.sendDynamicScenario !== undefined) {
      SendDynamicScenarioActionArgs.encode(message.sendDynamicScenario, writer.uint32(594).fork()).ldelim();
    }
    if (message.globalPlannerRequest !== undefined) {
      GlobalPlannerRequestActionArgs.encode(message.globalPlannerRequest, writer.uint32(602).fork()).ldelim();
    }
    if (message.toggleSubjectDetection !== undefined) {
      ToggleSubjectDetectionActionArgs.encode(message.toggleSubjectDetection, writer.uint32(610).fork()).ldelim();
    }
    if (message.spoofSubjectScenario !== undefined) {
      SpoofSubjectScenarioActionArgs.encode(message.spoofSubjectScenario, writer.uint32(618).fork()).ldelim();
    }
    if (message.setSubjectFollowerSettings !== undefined) {
      SetSubjectFollowerSettingsActionArgs.encode(message.setSubjectFollowerSettings, writer.uint32(626).fork())
        .ldelim();
    }
    if (message.scoutAction !== undefined) {
      ScoutActionActionArgs.encode(message.scoutAction, writer.uint32(634).fork()).ldelim();
    }
    if (message.spoofTrackingDevice !== undefined) {
      SpoofTrackingDeviceActionArgs.encode(message.spoofTrackingDevice, writer.uint32(642).fork()).ldelim();
    }
    if (message.geofenceConfig !== undefined) {
      GeofenceConfigActionArgs.encode(message.geofenceConfig, writer.uint32(650).fork()).ldelim();
    }
    if (message.setDesiredImuSource !== undefined) {
      SetDesiredImuSourceActionArgs.encode(message.setDesiredImuSource, writer.uint32(658).fork()).ldelim();
    }
    if (message.setGnssSolverQuality !== undefined) {
      SetGnssSolverQualityActionArgs.encode(message.setGnssSolverQuality, writer.uint32(666).fork()).ldelim();
    }
    if (message.sendMotionCommand !== undefined) {
      SendMotionCommandActionArgs.encode(message.sendMotionCommand, writer.uint32(674).fork()).ldelim();
    }
    if (message.spoofPhoneUiVariablesAction !== undefined) {
      SpoofPhoneUiVariablesActionArgs.encode(message.spoofPhoneUiVariablesAction, writer.uint32(682).fork()).ldelim();
    }
    if (message.playAudio !== undefined) {
      PlayAudioActionArgs.encode(message.playAudio, writer.uint32(690).fork()).ldelim();
    }
    if (message.dummy !== undefined) {
      DummyActionArgs.encode(message.dummy, writer.uint32(7202).fork()).ldelim();
    }
    if (message.testDesiredVelocity !== undefined) {
      TestDesiredVelocityActionArgs.encode(message.testDesiredVelocity, writer.uint32(7210).fork()).ldelim();
    }
    if (message.testTrackTrajectory !== undefined) {
      TestTrackTrajectoryActionArgs.encode(message.testTrackTrajectory, writer.uint32(7218).fork()).ldelim();
    }
    if (message.atvSubjectSpoofAction !== undefined) {
      AtvSubjectSpoofActionArgs.encode(message.atvSubjectSpoofAction, writer.uint32(7234).fork()).ldelim();
    }
    if (message.skiSubjectSpoofAction !== undefined) {
      SkiSubjectSpoofActionArgs.encode(message.skiSubjectSpoofAction, writer.uint32(7242).fork()).ldelim();
    }
    if (message.setGimbal !== undefined) {
      SetGimbalOrientationArgs.encode(message.setGimbal, writer.uint32(7250).fork()).ldelim();
    }
    if (message.updateDockLocationAction !== undefined) {
      UpdateDockLocationActionArgs.encode(message.updateDockLocationAction, writer.uint32(7258).fork()).ldelim();
    }
    if (message.photoOnCompletion === true) {
      writer.uint32(800).bool(message.photoOnCompletion);
    }
    if (message.isSkippable === true) {
      writer.uint32(808).bool(message.isSkippable);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ActionArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseActionArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.json = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.gotoGpsWaypoint = GotoGpsWaypointActionArgs.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.gotoNavWaypoint = GotoNavWaypointActionArgs.decode(reader, reader.uint32());
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.takePhoto = TakePhotoActionArgs.decode(reader, reader.uint32());
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.surfaceScanSkill = SurfaceScanActionArgs.decode(reader, reader.uint32());
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.startVideo = StartVideoActionArgs.decode(reader, reader.uint32());
          continue;
        case 7:
          if (tag !== 58) {
            break;
          }

          message.stopVideo = StopVideoActionArgs.decode(reader, reader.uint32());
          continue;
        case 8:
          if (tag !== 66) {
            break;
          }

          message.switchRecordingMode = SwitchRecordingModeActionArgs.decode(reader, reader.uint32());
          continue;
        case 9:
          if (tag !== 74) {
            break;
          }

          message.timedWait = TimedWaitActionArgs.decode(reader, reader.uint32());
          continue;
        case 10:
          if (tag !== 82) {
            break;
          }

          message.sequence = SequenceActionArgs.decode(reader, reader.uint32());
          continue;
        case 11:
          if (tag !== 90) {
            break;
          }

          message.orbitPoiAction = OrbitPoiActionArgs.decode(reader, reader.uint32());
          continue;
        case 12:
          if (tag !== 98) {
            break;
          }

          message.takePanorama = TakePanoramaActionArgs.decode(reader, reader.uint32());
          continue;
        case 13:
          if (tag !== 106) {
            break;
          }

          message.keyframeAction = KeyframeActionArgs.decode(reader, reader.uint32());
          continue;
        case 14:
          if (tag !== 114) {
            break;
          }

          message.gotoWaypoint = GotoWaypointActionArgs.decode(reader, reader.uint32());
          continue;
        case 15:
          if (tag !== 122) {
            break;
          }

          message.setObstacleAvoidance = SetObstacleAvoidanceActionArgs.decode(reader, reader.uint32());
          continue;
        case 16:
          if (tag !== 130) {
            break;
          }

          message.initializeGps = InitializeGpsActionArgs.decode(reader, reader.uint32());
          continue;
        case 17:
          if (tag !== 138) {
            break;
          }

          message.conditional = ConditionalActionArgs.decode(reader, reader.uint32());
          continue;
        case 18:
          if (tag !== 146) {
            break;
          }

          message.looper = LooperActionArgs.decode(reader, reader.uint32());
          continue;
        case 19:
          if (tag !== 154) {
            break;
          }

          message.withinDistance = WithinDistanceActionArgs.decode(reader, reader.uint32());
          continue;
        case 20:
          if (tag !== 162) {
            break;
          }

          message.unifiedFollow = UnifiedFollowActionArgs.decode(reader, reader.uint32());
          continue;
        case 21:
          if (tag !== 170) {
            break;
          }

          message.inverter = InverterActionArgs.decode(reader, reader.uint32());
          continue;
        case 22:
          if (tag !== 178) {
            break;
          }

          message.togglePhotoIntervalMode = TogglePhotoIntervalModeActionArgs.decode(reader, reader.uint32());
          continue;
        case 23:
          if (tag !== 186) {
            break;
          }

          message.wifiScan = WifiScanActionArgs.decode(reader, reader.uint32());
          continue;
        case 24:
          if (tag !== 194) {
            break;
          }

          message.enableStrobeLights = EnableStrobeLightsActionArgs.decode(reader, reader.uint32());
          continue;
        case 25:
          if (tag !== 202) {
            break;
          }

          message.disableStrobeLights = DisableStrobeLightsActionArgs.decode(reader, reader.uint32());
          continue;
        case 26:
          if (tag !== 210) {
            break;
          }

          message.spoofJoysticksInputs = SpoofJoysticksInputsActionArgs.decode(reader, reader.uint32());
          continue;
        case 27:
          if (tag !== 218) {
            break;
          }

          message.updateJoysticksSettings = UpdateJoysticksSettingsActionArgs.decode(reader, reader.uint32());
          continue;
        case 28:
          if (tag !== 226) {
            break;
          }

          message.updateShapeMap = UpdateShapeMapActionArgs.decode(reader, reader.uint32());
          continue;
        case 29:
          if (tag !== 234) {
            break;
          }

          message.spoofObstacle = SpoofObstacleActionArgs.decode(reader, reader.uint32());
          continue;
        case 30:
          if (tag !== 242) {
            break;
          }

          message.spoofDisturbanceAction = SpoofDisturbanceActionActionArgs.decode(reader, reader.uint32());
          continue;
        case 31:
          if (tag !== 250) {
            break;
          }

          message.updateVehicleSettings = UpdateVehicleSettingsActionArgs.decode(reader, reader.uint32());
          continue;
        case 32:
          if (tag !== 258) {
            break;
          }

          message.waitForVehicleStop = WaitForVehicleStopActionArgs.decode(reader, reader.uint32());
          continue;
        case 33:
          if (tag !== 266) {
            break;
          }

          message.precomputedSubjectSpoofAction = PrecomputedSubjectSpoofActionArgs.decode(reader, reader.uint32());
          continue;
        case 34:
          if (tag !== 274) {
            break;
          }

          message.modifySimStateEstimation = ModifySimStateEstimationActionArgs.decode(reader, reader.uint32());
          continue;
        case 35:
          if (tag !== 282) {
            break;
          }

          message.gotoAndOrbitPoi = GotoAndOrbitPoiActionArgs.decode(reader, reader.uint32());
          continue;
        case 36:
          if (tag !== 290) {
            break;
          }

          message.acquireGps = AcquireGpsActionArgs.decode(reader, reader.uint32());
          continue;
        case 37:
          if (tag !== 298) {
            break;
          }

          message.setFaultOverride = SetFaultOverrideActionArgs.decode(reader, reader.uint32());
          continue;
        case 38:
          if (tag !== 306) {
            break;
          }

          message.eLand = ELandActionArgs.decode(reader, reader.uint32());
          continue;
        case 39:
          if (tag !== 314) {
            break;
          }

          message.trajectoryInspect = TrajectoryInspectActionArgs.decode(reader, reader.uint32());
          continue;
        case 40:
          if (tag !== 322) {
            break;
          }

          message.toggleTargetPointExposure = ToggleTargetPointExposureActionArgs.decode(reader, reader.uint32());
          continue;
        case 41:
          if (tag !== 330) {
            break;
          }

          message.toggleSemanticAim = ToggleSemanticAimActionArgs.decode(reader, reader.uint32());
          continue;
        case 42:
          if (tag !== 338) {
            break;
          }

          message.spoofBatteryLevel = SpoofBatteryLevelActionArgs.decode(reader, reader.uint32());
          continue;
        case 43:
          if (tag !== 346) {
            break;
          }

          message.ncpgControl = NcpgControlActionArgs.decode(reader, reader.uint32());
          continue;
        case 44:
          if (tag !== 354) {
            break;
          }

          message.registerComplimentaryActions = RegisterComplimentaryActionsActionArgs.decode(reader, reader.uint32());
          continue;
        case 45:
          if (tag !== 362) {
            break;
          }

          message.trackInPlace = TrackInPlaceActionArgs.decode(reader, reader.uint32());
          continue;
        case 46:
          if (tag !== 370) {
            break;
          }

          message.globalGraphControl = GlobalGraphControlActionArgs.decode(reader, reader.uint32());
          continue;
        case 47:
          if (tag !== 378) {
            break;
          }

          message.overrideGpsQuality = OverrideGpsQualityActionArgs.decode(reader, reader.uint32());
          continue;
        case 48:
          if (tag !== 386) {
            break;
          }

          message.initGlobalMap = InitGlobalMapActionArgs.decode(reader, reader.uint32());
          continue;
        case 49:
          if (tag !== 394) {
            break;
          }

          message.stopForPhotoInspect = StopForPhotoInspectActionArgs.decode(reader, reader.uint32());
          continue;
        case 50:
          if (tag !== 402) {
            break;
          }

          message.spoofInitialGpsHeading = SpoofInitialGpsHeadingActionArgs.decode(reader, reader.uint32());
          continue;
        case 51:
          if (tag !== 410) {
            break;
          }

          message.trackLandingPadRequest = TrackLandingPadRequestActionArgs.decode(reader, reader.uint32());
          continue;
        case 52:
          if (tag !== 418) {
            break;
          }

          message.apriltagSetId = ApriltagSetIdActionArgs.decode(reader, reader.uint32());
          continue;
        case 53:
          if (tag !== 426) {
            break;
          }

          message.dockGpsEstimator = DockGpsEstimatorActionArgs.decode(reader, reader.uint32());
          continue;
        case 54:
          if (tag !== 434) {
            break;
          }

          message.g47CommandOverride = G47CommandOverrideActionArgs.decode(reader, reader.uint32());
          continue;
        case 55:
          if (tag !== 442) {
            break;
          }

          message.requestTakeoffProfile = RequestTakeoffProfileActionArgs.decode(reader, reader.uint32());
          continue;
        case 56:
          if (tag !== 450) {
            break;
          }

          message.setDesiredGpsSource = SetDesiredGpsSourceActionArgs.decode(reader, reader.uint32());
          continue;
        case 57:
          if (tag !== 458) {
            break;
          }

          message.spoofManualGps = SpoofManualGpsActionArgs.decode(reader, reader.uint32());
          continue;
        case 58:
          if (tag !== 466) {
            break;
          }

          message.weatherAction = WeatherActionArgs.decode(reader, reader.uint32());
          continue;
        case 59:
          if (tag !== 474) {
            break;
          }

          message.setZoom = SetZoomActionArgs.decode(reader, reader.uint32());
          continue;
        case 60:
          if (tag !== 482) {
            break;
          }

          message.missionPlannerServiceControl = MissionPlannerServiceControlActionArgs.decode(reader, reader.uint32());
          continue;
        case 61:
          if (tag !== 490) {
            break;
          }

          message.spotlightAction = SpotlightActionArgs.decode(reader, reader.uint32());
          continue;
        case 62:
          if (tag !== 498) {
            break;
          }

          message.setCameraSettings = SetCameraSettingsActionArgs.decode(reader, reader.uint32());
          continue;
        case 63:
          if (tag !== 506) {
            break;
          }

          message.parachuteControl = ParachuteControlActionArgs.decode(reader, reader.uint32());
          continue;
        case 64:
          if (tag !== 514) {
            break;
          }

          message.nightsenseAction = NightsenseActionArgs.decode(reader, reader.uint32());
          continue;
        case 65:
          if (tag !== 522) {
            break;
          }

          message.spoofMultiDrone = SpoofMultiDroneActionArgs.decode(reader, reader.uint32());
          continue;
        case 66:
          if (tag !== 530) {
            break;
          }

          message.setMovementCommand = SetMovementCommandActionArgs.decode(reader, reader.uint32());
          continue;
        case 67:
          if (tag !== 538) {
            break;
          }

          message.spoofFlightEnvelopeLimits = SpoofFlightEnvelopeLimitsActionArgs.decode(reader, reader.uint32());
          continue;
        case 68:
          if (tag !== 546) {
            break;
          }

          message.turntable = TurntableActionArgs.decode(reader, reader.uint32());
          continue;
        case 69:
          if (tag !== 554) {
            break;
          }

          message.waitForRtk = WaitForRtkActionArgs.decode(reader, reader.uint32());
          continue;
        case 70:
          if (tag !== 562) {
            break;
          }

          message.wingWaypointsCommand = WingWaypointsCommandActionArgs.decode(reader, reader.uint32());
          continue;
        case 71:
          if (tag !== 570) {
            break;
          }

          message.dancingDrone = DancingDroneActionArgs.decode(reader, reader.uint32());
          continue;
        case 72:
          if (tag !== 578) {
            break;
          }

          message.waitForPreciseFault = WaitForPreciseFaultActionArgs.decode(reader, reader.uint32());
          continue;
        case 73:
          if (tag !== 586) {
            break;
          }

          message.dancingDroneSpline = DancingDroneSplineActionArgs.decode(reader, reader.uint32());
          continue;
        case 74:
          if (tag !== 594) {
            break;
          }

          message.sendDynamicScenario = SendDynamicScenarioActionArgs.decode(reader, reader.uint32());
          continue;
        case 75:
          if (tag !== 602) {
            break;
          }

          message.globalPlannerRequest = GlobalPlannerRequestActionArgs.decode(reader, reader.uint32());
          continue;
        case 76:
          if (tag !== 610) {
            break;
          }

          message.toggleSubjectDetection = ToggleSubjectDetectionActionArgs.decode(reader, reader.uint32());
          continue;
        case 77:
          if (tag !== 618) {
            break;
          }

          message.spoofSubjectScenario = SpoofSubjectScenarioActionArgs.decode(reader, reader.uint32());
          continue;
        case 78:
          if (tag !== 626) {
            break;
          }

          message.setSubjectFollowerSettings = SetSubjectFollowerSettingsActionArgs.decode(reader, reader.uint32());
          continue;
        case 79:
          if (tag !== 634) {
            break;
          }

          message.scoutAction = ScoutActionActionArgs.decode(reader, reader.uint32());
          continue;
        case 80:
          if (tag !== 642) {
            break;
          }

          message.spoofTrackingDevice = SpoofTrackingDeviceActionArgs.decode(reader, reader.uint32());
          continue;
        case 81:
          if (tag !== 650) {
            break;
          }

          message.geofenceConfig = GeofenceConfigActionArgs.decode(reader, reader.uint32());
          continue;
        case 82:
          if (tag !== 658) {
            break;
          }

          message.setDesiredImuSource = SetDesiredImuSourceActionArgs.decode(reader, reader.uint32());
          continue;
        case 83:
          if (tag !== 666) {
            break;
          }

          message.setGnssSolverQuality = SetGnssSolverQualityActionArgs.decode(reader, reader.uint32());
          continue;
        case 84:
          if (tag !== 674) {
            break;
          }

          message.sendMotionCommand = SendMotionCommandActionArgs.decode(reader, reader.uint32());
          continue;
        case 85:
          if (tag !== 682) {
            break;
          }

          message.spoofPhoneUiVariablesAction = SpoofPhoneUiVariablesActionArgs.decode(reader, reader.uint32());
          continue;
        case 86:
          if (tag !== 690) {
            break;
          }

          message.playAudio = PlayAudioActionArgs.decode(reader, reader.uint32());
          continue;
        case 900:
          if (tag !== 7202) {
            break;
          }

          message.dummy = DummyActionArgs.decode(reader, reader.uint32());
          continue;
        case 901:
          if (tag !== 7210) {
            break;
          }

          message.testDesiredVelocity = TestDesiredVelocityActionArgs.decode(reader, reader.uint32());
          continue;
        case 902:
          if (tag !== 7218) {
            break;
          }

          message.testTrackTrajectory = TestTrackTrajectoryActionArgs.decode(reader, reader.uint32());
          continue;
        case 904:
          if (tag !== 7234) {
            break;
          }

          message.atvSubjectSpoofAction = AtvSubjectSpoofActionArgs.decode(reader, reader.uint32());
          continue;
        case 905:
          if (tag !== 7242) {
            break;
          }

          message.skiSubjectSpoofAction = SkiSubjectSpoofActionArgs.decode(reader, reader.uint32());
          continue;
        case 906:
          if (tag !== 7250) {
            break;
          }

          message.setGimbal = SetGimbalOrientationArgs.decode(reader, reader.uint32());
          continue;
        case 907:
          if (tag !== 7258) {
            break;
          }

          message.updateDockLocationAction = UpdateDockLocationActionArgs.decode(reader, reader.uint32());
          continue;
        case 100:
          if (tag !== 800) {
            break;
          }

          message.photoOnCompletion = reader.bool();
          continue;
        case 101:
          if (tag !== 808) {
            break;
          }

          message.isSkippable = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ActionArgs {
    return {
      json: isSet(object.json) ? globalThis.String(object.json) : undefined,
      gotoGpsWaypoint: isSet(object.gotoGpsWaypoint)
        ? GotoGpsWaypointActionArgs.fromJSON(object.gotoGpsWaypoint)
        : undefined,
      gotoNavWaypoint: isSet(object.gotoNavWaypoint)
        ? GotoNavWaypointActionArgs.fromJSON(object.gotoNavWaypoint)
        : undefined,
      takePhoto: isSet(object.takePhoto) ? TakePhotoActionArgs.fromJSON(object.takePhoto) : undefined,
      surfaceScanSkill: isSet(object.surfaceScanSkill)
        ? SurfaceScanActionArgs.fromJSON(object.surfaceScanSkill)
        : undefined,
      startVideo: isSet(object.startVideo) ? StartVideoActionArgs.fromJSON(object.startVideo) : undefined,
      stopVideo: isSet(object.stopVideo) ? StopVideoActionArgs.fromJSON(object.stopVideo) : undefined,
      switchRecordingMode: isSet(object.switchRecordingMode)
        ? SwitchRecordingModeActionArgs.fromJSON(object.switchRecordingMode)
        : undefined,
      timedWait: isSet(object.timedWait) ? TimedWaitActionArgs.fromJSON(object.timedWait) : undefined,
      sequence: isSet(object.sequence) ? SequenceActionArgs.fromJSON(object.sequence) : undefined,
      orbitPoiAction: isSet(object.orbitPoiAction) ? OrbitPoiActionArgs.fromJSON(object.orbitPoiAction) : undefined,
      takePanorama: isSet(object.takePanorama) ? TakePanoramaActionArgs.fromJSON(object.takePanorama) : undefined,
      keyframeAction: isSet(object.keyframeAction) ? KeyframeActionArgs.fromJSON(object.keyframeAction) : undefined,
      gotoWaypoint: isSet(object.gotoWaypoint) ? GotoWaypointActionArgs.fromJSON(object.gotoWaypoint) : undefined,
      setObstacleAvoidance: isSet(object.setObstacleAvoidance)
        ? SetObstacleAvoidanceActionArgs.fromJSON(object.setObstacleAvoidance)
        : undefined,
      initializeGps: isSet(object.initializeGps) ? InitializeGpsActionArgs.fromJSON(object.initializeGps) : undefined,
      conditional: isSet(object.conditional) ? ConditionalActionArgs.fromJSON(object.conditional) : undefined,
      looper: isSet(object.looper) ? LooperActionArgs.fromJSON(object.looper) : undefined,
      withinDistance: isSet(object.withinDistance)
        ? WithinDistanceActionArgs.fromJSON(object.withinDistance)
        : undefined,
      unifiedFollow: isSet(object.unifiedFollow) ? UnifiedFollowActionArgs.fromJSON(object.unifiedFollow) : undefined,
      inverter: isSet(object.inverter) ? InverterActionArgs.fromJSON(object.inverter) : undefined,
      togglePhotoIntervalMode: isSet(object.togglePhotoIntervalMode)
        ? TogglePhotoIntervalModeActionArgs.fromJSON(object.togglePhotoIntervalMode)
        : undefined,
      wifiScan: isSet(object.wifiScan) ? WifiScanActionArgs.fromJSON(object.wifiScan) : undefined,
      enableStrobeLights: isSet(object.enableStrobeLights)
        ? EnableStrobeLightsActionArgs.fromJSON(object.enableStrobeLights)
        : undefined,
      disableStrobeLights: isSet(object.disableStrobeLights)
        ? DisableStrobeLightsActionArgs.fromJSON(object.disableStrobeLights)
        : undefined,
      spoofJoysticksInputs: isSet(object.spoofJoysticksInputs)
        ? SpoofJoysticksInputsActionArgs.fromJSON(object.spoofJoysticksInputs)
        : undefined,
      updateJoysticksSettings: isSet(object.updateJoysticksSettings)
        ? UpdateJoysticksSettingsActionArgs.fromJSON(object.updateJoysticksSettings)
        : undefined,
      updateShapeMap: isSet(object.updateShapeMap)
        ? UpdateShapeMapActionArgs.fromJSON(object.updateShapeMap)
        : undefined,
      spoofObstacle: isSet(object.spoofObstacle) ? SpoofObstacleActionArgs.fromJSON(object.spoofObstacle) : undefined,
      spoofDisturbanceAction: isSet(object.spoofDisturbanceAction)
        ? SpoofDisturbanceActionActionArgs.fromJSON(object.spoofDisturbanceAction)
        : undefined,
      updateVehicleSettings: isSet(object.updateVehicleSettings)
        ? UpdateVehicleSettingsActionArgs.fromJSON(object.updateVehicleSettings)
        : undefined,
      waitForVehicleStop: isSet(object.waitForVehicleStop)
        ? WaitForVehicleStopActionArgs.fromJSON(object.waitForVehicleStop)
        : undefined,
      precomputedSubjectSpoofAction: isSet(object.precomputedSubjectSpoofAction)
        ? PrecomputedSubjectSpoofActionArgs.fromJSON(object.precomputedSubjectSpoofAction)
        : undefined,
      modifySimStateEstimation: isSet(object.modifySimStateEstimation)
        ? ModifySimStateEstimationActionArgs.fromJSON(object.modifySimStateEstimation)
        : undefined,
      gotoAndOrbitPoi: isSet(object.gotoAndOrbitPoi)
        ? GotoAndOrbitPoiActionArgs.fromJSON(object.gotoAndOrbitPoi)
        : undefined,
      acquireGps: isSet(object.acquireGps) ? AcquireGpsActionArgs.fromJSON(object.acquireGps) : undefined,
      setFaultOverride: isSet(object.setFaultOverride)
        ? SetFaultOverrideActionArgs.fromJSON(object.setFaultOverride)
        : undefined,
      eLand: isSet(object.eLand) ? ELandActionArgs.fromJSON(object.eLand) : undefined,
      trajectoryInspect: isSet(object.trajectoryInspect)
        ? TrajectoryInspectActionArgs.fromJSON(object.trajectoryInspect)
        : undefined,
      toggleTargetPointExposure: isSet(object.toggleTargetPointExposure)
        ? ToggleTargetPointExposureActionArgs.fromJSON(object.toggleTargetPointExposure)
        : undefined,
      toggleSemanticAim: isSet(object.toggleSemanticAim)
        ? ToggleSemanticAimActionArgs.fromJSON(object.toggleSemanticAim)
        : undefined,
      spoofBatteryLevel: isSet(object.spoofBatteryLevel)
        ? SpoofBatteryLevelActionArgs.fromJSON(object.spoofBatteryLevel)
        : undefined,
      ncpgControl: isSet(object.ncpgControl) ? NcpgControlActionArgs.fromJSON(object.ncpgControl) : undefined,
      registerComplimentaryActions: isSet(object.registerComplimentaryActions)
        ? RegisterComplimentaryActionsActionArgs.fromJSON(object.registerComplimentaryActions)
        : undefined,
      trackInPlace: isSet(object.trackInPlace) ? TrackInPlaceActionArgs.fromJSON(object.trackInPlace) : undefined,
      globalGraphControl: isSet(object.globalGraphControl)
        ? GlobalGraphControlActionArgs.fromJSON(object.globalGraphControl)
        : undefined,
      overrideGpsQuality: isSet(object.overrideGpsQuality)
        ? OverrideGpsQualityActionArgs.fromJSON(object.overrideGpsQuality)
        : undefined,
      initGlobalMap: isSet(object.initGlobalMap) ? InitGlobalMapActionArgs.fromJSON(object.initGlobalMap) : undefined,
      stopForPhotoInspect: isSet(object.stopForPhotoInspect)
        ? StopForPhotoInspectActionArgs.fromJSON(object.stopForPhotoInspect)
        : undefined,
      spoofInitialGpsHeading: isSet(object.spoofInitialGpsHeading)
        ? SpoofInitialGpsHeadingActionArgs.fromJSON(object.spoofInitialGpsHeading)
        : undefined,
      trackLandingPadRequest: isSet(object.trackLandingPadRequest)
        ? TrackLandingPadRequestActionArgs.fromJSON(object.trackLandingPadRequest)
        : undefined,
      apriltagSetId: isSet(object.apriltagSetId) ? ApriltagSetIdActionArgs.fromJSON(object.apriltagSetId) : undefined,
      dockGpsEstimator: isSet(object.dockGpsEstimator)
        ? DockGpsEstimatorActionArgs.fromJSON(object.dockGpsEstimator)
        : undefined,
      g47CommandOverride: isSet(object.g47CommandOverride)
        ? G47CommandOverrideActionArgs.fromJSON(object.g47CommandOverride)
        : undefined,
      requestTakeoffProfile: isSet(object.requestTakeoffProfile)
        ? RequestTakeoffProfileActionArgs.fromJSON(object.requestTakeoffProfile)
        : undefined,
      setDesiredGpsSource: isSet(object.setDesiredGpsSource)
        ? SetDesiredGpsSourceActionArgs.fromJSON(object.setDesiredGpsSource)
        : undefined,
      spoofManualGps: isSet(object.spoofManualGps)
        ? SpoofManualGpsActionArgs.fromJSON(object.spoofManualGps)
        : undefined,
      weatherAction: isSet(object.weatherAction) ? WeatherActionArgs.fromJSON(object.weatherAction) : undefined,
      setZoom: isSet(object.setZoom) ? SetZoomActionArgs.fromJSON(object.setZoom) : undefined,
      missionPlannerServiceControl: isSet(object.missionPlannerServiceControl)
        ? MissionPlannerServiceControlActionArgs.fromJSON(object.missionPlannerServiceControl)
        : undefined,
      spotlightAction: isSet(object.spotlightAction) ? SpotlightActionArgs.fromJSON(object.spotlightAction) : undefined,
      setCameraSettings: isSet(object.setCameraSettings)
        ? SetCameraSettingsActionArgs.fromJSON(object.setCameraSettings)
        : undefined,
      parachuteControl: isSet(object.parachuteControl)
        ? ParachuteControlActionArgs.fromJSON(object.parachuteControl)
        : undefined,
      nightsenseAction: isSet(object.nightsenseAction)
        ? NightsenseActionArgs.fromJSON(object.nightsenseAction)
        : undefined,
      spoofMultiDrone: isSet(object.spoofMultiDrone)
        ? SpoofMultiDroneActionArgs.fromJSON(object.spoofMultiDrone)
        : undefined,
      setMovementCommand: isSet(object.setMovementCommand)
        ? SetMovementCommandActionArgs.fromJSON(object.setMovementCommand)
        : undefined,
      spoofFlightEnvelopeLimits: isSet(object.spoofFlightEnvelopeLimits)
        ? SpoofFlightEnvelopeLimitsActionArgs.fromJSON(object.spoofFlightEnvelopeLimits)
        : undefined,
      turntable: isSet(object.turntable) ? TurntableActionArgs.fromJSON(object.turntable) : undefined,
      waitForRtk: isSet(object.waitForRtk) ? WaitForRtkActionArgs.fromJSON(object.waitForRtk) : undefined,
      wingWaypointsCommand: isSet(object.wingWaypointsCommand)
        ? WingWaypointsCommandActionArgs.fromJSON(object.wingWaypointsCommand)
        : undefined,
      dancingDrone: isSet(object.dancingDrone) ? DancingDroneActionArgs.fromJSON(object.dancingDrone) : undefined,
      waitForPreciseFault: isSet(object.waitForPreciseFault)
        ? WaitForPreciseFaultActionArgs.fromJSON(object.waitForPreciseFault)
        : undefined,
      dancingDroneSpline: isSet(object.dancingDroneSpline)
        ? DancingDroneSplineActionArgs.fromJSON(object.dancingDroneSpline)
        : undefined,
      sendDynamicScenario: isSet(object.sendDynamicScenario)
        ? SendDynamicScenarioActionArgs.fromJSON(object.sendDynamicScenario)
        : undefined,
      globalPlannerRequest: isSet(object.globalPlannerRequest)
        ? GlobalPlannerRequestActionArgs.fromJSON(object.globalPlannerRequest)
        : undefined,
      toggleSubjectDetection: isSet(object.toggleSubjectDetection)
        ? ToggleSubjectDetectionActionArgs.fromJSON(object.toggleSubjectDetection)
        : undefined,
      spoofSubjectScenario: isSet(object.spoofSubjectScenario)
        ? SpoofSubjectScenarioActionArgs.fromJSON(object.spoofSubjectScenario)
        : undefined,
      setSubjectFollowerSettings: isSet(object.setSubjectFollowerSettings)
        ? SetSubjectFollowerSettingsActionArgs.fromJSON(object.setSubjectFollowerSettings)
        : undefined,
      scoutAction: isSet(object.scoutAction) ? ScoutActionActionArgs.fromJSON(object.scoutAction) : undefined,
      spoofTrackingDevice: isSet(object.spoofTrackingDevice)
        ? SpoofTrackingDeviceActionArgs.fromJSON(object.spoofTrackingDevice)
        : undefined,
      geofenceConfig: isSet(object.geofenceConfig)
        ? GeofenceConfigActionArgs.fromJSON(object.geofenceConfig)
        : undefined,
      setDesiredImuSource: isSet(object.setDesiredImuSource)
        ? SetDesiredImuSourceActionArgs.fromJSON(object.setDesiredImuSource)
        : undefined,
      setGnssSolverQuality: isSet(object.setGnssSolverQuality)
        ? SetGnssSolverQualityActionArgs.fromJSON(object.setGnssSolverQuality)
        : undefined,
      sendMotionCommand: isSet(object.sendMotionCommand)
        ? SendMotionCommandActionArgs.fromJSON(object.sendMotionCommand)
        : undefined,
      spoofPhoneUiVariablesAction: isSet(object.spoofPhoneUiVariablesAction)
        ? SpoofPhoneUiVariablesActionArgs.fromJSON(object.spoofPhoneUiVariablesAction)
        : undefined,
      playAudio: isSet(object.playAudio) ? PlayAudioActionArgs.fromJSON(object.playAudio) : undefined,
      dummy: isSet(object.dummy) ? DummyActionArgs.fromJSON(object.dummy) : undefined,
      testDesiredVelocity: isSet(object.testDesiredVelocity)
        ? TestDesiredVelocityActionArgs.fromJSON(object.testDesiredVelocity)
        : undefined,
      testTrackTrajectory: isSet(object.testTrackTrajectory)
        ? TestTrackTrajectoryActionArgs.fromJSON(object.testTrackTrajectory)
        : undefined,
      atvSubjectSpoofAction: isSet(object.atvSubjectSpoofAction)
        ? AtvSubjectSpoofActionArgs.fromJSON(object.atvSubjectSpoofAction)
        : undefined,
      skiSubjectSpoofAction: isSet(object.skiSubjectSpoofAction)
        ? SkiSubjectSpoofActionArgs.fromJSON(object.skiSubjectSpoofAction)
        : undefined,
      setGimbal: isSet(object.setGimbal) ? SetGimbalOrientationArgs.fromJSON(object.setGimbal) : undefined,
      updateDockLocationAction: isSet(object.updateDockLocationAction)
        ? UpdateDockLocationActionArgs.fromJSON(object.updateDockLocationAction)
        : undefined,
      photoOnCompletion: isSet(object.photoOnCompletion) ? globalThis.Boolean(object.photoOnCompletion) : false,
      isSkippable: isSet(object.isSkippable) ? globalThis.Boolean(object.isSkippable) : false,
    };
  },

  toJSON(message: ActionArgs): unknown {
    const obj: any = {};
    if (message.json !== undefined) {
      obj.json = message.json;
    }
    if (message.gotoGpsWaypoint !== undefined) {
      obj.gotoGpsWaypoint = GotoGpsWaypointActionArgs.toJSON(message.gotoGpsWaypoint);
    }
    if (message.gotoNavWaypoint !== undefined) {
      obj.gotoNavWaypoint = GotoNavWaypointActionArgs.toJSON(message.gotoNavWaypoint);
    }
    if (message.takePhoto !== undefined) {
      obj.takePhoto = TakePhotoActionArgs.toJSON(message.takePhoto);
    }
    if (message.surfaceScanSkill !== undefined) {
      obj.surfaceScanSkill = SurfaceScanActionArgs.toJSON(message.surfaceScanSkill);
    }
    if (message.startVideo !== undefined) {
      obj.startVideo = StartVideoActionArgs.toJSON(message.startVideo);
    }
    if (message.stopVideo !== undefined) {
      obj.stopVideo = StopVideoActionArgs.toJSON(message.stopVideo);
    }
    if (message.switchRecordingMode !== undefined) {
      obj.switchRecordingMode = SwitchRecordingModeActionArgs.toJSON(message.switchRecordingMode);
    }
    if (message.timedWait !== undefined) {
      obj.timedWait = TimedWaitActionArgs.toJSON(message.timedWait);
    }
    if (message.sequence !== undefined) {
      obj.sequence = SequenceActionArgs.toJSON(message.sequence);
    }
    if (message.orbitPoiAction !== undefined) {
      obj.orbitPoiAction = OrbitPoiActionArgs.toJSON(message.orbitPoiAction);
    }
    if (message.takePanorama !== undefined) {
      obj.takePanorama = TakePanoramaActionArgs.toJSON(message.takePanorama);
    }
    if (message.keyframeAction !== undefined) {
      obj.keyframeAction = KeyframeActionArgs.toJSON(message.keyframeAction);
    }
    if (message.gotoWaypoint !== undefined) {
      obj.gotoWaypoint = GotoWaypointActionArgs.toJSON(message.gotoWaypoint);
    }
    if (message.setObstacleAvoidance !== undefined) {
      obj.setObstacleAvoidance = SetObstacleAvoidanceActionArgs.toJSON(message.setObstacleAvoidance);
    }
    if (message.initializeGps !== undefined) {
      obj.initializeGps = InitializeGpsActionArgs.toJSON(message.initializeGps);
    }
    if (message.conditional !== undefined) {
      obj.conditional = ConditionalActionArgs.toJSON(message.conditional);
    }
    if (message.looper !== undefined) {
      obj.looper = LooperActionArgs.toJSON(message.looper);
    }
    if (message.withinDistance !== undefined) {
      obj.withinDistance = WithinDistanceActionArgs.toJSON(message.withinDistance);
    }
    if (message.unifiedFollow !== undefined) {
      obj.unifiedFollow = UnifiedFollowActionArgs.toJSON(message.unifiedFollow);
    }
    if (message.inverter !== undefined) {
      obj.inverter = InverterActionArgs.toJSON(message.inverter);
    }
    if (message.togglePhotoIntervalMode !== undefined) {
      obj.togglePhotoIntervalMode = TogglePhotoIntervalModeActionArgs.toJSON(message.togglePhotoIntervalMode);
    }
    if (message.wifiScan !== undefined) {
      obj.wifiScan = WifiScanActionArgs.toJSON(message.wifiScan);
    }
    if (message.enableStrobeLights !== undefined) {
      obj.enableStrobeLights = EnableStrobeLightsActionArgs.toJSON(message.enableStrobeLights);
    }
    if (message.disableStrobeLights !== undefined) {
      obj.disableStrobeLights = DisableStrobeLightsActionArgs.toJSON(message.disableStrobeLights);
    }
    if (message.spoofJoysticksInputs !== undefined) {
      obj.spoofJoysticksInputs = SpoofJoysticksInputsActionArgs.toJSON(message.spoofJoysticksInputs);
    }
    if (message.updateJoysticksSettings !== undefined) {
      obj.updateJoysticksSettings = UpdateJoysticksSettingsActionArgs.toJSON(message.updateJoysticksSettings);
    }
    if (message.updateShapeMap !== undefined) {
      obj.updateShapeMap = UpdateShapeMapActionArgs.toJSON(message.updateShapeMap);
    }
    if (message.spoofObstacle !== undefined) {
      obj.spoofObstacle = SpoofObstacleActionArgs.toJSON(message.spoofObstacle);
    }
    if (message.spoofDisturbanceAction !== undefined) {
      obj.spoofDisturbanceAction = SpoofDisturbanceActionActionArgs.toJSON(message.spoofDisturbanceAction);
    }
    if (message.updateVehicleSettings !== undefined) {
      obj.updateVehicleSettings = UpdateVehicleSettingsActionArgs.toJSON(message.updateVehicleSettings);
    }
    if (message.waitForVehicleStop !== undefined) {
      obj.waitForVehicleStop = WaitForVehicleStopActionArgs.toJSON(message.waitForVehicleStop);
    }
    if (message.precomputedSubjectSpoofAction !== undefined) {
      obj.precomputedSubjectSpoofAction = PrecomputedSubjectSpoofActionArgs.toJSON(
        message.precomputedSubjectSpoofAction,
      );
    }
    if (message.modifySimStateEstimation !== undefined) {
      obj.modifySimStateEstimation = ModifySimStateEstimationActionArgs.toJSON(message.modifySimStateEstimation);
    }
    if (message.gotoAndOrbitPoi !== undefined) {
      obj.gotoAndOrbitPoi = GotoAndOrbitPoiActionArgs.toJSON(message.gotoAndOrbitPoi);
    }
    if (message.acquireGps !== undefined) {
      obj.acquireGps = AcquireGpsActionArgs.toJSON(message.acquireGps);
    }
    if (message.setFaultOverride !== undefined) {
      obj.setFaultOverride = SetFaultOverrideActionArgs.toJSON(message.setFaultOverride);
    }
    if (message.eLand !== undefined) {
      obj.eLand = ELandActionArgs.toJSON(message.eLand);
    }
    if (message.trajectoryInspect !== undefined) {
      obj.trajectoryInspect = TrajectoryInspectActionArgs.toJSON(message.trajectoryInspect);
    }
    if (message.toggleTargetPointExposure !== undefined) {
      obj.toggleTargetPointExposure = ToggleTargetPointExposureActionArgs.toJSON(message.toggleTargetPointExposure);
    }
    if (message.toggleSemanticAim !== undefined) {
      obj.toggleSemanticAim = ToggleSemanticAimActionArgs.toJSON(message.toggleSemanticAim);
    }
    if (message.spoofBatteryLevel !== undefined) {
      obj.spoofBatteryLevel = SpoofBatteryLevelActionArgs.toJSON(message.spoofBatteryLevel);
    }
    if (message.ncpgControl !== undefined) {
      obj.ncpgControl = NcpgControlActionArgs.toJSON(message.ncpgControl);
    }
    if (message.registerComplimentaryActions !== undefined) {
      obj.registerComplimentaryActions = RegisterComplimentaryActionsActionArgs.toJSON(
        message.registerComplimentaryActions,
      );
    }
    if (message.trackInPlace !== undefined) {
      obj.trackInPlace = TrackInPlaceActionArgs.toJSON(message.trackInPlace);
    }
    if (message.globalGraphControl !== undefined) {
      obj.globalGraphControl = GlobalGraphControlActionArgs.toJSON(message.globalGraphControl);
    }
    if (message.overrideGpsQuality !== undefined) {
      obj.overrideGpsQuality = OverrideGpsQualityActionArgs.toJSON(message.overrideGpsQuality);
    }
    if (message.initGlobalMap !== undefined) {
      obj.initGlobalMap = InitGlobalMapActionArgs.toJSON(message.initGlobalMap);
    }
    if (message.stopForPhotoInspect !== undefined) {
      obj.stopForPhotoInspect = StopForPhotoInspectActionArgs.toJSON(message.stopForPhotoInspect);
    }
    if (message.spoofInitialGpsHeading !== undefined) {
      obj.spoofInitialGpsHeading = SpoofInitialGpsHeadingActionArgs.toJSON(message.spoofInitialGpsHeading);
    }
    if (message.trackLandingPadRequest !== undefined) {
      obj.trackLandingPadRequest = TrackLandingPadRequestActionArgs.toJSON(message.trackLandingPadRequest);
    }
    if (message.apriltagSetId !== undefined) {
      obj.apriltagSetId = ApriltagSetIdActionArgs.toJSON(message.apriltagSetId);
    }
    if (message.dockGpsEstimator !== undefined) {
      obj.dockGpsEstimator = DockGpsEstimatorActionArgs.toJSON(message.dockGpsEstimator);
    }
    if (message.g47CommandOverride !== undefined) {
      obj.g47CommandOverride = G47CommandOverrideActionArgs.toJSON(message.g47CommandOverride);
    }
    if (message.requestTakeoffProfile !== undefined) {
      obj.requestTakeoffProfile = RequestTakeoffProfileActionArgs.toJSON(message.requestTakeoffProfile);
    }
    if (message.setDesiredGpsSource !== undefined) {
      obj.setDesiredGpsSource = SetDesiredGpsSourceActionArgs.toJSON(message.setDesiredGpsSource);
    }
    if (message.spoofManualGps !== undefined) {
      obj.spoofManualGps = SpoofManualGpsActionArgs.toJSON(message.spoofManualGps);
    }
    if (message.weatherAction !== undefined) {
      obj.weatherAction = WeatherActionArgs.toJSON(message.weatherAction);
    }
    if (message.setZoom !== undefined) {
      obj.setZoom = SetZoomActionArgs.toJSON(message.setZoom);
    }
    if (message.missionPlannerServiceControl !== undefined) {
      obj.missionPlannerServiceControl = MissionPlannerServiceControlActionArgs.toJSON(
        message.missionPlannerServiceControl,
      );
    }
    if (message.spotlightAction !== undefined) {
      obj.spotlightAction = SpotlightActionArgs.toJSON(message.spotlightAction);
    }
    if (message.setCameraSettings !== undefined) {
      obj.setCameraSettings = SetCameraSettingsActionArgs.toJSON(message.setCameraSettings);
    }
    if (message.parachuteControl !== undefined) {
      obj.parachuteControl = ParachuteControlActionArgs.toJSON(message.parachuteControl);
    }
    if (message.nightsenseAction !== undefined) {
      obj.nightsenseAction = NightsenseActionArgs.toJSON(message.nightsenseAction);
    }
    if (message.spoofMultiDrone !== undefined) {
      obj.spoofMultiDrone = SpoofMultiDroneActionArgs.toJSON(message.spoofMultiDrone);
    }
    if (message.setMovementCommand !== undefined) {
      obj.setMovementCommand = SetMovementCommandActionArgs.toJSON(message.setMovementCommand);
    }
    if (message.spoofFlightEnvelopeLimits !== undefined) {
      obj.spoofFlightEnvelopeLimits = SpoofFlightEnvelopeLimitsActionArgs.toJSON(message.spoofFlightEnvelopeLimits);
    }
    if (message.turntable !== undefined) {
      obj.turntable = TurntableActionArgs.toJSON(message.turntable);
    }
    if (message.waitForRtk !== undefined) {
      obj.waitForRtk = WaitForRtkActionArgs.toJSON(message.waitForRtk);
    }
    if (message.wingWaypointsCommand !== undefined) {
      obj.wingWaypointsCommand = WingWaypointsCommandActionArgs.toJSON(message.wingWaypointsCommand);
    }
    if (message.dancingDrone !== undefined) {
      obj.dancingDrone = DancingDroneActionArgs.toJSON(message.dancingDrone);
    }
    if (message.waitForPreciseFault !== undefined) {
      obj.waitForPreciseFault = WaitForPreciseFaultActionArgs.toJSON(message.waitForPreciseFault);
    }
    if (message.dancingDroneSpline !== undefined) {
      obj.dancingDroneSpline = DancingDroneSplineActionArgs.toJSON(message.dancingDroneSpline);
    }
    if (message.sendDynamicScenario !== undefined) {
      obj.sendDynamicScenario = SendDynamicScenarioActionArgs.toJSON(message.sendDynamicScenario);
    }
    if (message.globalPlannerRequest !== undefined) {
      obj.globalPlannerRequest = GlobalPlannerRequestActionArgs.toJSON(message.globalPlannerRequest);
    }
    if (message.toggleSubjectDetection !== undefined) {
      obj.toggleSubjectDetection = ToggleSubjectDetectionActionArgs.toJSON(message.toggleSubjectDetection);
    }
    if (message.spoofSubjectScenario !== undefined) {
      obj.spoofSubjectScenario = SpoofSubjectScenarioActionArgs.toJSON(message.spoofSubjectScenario);
    }
    if (message.setSubjectFollowerSettings !== undefined) {
      obj.setSubjectFollowerSettings = SetSubjectFollowerSettingsActionArgs.toJSON(message.setSubjectFollowerSettings);
    }
    if (message.scoutAction !== undefined) {
      obj.scoutAction = ScoutActionActionArgs.toJSON(message.scoutAction);
    }
    if (message.spoofTrackingDevice !== undefined) {
      obj.spoofTrackingDevice = SpoofTrackingDeviceActionArgs.toJSON(message.spoofTrackingDevice);
    }
    if (message.geofenceConfig !== undefined) {
      obj.geofenceConfig = GeofenceConfigActionArgs.toJSON(message.geofenceConfig);
    }
    if (message.setDesiredImuSource !== undefined) {
      obj.setDesiredImuSource = SetDesiredImuSourceActionArgs.toJSON(message.setDesiredImuSource);
    }
    if (message.setGnssSolverQuality !== undefined) {
      obj.setGnssSolverQuality = SetGnssSolverQualityActionArgs.toJSON(message.setGnssSolverQuality);
    }
    if (message.sendMotionCommand !== undefined) {
      obj.sendMotionCommand = SendMotionCommandActionArgs.toJSON(message.sendMotionCommand);
    }
    if (message.spoofPhoneUiVariablesAction !== undefined) {
      obj.spoofPhoneUiVariablesAction = SpoofPhoneUiVariablesActionArgs.toJSON(message.spoofPhoneUiVariablesAction);
    }
    if (message.playAudio !== undefined) {
      obj.playAudio = PlayAudioActionArgs.toJSON(message.playAudio);
    }
    if (message.dummy !== undefined) {
      obj.dummy = DummyActionArgs.toJSON(message.dummy);
    }
    if (message.testDesiredVelocity !== undefined) {
      obj.testDesiredVelocity = TestDesiredVelocityActionArgs.toJSON(message.testDesiredVelocity);
    }
    if (message.testTrackTrajectory !== undefined) {
      obj.testTrackTrajectory = TestTrackTrajectoryActionArgs.toJSON(message.testTrackTrajectory);
    }
    if (message.atvSubjectSpoofAction !== undefined) {
      obj.atvSubjectSpoofAction = AtvSubjectSpoofActionArgs.toJSON(message.atvSubjectSpoofAction);
    }
    if (message.skiSubjectSpoofAction !== undefined) {
      obj.skiSubjectSpoofAction = SkiSubjectSpoofActionArgs.toJSON(message.skiSubjectSpoofAction);
    }
    if (message.setGimbal !== undefined) {
      obj.setGimbal = SetGimbalOrientationArgs.toJSON(message.setGimbal);
    }
    if (message.updateDockLocationAction !== undefined) {
      obj.updateDockLocationAction = UpdateDockLocationActionArgs.toJSON(message.updateDockLocationAction);
    }
    if (message.photoOnCompletion === true) {
      obj.photoOnCompletion = message.photoOnCompletion;
    }
    if (message.isSkippable === true) {
      obj.isSkippable = message.isSkippable;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ActionArgs>, I>>(base?: I): ActionArgs {
    return ActionArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ActionArgs>, I>>(object: I): ActionArgs {
    const message = createBaseActionArgs();
    message.json = object.json ?? undefined;
    message.gotoGpsWaypoint = (object.gotoGpsWaypoint !== undefined && object.gotoGpsWaypoint !== null)
      ? GotoGpsWaypointActionArgs.fromPartial(object.gotoGpsWaypoint)
      : undefined;
    message.gotoNavWaypoint = (object.gotoNavWaypoint !== undefined && object.gotoNavWaypoint !== null)
      ? GotoNavWaypointActionArgs.fromPartial(object.gotoNavWaypoint)
      : undefined;
    message.takePhoto = (object.takePhoto !== undefined && object.takePhoto !== null)
      ? TakePhotoActionArgs.fromPartial(object.takePhoto)
      : undefined;
    message.surfaceScanSkill = (object.surfaceScanSkill !== undefined && object.surfaceScanSkill !== null)
      ? SurfaceScanActionArgs.fromPartial(object.surfaceScanSkill)
      : undefined;
    message.startVideo = (object.startVideo !== undefined && object.startVideo !== null)
      ? StartVideoActionArgs.fromPartial(object.startVideo)
      : undefined;
    message.stopVideo = (object.stopVideo !== undefined && object.stopVideo !== null)
      ? StopVideoActionArgs.fromPartial(object.stopVideo)
      : undefined;
    message.switchRecordingMode = (object.switchRecordingMode !== undefined && object.switchRecordingMode !== null)
      ? SwitchRecordingModeActionArgs.fromPartial(object.switchRecordingMode)
      : undefined;
    message.timedWait = (object.timedWait !== undefined && object.timedWait !== null)
      ? TimedWaitActionArgs.fromPartial(object.timedWait)
      : undefined;
    message.sequence = (object.sequence !== undefined && object.sequence !== null)
      ? SequenceActionArgs.fromPartial(object.sequence)
      : undefined;
    message.orbitPoiAction = (object.orbitPoiAction !== undefined && object.orbitPoiAction !== null)
      ? OrbitPoiActionArgs.fromPartial(object.orbitPoiAction)
      : undefined;
    message.takePanorama = (object.takePanorama !== undefined && object.takePanorama !== null)
      ? TakePanoramaActionArgs.fromPartial(object.takePanorama)
      : undefined;
    message.keyframeAction = (object.keyframeAction !== undefined && object.keyframeAction !== null)
      ? KeyframeActionArgs.fromPartial(object.keyframeAction)
      : undefined;
    message.gotoWaypoint = (object.gotoWaypoint !== undefined && object.gotoWaypoint !== null)
      ? GotoWaypointActionArgs.fromPartial(object.gotoWaypoint)
      : undefined;
    message.setObstacleAvoidance = (object.setObstacleAvoidance !== undefined && object.setObstacleAvoidance !== null)
      ? SetObstacleAvoidanceActionArgs.fromPartial(object.setObstacleAvoidance)
      : undefined;
    message.initializeGps = (object.initializeGps !== undefined && object.initializeGps !== null)
      ? InitializeGpsActionArgs.fromPartial(object.initializeGps)
      : undefined;
    message.conditional = (object.conditional !== undefined && object.conditional !== null)
      ? ConditionalActionArgs.fromPartial(object.conditional)
      : undefined;
    message.looper = (object.looper !== undefined && object.looper !== null)
      ? LooperActionArgs.fromPartial(object.looper)
      : undefined;
    message.withinDistance = (object.withinDistance !== undefined && object.withinDistance !== null)
      ? WithinDistanceActionArgs.fromPartial(object.withinDistance)
      : undefined;
    message.unifiedFollow = (object.unifiedFollow !== undefined && object.unifiedFollow !== null)
      ? UnifiedFollowActionArgs.fromPartial(object.unifiedFollow)
      : undefined;
    message.inverter = (object.inverter !== undefined && object.inverter !== null)
      ? InverterActionArgs.fromPartial(object.inverter)
      : undefined;
    message.togglePhotoIntervalMode =
      (object.togglePhotoIntervalMode !== undefined && object.togglePhotoIntervalMode !== null)
        ? TogglePhotoIntervalModeActionArgs.fromPartial(object.togglePhotoIntervalMode)
        : undefined;
    message.wifiScan = (object.wifiScan !== undefined && object.wifiScan !== null)
      ? WifiScanActionArgs.fromPartial(object.wifiScan)
      : undefined;
    message.enableStrobeLights = (object.enableStrobeLights !== undefined && object.enableStrobeLights !== null)
      ? EnableStrobeLightsActionArgs.fromPartial(object.enableStrobeLights)
      : undefined;
    message.disableStrobeLights = (object.disableStrobeLights !== undefined && object.disableStrobeLights !== null)
      ? DisableStrobeLightsActionArgs.fromPartial(object.disableStrobeLights)
      : undefined;
    message.spoofJoysticksInputs = (object.spoofJoysticksInputs !== undefined && object.spoofJoysticksInputs !== null)
      ? SpoofJoysticksInputsActionArgs.fromPartial(object.spoofJoysticksInputs)
      : undefined;
    message.updateJoysticksSettings =
      (object.updateJoysticksSettings !== undefined && object.updateJoysticksSettings !== null)
        ? UpdateJoysticksSettingsActionArgs.fromPartial(object.updateJoysticksSettings)
        : undefined;
    message.updateShapeMap = (object.updateShapeMap !== undefined && object.updateShapeMap !== null)
      ? UpdateShapeMapActionArgs.fromPartial(object.updateShapeMap)
      : undefined;
    message.spoofObstacle = (object.spoofObstacle !== undefined && object.spoofObstacle !== null)
      ? SpoofObstacleActionArgs.fromPartial(object.spoofObstacle)
      : undefined;
    message.spoofDisturbanceAction =
      (object.spoofDisturbanceAction !== undefined && object.spoofDisturbanceAction !== null)
        ? SpoofDisturbanceActionActionArgs.fromPartial(object.spoofDisturbanceAction)
        : undefined;
    message.updateVehicleSettings =
      (object.updateVehicleSettings !== undefined && object.updateVehicleSettings !== null)
        ? UpdateVehicleSettingsActionArgs.fromPartial(object.updateVehicleSettings)
        : undefined;
    message.waitForVehicleStop = (object.waitForVehicleStop !== undefined && object.waitForVehicleStop !== null)
      ? WaitForVehicleStopActionArgs.fromPartial(object.waitForVehicleStop)
      : undefined;
    message.precomputedSubjectSpoofAction =
      (object.precomputedSubjectSpoofAction !== undefined && object.precomputedSubjectSpoofAction !== null)
        ? PrecomputedSubjectSpoofActionArgs.fromPartial(object.precomputedSubjectSpoofAction)
        : undefined;
    message.modifySimStateEstimation =
      (object.modifySimStateEstimation !== undefined && object.modifySimStateEstimation !== null)
        ? ModifySimStateEstimationActionArgs.fromPartial(object.modifySimStateEstimation)
        : undefined;
    message.gotoAndOrbitPoi = (object.gotoAndOrbitPoi !== undefined && object.gotoAndOrbitPoi !== null)
      ? GotoAndOrbitPoiActionArgs.fromPartial(object.gotoAndOrbitPoi)
      : undefined;
    message.acquireGps = (object.acquireGps !== undefined && object.acquireGps !== null)
      ? AcquireGpsActionArgs.fromPartial(object.acquireGps)
      : undefined;
    message.setFaultOverride = (object.setFaultOverride !== undefined && object.setFaultOverride !== null)
      ? SetFaultOverrideActionArgs.fromPartial(object.setFaultOverride)
      : undefined;
    message.eLand = (object.eLand !== undefined && object.eLand !== null)
      ? ELandActionArgs.fromPartial(object.eLand)
      : undefined;
    message.trajectoryInspect = (object.trajectoryInspect !== undefined && object.trajectoryInspect !== null)
      ? TrajectoryInspectActionArgs.fromPartial(object.trajectoryInspect)
      : undefined;
    message.toggleTargetPointExposure =
      (object.toggleTargetPointExposure !== undefined && object.toggleTargetPointExposure !== null)
        ? ToggleTargetPointExposureActionArgs.fromPartial(object.toggleTargetPointExposure)
        : undefined;
    message.toggleSemanticAim = (object.toggleSemanticAim !== undefined && object.toggleSemanticAim !== null)
      ? ToggleSemanticAimActionArgs.fromPartial(object.toggleSemanticAim)
      : undefined;
    message.spoofBatteryLevel = (object.spoofBatteryLevel !== undefined && object.spoofBatteryLevel !== null)
      ? SpoofBatteryLevelActionArgs.fromPartial(object.spoofBatteryLevel)
      : undefined;
    message.ncpgControl = (object.ncpgControl !== undefined && object.ncpgControl !== null)
      ? NcpgControlActionArgs.fromPartial(object.ncpgControl)
      : undefined;
    message.registerComplimentaryActions =
      (object.registerComplimentaryActions !== undefined && object.registerComplimentaryActions !== null)
        ? RegisterComplimentaryActionsActionArgs.fromPartial(object.registerComplimentaryActions)
        : undefined;
    message.trackInPlace = (object.trackInPlace !== undefined && object.trackInPlace !== null)
      ? TrackInPlaceActionArgs.fromPartial(object.trackInPlace)
      : undefined;
    message.globalGraphControl = (object.globalGraphControl !== undefined && object.globalGraphControl !== null)
      ? GlobalGraphControlActionArgs.fromPartial(object.globalGraphControl)
      : undefined;
    message.overrideGpsQuality = (object.overrideGpsQuality !== undefined && object.overrideGpsQuality !== null)
      ? OverrideGpsQualityActionArgs.fromPartial(object.overrideGpsQuality)
      : undefined;
    message.initGlobalMap = (object.initGlobalMap !== undefined && object.initGlobalMap !== null)
      ? InitGlobalMapActionArgs.fromPartial(object.initGlobalMap)
      : undefined;
    message.stopForPhotoInspect = (object.stopForPhotoInspect !== undefined && object.stopForPhotoInspect !== null)
      ? StopForPhotoInspectActionArgs.fromPartial(object.stopForPhotoInspect)
      : undefined;
    message.spoofInitialGpsHeading =
      (object.spoofInitialGpsHeading !== undefined && object.spoofInitialGpsHeading !== null)
        ? SpoofInitialGpsHeadingActionArgs.fromPartial(object.spoofInitialGpsHeading)
        : undefined;
    message.trackLandingPadRequest =
      (object.trackLandingPadRequest !== undefined && object.trackLandingPadRequest !== null)
        ? TrackLandingPadRequestActionArgs.fromPartial(object.trackLandingPadRequest)
        : undefined;
    message.apriltagSetId = (object.apriltagSetId !== undefined && object.apriltagSetId !== null)
      ? ApriltagSetIdActionArgs.fromPartial(object.apriltagSetId)
      : undefined;
    message.dockGpsEstimator = (object.dockGpsEstimator !== undefined && object.dockGpsEstimator !== null)
      ? DockGpsEstimatorActionArgs.fromPartial(object.dockGpsEstimator)
      : undefined;
    message.g47CommandOverride = (object.g47CommandOverride !== undefined && object.g47CommandOverride !== null)
      ? G47CommandOverrideActionArgs.fromPartial(object.g47CommandOverride)
      : undefined;
    message.requestTakeoffProfile =
      (object.requestTakeoffProfile !== undefined && object.requestTakeoffProfile !== null)
        ? RequestTakeoffProfileActionArgs.fromPartial(object.requestTakeoffProfile)
        : undefined;
    message.setDesiredGpsSource = (object.setDesiredGpsSource !== undefined && object.setDesiredGpsSource !== null)
      ? SetDesiredGpsSourceActionArgs.fromPartial(object.setDesiredGpsSource)
      : undefined;
    message.spoofManualGps = (object.spoofManualGps !== undefined && object.spoofManualGps !== null)
      ? SpoofManualGpsActionArgs.fromPartial(object.spoofManualGps)
      : undefined;
    message.weatherAction = (object.weatherAction !== undefined && object.weatherAction !== null)
      ? WeatherActionArgs.fromPartial(object.weatherAction)
      : undefined;
    message.setZoom = (object.setZoom !== undefined && object.setZoom !== null)
      ? SetZoomActionArgs.fromPartial(object.setZoom)
      : undefined;
    message.missionPlannerServiceControl =
      (object.missionPlannerServiceControl !== undefined && object.missionPlannerServiceControl !== null)
        ? MissionPlannerServiceControlActionArgs.fromPartial(object.missionPlannerServiceControl)
        : undefined;
    message.spotlightAction = (object.spotlightAction !== undefined && object.spotlightAction !== null)
      ? SpotlightActionArgs.fromPartial(object.spotlightAction)
      : undefined;
    message.setCameraSettings = (object.setCameraSettings !== undefined && object.setCameraSettings !== null)
      ? SetCameraSettingsActionArgs.fromPartial(object.setCameraSettings)
      : undefined;
    message.parachuteControl = (object.parachuteControl !== undefined && object.parachuteControl !== null)
      ? ParachuteControlActionArgs.fromPartial(object.parachuteControl)
      : undefined;
    message.nightsenseAction = (object.nightsenseAction !== undefined && object.nightsenseAction !== null)
      ? NightsenseActionArgs.fromPartial(object.nightsenseAction)
      : undefined;
    message.spoofMultiDrone = (object.spoofMultiDrone !== undefined && object.spoofMultiDrone !== null)
      ? SpoofMultiDroneActionArgs.fromPartial(object.spoofMultiDrone)
      : undefined;
    message.setMovementCommand = (object.setMovementCommand !== undefined && object.setMovementCommand !== null)
      ? SetMovementCommandActionArgs.fromPartial(object.setMovementCommand)
      : undefined;
    message.spoofFlightEnvelopeLimits =
      (object.spoofFlightEnvelopeLimits !== undefined && object.spoofFlightEnvelopeLimits !== null)
        ? SpoofFlightEnvelopeLimitsActionArgs.fromPartial(object.spoofFlightEnvelopeLimits)
        : undefined;
    message.turntable = (object.turntable !== undefined && object.turntable !== null)
      ? TurntableActionArgs.fromPartial(object.turntable)
      : undefined;
    message.waitForRtk = (object.waitForRtk !== undefined && object.waitForRtk !== null)
      ? WaitForRtkActionArgs.fromPartial(object.waitForRtk)
      : undefined;
    message.wingWaypointsCommand = (object.wingWaypointsCommand !== undefined && object.wingWaypointsCommand !== null)
      ? WingWaypointsCommandActionArgs.fromPartial(object.wingWaypointsCommand)
      : undefined;
    message.dancingDrone = (object.dancingDrone !== undefined && object.dancingDrone !== null)
      ? DancingDroneActionArgs.fromPartial(object.dancingDrone)
      : undefined;
    message.waitForPreciseFault = (object.waitForPreciseFault !== undefined && object.waitForPreciseFault !== null)
      ? WaitForPreciseFaultActionArgs.fromPartial(object.waitForPreciseFault)
      : undefined;
    message.dancingDroneSpline = (object.dancingDroneSpline !== undefined && object.dancingDroneSpline !== null)
      ? DancingDroneSplineActionArgs.fromPartial(object.dancingDroneSpline)
      : undefined;
    message.sendDynamicScenario = (object.sendDynamicScenario !== undefined && object.sendDynamicScenario !== null)
      ? SendDynamicScenarioActionArgs.fromPartial(object.sendDynamicScenario)
      : undefined;
    message.globalPlannerRequest = (object.globalPlannerRequest !== undefined && object.globalPlannerRequest !== null)
      ? GlobalPlannerRequestActionArgs.fromPartial(object.globalPlannerRequest)
      : undefined;
    message.toggleSubjectDetection =
      (object.toggleSubjectDetection !== undefined && object.toggleSubjectDetection !== null)
        ? ToggleSubjectDetectionActionArgs.fromPartial(object.toggleSubjectDetection)
        : undefined;
    message.spoofSubjectScenario = (object.spoofSubjectScenario !== undefined && object.spoofSubjectScenario !== null)
      ? SpoofSubjectScenarioActionArgs.fromPartial(object.spoofSubjectScenario)
      : undefined;
    message.setSubjectFollowerSettings =
      (object.setSubjectFollowerSettings !== undefined && object.setSubjectFollowerSettings !== null)
        ? SetSubjectFollowerSettingsActionArgs.fromPartial(object.setSubjectFollowerSettings)
        : undefined;
    message.scoutAction = (object.scoutAction !== undefined && object.scoutAction !== null)
      ? ScoutActionActionArgs.fromPartial(object.scoutAction)
      : undefined;
    message.spoofTrackingDevice = (object.spoofTrackingDevice !== undefined && object.spoofTrackingDevice !== null)
      ? SpoofTrackingDeviceActionArgs.fromPartial(object.spoofTrackingDevice)
      : undefined;
    message.geofenceConfig = (object.geofenceConfig !== undefined && object.geofenceConfig !== null)
      ? GeofenceConfigActionArgs.fromPartial(object.geofenceConfig)
      : undefined;
    message.setDesiredImuSource = (object.setDesiredImuSource !== undefined && object.setDesiredImuSource !== null)
      ? SetDesiredImuSourceActionArgs.fromPartial(object.setDesiredImuSource)
      : undefined;
    message.setGnssSolverQuality = (object.setGnssSolverQuality !== undefined && object.setGnssSolverQuality !== null)
      ? SetGnssSolverQualityActionArgs.fromPartial(object.setGnssSolverQuality)
      : undefined;
    message.sendMotionCommand = (object.sendMotionCommand !== undefined && object.sendMotionCommand !== null)
      ? SendMotionCommandActionArgs.fromPartial(object.sendMotionCommand)
      : undefined;
    message.spoofPhoneUiVariablesAction =
      (object.spoofPhoneUiVariablesAction !== undefined && object.spoofPhoneUiVariablesAction !== null)
        ? SpoofPhoneUiVariablesActionArgs.fromPartial(object.spoofPhoneUiVariablesAction)
        : undefined;
    message.playAudio = (object.playAudio !== undefined && object.playAudio !== null)
      ? PlayAudioActionArgs.fromPartial(object.playAudio)
      : undefined;
    message.dummy = (object.dummy !== undefined && object.dummy !== null)
      ? DummyActionArgs.fromPartial(object.dummy)
      : undefined;
    message.testDesiredVelocity = (object.testDesiredVelocity !== undefined && object.testDesiredVelocity !== null)
      ? TestDesiredVelocityActionArgs.fromPartial(object.testDesiredVelocity)
      : undefined;
    message.testTrackTrajectory = (object.testTrackTrajectory !== undefined && object.testTrackTrajectory !== null)
      ? TestTrackTrajectoryActionArgs.fromPartial(object.testTrackTrajectory)
      : undefined;
    message.atvSubjectSpoofAction =
      (object.atvSubjectSpoofAction !== undefined && object.atvSubjectSpoofAction !== null)
        ? AtvSubjectSpoofActionArgs.fromPartial(object.atvSubjectSpoofAction)
        : undefined;
    message.skiSubjectSpoofAction =
      (object.skiSubjectSpoofAction !== undefined && object.skiSubjectSpoofAction !== null)
        ? SkiSubjectSpoofActionArgs.fromPartial(object.skiSubjectSpoofAction)
        : undefined;
    message.setGimbal = (object.setGimbal !== undefined && object.setGimbal !== null)
      ? SetGimbalOrientationArgs.fromPartial(object.setGimbal)
      : undefined;
    message.updateDockLocationAction =
      (object.updateDockLocationAction !== undefined && object.updateDockLocationAction !== null)
        ? UpdateDockLocationActionArgs.fromPartial(object.updateDockLocationAction)
        : undefined;
    message.photoOnCompletion = object.photoOnCompletion ?? false;
    message.isSkippable = object.isSkippable ?? false;
    return message;
  },
};

function createBaseMissionState(): MissionState {
  return {
    utime: 0,
    stateEnum: 0,
    missionName: "",
    missionUuid: "",
    templateUuid: "",
    executionUuid: "",
    scheduledMissionUuid: "",
    actionIndex: 0,
    actionState: undefined,
    waypointIndex: 0,
    numWaypoints: 0,
    flightInfo: undefined,
    updateNonceHistory: [],
    gpsStatus: 0,
    postMissionAction: 0,
    lostConnectionAction: 0,
    faultBasedDirectRtdEnabled: false,
    actionTimeEstimate: 0,
    actionDistanceEstimate: 0,
    remainingTimeEstimate: 0,
    remainingDistanceEstimate: 0,
    useRtxSettings: false,
    rtxSettings: undefined,
    waypointsCompleted: 0,
    navigationModeOverrideEnabled: false,
    navigationModeOverride: 0,
    expectedMissionResult: 0,
    lastActionResult: undefined,
    freeLookActive: false,
    supportedFreeLookMode: 0,
    skipAlert: false,
    pausedUnresumableReason: 0,
    activeMissionTierType: 0,
    queuedMissions: [],
  };
}

export const MissionState = {
  encode(message: MissionState, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.utime !== 0) {
      writer.uint32(80).int64(message.utime);
    }
    if (message.stateEnum !== 0) {
      writer.uint32(8).int32(message.stateEnum);
    }
    if (message.missionName !== "") {
      writer.uint32(18).string(message.missionName);
    }
    if (message.missionUuid !== "") {
      writer.uint32(26).string(message.missionUuid);
    }
    if (message.templateUuid !== "") {
      writer.uint32(202).string(message.templateUuid);
    }
    if (message.executionUuid !== "") {
      writer.uint32(122).string(message.executionUuid);
    }
    if (message.scheduledMissionUuid !== "") {
      writer.uint32(114).string(message.scheduledMissionUuid);
    }
    if (message.actionIndex !== 0) {
      writer.uint32(40).int32(message.actionIndex);
    }
    if (message.actionState !== undefined) {
      ActionState.encode(message.actionState, writer.uint32(50).fork()).ldelim();
    }
    if (message.waypointIndex !== 0) {
      writer.uint32(136).int32(message.waypointIndex);
    }
    if (message.numWaypoints !== 0) {
      writer.uint32(144).int32(message.numWaypoints);
    }
    if (message.flightInfo !== undefined) {
      FlightInfo.encode(message.flightInfo, writer.uint32(66).fork()).ldelim();
    }
    for (const v of message.updateNonceHistory) {
      writer.uint32(74).string(v!);
    }
    if (message.gpsStatus !== 0) {
      writer.uint32(88).int32(message.gpsStatus);
    }
    if (message.postMissionAction !== 0) {
      writer.uint32(96).int32(message.postMissionAction);
    }
    if (message.lostConnectionAction !== 0) {
      writer.uint32(104).int32(message.lostConnectionAction);
    }
    if (message.faultBasedDirectRtdEnabled === true) {
      writer.uint32(128).bool(message.faultBasedDirectRtdEnabled);
    }
    if (message.actionTimeEstimate !== 0) {
      writer.uint32(157).float(message.actionTimeEstimate);
    }
    if (message.actionDistanceEstimate !== 0) {
      writer.uint32(165).float(message.actionDistanceEstimate);
    }
    if (message.remainingTimeEstimate !== 0) {
      writer.uint32(173).float(message.remainingTimeEstimate);
    }
    if (message.remainingDistanceEstimate !== 0) {
      writer.uint32(181).float(message.remainingDistanceEstimate);
    }
    if (message.useRtxSettings === true) {
      writer.uint32(184).bool(message.useRtxSettings);
    }
    if (message.rtxSettings !== undefined) {
      ReturnSettings.encode(message.rtxSettings, writer.uint32(194).fork()).ldelim();
    }
    if (message.waypointsCompleted !== 0) {
      writer.uint32(208).int32(message.waypointsCompleted);
    }
    if (message.navigationModeOverrideEnabled === true) {
      writer.uint32(216).bool(message.navigationModeOverrideEnabled);
    }
    if (message.navigationModeOverride !== 0) {
      writer.uint32(224).int32(message.navigationModeOverride);
    }
    if (message.expectedMissionResult !== 0) {
      writer.uint32(232).int32(message.expectedMissionResult);
    }
    if (message.lastActionResult !== undefined) {
      ActionResult.encode(message.lastActionResult, writer.uint32(242).fork()).ldelim();
    }
    if (message.freeLookActive === true) {
      writer.uint32(248).bool(message.freeLookActive);
    }
    if (message.supportedFreeLookMode !== 0) {
      writer.uint32(256).int32(message.supportedFreeLookMode);
    }
    if (message.skipAlert === true) {
      writer.uint32(264).bool(message.skipAlert);
    }
    if (message.pausedUnresumableReason !== 0) {
      writer.uint32(272).int32(message.pausedUnresumableReason);
    }
    if (message.activeMissionTierType !== 0) {
      writer.uint32(280).int32(message.activeMissionTierType);
    }
    for (const v of message.queuedMissions) {
      MissionSummary.encode(v!, writer.uint32(290).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): MissionState {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMissionState();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 10:
          if (tag !== 80) {
            break;
          }

          message.utime = longToNumber(reader.int64() as Long);
          continue;
        case 1:
          if (tag !== 8) {
            break;
          }

          message.stateEnum = reader.int32() as any;
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.missionName = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.missionUuid = reader.string();
          continue;
        case 25:
          if (tag !== 202) {
            break;
          }

          message.templateUuid = reader.string();
          continue;
        case 15:
          if (tag !== 122) {
            break;
          }

          message.executionUuid = reader.string();
          continue;
        case 14:
          if (tag !== 114) {
            break;
          }

          message.scheduledMissionUuid = reader.string();
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }

          message.actionIndex = reader.int32();
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.actionState = ActionState.decode(reader, reader.uint32());
          continue;
        case 17:
          if (tag !== 136) {
            break;
          }

          message.waypointIndex = reader.int32();
          continue;
        case 18:
          if (tag !== 144) {
            break;
          }

          message.numWaypoints = reader.int32();
          continue;
        case 8:
          if (tag !== 66) {
            break;
          }

          message.flightInfo = FlightInfo.decode(reader, reader.uint32());
          continue;
        case 9:
          if (tag !== 74) {
            break;
          }

          message.updateNonceHistory.push(reader.string());
          continue;
        case 11:
          if (tag !== 88) {
            break;
          }

          message.gpsStatus = reader.int32() as any;
          continue;
        case 12:
          if (tag !== 96) {
            break;
          }

          message.postMissionAction = reader.int32() as any;
          continue;
        case 13:
          if (tag !== 104) {
            break;
          }

          message.lostConnectionAction = reader.int32() as any;
          continue;
        case 16:
          if (tag !== 128) {
            break;
          }

          message.faultBasedDirectRtdEnabled = reader.bool();
          continue;
        case 19:
          if (tag !== 157) {
            break;
          }

          message.actionTimeEstimate = reader.float();
          continue;
        case 20:
          if (tag !== 165) {
            break;
          }

          message.actionDistanceEstimate = reader.float();
          continue;
        case 21:
          if (tag !== 173) {
            break;
          }

          message.remainingTimeEstimate = reader.float();
          continue;
        case 22:
          if (tag !== 181) {
            break;
          }

          message.remainingDistanceEstimate = reader.float();
          continue;
        case 23:
          if (tag !== 184) {
            break;
          }

          message.useRtxSettings = reader.bool();
          continue;
        case 24:
          if (tag !== 194) {
            break;
          }

          message.rtxSettings = ReturnSettings.decode(reader, reader.uint32());
          continue;
        case 26:
          if (tag !== 208) {
            break;
          }

          message.waypointsCompleted = reader.int32();
          continue;
        case 27:
          if (tag !== 216) {
            break;
          }

          message.navigationModeOverrideEnabled = reader.bool();
          continue;
        case 28:
          if (tag !== 224) {
            break;
          }

          message.navigationModeOverride = reader.int32() as any;
          continue;
        case 29:
          if (tag !== 232) {
            break;
          }

          message.expectedMissionResult = reader.int32() as any;
          continue;
        case 30:
          if (tag !== 242) {
            break;
          }

          message.lastActionResult = ActionResult.decode(reader, reader.uint32());
          continue;
        case 31:
          if (tag !== 248) {
            break;
          }

          message.freeLookActive = reader.bool();
          continue;
        case 32:
          if (tag !== 256) {
            break;
          }

          message.supportedFreeLookMode = reader.int32() as any;
          continue;
        case 33:
          if (tag !== 264) {
            break;
          }

          message.skipAlert = reader.bool();
          continue;
        case 34:
          if (tag !== 272) {
            break;
          }

          message.pausedUnresumableReason = reader.int32() as any;
          continue;
        case 35:
          if (tag !== 280) {
            break;
          }

          message.activeMissionTierType = reader.int32() as any;
          continue;
        case 36:
          if (tag !== 290) {
            break;
          }

          message.queuedMissions.push(MissionSummary.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MissionState {
    return {
      utime: isSet(object.utime) ? globalThis.Number(object.utime) : 0,
      stateEnum: isSet(object.stateEnum) ? missionState_MissionStateEnumFromJSON(object.stateEnum) : 0,
      missionName: isSet(object.missionName) ? globalThis.String(object.missionName) : "",
      missionUuid: isSet(object.missionUuid) ? globalThis.String(object.missionUuid) : "",
      templateUuid: isSet(object.templateUuid) ? globalThis.String(object.templateUuid) : "",
      executionUuid: isSet(object.executionUuid) ? globalThis.String(object.executionUuid) : "",
      scheduledMissionUuid: isSet(object.scheduledMissionUuid) ? globalThis.String(object.scheduledMissionUuid) : "",
      actionIndex: isSet(object.actionIndex) ? globalThis.Number(object.actionIndex) : 0,
      actionState: isSet(object.actionState) ? ActionState.fromJSON(object.actionState) : undefined,
      waypointIndex: isSet(object.waypointIndex) ? globalThis.Number(object.waypointIndex) : 0,
      numWaypoints: isSet(object.numWaypoints) ? globalThis.Number(object.numWaypoints) : 0,
      flightInfo: isSet(object.flightInfo) ? FlightInfo.fromJSON(object.flightInfo) : undefined,
      updateNonceHistory: globalThis.Array.isArray(object?.updateNonceHistory)
        ? object.updateNonceHistory.map((e: any) => globalThis.String(e))
        : [],
      gpsStatus: isSet(object.gpsStatus) ? missionState_GpsStatusEnumFromJSON(object.gpsStatus) : 0,
      postMissionAction: isSet(object.postMissionAction)
        ? postMissionActionEnum_EnumFromJSON(object.postMissionAction)
        : 0,
      lostConnectionAction: isSet(object.lostConnectionAction)
        ? lostConnectionActionEnum_EnumFromJSON(object.lostConnectionAction)
        : 0,
      faultBasedDirectRtdEnabled: isSet(object.faultBasedDirectRtdEnabled)
        ? globalThis.Boolean(object.faultBasedDirectRtdEnabled)
        : false,
      actionTimeEstimate: isSet(object.actionTimeEstimate) ? globalThis.Number(object.actionTimeEstimate) : 0,
      actionDistanceEstimate: isSet(object.actionDistanceEstimate)
        ? globalThis.Number(object.actionDistanceEstimate)
        : 0,
      remainingTimeEstimate: isSet(object.remainingTimeEstimate) ? globalThis.Number(object.remainingTimeEstimate) : 0,
      remainingDistanceEstimate: isSet(object.remainingDistanceEstimate)
        ? globalThis.Number(object.remainingDistanceEstimate)
        : 0,
      useRtxSettings: isSet(object.useRtxSettings) ? globalThis.Boolean(object.useRtxSettings) : false,
      rtxSettings: isSet(object.rtxSettings) ? ReturnSettings.fromJSON(object.rtxSettings) : undefined,
      waypointsCompleted: isSet(object.waypointsCompleted) ? globalThis.Number(object.waypointsCompleted) : 0,
      navigationModeOverrideEnabled: isSet(object.navigationModeOverrideEnabled)
        ? globalThis.Boolean(object.navigationModeOverrideEnabled)
        : false,
      navigationModeOverride: isSet(object.navigationModeOverride)
        ? navigationMode_ModeFromJSON(object.navigationModeOverride)
        : 0,
      expectedMissionResult: isSet(object.expectedMissionResult)
        ? missionResult_ResultFromJSON(object.expectedMissionResult)
        : 0,
      lastActionResult: isSet(object.lastActionResult) ? ActionResult.fromJSON(object.lastActionResult) : undefined,
      freeLookActive: isSet(object.freeLookActive) ? globalThis.Boolean(object.freeLookActive) : false,
      supportedFreeLookMode: isSet(object.supportedFreeLookMode)
        ? freeLookMode_EnumFromJSON(object.supportedFreeLookMode)
        : 0,
      skipAlert: isSet(object.skipAlert) ? globalThis.Boolean(object.skipAlert) : false,
      pausedUnresumableReason: isSet(object.pausedUnresumableReason)
        ? missionState_PausedUnresumableReasonFromJSON(object.pausedUnresumableReason)
        : 0,
      activeMissionTierType: isSet(object.activeMissionTierType)
        ? missionTierTypeEnum_EnumFromJSON(object.activeMissionTierType)
        : 0,
      queuedMissions: globalThis.Array.isArray(object?.queuedMissions)
        ? object.queuedMissions.map((e: any) => MissionSummary.fromJSON(e))
        : [],
    };
  },

  toJSON(message: MissionState): unknown {
    const obj: any = {};
    if (message.utime !== 0) {
      obj.utime = Math.round(message.utime);
    }
    if (message.stateEnum !== 0) {
      obj.stateEnum = missionState_MissionStateEnumToJSON(message.stateEnum);
    }
    if (message.missionName !== "") {
      obj.missionName = message.missionName;
    }
    if (message.missionUuid !== "") {
      obj.missionUuid = message.missionUuid;
    }
    if (message.templateUuid !== "") {
      obj.templateUuid = message.templateUuid;
    }
    if (message.executionUuid !== "") {
      obj.executionUuid = message.executionUuid;
    }
    if (message.scheduledMissionUuid !== "") {
      obj.scheduledMissionUuid = message.scheduledMissionUuid;
    }
    if (message.actionIndex !== 0) {
      obj.actionIndex = Math.round(message.actionIndex);
    }
    if (message.actionState !== undefined) {
      obj.actionState = ActionState.toJSON(message.actionState);
    }
    if (message.waypointIndex !== 0) {
      obj.waypointIndex = Math.round(message.waypointIndex);
    }
    if (message.numWaypoints !== 0) {
      obj.numWaypoints = Math.round(message.numWaypoints);
    }
    if (message.flightInfo !== undefined) {
      obj.flightInfo = FlightInfo.toJSON(message.flightInfo);
    }
    if (message.updateNonceHistory?.length) {
      obj.updateNonceHistory = message.updateNonceHistory;
    }
    if (message.gpsStatus !== 0) {
      obj.gpsStatus = missionState_GpsStatusEnumToJSON(message.gpsStatus);
    }
    if (message.postMissionAction !== 0) {
      obj.postMissionAction = postMissionActionEnum_EnumToJSON(message.postMissionAction);
    }
    if (message.lostConnectionAction !== 0) {
      obj.lostConnectionAction = lostConnectionActionEnum_EnumToJSON(message.lostConnectionAction);
    }
    if (message.faultBasedDirectRtdEnabled === true) {
      obj.faultBasedDirectRtdEnabled = message.faultBasedDirectRtdEnabled;
    }
    if (message.actionTimeEstimate !== 0) {
      obj.actionTimeEstimate = message.actionTimeEstimate;
    }
    if (message.actionDistanceEstimate !== 0) {
      obj.actionDistanceEstimate = message.actionDistanceEstimate;
    }
    if (message.remainingTimeEstimate !== 0) {
      obj.remainingTimeEstimate = message.remainingTimeEstimate;
    }
    if (message.remainingDistanceEstimate !== 0) {
      obj.remainingDistanceEstimate = message.remainingDistanceEstimate;
    }
    if (message.useRtxSettings === true) {
      obj.useRtxSettings = message.useRtxSettings;
    }
    if (message.rtxSettings !== undefined) {
      obj.rtxSettings = ReturnSettings.toJSON(message.rtxSettings);
    }
    if (message.waypointsCompleted !== 0) {
      obj.waypointsCompleted = Math.round(message.waypointsCompleted);
    }
    if (message.navigationModeOverrideEnabled === true) {
      obj.navigationModeOverrideEnabled = message.navigationModeOverrideEnabled;
    }
    if (message.navigationModeOverride !== 0) {
      obj.navigationModeOverride = navigationMode_ModeToJSON(message.navigationModeOverride);
    }
    if (message.expectedMissionResult !== 0) {
      obj.expectedMissionResult = missionResult_ResultToJSON(message.expectedMissionResult);
    }
    if (message.lastActionResult !== undefined) {
      obj.lastActionResult = ActionResult.toJSON(message.lastActionResult);
    }
    if (message.freeLookActive === true) {
      obj.freeLookActive = message.freeLookActive;
    }
    if (message.supportedFreeLookMode !== 0) {
      obj.supportedFreeLookMode = freeLookMode_EnumToJSON(message.supportedFreeLookMode);
    }
    if (message.skipAlert === true) {
      obj.skipAlert = message.skipAlert;
    }
    if (message.pausedUnresumableReason !== 0) {
      obj.pausedUnresumableReason = missionState_PausedUnresumableReasonToJSON(message.pausedUnresumableReason);
    }
    if (message.activeMissionTierType !== 0) {
      obj.activeMissionTierType = missionTierTypeEnum_EnumToJSON(message.activeMissionTierType);
    }
    if (message.queuedMissions?.length) {
      obj.queuedMissions = message.queuedMissions.map((e) => MissionSummary.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MissionState>, I>>(base?: I): MissionState {
    return MissionState.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MissionState>, I>>(object: I): MissionState {
    const message = createBaseMissionState();
    message.utime = object.utime ?? 0;
    message.stateEnum = object.stateEnum ?? 0;
    message.missionName = object.missionName ?? "";
    message.missionUuid = object.missionUuid ?? "";
    message.templateUuid = object.templateUuid ?? "";
    message.executionUuid = object.executionUuid ?? "";
    message.scheduledMissionUuid = object.scheduledMissionUuid ?? "";
    message.actionIndex = object.actionIndex ?? 0;
    message.actionState = (object.actionState !== undefined && object.actionState !== null)
      ? ActionState.fromPartial(object.actionState)
      : undefined;
    message.waypointIndex = object.waypointIndex ?? 0;
    message.numWaypoints = object.numWaypoints ?? 0;
    message.flightInfo = (object.flightInfo !== undefined && object.flightInfo !== null)
      ? FlightInfo.fromPartial(object.flightInfo)
      : undefined;
    message.updateNonceHistory = object.updateNonceHistory?.map((e) => e) || [];
    message.gpsStatus = object.gpsStatus ?? 0;
    message.postMissionAction = object.postMissionAction ?? 0;
    message.lostConnectionAction = object.lostConnectionAction ?? 0;
    message.faultBasedDirectRtdEnabled = object.faultBasedDirectRtdEnabled ?? false;
    message.actionTimeEstimate = object.actionTimeEstimate ?? 0;
    message.actionDistanceEstimate = object.actionDistanceEstimate ?? 0;
    message.remainingTimeEstimate = object.remainingTimeEstimate ?? 0;
    message.remainingDistanceEstimate = object.remainingDistanceEstimate ?? 0;
    message.useRtxSettings = object.useRtxSettings ?? false;
    message.rtxSettings = (object.rtxSettings !== undefined && object.rtxSettings !== null)
      ? ReturnSettings.fromPartial(object.rtxSettings)
      : undefined;
    message.waypointsCompleted = object.waypointsCompleted ?? 0;
    message.navigationModeOverrideEnabled = object.navigationModeOverrideEnabled ?? false;
    message.navigationModeOverride = object.navigationModeOverride ?? 0;
    message.expectedMissionResult = object.expectedMissionResult ?? 0;
    message.lastActionResult = (object.lastActionResult !== undefined && object.lastActionResult !== null)
      ? ActionResult.fromPartial(object.lastActionResult)
      : undefined;
    message.freeLookActive = object.freeLookActive ?? false;
    message.supportedFreeLookMode = object.supportedFreeLookMode ?? 0;
    message.skipAlert = object.skipAlert ?? false;
    message.pausedUnresumableReason = object.pausedUnresumableReason ?? 0;
    message.activeMissionTierType = object.activeMissionTierType ?? 0;
    message.queuedMissions = object.queuedMissions?.map((e) => MissionSummary.fromPartial(e)) || [];
    return message;
  },
};

function createBaseMissionSummary(): MissionSummary {
  return {
    missionTierType: 0,
    stateEnum: 0,
    missionName: "",
    templateUuid: undefined,
    executionUuid: undefined,
    progressRatio: 0,
  };
}

export const MissionSummary = {
  encode(message: MissionSummary, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.missionTierType !== 0) {
      writer.uint32(8).int32(message.missionTierType);
    }
    if (message.stateEnum !== 0) {
      writer.uint32(16).int32(message.stateEnum);
    }
    if (message.missionName !== "") {
      writer.uint32(34).string(message.missionName);
    }
    if (message.templateUuid !== undefined) {
      Uuid.encode(message.templateUuid, writer.uint32(42).fork()).ldelim();
    }
    if (message.executionUuid !== undefined) {
      Uuid.encode(message.executionUuid, writer.uint32(50).fork()).ldelim();
    }
    if (message.progressRatio !== 0) {
      writer.uint32(61).float(message.progressRatio);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): MissionSummary {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMissionSummary();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.missionTierType = reader.int32() as any;
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.stateEnum = reader.int32() as any;
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.missionName = reader.string();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.templateUuid = Uuid.decode(reader, reader.uint32());
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.executionUuid = Uuid.decode(reader, reader.uint32());
          continue;
        case 7:
          if (tag !== 61) {
            break;
          }

          message.progressRatio = reader.float();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MissionSummary {
    return {
      missionTierType: isSet(object.missionTierType) ? missionTierTypeEnum_EnumFromJSON(object.missionTierType) : 0,
      stateEnum: isSet(object.stateEnum) ? missionState_MissionStateEnumFromJSON(object.stateEnum) : 0,
      missionName: isSet(object.missionName) ? globalThis.String(object.missionName) : "",
      templateUuid: isSet(object.templateUuid) ? Uuid.fromJSON(object.templateUuid) : undefined,
      executionUuid: isSet(object.executionUuid) ? Uuid.fromJSON(object.executionUuid) : undefined,
      progressRatio: isSet(object.progressRatio) ? globalThis.Number(object.progressRatio) : 0,
    };
  },

  toJSON(message: MissionSummary): unknown {
    const obj: any = {};
    if (message.missionTierType !== 0) {
      obj.missionTierType = missionTierTypeEnum_EnumToJSON(message.missionTierType);
    }
    if (message.stateEnum !== 0) {
      obj.stateEnum = missionState_MissionStateEnumToJSON(message.stateEnum);
    }
    if (message.missionName !== "") {
      obj.missionName = message.missionName;
    }
    if (message.templateUuid !== undefined) {
      obj.templateUuid = Uuid.toJSON(message.templateUuid);
    }
    if (message.executionUuid !== undefined) {
      obj.executionUuid = Uuid.toJSON(message.executionUuid);
    }
    if (message.progressRatio !== 0) {
      obj.progressRatio = message.progressRatio;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MissionSummary>, I>>(base?: I): MissionSummary {
    return MissionSummary.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MissionSummary>, I>>(object: I): MissionSummary {
    const message = createBaseMissionSummary();
    message.missionTierType = object.missionTierType ?? 0;
    message.stateEnum = object.stateEnum ?? 0;
    message.missionName = object.missionName ?? "";
    message.templateUuid = (object.templateUuid !== undefined && object.templateUuid !== null)
      ? Uuid.fromPartial(object.templateUuid)
      : undefined;
    message.executionUuid = (object.executionUuid !== undefined && object.executionUuid !== null)
      ? Uuid.fromPartial(object.executionUuid)
      : undefined;
    message.progressRatio = object.progressRatio ?? 0;
    return message;
  },
};

function createBaseSequenceEstimate(): SequenceEstimate {
  return {
    name: "",
    actionUuid: "",
    duration: 0,
    distanceTraveled: 0,
    finalPosition: undefined,
    childSequenceEstimates: [],
  };
}

export const SequenceEstimate = {
  encode(message: SequenceEstimate, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    if (message.actionUuid !== "") {
      writer.uint32(50).string(message.actionUuid);
    }
    if (message.duration !== 0) {
      writer.uint32(21).float(message.duration);
    }
    if (message.distanceTraveled !== 0) {
      writer.uint32(29).float(message.distanceTraveled);
    }
    if (message.finalPosition !== undefined) {
      Waypoint.encode(message.finalPosition, writer.uint32(34).fork()).ldelim();
    }
    for (const v of message.childSequenceEstimates) {
      SequenceEstimate.encode(v!, writer.uint32(42).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SequenceEstimate {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSequenceEstimate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.actionUuid = reader.string();
          continue;
        case 2:
          if (tag !== 21) {
            break;
          }

          message.duration = reader.float();
          continue;
        case 3:
          if (tag !== 29) {
            break;
          }

          message.distanceTraveled = reader.float();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.finalPosition = Waypoint.decode(reader, reader.uint32());
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.childSequenceEstimates.push(SequenceEstimate.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SequenceEstimate {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      actionUuid: isSet(object.actionUuid) ? globalThis.String(object.actionUuid) : "",
      duration: isSet(object.duration) ? globalThis.Number(object.duration) : 0,
      distanceTraveled: isSet(object.distanceTraveled) ? globalThis.Number(object.distanceTraveled) : 0,
      finalPosition: isSet(object.finalPosition) ? Waypoint.fromJSON(object.finalPosition) : undefined,
      childSequenceEstimates: globalThis.Array.isArray(object?.childSequenceEstimates)
        ? object.childSequenceEstimates.map((e: any) => SequenceEstimate.fromJSON(e))
        : [],
    };
  },

  toJSON(message: SequenceEstimate): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.actionUuid !== "") {
      obj.actionUuid = message.actionUuid;
    }
    if (message.duration !== 0) {
      obj.duration = message.duration;
    }
    if (message.distanceTraveled !== 0) {
      obj.distanceTraveled = message.distanceTraveled;
    }
    if (message.finalPosition !== undefined) {
      obj.finalPosition = Waypoint.toJSON(message.finalPosition);
    }
    if (message.childSequenceEstimates?.length) {
      obj.childSequenceEstimates = message.childSequenceEstimates.map((e) => SequenceEstimate.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SequenceEstimate>, I>>(base?: I): SequenceEstimate {
    return SequenceEstimate.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SequenceEstimate>, I>>(object: I): SequenceEstimate {
    const message = createBaseSequenceEstimate();
    message.name = object.name ?? "";
    message.actionUuid = object.actionUuid ?? "";
    message.duration = object.duration ?? 0;
    message.distanceTraveled = object.distanceTraveled ?? 0;
    message.finalPosition = (object.finalPosition !== undefined && object.finalPosition !== null)
      ? Waypoint.fromPartial(object.finalPosition)
      : undefined;
    message.childSequenceEstimates = object.childSequenceEstimates?.map((e) => SequenceEstimate.fromPartial(e)) || [];
    return message;
  },
};

function createBaseMissionUpdate(): MissionUpdate {
  return { utime: 0, nonce: "", missionUuid: "", type: 0, actions: [], relativeActionUuid: "", insertBefore: false };
}

export const MissionUpdate = {
  encode(message: MissionUpdate, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.utime !== 0) {
      writer.uint32(48).int64(message.utime);
    }
    if (message.nonce !== "") {
      writer.uint32(10).string(message.nonce);
    }
    if (message.missionUuid !== "") {
      writer.uint32(18).string(message.missionUuid);
    }
    if (message.type !== 0) {
      writer.uint32(24).int32(message.type);
    }
    for (const v of message.actions) {
      Action.encode(v!, writer.uint32(34).fork()).ldelim();
    }
    if (message.relativeActionUuid !== "") {
      writer.uint32(42).string(message.relativeActionUuid);
    }
    if (message.insertBefore === true) {
      writer.uint32(56).bool(message.insertBefore);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): MissionUpdate {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMissionUpdate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 6:
          if (tag !== 48) {
            break;
          }

          message.utime = longToNumber(reader.int64() as Long);
          continue;
        case 1:
          if (tag !== 10) {
            break;
          }

          message.nonce = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.missionUuid = reader.string();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.actions.push(Action.decode(reader, reader.uint32()));
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.relativeActionUuid = reader.string();
          continue;
        case 7:
          if (tag !== 56) {
            break;
          }

          message.insertBefore = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MissionUpdate {
    return {
      utime: isSet(object.utime) ? globalThis.Number(object.utime) : 0,
      nonce: isSet(object.nonce) ? globalThis.String(object.nonce) : "",
      missionUuid: isSet(object.missionUuid) ? globalThis.String(object.missionUuid) : "",
      type: isSet(object.type) ? missionUpdate_UpdateTypeFromJSON(object.type) : 0,
      actions: globalThis.Array.isArray(object?.actions) ? object.actions.map((e: any) => Action.fromJSON(e)) : [],
      relativeActionUuid: isSet(object.relativeActionUuid) ? globalThis.String(object.relativeActionUuid) : "",
      insertBefore: isSet(object.insertBefore) ? globalThis.Boolean(object.insertBefore) : false,
    };
  },

  toJSON(message: MissionUpdate): unknown {
    const obj: any = {};
    if (message.utime !== 0) {
      obj.utime = Math.round(message.utime);
    }
    if (message.nonce !== "") {
      obj.nonce = message.nonce;
    }
    if (message.missionUuid !== "") {
      obj.missionUuid = message.missionUuid;
    }
    if (message.type !== 0) {
      obj.type = missionUpdate_UpdateTypeToJSON(message.type);
    }
    if (message.actions?.length) {
      obj.actions = message.actions.map((e) => Action.toJSON(e));
    }
    if (message.relativeActionUuid !== "") {
      obj.relativeActionUuid = message.relativeActionUuid;
    }
    if (message.insertBefore === true) {
      obj.insertBefore = message.insertBefore;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MissionUpdate>, I>>(base?: I): MissionUpdate {
    return MissionUpdate.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MissionUpdate>, I>>(object: I): MissionUpdate {
    const message = createBaseMissionUpdate();
    message.utime = object.utime ?? 0;
    message.nonce = object.nonce ?? "";
    message.missionUuid = object.missionUuid ?? "";
    message.type = object.type ?? 0;
    message.actions = object.actions?.map((e) => Action.fromPartial(e)) || [];
    message.relativeActionUuid = object.relativeActionUuid ?? "";
    message.insertBefore = object.insertBefore ?? false;
    return message;
  },
};

function createBaseMissionUpdateResponse(): MissionUpdateResponse {
  return { utime: 0, nonce: "", uuid: "", updateAccepted: false };
}

export const MissionUpdateResponse = {
  encode(message: MissionUpdateResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.utime !== 0) {
      writer.uint32(8).int64(message.utime);
    }
    if (message.nonce !== "") {
      writer.uint32(18).string(message.nonce);
    }
    if (message.uuid !== "") {
      writer.uint32(26).string(message.uuid);
    }
    if (message.updateAccepted === true) {
      writer.uint32(32).bool(message.updateAccepted);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): MissionUpdateResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMissionUpdateResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.utime = longToNumber(reader.int64() as Long);
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.nonce = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.uuid = reader.string();
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.updateAccepted = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MissionUpdateResponse {
    return {
      utime: isSet(object.utime) ? globalThis.Number(object.utime) : 0,
      nonce: isSet(object.nonce) ? globalThis.String(object.nonce) : "",
      uuid: isSet(object.uuid) ? globalThis.String(object.uuid) : "",
      updateAccepted: isSet(object.updateAccepted) ? globalThis.Boolean(object.updateAccepted) : false,
    };
  },

  toJSON(message: MissionUpdateResponse): unknown {
    const obj: any = {};
    if (message.utime !== 0) {
      obj.utime = Math.round(message.utime);
    }
    if (message.nonce !== "") {
      obj.nonce = message.nonce;
    }
    if (message.uuid !== "") {
      obj.uuid = message.uuid;
    }
    if (message.updateAccepted === true) {
      obj.updateAccepted = message.updateAccepted;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MissionUpdateResponse>, I>>(base?: I): MissionUpdateResponse {
    return MissionUpdateResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MissionUpdateResponse>, I>>(object: I): MissionUpdateResponse {
    const message = createBaseMissionUpdateResponse();
    message.utime = object.utime ?? 0;
    message.nonce = object.nonce ?? "";
    message.uuid = object.uuid ?? "";
    message.updateAccepted = object.updateAccepted ?? false;
    return message;
  },
};

function createBaseMissionControl(): MissionControl {
  return { utime: 0, command: 0, actionUuid: "" };
}

export const MissionControl = {
  encode(message: MissionControl, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.utime !== 0) {
      writer.uint32(16).int64(message.utime);
    }
    if (message.command !== 0) {
      writer.uint32(8).int32(message.command);
    }
    if (message.actionUuid !== "") {
      writer.uint32(26).string(message.actionUuid);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): MissionControl {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMissionControl();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2:
          if (tag !== 16) {
            break;
          }

          message.utime = longToNumber(reader.int64() as Long);
          continue;
        case 1:
          if (tag !== 8) {
            break;
          }

          message.command = reader.int32() as any;
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.actionUuid = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MissionControl {
    return {
      utime: isSet(object.utime) ? globalThis.Number(object.utime) : 0,
      command: isSet(object.command) ? missionControl_ControlTypeFromJSON(object.command) : 0,
      actionUuid: isSet(object.actionUuid) ? globalThis.String(object.actionUuid) : "",
    };
  },

  toJSON(message: MissionControl): unknown {
    const obj: any = {};
    if (message.utime !== 0) {
      obj.utime = Math.round(message.utime);
    }
    if (message.command !== 0) {
      obj.command = missionControl_ControlTypeToJSON(message.command);
    }
    if (message.actionUuid !== "") {
      obj.actionUuid = message.actionUuid;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MissionControl>, I>>(base?: I): MissionControl {
    return MissionControl.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MissionControl>, I>>(object: I): MissionControl {
    const message = createBaseMissionControl();
    message.utime = object.utime ?? 0;
    message.command = object.command ?? 0;
    message.actionUuid = object.actionUuid ?? "";
    return message;
  },
};

function createBaseFlightInfo(): FlightInfo {
  return { vehicleName: "", vehicleId: "", flightId: "", startUclock: 0 };
}

export const FlightInfo = {
  encode(message: FlightInfo, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.vehicleName !== "") {
      writer.uint32(10).string(message.vehicleName);
    }
    if (message.vehicleId !== "") {
      writer.uint32(18).string(message.vehicleId);
    }
    if (message.flightId !== "") {
      writer.uint32(26).string(message.flightId);
    }
    if (message.startUclock !== 0) {
      writer.uint32(32).int64(message.startUclock);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): FlightInfo {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFlightInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.vehicleName = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.vehicleId = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.flightId = reader.string();
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.startUclock = longToNumber(reader.int64() as Long);
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FlightInfo {
    return {
      vehicleName: isSet(object.vehicleName) ? globalThis.String(object.vehicleName) : "",
      vehicleId: isSet(object.vehicleId) ? globalThis.String(object.vehicleId) : "",
      flightId: isSet(object.flightId) ? globalThis.String(object.flightId) : "",
      startUclock: isSet(object.startUclock) ? globalThis.Number(object.startUclock) : 0,
    };
  },

  toJSON(message: FlightInfo): unknown {
    const obj: any = {};
    if (message.vehicleName !== "") {
      obj.vehicleName = message.vehicleName;
    }
    if (message.vehicleId !== "") {
      obj.vehicleId = message.vehicleId;
    }
    if (message.flightId !== "") {
      obj.flightId = message.flightId;
    }
    if (message.startUclock !== 0) {
      obj.startUclock = Math.round(message.startUclock);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FlightInfo>, I>>(base?: I): FlightInfo {
    return FlightInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FlightInfo>, I>>(object: I): FlightInfo {
    const message = createBaseFlightInfo();
    message.vehicleName = object.vehicleName ?? "";
    message.vehicleId = object.vehicleId ?? "";
    message.flightId = object.flightId ?? "";
    message.startUclock = object.startUclock ?? 0;
    return message;
  },
};

function createBaseActionState(): ActionState {
  return {
    actionUuid: "",
    progressRatio: 0,
    startUclock: 0,
    displayMessage: "",
    sequence: undefined,
    gotoAndOrbitPoi: undefined,
    orbitPoiAction: undefined,
    gotoGpsWaypoint: undefined,
    gotoNavWaypoint: undefined,
    takePhoto: undefined,
    surfaceScanSkill: undefined,
    startVideo: undefined,
    stopVideo: undefined,
    switchRecordingMode: undefined,
    timedWait: undefined,
    takePanorama: undefined,
    keyframeSkill: undefined,
    gotoWaypoint: undefined,
    setObstacleAvoidance: undefined,
    initializeGps: undefined,
    subjectDetected: undefined,
    looper: undefined,
    withinDistance: undefined,
    unifiedFollowAction: undefined,
    inverter: undefined,
    togglePhotoIntervalMode: undefined,
    wifiScan: undefined,
    enableStrobeLights: undefined,
    disableStrobeLights: undefined,
    spoofJoysticksInputs: undefined,
    updateJoysticksSettings: undefined,
    updateShapeMap: undefined,
    spoofObstacle: undefined,
    dummyAction: undefined,
    testDesiredVelocityAction: undefined,
    testTrackTrajectory: undefined,
    atvSubjectSpoofAction: undefined,
    skiSubjectSpoofAction: undefined,
    setGimbalOrientation: undefined,
    parallel: undefined,
    sequenceUntilSuccess: undefined,
    sequenceUntilFailure: undefined,
    sequencePretakeoff: undefined,
    sequenceConfig: undefined,
    waitForRtk: undefined,
    wingWaypointsCommand: undefined,
    sendDynamicScenario: undefined,
    scoutAction: undefined,
    spoofTrackingDevice: undefined,
    spoofDisturbanceAction: undefined,
    updateVehicleSettings: undefined,
    waitForVehicleStop: undefined,
    precomputedSubjectSpoofAction: undefined,
    modifySimStateEstimation: undefined,
    acquireGps: undefined,
    setFaultOverride: undefined,
    eLand: undefined,
    trajectoryInspect: undefined,
    toggleTargetPointExposure: undefined,
    toggleSemanticAim: undefined,
    spoofBatteryLevel: undefined,
    ncpgControl: undefined,
    registerComplimentaryActions: undefined,
    trackInPlace: undefined,
    globalGraphControl: undefined,
    overrideGpsQuality: undefined,
    initGlobalMap: undefined,
    stopForPhotoInspect: undefined,
    spoofInitialGpsHeading: undefined,
    trackLandingPadRequest: undefined,
    apriltagSetId: undefined,
    dockGpsEstimator: undefined,
    g47CommandOverride: undefined,
    requestTakeoffProfile: undefined,
    updateDockLocationAction: undefined,
    setDesiredGpsSource: undefined,
    spoofManualGps: undefined,
    weatherAction: undefined,
    setZoom: undefined,
    missionPlannerServiceControl: undefined,
    spotlightAction: undefined,
    setCameraSettings: undefined,
    parachuteControl: undefined,
    nightsenseAction: undefined,
    spoofMultiDrone: undefined,
    setMovementCommand: undefined,
    spoofFlightEnvelopeLimits: undefined,
    turntable: undefined,
    dancingDrone: undefined,
    waitForPreciseFault: undefined,
    dancingDroneSpline: undefined,
    globalPlannerRequest: undefined,
    toggleSubjectDetection: undefined,
    spoofSubjectScenario: undefined,
    setSubjectFollowerSettings: undefined,
    geofenceConfig: undefined,
    setDesiredImuSource: undefined,
    sendMotionCommand: undefined,
    setGnssSolverQuality: undefined,
    spoofPhoneUiVariablesAction: undefined,
    playAudio: undefined,
  };
}

export const ActionState = {
  encode(message: ActionState, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.actionUuid !== "") {
      writer.uint32(10).string(message.actionUuid);
    }
    if (message.progressRatio !== 0) {
      writer.uint32(21).float(message.progressRatio);
    }
    if (message.startUclock !== 0) {
      writer.uint32(24).int64(message.startUclock);
    }
    if (message.displayMessage !== "") {
      writer.uint32(34).string(message.displayMessage);
    }
    if (message.sequence !== undefined) {
      SequenceActionStateData.encode(message.sequence, writer.uint32(1602).fork()).ldelim();
    }
    if (message.gotoAndOrbitPoi !== undefined) {
      GotoAndOrbitPoiActionStateData.encode(message.gotoAndOrbitPoi, writer.uint32(1618).fork()).ldelim();
    }
    if (message.orbitPoiAction !== undefined) {
      OrbitPoiActionStateData.encode(message.orbitPoiAction, writer.uint32(1626).fork()).ldelim();
    }
    if (message.gotoGpsWaypoint !== undefined) {
      GotoGpsWaypointActionStateData.encode(message.gotoGpsWaypoint, writer.uint32(1634).fork()).ldelim();
    }
    if (message.gotoNavWaypoint !== undefined) {
      GotoNavWaypointActionStateData.encode(message.gotoNavWaypoint, writer.uint32(1642).fork()).ldelim();
    }
    if (message.takePhoto !== undefined) {
      TakePhotoActionStateData.encode(message.takePhoto, writer.uint32(1650).fork()).ldelim();
    }
    if (message.surfaceScanSkill !== undefined) {
      SurfaceScanActionStateData.encode(message.surfaceScanSkill, writer.uint32(1658).fork()).ldelim();
    }
    if (message.startVideo !== undefined) {
      StartVideoActionStateData.encode(message.startVideo, writer.uint32(1666).fork()).ldelim();
    }
    if (message.stopVideo !== undefined) {
      StopVideoActionStateData.encode(message.stopVideo, writer.uint32(1674).fork()).ldelim();
    }
    if (message.switchRecordingMode !== undefined) {
      SwitchRecordingModeActionStateData.encode(message.switchRecordingMode, writer.uint32(1682).fork()).ldelim();
    }
    if (message.timedWait !== undefined) {
      TimedWaitActionStateData.encode(message.timedWait, writer.uint32(1690).fork()).ldelim();
    }
    if (message.takePanorama !== undefined) {
      TakePanoramaActionStateData.encode(message.takePanorama, writer.uint32(1698).fork()).ldelim();
    }
    if (message.keyframeSkill !== undefined) {
      KeyframeActionStateData.encode(message.keyframeSkill, writer.uint32(1706).fork()).ldelim();
    }
    if (message.gotoWaypoint !== undefined) {
      GotoWaypointActionStateData.encode(message.gotoWaypoint, writer.uint32(1714).fork()).ldelim();
    }
    if (message.setObstacleAvoidance !== undefined) {
      SetObstacleAvoidanceActionStateData.encode(message.setObstacleAvoidance, writer.uint32(1722).fork()).ldelim();
    }
    if (message.initializeGps !== undefined) {
      InitializeGpsActionStateData.encode(message.initializeGps, writer.uint32(1730).fork()).ldelim();
    }
    if (message.subjectDetected !== undefined) {
      SubjectDetectedActionStateData.encode(message.subjectDetected, writer.uint32(1738).fork()).ldelim();
    }
    if (message.looper !== undefined) {
      LooperActionStateData.encode(message.looper, writer.uint32(1746).fork()).ldelim();
    }
    if (message.withinDistance !== undefined) {
      WithinDistanceActionStateData.encode(message.withinDistance, writer.uint32(1754).fork()).ldelim();
    }
    if (message.unifiedFollowAction !== undefined) {
      UnifiedFollowActionStateData.encode(message.unifiedFollowAction, writer.uint32(1762).fork()).ldelim();
    }
    if (message.inverter !== undefined) {
      InverterActionStateData.encode(message.inverter, writer.uint32(1770).fork()).ldelim();
    }
    if (message.togglePhotoIntervalMode !== undefined) {
      TogglePhotoIntervalModeActionStateData.encode(message.togglePhotoIntervalMode, writer.uint32(1778).fork())
        .ldelim();
    }
    if (message.wifiScan !== undefined) {
      WifiScanActionStateData.encode(message.wifiScan, writer.uint32(1786).fork()).ldelim();
    }
    if (message.enableStrobeLights !== undefined) {
      EnableStrobeLightsActionStateData.encode(message.enableStrobeLights, writer.uint32(1794).fork()).ldelim();
    }
    if (message.disableStrobeLights !== undefined) {
      DisableStrobeLightsActionStateData.encode(message.disableStrobeLights, writer.uint32(1802).fork()).ldelim();
    }
    if (message.spoofJoysticksInputs !== undefined) {
      SpoofJoysticksInputsActionStateData.encode(message.spoofJoysticksInputs, writer.uint32(1810).fork()).ldelim();
    }
    if (message.updateJoysticksSettings !== undefined) {
      UpdateJoysticksSettingsActionStateData.encode(message.updateJoysticksSettings, writer.uint32(1818).fork())
        .ldelim();
    }
    if (message.updateShapeMap !== undefined) {
      UpdateShapeMapActionStateData.encode(message.updateShapeMap, writer.uint32(1826).fork()).ldelim();
    }
    if (message.spoofObstacle !== undefined) {
      SpoofObstacleActionStateData.encode(message.spoofObstacle, writer.uint32(1834).fork()).ldelim();
    }
    if (message.dummyAction !== undefined) {
      DummyActionStateData.encode(message.dummyAction, writer.uint32(1842).fork()).ldelim();
    }
    if (message.testDesiredVelocityAction !== undefined) {
      TestDesiredVelocityActionStateData.encode(message.testDesiredVelocityAction, writer.uint32(1850).fork()).ldelim();
    }
    if (message.testTrackTrajectory !== undefined) {
      TestTrackTrajectoryActionStateData.encode(message.testTrackTrajectory, writer.uint32(1858).fork()).ldelim();
    }
    if (message.atvSubjectSpoofAction !== undefined) {
      AtvSubjectSpoofActionStateData.encode(message.atvSubjectSpoofAction, writer.uint32(1866).fork()).ldelim();
    }
    if (message.skiSubjectSpoofAction !== undefined) {
      SkiSubjectSpoofActionStateData.encode(message.skiSubjectSpoofAction, writer.uint32(1874).fork()).ldelim();
    }
    if (message.setGimbalOrientation !== undefined) {
      SetGimbalOrientationActionStateData.encode(message.setGimbalOrientation, writer.uint32(1882).fork()).ldelim();
    }
    if (message.parallel !== undefined) {
      ParallelActionStateData.encode(message.parallel, writer.uint32(1890).fork()).ldelim();
    }
    if (message.sequenceUntilSuccess !== undefined) {
      SequenceUntilSuccessActionStateData.encode(message.sequenceUntilSuccess, writer.uint32(1898).fork()).ldelim();
    }
    if (message.sequenceUntilFailure !== undefined) {
      SequenceUntilFailureActionStateData.encode(message.sequenceUntilFailure, writer.uint32(1906).fork()).ldelim();
    }
    if (message.sequencePretakeoff !== undefined) {
      SequencePretakeoffActionStateData.encode(message.sequencePretakeoff, writer.uint32(2066).fork()).ldelim();
    }
    if (message.sequenceConfig !== undefined) {
      SequenceConfigActionStateData.encode(message.sequenceConfig, writer.uint32(2234).fork()).ldelim();
    }
    if (message.waitForRtk !== undefined) {
      WaitForRtkActionStateData.encode(message.waitForRtk, writer.uint32(2242).fork()).ldelim();
    }
    if (message.wingWaypointsCommand !== undefined) {
      WingWaypointsCommandActionStateData.encode(message.wingWaypointsCommand, writer.uint32(4002).fork()).ldelim();
    }
    if (message.sendDynamicScenario !== undefined) {
      SendDynamicScenarioActionStateData.encode(message.sendDynamicScenario, writer.uint32(4010).fork()).ldelim();
    }
    if (message.scoutAction !== undefined) {
      ScoutActionActionStateData.encode(message.scoutAction, writer.uint32(4018).fork()).ldelim();
    }
    if (message.spoofTrackingDevice !== undefined) {
      SpoofTrackingDeviceActionStateData.encode(message.spoofTrackingDevice, writer.uint32(4026).fork()).ldelim();
    }
    if (message.spoofDisturbanceAction !== undefined) {
      SpoofDisturbanceActionStateData.encode(message.spoofDisturbanceAction, writer.uint32(1914).fork()).ldelim();
    }
    if (message.updateVehicleSettings !== undefined) {
      UpdateVehicleSettingsActionStateData.encode(message.updateVehicleSettings, writer.uint32(1922).fork()).ldelim();
    }
    if (message.waitForVehicleStop !== undefined) {
      WaitForVehicleStopActionStateData.encode(message.waitForVehicleStop, writer.uint32(1930).fork()).ldelim();
    }
    if (message.precomputedSubjectSpoofAction !== undefined) {
      PrecomputedSubjectSpoofActionStateData.encode(message.precomputedSubjectSpoofAction, writer.uint32(1938).fork())
        .ldelim();
    }
    if (message.modifySimStateEstimation !== undefined) {
      ModifySimStateEstimationActionStateData.encode(message.modifySimStateEstimation, writer.uint32(1946).fork())
        .ldelim();
    }
    if (message.acquireGps !== undefined) {
      AcquireGpsActionStateData.encode(message.acquireGps, writer.uint32(1954).fork()).ldelim();
    }
    if (message.setFaultOverride !== undefined) {
      SetFaultOverrideActionStateData.encode(message.setFaultOverride, writer.uint32(1962).fork()).ldelim();
    }
    if (message.eLand !== undefined) {
      ELandActionStateData.encode(message.eLand, writer.uint32(1970).fork()).ldelim();
    }
    if (message.trajectoryInspect !== undefined) {
      TrajectoryInspectActionStateData.encode(message.trajectoryInspect, writer.uint32(1978).fork()).ldelim();
    }
    if (message.toggleTargetPointExposure !== undefined) {
      ToggleTargetPointExposureActionStateData.encode(message.toggleTargetPointExposure, writer.uint32(1986).fork())
        .ldelim();
    }
    if (message.toggleSemanticAim !== undefined) {
      ToggleSemanticAimActionStateData.encode(message.toggleSemanticAim, writer.uint32(1994).fork()).ldelim();
    }
    if (message.spoofBatteryLevel !== undefined) {
      SpoofBatteryLevelActionStateData.encode(message.spoofBatteryLevel, writer.uint32(2002).fork()).ldelim();
    }
    if (message.ncpgControl !== undefined) {
      NcpgControlActionStateData.encode(message.ncpgControl, writer.uint32(2010).fork()).ldelim();
    }
    if (message.registerComplimentaryActions !== undefined) {
      RegisterComplimentaryActionsActionStateData.encode(
        message.registerComplimentaryActions,
        writer.uint32(2018).fork(),
      ).ldelim();
    }
    if (message.trackInPlace !== undefined) {
      TrackInPlaceActionStateData.encode(message.trackInPlace, writer.uint32(2026).fork()).ldelim();
    }
    if (message.globalGraphControl !== undefined) {
      GlobalGraphControlActionStateData.encode(message.globalGraphControl, writer.uint32(2034).fork()).ldelim();
    }
    if (message.overrideGpsQuality !== undefined) {
      OverrideGpsQualityActionStateData.encode(message.overrideGpsQuality, writer.uint32(2042).fork()).ldelim();
    }
    if (message.initGlobalMap !== undefined) {
      InitGlobalMapActionStateData.encode(message.initGlobalMap, writer.uint32(2050).fork()).ldelim();
    }
    if (message.stopForPhotoInspect !== undefined) {
      StopForPhotoInspectActionStateData.encode(message.stopForPhotoInspect, writer.uint32(2058).fork()).ldelim();
    }
    if (message.spoofInitialGpsHeading !== undefined) {
      SpoofInitialGpsHeadingActionStateData.encode(message.spoofInitialGpsHeading, writer.uint32(2074).fork()).ldelim();
    }
    if (message.trackLandingPadRequest !== undefined) {
      TrackLandingPadRequestActionStateData.encode(message.trackLandingPadRequest, writer.uint32(2082).fork()).ldelim();
    }
    if (message.apriltagSetId !== undefined) {
      ApriltagSetIdActionStateData.encode(message.apriltagSetId, writer.uint32(2090).fork()).ldelim();
    }
    if (message.dockGpsEstimator !== undefined) {
      DockGpsEstimatorActionStateData.encode(message.dockGpsEstimator, writer.uint32(2098).fork()).ldelim();
    }
    if (message.g47CommandOverride !== undefined) {
      G47CommandOverrideActionStateData.encode(message.g47CommandOverride, writer.uint32(2106).fork()).ldelim();
    }
    if (message.requestTakeoffProfile !== undefined) {
      RequestTakeoffProfileActionStateData.encode(message.requestTakeoffProfile, writer.uint32(2114).fork()).ldelim();
    }
    if (message.updateDockLocationAction !== undefined) {
      UpdateDockLocationActionStateData.encode(message.updateDockLocationAction, writer.uint32(2122).fork()).ldelim();
    }
    if (message.setDesiredGpsSource !== undefined) {
      SetDesiredGpsSourceActionStateData.encode(message.setDesiredGpsSource, writer.uint32(2130).fork()).ldelim();
    }
    if (message.spoofManualGps !== undefined) {
      SpoofManualGpsActionStateData.encode(message.spoofManualGps, writer.uint32(2138).fork()).ldelim();
    }
    if (message.weatherAction !== undefined) {
      WeatherActionStateData.encode(message.weatherAction, writer.uint32(2146).fork()).ldelim();
    }
    if (message.setZoom !== undefined) {
      SetZoomActionStateData.encode(message.setZoom, writer.uint32(2154).fork()).ldelim();
    }
    if (message.missionPlannerServiceControl !== undefined) {
      MissionPlannerServiceControlActionStateData.encode(
        message.missionPlannerServiceControl,
        writer.uint32(2162).fork(),
      ).ldelim();
    }
    if (message.spotlightAction !== undefined) {
      SpotlightActionStateData.encode(message.spotlightAction, writer.uint32(2170).fork()).ldelim();
    }
    if (message.setCameraSettings !== undefined) {
      SetCameraSettingsActionStateData.encode(message.setCameraSettings, writer.uint32(2178).fork()).ldelim();
    }
    if (message.parachuteControl !== undefined) {
      ParachuteControlActionStateData.encode(message.parachuteControl, writer.uint32(2186).fork()).ldelim();
    }
    if (message.nightsenseAction !== undefined) {
      NightsenseActionStateData.encode(message.nightsenseAction, writer.uint32(2194).fork()).ldelim();
    }
    if (message.spoofMultiDrone !== undefined) {
      SpoofMultiDroneActionStateData.encode(message.spoofMultiDrone, writer.uint32(2202).fork()).ldelim();
    }
    if (message.setMovementCommand !== undefined) {
      SetMovementCommandActionStateData.encode(message.setMovementCommand, writer.uint32(2210).fork()).ldelim();
    }
    if (message.spoofFlightEnvelopeLimits !== undefined) {
      SpoofFlightEnvelopeLimitsActionStateData.encode(message.spoofFlightEnvelopeLimits, writer.uint32(2218).fork())
        .ldelim();
    }
    if (message.turntable !== undefined) {
      TurntableActionStateData.encode(message.turntable, writer.uint32(2226).fork()).ldelim();
    }
    if (message.dancingDrone !== undefined) {
      DancingDroneActionStateData.encode(message.dancingDrone, writer.uint32(2250).fork()).ldelim();
    }
    if (message.waitForPreciseFault !== undefined) {
      WaitForPreciseFaultActionStateData.encode(message.waitForPreciseFault, writer.uint32(2258).fork()).ldelim();
    }
    if (message.dancingDroneSpline !== undefined) {
      DancingDroneSplineActionStateData.encode(message.dancingDroneSpline, writer.uint32(2266).fork()).ldelim();
    }
    if (message.globalPlannerRequest !== undefined) {
      GlobalPlannerRequestActionStateData.encode(message.globalPlannerRequest, writer.uint32(2274).fork()).ldelim();
    }
    if (message.toggleSubjectDetection !== undefined) {
      ToggleSubjectDetectionActionStateData.encode(message.toggleSubjectDetection, writer.uint32(2282).fork()).ldelim();
    }
    if (message.spoofSubjectScenario !== undefined) {
      SpoofSubjectScenarioActionStateData.encode(message.spoofSubjectScenario, writer.uint32(2290).fork()).ldelim();
    }
    if (message.setSubjectFollowerSettings !== undefined) {
      SetSubjectFollowerSettingsActionStateData.encode(message.setSubjectFollowerSettings, writer.uint32(2298).fork())
        .ldelim();
    }
    if (message.geofenceConfig !== undefined) {
      GeofenceConfigActionStateData.encode(message.geofenceConfig, writer.uint32(2306).fork()).ldelim();
    }
    if (message.setDesiredImuSource !== undefined) {
      SetDesiredImuSourceActionStateData.encode(message.setDesiredImuSource, writer.uint32(4034).fork()).ldelim();
    }
    if (message.sendMotionCommand !== undefined) {
      SendMotionCommandActionStateData.encode(message.sendMotionCommand, writer.uint32(4042).fork()).ldelim();
    }
    if (message.setGnssSolverQuality !== undefined) {
      SetGnssSolverQualityActionStateData.encode(message.setGnssSolverQuality, writer.uint32(2314).fork()).ldelim();
    }
    if (message.spoofPhoneUiVariablesAction !== undefined) {
      SpoofPhoneUiVariablesActionStateData.encode(message.spoofPhoneUiVariablesAction, writer.uint32(4050).fork())
        .ldelim();
    }
    if (message.playAudio !== undefined) {
      PlayAudioActionStateData.encode(message.playAudio, writer.uint32(2322).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ActionState {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseActionState();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.actionUuid = reader.string();
          continue;
        case 2:
          if (tag !== 21) {
            break;
          }

          message.progressRatio = reader.float();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.startUclock = longToNumber(reader.int64() as Long);
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.displayMessage = reader.string();
          continue;
        case 200:
          if (tag !== 1602) {
            break;
          }

          message.sequence = SequenceActionStateData.decode(reader, reader.uint32());
          continue;
        case 202:
          if (tag !== 1618) {
            break;
          }

          message.gotoAndOrbitPoi = GotoAndOrbitPoiActionStateData.decode(reader, reader.uint32());
          continue;
        case 203:
          if (tag !== 1626) {
            break;
          }

          message.orbitPoiAction = OrbitPoiActionStateData.decode(reader, reader.uint32());
          continue;
        case 204:
          if (tag !== 1634) {
            break;
          }

          message.gotoGpsWaypoint = GotoGpsWaypointActionStateData.decode(reader, reader.uint32());
          continue;
        case 205:
          if (tag !== 1642) {
            break;
          }

          message.gotoNavWaypoint = GotoNavWaypointActionStateData.decode(reader, reader.uint32());
          continue;
        case 206:
          if (tag !== 1650) {
            break;
          }

          message.takePhoto = TakePhotoActionStateData.decode(reader, reader.uint32());
          continue;
        case 207:
          if (tag !== 1658) {
            break;
          }

          message.surfaceScanSkill = SurfaceScanActionStateData.decode(reader, reader.uint32());
          continue;
        case 208:
          if (tag !== 1666) {
            break;
          }

          message.startVideo = StartVideoActionStateData.decode(reader, reader.uint32());
          continue;
        case 209:
          if (tag !== 1674) {
            break;
          }

          message.stopVideo = StopVideoActionStateData.decode(reader, reader.uint32());
          continue;
        case 210:
          if (tag !== 1682) {
            break;
          }

          message.switchRecordingMode = SwitchRecordingModeActionStateData.decode(reader, reader.uint32());
          continue;
        case 211:
          if (tag !== 1690) {
            break;
          }

          message.timedWait = TimedWaitActionStateData.decode(reader, reader.uint32());
          continue;
        case 212:
          if (tag !== 1698) {
            break;
          }

          message.takePanorama = TakePanoramaActionStateData.decode(reader, reader.uint32());
          continue;
        case 213:
          if (tag !== 1706) {
            break;
          }

          message.keyframeSkill = KeyframeActionStateData.decode(reader, reader.uint32());
          continue;
        case 214:
          if (tag !== 1714) {
            break;
          }

          message.gotoWaypoint = GotoWaypointActionStateData.decode(reader, reader.uint32());
          continue;
        case 215:
          if (tag !== 1722) {
            break;
          }

          message.setObstacleAvoidance = SetObstacleAvoidanceActionStateData.decode(reader, reader.uint32());
          continue;
        case 216:
          if (tag !== 1730) {
            break;
          }

          message.initializeGps = InitializeGpsActionStateData.decode(reader, reader.uint32());
          continue;
        case 217:
          if (tag !== 1738) {
            break;
          }

          message.subjectDetected = SubjectDetectedActionStateData.decode(reader, reader.uint32());
          continue;
        case 218:
          if (tag !== 1746) {
            break;
          }

          message.looper = LooperActionStateData.decode(reader, reader.uint32());
          continue;
        case 219:
          if (tag !== 1754) {
            break;
          }

          message.withinDistance = WithinDistanceActionStateData.decode(reader, reader.uint32());
          continue;
        case 220:
          if (tag !== 1762) {
            break;
          }

          message.unifiedFollowAction = UnifiedFollowActionStateData.decode(reader, reader.uint32());
          continue;
        case 221:
          if (tag !== 1770) {
            break;
          }

          message.inverter = InverterActionStateData.decode(reader, reader.uint32());
          continue;
        case 222:
          if (tag !== 1778) {
            break;
          }

          message.togglePhotoIntervalMode = TogglePhotoIntervalModeActionStateData.decode(reader, reader.uint32());
          continue;
        case 223:
          if (tag !== 1786) {
            break;
          }

          message.wifiScan = WifiScanActionStateData.decode(reader, reader.uint32());
          continue;
        case 224:
          if (tag !== 1794) {
            break;
          }

          message.enableStrobeLights = EnableStrobeLightsActionStateData.decode(reader, reader.uint32());
          continue;
        case 225:
          if (tag !== 1802) {
            break;
          }

          message.disableStrobeLights = DisableStrobeLightsActionStateData.decode(reader, reader.uint32());
          continue;
        case 226:
          if (tag !== 1810) {
            break;
          }

          message.spoofJoysticksInputs = SpoofJoysticksInputsActionStateData.decode(reader, reader.uint32());
          continue;
        case 227:
          if (tag !== 1818) {
            break;
          }

          message.updateJoysticksSettings = UpdateJoysticksSettingsActionStateData.decode(reader, reader.uint32());
          continue;
        case 228:
          if (tag !== 1826) {
            break;
          }

          message.updateShapeMap = UpdateShapeMapActionStateData.decode(reader, reader.uint32());
          continue;
        case 229:
          if (tag !== 1834) {
            break;
          }

          message.spoofObstacle = SpoofObstacleActionStateData.decode(reader, reader.uint32());
          continue;
        case 230:
          if (tag !== 1842) {
            break;
          }

          message.dummyAction = DummyActionStateData.decode(reader, reader.uint32());
          continue;
        case 231:
          if (tag !== 1850) {
            break;
          }

          message.testDesiredVelocityAction = TestDesiredVelocityActionStateData.decode(reader, reader.uint32());
          continue;
        case 232:
          if (tag !== 1858) {
            break;
          }

          message.testTrackTrajectory = TestTrackTrajectoryActionStateData.decode(reader, reader.uint32());
          continue;
        case 233:
          if (tag !== 1866) {
            break;
          }

          message.atvSubjectSpoofAction = AtvSubjectSpoofActionStateData.decode(reader, reader.uint32());
          continue;
        case 234:
          if (tag !== 1874) {
            break;
          }

          message.skiSubjectSpoofAction = SkiSubjectSpoofActionStateData.decode(reader, reader.uint32());
          continue;
        case 235:
          if (tag !== 1882) {
            break;
          }

          message.setGimbalOrientation = SetGimbalOrientationActionStateData.decode(reader, reader.uint32());
          continue;
        case 236:
          if (tag !== 1890) {
            break;
          }

          message.parallel = ParallelActionStateData.decode(reader, reader.uint32());
          continue;
        case 237:
          if (tag !== 1898) {
            break;
          }

          message.sequenceUntilSuccess = SequenceUntilSuccessActionStateData.decode(reader, reader.uint32());
          continue;
        case 238:
          if (tag !== 1906) {
            break;
          }

          message.sequenceUntilFailure = SequenceUntilFailureActionStateData.decode(reader, reader.uint32());
          continue;
        case 258:
          if (tag !== 2066) {
            break;
          }

          message.sequencePretakeoff = SequencePretakeoffActionStateData.decode(reader, reader.uint32());
          continue;
        case 279:
          if (tag !== 2234) {
            break;
          }

          message.sequenceConfig = SequenceConfigActionStateData.decode(reader, reader.uint32());
          continue;
        case 280:
          if (tag !== 2242) {
            break;
          }

          message.waitForRtk = WaitForRtkActionStateData.decode(reader, reader.uint32());
          continue;
        case 500:
          if (tag !== 4002) {
            break;
          }

          message.wingWaypointsCommand = WingWaypointsCommandActionStateData.decode(reader, reader.uint32());
          continue;
        case 501:
          if (tag !== 4010) {
            break;
          }

          message.sendDynamicScenario = SendDynamicScenarioActionStateData.decode(reader, reader.uint32());
          continue;
        case 502:
          if (tag !== 4018) {
            break;
          }

          message.scoutAction = ScoutActionActionStateData.decode(reader, reader.uint32());
          continue;
        case 503:
          if (tag !== 4026) {
            break;
          }

          message.spoofTrackingDevice = SpoofTrackingDeviceActionStateData.decode(reader, reader.uint32());
          continue;
        case 239:
          if (tag !== 1914) {
            break;
          }

          message.spoofDisturbanceAction = SpoofDisturbanceActionStateData.decode(reader, reader.uint32());
          continue;
        case 240:
          if (tag !== 1922) {
            break;
          }

          message.updateVehicleSettings = UpdateVehicleSettingsActionStateData.decode(reader, reader.uint32());
          continue;
        case 241:
          if (tag !== 1930) {
            break;
          }

          message.waitForVehicleStop = WaitForVehicleStopActionStateData.decode(reader, reader.uint32());
          continue;
        case 242:
          if (tag !== 1938) {
            break;
          }

          message.precomputedSubjectSpoofAction = PrecomputedSubjectSpoofActionStateData.decode(
            reader,
            reader.uint32(),
          );
          continue;
        case 243:
          if (tag !== 1946) {
            break;
          }

          message.modifySimStateEstimation = ModifySimStateEstimationActionStateData.decode(reader, reader.uint32());
          continue;
        case 244:
          if (tag !== 1954) {
            break;
          }

          message.acquireGps = AcquireGpsActionStateData.decode(reader, reader.uint32());
          continue;
        case 245:
          if (tag !== 1962) {
            break;
          }

          message.setFaultOverride = SetFaultOverrideActionStateData.decode(reader, reader.uint32());
          continue;
        case 246:
          if (tag !== 1970) {
            break;
          }

          message.eLand = ELandActionStateData.decode(reader, reader.uint32());
          continue;
        case 247:
          if (tag !== 1978) {
            break;
          }

          message.trajectoryInspect = TrajectoryInspectActionStateData.decode(reader, reader.uint32());
          continue;
        case 248:
          if (tag !== 1986) {
            break;
          }

          message.toggleTargetPointExposure = ToggleTargetPointExposureActionStateData.decode(reader, reader.uint32());
          continue;
        case 249:
          if (tag !== 1994) {
            break;
          }

          message.toggleSemanticAim = ToggleSemanticAimActionStateData.decode(reader, reader.uint32());
          continue;
        case 250:
          if (tag !== 2002) {
            break;
          }

          message.spoofBatteryLevel = SpoofBatteryLevelActionStateData.decode(reader, reader.uint32());
          continue;
        case 251:
          if (tag !== 2010) {
            break;
          }

          message.ncpgControl = NcpgControlActionStateData.decode(reader, reader.uint32());
          continue;
        case 252:
          if (tag !== 2018) {
            break;
          }

          message.registerComplimentaryActions = RegisterComplimentaryActionsActionStateData.decode(
            reader,
            reader.uint32(),
          );
          continue;
        case 253:
          if (tag !== 2026) {
            break;
          }

          message.trackInPlace = TrackInPlaceActionStateData.decode(reader, reader.uint32());
          continue;
        case 254:
          if (tag !== 2034) {
            break;
          }

          message.globalGraphControl = GlobalGraphControlActionStateData.decode(reader, reader.uint32());
          continue;
        case 255:
          if (tag !== 2042) {
            break;
          }

          message.overrideGpsQuality = OverrideGpsQualityActionStateData.decode(reader, reader.uint32());
          continue;
        case 256:
          if (tag !== 2050) {
            break;
          }

          message.initGlobalMap = InitGlobalMapActionStateData.decode(reader, reader.uint32());
          continue;
        case 257:
          if (tag !== 2058) {
            break;
          }

          message.stopForPhotoInspect = StopForPhotoInspectActionStateData.decode(reader, reader.uint32());
          continue;
        case 259:
          if (tag !== 2074) {
            break;
          }

          message.spoofInitialGpsHeading = SpoofInitialGpsHeadingActionStateData.decode(reader, reader.uint32());
          continue;
        case 260:
          if (tag !== 2082) {
            break;
          }

          message.trackLandingPadRequest = TrackLandingPadRequestActionStateData.decode(reader, reader.uint32());
          continue;
        case 261:
          if (tag !== 2090) {
            break;
          }

          message.apriltagSetId = ApriltagSetIdActionStateData.decode(reader, reader.uint32());
          continue;
        case 262:
          if (tag !== 2098) {
            break;
          }

          message.dockGpsEstimator = DockGpsEstimatorActionStateData.decode(reader, reader.uint32());
          continue;
        case 263:
          if (tag !== 2106) {
            break;
          }

          message.g47CommandOverride = G47CommandOverrideActionStateData.decode(reader, reader.uint32());
          continue;
        case 264:
          if (tag !== 2114) {
            break;
          }

          message.requestTakeoffProfile = RequestTakeoffProfileActionStateData.decode(reader, reader.uint32());
          continue;
        case 265:
          if (tag !== 2122) {
            break;
          }

          message.updateDockLocationAction = UpdateDockLocationActionStateData.decode(reader, reader.uint32());
          continue;
        case 266:
          if (tag !== 2130) {
            break;
          }

          message.setDesiredGpsSource = SetDesiredGpsSourceActionStateData.decode(reader, reader.uint32());
          continue;
        case 267:
          if (tag !== 2138) {
            break;
          }

          message.spoofManualGps = SpoofManualGpsActionStateData.decode(reader, reader.uint32());
          continue;
        case 268:
          if (tag !== 2146) {
            break;
          }

          message.weatherAction = WeatherActionStateData.decode(reader, reader.uint32());
          continue;
        case 269:
          if (tag !== 2154) {
            break;
          }

          message.setZoom = SetZoomActionStateData.decode(reader, reader.uint32());
          continue;
        case 270:
          if (tag !== 2162) {
            break;
          }

          message.missionPlannerServiceControl = MissionPlannerServiceControlActionStateData.decode(
            reader,
            reader.uint32(),
          );
          continue;
        case 271:
          if (tag !== 2170) {
            break;
          }

          message.spotlightAction = SpotlightActionStateData.decode(reader, reader.uint32());
          continue;
        case 272:
          if (tag !== 2178) {
            break;
          }

          message.setCameraSettings = SetCameraSettingsActionStateData.decode(reader, reader.uint32());
          continue;
        case 273:
          if (tag !== 2186) {
            break;
          }

          message.parachuteControl = ParachuteControlActionStateData.decode(reader, reader.uint32());
          continue;
        case 274:
          if (tag !== 2194) {
            break;
          }

          message.nightsenseAction = NightsenseActionStateData.decode(reader, reader.uint32());
          continue;
        case 275:
          if (tag !== 2202) {
            break;
          }

          message.spoofMultiDrone = SpoofMultiDroneActionStateData.decode(reader, reader.uint32());
          continue;
        case 276:
          if (tag !== 2210) {
            break;
          }

          message.setMovementCommand = SetMovementCommandActionStateData.decode(reader, reader.uint32());
          continue;
        case 277:
          if (tag !== 2218) {
            break;
          }

          message.spoofFlightEnvelopeLimits = SpoofFlightEnvelopeLimitsActionStateData.decode(reader, reader.uint32());
          continue;
        case 278:
          if (tag !== 2226) {
            break;
          }

          message.turntable = TurntableActionStateData.decode(reader, reader.uint32());
          continue;
        case 281:
          if (tag !== 2250) {
            break;
          }

          message.dancingDrone = DancingDroneActionStateData.decode(reader, reader.uint32());
          continue;
        case 282:
          if (tag !== 2258) {
            break;
          }

          message.waitForPreciseFault = WaitForPreciseFaultActionStateData.decode(reader, reader.uint32());
          continue;
        case 283:
          if (tag !== 2266) {
            break;
          }

          message.dancingDroneSpline = DancingDroneSplineActionStateData.decode(reader, reader.uint32());
          continue;
        case 284:
          if (tag !== 2274) {
            break;
          }

          message.globalPlannerRequest = GlobalPlannerRequestActionStateData.decode(reader, reader.uint32());
          continue;
        case 285:
          if (tag !== 2282) {
            break;
          }

          message.toggleSubjectDetection = ToggleSubjectDetectionActionStateData.decode(reader, reader.uint32());
          continue;
        case 286:
          if (tag !== 2290) {
            break;
          }

          message.spoofSubjectScenario = SpoofSubjectScenarioActionStateData.decode(reader, reader.uint32());
          continue;
        case 287:
          if (tag !== 2298) {
            break;
          }

          message.setSubjectFollowerSettings = SetSubjectFollowerSettingsActionStateData.decode(
            reader,
            reader.uint32(),
          );
          continue;
        case 288:
          if (tag !== 2306) {
            break;
          }

          message.geofenceConfig = GeofenceConfigActionStateData.decode(reader, reader.uint32());
          continue;
        case 504:
          if (tag !== 4034) {
            break;
          }

          message.setDesiredImuSource = SetDesiredImuSourceActionStateData.decode(reader, reader.uint32());
          continue;
        case 505:
          if (tag !== 4042) {
            break;
          }

          message.sendMotionCommand = SendMotionCommandActionStateData.decode(reader, reader.uint32());
          continue;
        case 289:
          if (tag !== 2314) {
            break;
          }

          message.setGnssSolverQuality = SetGnssSolverQualityActionStateData.decode(reader, reader.uint32());
          continue;
        case 506:
          if (tag !== 4050) {
            break;
          }

          message.spoofPhoneUiVariablesAction = SpoofPhoneUiVariablesActionStateData.decode(reader, reader.uint32());
          continue;
        case 290:
          if (tag !== 2322) {
            break;
          }

          message.playAudio = PlayAudioActionStateData.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ActionState {
    return {
      actionUuid: isSet(object.actionUuid) ? globalThis.String(object.actionUuid) : "",
      progressRatio: isSet(object.progressRatio) ? globalThis.Number(object.progressRatio) : 0,
      startUclock: isSet(object.startUclock) ? globalThis.Number(object.startUclock) : 0,
      displayMessage: isSet(object.displayMessage) ? globalThis.String(object.displayMessage) : "",
      sequence: isSet(object.sequence) ? SequenceActionStateData.fromJSON(object.sequence) : undefined,
      gotoAndOrbitPoi: isSet(object.gotoAndOrbitPoi)
        ? GotoAndOrbitPoiActionStateData.fromJSON(object.gotoAndOrbitPoi)
        : undefined,
      orbitPoiAction: isSet(object.orbitPoiAction)
        ? OrbitPoiActionStateData.fromJSON(object.orbitPoiAction)
        : undefined,
      gotoGpsWaypoint: isSet(object.gotoGpsWaypoint)
        ? GotoGpsWaypointActionStateData.fromJSON(object.gotoGpsWaypoint)
        : undefined,
      gotoNavWaypoint: isSet(object.gotoNavWaypoint)
        ? GotoNavWaypointActionStateData.fromJSON(object.gotoNavWaypoint)
        : undefined,
      takePhoto: isSet(object.takePhoto) ? TakePhotoActionStateData.fromJSON(object.takePhoto) : undefined,
      surfaceScanSkill: isSet(object.surfaceScanSkill)
        ? SurfaceScanActionStateData.fromJSON(object.surfaceScanSkill)
        : undefined,
      startVideo: isSet(object.startVideo) ? StartVideoActionStateData.fromJSON(object.startVideo) : undefined,
      stopVideo: isSet(object.stopVideo) ? StopVideoActionStateData.fromJSON(object.stopVideo) : undefined,
      switchRecordingMode: isSet(object.switchRecordingMode)
        ? SwitchRecordingModeActionStateData.fromJSON(object.switchRecordingMode)
        : undefined,
      timedWait: isSet(object.timedWait) ? TimedWaitActionStateData.fromJSON(object.timedWait) : undefined,
      takePanorama: isSet(object.takePanorama) ? TakePanoramaActionStateData.fromJSON(object.takePanorama) : undefined,
      keyframeSkill: isSet(object.keyframeSkill) ? KeyframeActionStateData.fromJSON(object.keyframeSkill) : undefined,
      gotoWaypoint: isSet(object.gotoWaypoint) ? GotoWaypointActionStateData.fromJSON(object.gotoWaypoint) : undefined,
      setObstacleAvoidance: isSet(object.setObstacleAvoidance)
        ? SetObstacleAvoidanceActionStateData.fromJSON(object.setObstacleAvoidance)
        : undefined,
      initializeGps: isSet(object.initializeGps)
        ? InitializeGpsActionStateData.fromJSON(object.initializeGps)
        : undefined,
      subjectDetected: isSet(object.subjectDetected)
        ? SubjectDetectedActionStateData.fromJSON(object.subjectDetected)
        : undefined,
      looper: isSet(object.looper) ? LooperActionStateData.fromJSON(object.looper) : undefined,
      withinDistance: isSet(object.withinDistance)
        ? WithinDistanceActionStateData.fromJSON(object.withinDistance)
        : undefined,
      unifiedFollowAction: isSet(object.unifiedFollowAction)
        ? UnifiedFollowActionStateData.fromJSON(object.unifiedFollowAction)
        : undefined,
      inverter: isSet(object.inverter) ? InverterActionStateData.fromJSON(object.inverter) : undefined,
      togglePhotoIntervalMode: isSet(object.togglePhotoIntervalMode)
        ? TogglePhotoIntervalModeActionStateData.fromJSON(object.togglePhotoIntervalMode)
        : undefined,
      wifiScan: isSet(object.wifiScan) ? WifiScanActionStateData.fromJSON(object.wifiScan) : undefined,
      enableStrobeLights: isSet(object.enableStrobeLights)
        ? EnableStrobeLightsActionStateData.fromJSON(object.enableStrobeLights)
        : undefined,
      disableStrobeLights: isSet(object.disableStrobeLights)
        ? DisableStrobeLightsActionStateData.fromJSON(object.disableStrobeLights)
        : undefined,
      spoofJoysticksInputs: isSet(object.spoofJoysticksInputs)
        ? SpoofJoysticksInputsActionStateData.fromJSON(object.spoofJoysticksInputs)
        : undefined,
      updateJoysticksSettings: isSet(object.updateJoysticksSettings)
        ? UpdateJoysticksSettingsActionStateData.fromJSON(object.updateJoysticksSettings)
        : undefined,
      updateShapeMap: isSet(object.updateShapeMap)
        ? UpdateShapeMapActionStateData.fromJSON(object.updateShapeMap)
        : undefined,
      spoofObstacle: isSet(object.spoofObstacle)
        ? SpoofObstacleActionStateData.fromJSON(object.spoofObstacle)
        : undefined,
      dummyAction: isSet(object.dummyAction) ? DummyActionStateData.fromJSON(object.dummyAction) : undefined,
      testDesiredVelocityAction: isSet(object.testDesiredVelocityAction)
        ? TestDesiredVelocityActionStateData.fromJSON(object.testDesiredVelocityAction)
        : undefined,
      testTrackTrajectory: isSet(object.testTrackTrajectory)
        ? TestTrackTrajectoryActionStateData.fromJSON(object.testTrackTrajectory)
        : undefined,
      atvSubjectSpoofAction: isSet(object.atvSubjectSpoofAction)
        ? AtvSubjectSpoofActionStateData.fromJSON(object.atvSubjectSpoofAction)
        : undefined,
      skiSubjectSpoofAction: isSet(object.skiSubjectSpoofAction)
        ? SkiSubjectSpoofActionStateData.fromJSON(object.skiSubjectSpoofAction)
        : undefined,
      setGimbalOrientation: isSet(object.setGimbalOrientation)
        ? SetGimbalOrientationActionStateData.fromJSON(object.setGimbalOrientation)
        : undefined,
      parallel: isSet(object.parallel) ? ParallelActionStateData.fromJSON(object.parallel) : undefined,
      sequenceUntilSuccess: isSet(object.sequenceUntilSuccess)
        ? SequenceUntilSuccessActionStateData.fromJSON(object.sequenceUntilSuccess)
        : undefined,
      sequenceUntilFailure: isSet(object.sequenceUntilFailure)
        ? SequenceUntilFailureActionStateData.fromJSON(object.sequenceUntilFailure)
        : undefined,
      sequencePretakeoff: isSet(object.sequencePretakeoff)
        ? SequencePretakeoffActionStateData.fromJSON(object.sequencePretakeoff)
        : undefined,
      sequenceConfig: isSet(object.sequenceConfig)
        ? SequenceConfigActionStateData.fromJSON(object.sequenceConfig)
        : undefined,
      waitForRtk: isSet(object.waitForRtk) ? WaitForRtkActionStateData.fromJSON(object.waitForRtk) : undefined,
      wingWaypointsCommand: isSet(object.wingWaypointsCommand)
        ? WingWaypointsCommandActionStateData.fromJSON(object.wingWaypointsCommand)
        : undefined,
      sendDynamicScenario: isSet(object.sendDynamicScenario)
        ? SendDynamicScenarioActionStateData.fromJSON(object.sendDynamicScenario)
        : undefined,
      scoutAction: isSet(object.scoutAction) ? ScoutActionActionStateData.fromJSON(object.scoutAction) : undefined,
      spoofTrackingDevice: isSet(object.spoofTrackingDevice)
        ? SpoofTrackingDeviceActionStateData.fromJSON(object.spoofTrackingDevice)
        : undefined,
      spoofDisturbanceAction: isSet(object.spoofDisturbanceAction)
        ? SpoofDisturbanceActionStateData.fromJSON(object.spoofDisturbanceAction)
        : undefined,
      updateVehicleSettings: isSet(object.updateVehicleSettings)
        ? UpdateVehicleSettingsActionStateData.fromJSON(object.updateVehicleSettings)
        : undefined,
      waitForVehicleStop: isSet(object.waitForVehicleStop)
        ? WaitForVehicleStopActionStateData.fromJSON(object.waitForVehicleStop)
        : undefined,
      precomputedSubjectSpoofAction: isSet(object.precomputedSubjectSpoofAction)
        ? PrecomputedSubjectSpoofActionStateData.fromJSON(object.precomputedSubjectSpoofAction)
        : undefined,
      modifySimStateEstimation: isSet(object.modifySimStateEstimation)
        ? ModifySimStateEstimationActionStateData.fromJSON(object.modifySimStateEstimation)
        : undefined,
      acquireGps: isSet(object.acquireGps) ? AcquireGpsActionStateData.fromJSON(object.acquireGps) : undefined,
      setFaultOverride: isSet(object.setFaultOverride)
        ? SetFaultOverrideActionStateData.fromJSON(object.setFaultOverride)
        : undefined,
      eLand: isSet(object.eLand) ? ELandActionStateData.fromJSON(object.eLand) : undefined,
      trajectoryInspect: isSet(object.trajectoryInspect)
        ? TrajectoryInspectActionStateData.fromJSON(object.trajectoryInspect)
        : undefined,
      toggleTargetPointExposure: isSet(object.toggleTargetPointExposure)
        ? ToggleTargetPointExposureActionStateData.fromJSON(object.toggleTargetPointExposure)
        : undefined,
      toggleSemanticAim: isSet(object.toggleSemanticAim)
        ? ToggleSemanticAimActionStateData.fromJSON(object.toggleSemanticAim)
        : undefined,
      spoofBatteryLevel: isSet(object.spoofBatteryLevel)
        ? SpoofBatteryLevelActionStateData.fromJSON(object.spoofBatteryLevel)
        : undefined,
      ncpgControl: isSet(object.ncpgControl) ? NcpgControlActionStateData.fromJSON(object.ncpgControl) : undefined,
      registerComplimentaryActions: isSet(object.registerComplimentaryActions)
        ? RegisterComplimentaryActionsActionStateData.fromJSON(object.registerComplimentaryActions)
        : undefined,
      trackInPlace: isSet(object.trackInPlace) ? TrackInPlaceActionStateData.fromJSON(object.trackInPlace) : undefined,
      globalGraphControl: isSet(object.globalGraphControl)
        ? GlobalGraphControlActionStateData.fromJSON(object.globalGraphControl)
        : undefined,
      overrideGpsQuality: isSet(object.overrideGpsQuality)
        ? OverrideGpsQualityActionStateData.fromJSON(object.overrideGpsQuality)
        : undefined,
      initGlobalMap: isSet(object.initGlobalMap)
        ? InitGlobalMapActionStateData.fromJSON(object.initGlobalMap)
        : undefined,
      stopForPhotoInspect: isSet(object.stopForPhotoInspect)
        ? StopForPhotoInspectActionStateData.fromJSON(object.stopForPhotoInspect)
        : undefined,
      spoofInitialGpsHeading: isSet(object.spoofInitialGpsHeading)
        ? SpoofInitialGpsHeadingActionStateData.fromJSON(object.spoofInitialGpsHeading)
        : undefined,
      trackLandingPadRequest: isSet(object.trackLandingPadRequest)
        ? TrackLandingPadRequestActionStateData.fromJSON(object.trackLandingPadRequest)
        : undefined,
      apriltagSetId: isSet(object.apriltagSetId)
        ? ApriltagSetIdActionStateData.fromJSON(object.apriltagSetId)
        : undefined,
      dockGpsEstimator: isSet(object.dockGpsEstimator)
        ? DockGpsEstimatorActionStateData.fromJSON(object.dockGpsEstimator)
        : undefined,
      g47CommandOverride: isSet(object.g47CommandOverride)
        ? G47CommandOverrideActionStateData.fromJSON(object.g47CommandOverride)
        : undefined,
      requestTakeoffProfile: isSet(object.requestTakeoffProfile)
        ? RequestTakeoffProfileActionStateData.fromJSON(object.requestTakeoffProfile)
        : undefined,
      updateDockLocationAction: isSet(object.updateDockLocationAction)
        ? UpdateDockLocationActionStateData.fromJSON(object.updateDockLocationAction)
        : undefined,
      setDesiredGpsSource: isSet(object.setDesiredGpsSource)
        ? SetDesiredGpsSourceActionStateData.fromJSON(object.setDesiredGpsSource)
        : undefined,
      spoofManualGps: isSet(object.spoofManualGps)
        ? SpoofManualGpsActionStateData.fromJSON(object.spoofManualGps)
        : undefined,
      weatherAction: isSet(object.weatherAction) ? WeatherActionStateData.fromJSON(object.weatherAction) : undefined,
      setZoom: isSet(object.setZoom) ? SetZoomActionStateData.fromJSON(object.setZoom) : undefined,
      missionPlannerServiceControl: isSet(object.missionPlannerServiceControl)
        ? MissionPlannerServiceControlActionStateData.fromJSON(object.missionPlannerServiceControl)
        : undefined,
      spotlightAction: isSet(object.spotlightAction)
        ? SpotlightActionStateData.fromJSON(object.spotlightAction)
        : undefined,
      setCameraSettings: isSet(object.setCameraSettings)
        ? SetCameraSettingsActionStateData.fromJSON(object.setCameraSettings)
        : undefined,
      parachuteControl: isSet(object.parachuteControl)
        ? ParachuteControlActionStateData.fromJSON(object.parachuteControl)
        : undefined,
      nightsenseAction: isSet(object.nightsenseAction)
        ? NightsenseActionStateData.fromJSON(object.nightsenseAction)
        : undefined,
      spoofMultiDrone: isSet(object.spoofMultiDrone)
        ? SpoofMultiDroneActionStateData.fromJSON(object.spoofMultiDrone)
        : undefined,
      setMovementCommand: isSet(object.setMovementCommand)
        ? SetMovementCommandActionStateData.fromJSON(object.setMovementCommand)
        : undefined,
      spoofFlightEnvelopeLimits: isSet(object.spoofFlightEnvelopeLimits)
        ? SpoofFlightEnvelopeLimitsActionStateData.fromJSON(object.spoofFlightEnvelopeLimits)
        : undefined,
      turntable: isSet(object.turntable) ? TurntableActionStateData.fromJSON(object.turntable) : undefined,
      dancingDrone: isSet(object.dancingDrone) ? DancingDroneActionStateData.fromJSON(object.dancingDrone) : undefined,
      waitForPreciseFault: isSet(object.waitForPreciseFault)
        ? WaitForPreciseFaultActionStateData.fromJSON(object.waitForPreciseFault)
        : undefined,
      dancingDroneSpline: isSet(object.dancingDroneSpline)
        ? DancingDroneSplineActionStateData.fromJSON(object.dancingDroneSpline)
        : undefined,
      globalPlannerRequest: isSet(object.globalPlannerRequest)
        ? GlobalPlannerRequestActionStateData.fromJSON(object.globalPlannerRequest)
        : undefined,
      toggleSubjectDetection: isSet(object.toggleSubjectDetection)
        ? ToggleSubjectDetectionActionStateData.fromJSON(object.toggleSubjectDetection)
        : undefined,
      spoofSubjectScenario: isSet(object.spoofSubjectScenario)
        ? SpoofSubjectScenarioActionStateData.fromJSON(object.spoofSubjectScenario)
        : undefined,
      setSubjectFollowerSettings: isSet(object.setSubjectFollowerSettings)
        ? SetSubjectFollowerSettingsActionStateData.fromJSON(object.setSubjectFollowerSettings)
        : undefined,
      geofenceConfig: isSet(object.geofenceConfig)
        ? GeofenceConfigActionStateData.fromJSON(object.geofenceConfig)
        : undefined,
      setDesiredImuSource: isSet(object.setDesiredImuSource)
        ? SetDesiredImuSourceActionStateData.fromJSON(object.setDesiredImuSource)
        : undefined,
      sendMotionCommand: isSet(object.sendMotionCommand)
        ? SendMotionCommandActionStateData.fromJSON(object.sendMotionCommand)
        : undefined,
      setGnssSolverQuality: isSet(object.setGnssSolverQuality)
        ? SetGnssSolverQualityActionStateData.fromJSON(object.setGnssSolverQuality)
        : undefined,
      spoofPhoneUiVariablesAction: isSet(object.spoofPhoneUiVariablesAction)
        ? SpoofPhoneUiVariablesActionStateData.fromJSON(object.spoofPhoneUiVariablesAction)
        : undefined,
      playAudio: isSet(object.playAudio) ? PlayAudioActionStateData.fromJSON(object.playAudio) : undefined,
    };
  },

  toJSON(message: ActionState): unknown {
    const obj: any = {};
    if (message.actionUuid !== "") {
      obj.actionUuid = message.actionUuid;
    }
    if (message.progressRatio !== 0) {
      obj.progressRatio = message.progressRatio;
    }
    if (message.startUclock !== 0) {
      obj.startUclock = Math.round(message.startUclock);
    }
    if (message.displayMessage !== "") {
      obj.displayMessage = message.displayMessage;
    }
    if (message.sequence !== undefined) {
      obj.sequence = SequenceActionStateData.toJSON(message.sequence);
    }
    if (message.gotoAndOrbitPoi !== undefined) {
      obj.gotoAndOrbitPoi = GotoAndOrbitPoiActionStateData.toJSON(message.gotoAndOrbitPoi);
    }
    if (message.orbitPoiAction !== undefined) {
      obj.orbitPoiAction = OrbitPoiActionStateData.toJSON(message.orbitPoiAction);
    }
    if (message.gotoGpsWaypoint !== undefined) {
      obj.gotoGpsWaypoint = GotoGpsWaypointActionStateData.toJSON(message.gotoGpsWaypoint);
    }
    if (message.gotoNavWaypoint !== undefined) {
      obj.gotoNavWaypoint = GotoNavWaypointActionStateData.toJSON(message.gotoNavWaypoint);
    }
    if (message.takePhoto !== undefined) {
      obj.takePhoto = TakePhotoActionStateData.toJSON(message.takePhoto);
    }
    if (message.surfaceScanSkill !== undefined) {
      obj.surfaceScanSkill = SurfaceScanActionStateData.toJSON(message.surfaceScanSkill);
    }
    if (message.startVideo !== undefined) {
      obj.startVideo = StartVideoActionStateData.toJSON(message.startVideo);
    }
    if (message.stopVideo !== undefined) {
      obj.stopVideo = StopVideoActionStateData.toJSON(message.stopVideo);
    }
    if (message.switchRecordingMode !== undefined) {
      obj.switchRecordingMode = SwitchRecordingModeActionStateData.toJSON(message.switchRecordingMode);
    }
    if (message.timedWait !== undefined) {
      obj.timedWait = TimedWaitActionStateData.toJSON(message.timedWait);
    }
    if (message.takePanorama !== undefined) {
      obj.takePanorama = TakePanoramaActionStateData.toJSON(message.takePanorama);
    }
    if (message.keyframeSkill !== undefined) {
      obj.keyframeSkill = KeyframeActionStateData.toJSON(message.keyframeSkill);
    }
    if (message.gotoWaypoint !== undefined) {
      obj.gotoWaypoint = GotoWaypointActionStateData.toJSON(message.gotoWaypoint);
    }
    if (message.setObstacleAvoidance !== undefined) {
      obj.setObstacleAvoidance = SetObstacleAvoidanceActionStateData.toJSON(message.setObstacleAvoidance);
    }
    if (message.initializeGps !== undefined) {
      obj.initializeGps = InitializeGpsActionStateData.toJSON(message.initializeGps);
    }
    if (message.subjectDetected !== undefined) {
      obj.subjectDetected = SubjectDetectedActionStateData.toJSON(message.subjectDetected);
    }
    if (message.looper !== undefined) {
      obj.looper = LooperActionStateData.toJSON(message.looper);
    }
    if (message.withinDistance !== undefined) {
      obj.withinDistance = WithinDistanceActionStateData.toJSON(message.withinDistance);
    }
    if (message.unifiedFollowAction !== undefined) {
      obj.unifiedFollowAction = UnifiedFollowActionStateData.toJSON(message.unifiedFollowAction);
    }
    if (message.inverter !== undefined) {
      obj.inverter = InverterActionStateData.toJSON(message.inverter);
    }
    if (message.togglePhotoIntervalMode !== undefined) {
      obj.togglePhotoIntervalMode = TogglePhotoIntervalModeActionStateData.toJSON(message.togglePhotoIntervalMode);
    }
    if (message.wifiScan !== undefined) {
      obj.wifiScan = WifiScanActionStateData.toJSON(message.wifiScan);
    }
    if (message.enableStrobeLights !== undefined) {
      obj.enableStrobeLights = EnableStrobeLightsActionStateData.toJSON(message.enableStrobeLights);
    }
    if (message.disableStrobeLights !== undefined) {
      obj.disableStrobeLights = DisableStrobeLightsActionStateData.toJSON(message.disableStrobeLights);
    }
    if (message.spoofJoysticksInputs !== undefined) {
      obj.spoofJoysticksInputs = SpoofJoysticksInputsActionStateData.toJSON(message.spoofJoysticksInputs);
    }
    if (message.updateJoysticksSettings !== undefined) {
      obj.updateJoysticksSettings = UpdateJoysticksSettingsActionStateData.toJSON(message.updateJoysticksSettings);
    }
    if (message.updateShapeMap !== undefined) {
      obj.updateShapeMap = UpdateShapeMapActionStateData.toJSON(message.updateShapeMap);
    }
    if (message.spoofObstacle !== undefined) {
      obj.spoofObstacle = SpoofObstacleActionStateData.toJSON(message.spoofObstacle);
    }
    if (message.dummyAction !== undefined) {
      obj.dummyAction = DummyActionStateData.toJSON(message.dummyAction);
    }
    if (message.testDesiredVelocityAction !== undefined) {
      obj.testDesiredVelocityAction = TestDesiredVelocityActionStateData.toJSON(message.testDesiredVelocityAction);
    }
    if (message.testTrackTrajectory !== undefined) {
      obj.testTrackTrajectory = TestTrackTrajectoryActionStateData.toJSON(message.testTrackTrajectory);
    }
    if (message.atvSubjectSpoofAction !== undefined) {
      obj.atvSubjectSpoofAction = AtvSubjectSpoofActionStateData.toJSON(message.atvSubjectSpoofAction);
    }
    if (message.skiSubjectSpoofAction !== undefined) {
      obj.skiSubjectSpoofAction = SkiSubjectSpoofActionStateData.toJSON(message.skiSubjectSpoofAction);
    }
    if (message.setGimbalOrientation !== undefined) {
      obj.setGimbalOrientation = SetGimbalOrientationActionStateData.toJSON(message.setGimbalOrientation);
    }
    if (message.parallel !== undefined) {
      obj.parallel = ParallelActionStateData.toJSON(message.parallel);
    }
    if (message.sequenceUntilSuccess !== undefined) {
      obj.sequenceUntilSuccess = SequenceUntilSuccessActionStateData.toJSON(message.sequenceUntilSuccess);
    }
    if (message.sequenceUntilFailure !== undefined) {
      obj.sequenceUntilFailure = SequenceUntilFailureActionStateData.toJSON(message.sequenceUntilFailure);
    }
    if (message.sequencePretakeoff !== undefined) {
      obj.sequencePretakeoff = SequencePretakeoffActionStateData.toJSON(message.sequencePretakeoff);
    }
    if (message.sequenceConfig !== undefined) {
      obj.sequenceConfig = SequenceConfigActionStateData.toJSON(message.sequenceConfig);
    }
    if (message.waitForRtk !== undefined) {
      obj.waitForRtk = WaitForRtkActionStateData.toJSON(message.waitForRtk);
    }
    if (message.wingWaypointsCommand !== undefined) {
      obj.wingWaypointsCommand = WingWaypointsCommandActionStateData.toJSON(message.wingWaypointsCommand);
    }
    if (message.sendDynamicScenario !== undefined) {
      obj.sendDynamicScenario = SendDynamicScenarioActionStateData.toJSON(message.sendDynamicScenario);
    }
    if (message.scoutAction !== undefined) {
      obj.scoutAction = ScoutActionActionStateData.toJSON(message.scoutAction);
    }
    if (message.spoofTrackingDevice !== undefined) {
      obj.spoofTrackingDevice = SpoofTrackingDeviceActionStateData.toJSON(message.spoofTrackingDevice);
    }
    if (message.spoofDisturbanceAction !== undefined) {
      obj.spoofDisturbanceAction = SpoofDisturbanceActionStateData.toJSON(message.spoofDisturbanceAction);
    }
    if (message.updateVehicleSettings !== undefined) {
      obj.updateVehicleSettings = UpdateVehicleSettingsActionStateData.toJSON(message.updateVehicleSettings);
    }
    if (message.waitForVehicleStop !== undefined) {
      obj.waitForVehicleStop = WaitForVehicleStopActionStateData.toJSON(message.waitForVehicleStop);
    }
    if (message.precomputedSubjectSpoofAction !== undefined) {
      obj.precomputedSubjectSpoofAction = PrecomputedSubjectSpoofActionStateData.toJSON(
        message.precomputedSubjectSpoofAction,
      );
    }
    if (message.modifySimStateEstimation !== undefined) {
      obj.modifySimStateEstimation = ModifySimStateEstimationActionStateData.toJSON(message.modifySimStateEstimation);
    }
    if (message.acquireGps !== undefined) {
      obj.acquireGps = AcquireGpsActionStateData.toJSON(message.acquireGps);
    }
    if (message.setFaultOverride !== undefined) {
      obj.setFaultOverride = SetFaultOverrideActionStateData.toJSON(message.setFaultOverride);
    }
    if (message.eLand !== undefined) {
      obj.eLand = ELandActionStateData.toJSON(message.eLand);
    }
    if (message.trajectoryInspect !== undefined) {
      obj.trajectoryInspect = TrajectoryInspectActionStateData.toJSON(message.trajectoryInspect);
    }
    if (message.toggleTargetPointExposure !== undefined) {
      obj.toggleTargetPointExposure = ToggleTargetPointExposureActionStateData.toJSON(
        message.toggleTargetPointExposure,
      );
    }
    if (message.toggleSemanticAim !== undefined) {
      obj.toggleSemanticAim = ToggleSemanticAimActionStateData.toJSON(message.toggleSemanticAim);
    }
    if (message.spoofBatteryLevel !== undefined) {
      obj.spoofBatteryLevel = SpoofBatteryLevelActionStateData.toJSON(message.spoofBatteryLevel);
    }
    if (message.ncpgControl !== undefined) {
      obj.ncpgControl = NcpgControlActionStateData.toJSON(message.ncpgControl);
    }
    if (message.registerComplimentaryActions !== undefined) {
      obj.registerComplimentaryActions = RegisterComplimentaryActionsActionStateData.toJSON(
        message.registerComplimentaryActions,
      );
    }
    if (message.trackInPlace !== undefined) {
      obj.trackInPlace = TrackInPlaceActionStateData.toJSON(message.trackInPlace);
    }
    if (message.globalGraphControl !== undefined) {
      obj.globalGraphControl = GlobalGraphControlActionStateData.toJSON(message.globalGraphControl);
    }
    if (message.overrideGpsQuality !== undefined) {
      obj.overrideGpsQuality = OverrideGpsQualityActionStateData.toJSON(message.overrideGpsQuality);
    }
    if (message.initGlobalMap !== undefined) {
      obj.initGlobalMap = InitGlobalMapActionStateData.toJSON(message.initGlobalMap);
    }
    if (message.stopForPhotoInspect !== undefined) {
      obj.stopForPhotoInspect = StopForPhotoInspectActionStateData.toJSON(message.stopForPhotoInspect);
    }
    if (message.spoofInitialGpsHeading !== undefined) {
      obj.spoofInitialGpsHeading = SpoofInitialGpsHeadingActionStateData.toJSON(message.spoofInitialGpsHeading);
    }
    if (message.trackLandingPadRequest !== undefined) {
      obj.trackLandingPadRequest = TrackLandingPadRequestActionStateData.toJSON(message.trackLandingPadRequest);
    }
    if (message.apriltagSetId !== undefined) {
      obj.apriltagSetId = ApriltagSetIdActionStateData.toJSON(message.apriltagSetId);
    }
    if (message.dockGpsEstimator !== undefined) {
      obj.dockGpsEstimator = DockGpsEstimatorActionStateData.toJSON(message.dockGpsEstimator);
    }
    if (message.g47CommandOverride !== undefined) {
      obj.g47CommandOverride = G47CommandOverrideActionStateData.toJSON(message.g47CommandOverride);
    }
    if (message.requestTakeoffProfile !== undefined) {
      obj.requestTakeoffProfile = RequestTakeoffProfileActionStateData.toJSON(message.requestTakeoffProfile);
    }
    if (message.updateDockLocationAction !== undefined) {
      obj.updateDockLocationAction = UpdateDockLocationActionStateData.toJSON(message.updateDockLocationAction);
    }
    if (message.setDesiredGpsSource !== undefined) {
      obj.setDesiredGpsSource = SetDesiredGpsSourceActionStateData.toJSON(message.setDesiredGpsSource);
    }
    if (message.spoofManualGps !== undefined) {
      obj.spoofManualGps = SpoofManualGpsActionStateData.toJSON(message.spoofManualGps);
    }
    if (message.weatherAction !== undefined) {
      obj.weatherAction = WeatherActionStateData.toJSON(message.weatherAction);
    }
    if (message.setZoom !== undefined) {
      obj.setZoom = SetZoomActionStateData.toJSON(message.setZoom);
    }
    if (message.missionPlannerServiceControl !== undefined) {
      obj.missionPlannerServiceControl = MissionPlannerServiceControlActionStateData.toJSON(
        message.missionPlannerServiceControl,
      );
    }
    if (message.spotlightAction !== undefined) {
      obj.spotlightAction = SpotlightActionStateData.toJSON(message.spotlightAction);
    }
    if (message.setCameraSettings !== undefined) {
      obj.setCameraSettings = SetCameraSettingsActionStateData.toJSON(message.setCameraSettings);
    }
    if (message.parachuteControl !== undefined) {
      obj.parachuteControl = ParachuteControlActionStateData.toJSON(message.parachuteControl);
    }
    if (message.nightsenseAction !== undefined) {
      obj.nightsenseAction = NightsenseActionStateData.toJSON(message.nightsenseAction);
    }
    if (message.spoofMultiDrone !== undefined) {
      obj.spoofMultiDrone = SpoofMultiDroneActionStateData.toJSON(message.spoofMultiDrone);
    }
    if (message.setMovementCommand !== undefined) {
      obj.setMovementCommand = SetMovementCommandActionStateData.toJSON(message.setMovementCommand);
    }
    if (message.spoofFlightEnvelopeLimits !== undefined) {
      obj.spoofFlightEnvelopeLimits = SpoofFlightEnvelopeLimitsActionStateData.toJSON(
        message.spoofFlightEnvelopeLimits,
      );
    }
    if (message.turntable !== undefined) {
      obj.turntable = TurntableActionStateData.toJSON(message.turntable);
    }
    if (message.dancingDrone !== undefined) {
      obj.dancingDrone = DancingDroneActionStateData.toJSON(message.dancingDrone);
    }
    if (message.waitForPreciseFault !== undefined) {
      obj.waitForPreciseFault = WaitForPreciseFaultActionStateData.toJSON(message.waitForPreciseFault);
    }
    if (message.dancingDroneSpline !== undefined) {
      obj.dancingDroneSpline = DancingDroneSplineActionStateData.toJSON(message.dancingDroneSpline);
    }
    if (message.globalPlannerRequest !== undefined) {
      obj.globalPlannerRequest = GlobalPlannerRequestActionStateData.toJSON(message.globalPlannerRequest);
    }
    if (message.toggleSubjectDetection !== undefined) {
      obj.toggleSubjectDetection = ToggleSubjectDetectionActionStateData.toJSON(message.toggleSubjectDetection);
    }
    if (message.spoofSubjectScenario !== undefined) {
      obj.spoofSubjectScenario = SpoofSubjectScenarioActionStateData.toJSON(message.spoofSubjectScenario);
    }
    if (message.setSubjectFollowerSettings !== undefined) {
      obj.setSubjectFollowerSettings = SetSubjectFollowerSettingsActionStateData.toJSON(
        message.setSubjectFollowerSettings,
      );
    }
    if (message.geofenceConfig !== undefined) {
      obj.geofenceConfig = GeofenceConfigActionStateData.toJSON(message.geofenceConfig);
    }
    if (message.setDesiredImuSource !== undefined) {
      obj.setDesiredImuSource = SetDesiredImuSourceActionStateData.toJSON(message.setDesiredImuSource);
    }
    if (message.sendMotionCommand !== undefined) {
      obj.sendMotionCommand = SendMotionCommandActionStateData.toJSON(message.sendMotionCommand);
    }
    if (message.setGnssSolverQuality !== undefined) {
      obj.setGnssSolverQuality = SetGnssSolverQualityActionStateData.toJSON(message.setGnssSolverQuality);
    }
    if (message.spoofPhoneUiVariablesAction !== undefined) {
      obj.spoofPhoneUiVariablesAction = SpoofPhoneUiVariablesActionStateData.toJSON(
        message.spoofPhoneUiVariablesAction,
      );
    }
    if (message.playAudio !== undefined) {
      obj.playAudio = PlayAudioActionStateData.toJSON(message.playAudio);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ActionState>, I>>(base?: I): ActionState {
    return ActionState.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ActionState>, I>>(object: I): ActionState {
    const message = createBaseActionState();
    message.actionUuid = object.actionUuid ?? "";
    message.progressRatio = object.progressRatio ?? 0;
    message.startUclock = object.startUclock ?? 0;
    message.displayMessage = object.displayMessage ?? "";
    message.sequence = (object.sequence !== undefined && object.sequence !== null)
      ? SequenceActionStateData.fromPartial(object.sequence)
      : undefined;
    message.gotoAndOrbitPoi = (object.gotoAndOrbitPoi !== undefined && object.gotoAndOrbitPoi !== null)
      ? GotoAndOrbitPoiActionStateData.fromPartial(object.gotoAndOrbitPoi)
      : undefined;
    message.orbitPoiAction = (object.orbitPoiAction !== undefined && object.orbitPoiAction !== null)
      ? OrbitPoiActionStateData.fromPartial(object.orbitPoiAction)
      : undefined;
    message.gotoGpsWaypoint = (object.gotoGpsWaypoint !== undefined && object.gotoGpsWaypoint !== null)
      ? GotoGpsWaypointActionStateData.fromPartial(object.gotoGpsWaypoint)
      : undefined;
    message.gotoNavWaypoint = (object.gotoNavWaypoint !== undefined && object.gotoNavWaypoint !== null)
      ? GotoNavWaypointActionStateData.fromPartial(object.gotoNavWaypoint)
      : undefined;
    message.takePhoto = (object.takePhoto !== undefined && object.takePhoto !== null)
      ? TakePhotoActionStateData.fromPartial(object.takePhoto)
      : undefined;
    message.surfaceScanSkill = (object.surfaceScanSkill !== undefined && object.surfaceScanSkill !== null)
      ? SurfaceScanActionStateData.fromPartial(object.surfaceScanSkill)
      : undefined;
    message.startVideo = (object.startVideo !== undefined && object.startVideo !== null)
      ? StartVideoActionStateData.fromPartial(object.startVideo)
      : undefined;
    message.stopVideo = (object.stopVideo !== undefined && object.stopVideo !== null)
      ? StopVideoActionStateData.fromPartial(object.stopVideo)
      : undefined;
    message.switchRecordingMode = (object.switchRecordingMode !== undefined && object.switchRecordingMode !== null)
      ? SwitchRecordingModeActionStateData.fromPartial(object.switchRecordingMode)
      : undefined;
    message.timedWait = (object.timedWait !== undefined && object.timedWait !== null)
      ? TimedWaitActionStateData.fromPartial(object.timedWait)
      : undefined;
    message.takePanorama = (object.takePanorama !== undefined && object.takePanorama !== null)
      ? TakePanoramaActionStateData.fromPartial(object.takePanorama)
      : undefined;
    message.keyframeSkill = (object.keyframeSkill !== undefined && object.keyframeSkill !== null)
      ? KeyframeActionStateData.fromPartial(object.keyframeSkill)
      : undefined;
    message.gotoWaypoint = (object.gotoWaypoint !== undefined && object.gotoWaypoint !== null)
      ? GotoWaypointActionStateData.fromPartial(object.gotoWaypoint)
      : undefined;
    message.setObstacleAvoidance = (object.setObstacleAvoidance !== undefined && object.setObstacleAvoidance !== null)
      ? SetObstacleAvoidanceActionStateData.fromPartial(object.setObstacleAvoidance)
      : undefined;
    message.initializeGps = (object.initializeGps !== undefined && object.initializeGps !== null)
      ? InitializeGpsActionStateData.fromPartial(object.initializeGps)
      : undefined;
    message.subjectDetected = (object.subjectDetected !== undefined && object.subjectDetected !== null)
      ? SubjectDetectedActionStateData.fromPartial(object.subjectDetected)
      : undefined;
    message.looper = (object.looper !== undefined && object.looper !== null)
      ? LooperActionStateData.fromPartial(object.looper)
      : undefined;
    message.withinDistance = (object.withinDistance !== undefined && object.withinDistance !== null)
      ? WithinDistanceActionStateData.fromPartial(object.withinDistance)
      : undefined;
    message.unifiedFollowAction = (object.unifiedFollowAction !== undefined && object.unifiedFollowAction !== null)
      ? UnifiedFollowActionStateData.fromPartial(object.unifiedFollowAction)
      : undefined;
    message.inverter = (object.inverter !== undefined && object.inverter !== null)
      ? InverterActionStateData.fromPartial(object.inverter)
      : undefined;
    message.togglePhotoIntervalMode =
      (object.togglePhotoIntervalMode !== undefined && object.togglePhotoIntervalMode !== null)
        ? TogglePhotoIntervalModeActionStateData.fromPartial(object.togglePhotoIntervalMode)
        : undefined;
    message.wifiScan = (object.wifiScan !== undefined && object.wifiScan !== null)
      ? WifiScanActionStateData.fromPartial(object.wifiScan)
      : undefined;
    message.enableStrobeLights = (object.enableStrobeLights !== undefined && object.enableStrobeLights !== null)
      ? EnableStrobeLightsActionStateData.fromPartial(object.enableStrobeLights)
      : undefined;
    message.disableStrobeLights = (object.disableStrobeLights !== undefined && object.disableStrobeLights !== null)
      ? DisableStrobeLightsActionStateData.fromPartial(object.disableStrobeLights)
      : undefined;
    message.spoofJoysticksInputs = (object.spoofJoysticksInputs !== undefined && object.spoofJoysticksInputs !== null)
      ? SpoofJoysticksInputsActionStateData.fromPartial(object.spoofJoysticksInputs)
      : undefined;
    message.updateJoysticksSettings =
      (object.updateJoysticksSettings !== undefined && object.updateJoysticksSettings !== null)
        ? UpdateJoysticksSettingsActionStateData.fromPartial(object.updateJoysticksSettings)
        : undefined;
    message.updateShapeMap = (object.updateShapeMap !== undefined && object.updateShapeMap !== null)
      ? UpdateShapeMapActionStateData.fromPartial(object.updateShapeMap)
      : undefined;
    message.spoofObstacle = (object.spoofObstacle !== undefined && object.spoofObstacle !== null)
      ? SpoofObstacleActionStateData.fromPartial(object.spoofObstacle)
      : undefined;
    message.dummyAction = (object.dummyAction !== undefined && object.dummyAction !== null)
      ? DummyActionStateData.fromPartial(object.dummyAction)
      : undefined;
    message.testDesiredVelocityAction =
      (object.testDesiredVelocityAction !== undefined && object.testDesiredVelocityAction !== null)
        ? TestDesiredVelocityActionStateData.fromPartial(object.testDesiredVelocityAction)
        : undefined;
    message.testTrackTrajectory = (object.testTrackTrajectory !== undefined && object.testTrackTrajectory !== null)
      ? TestTrackTrajectoryActionStateData.fromPartial(object.testTrackTrajectory)
      : undefined;
    message.atvSubjectSpoofAction =
      (object.atvSubjectSpoofAction !== undefined && object.atvSubjectSpoofAction !== null)
        ? AtvSubjectSpoofActionStateData.fromPartial(object.atvSubjectSpoofAction)
        : undefined;
    message.skiSubjectSpoofAction =
      (object.skiSubjectSpoofAction !== undefined && object.skiSubjectSpoofAction !== null)
        ? SkiSubjectSpoofActionStateData.fromPartial(object.skiSubjectSpoofAction)
        : undefined;
    message.setGimbalOrientation = (object.setGimbalOrientation !== undefined && object.setGimbalOrientation !== null)
      ? SetGimbalOrientationActionStateData.fromPartial(object.setGimbalOrientation)
      : undefined;
    message.parallel = (object.parallel !== undefined && object.parallel !== null)
      ? ParallelActionStateData.fromPartial(object.parallel)
      : undefined;
    message.sequenceUntilSuccess = (object.sequenceUntilSuccess !== undefined && object.sequenceUntilSuccess !== null)
      ? SequenceUntilSuccessActionStateData.fromPartial(object.sequenceUntilSuccess)
      : undefined;
    message.sequenceUntilFailure = (object.sequenceUntilFailure !== undefined && object.sequenceUntilFailure !== null)
      ? SequenceUntilFailureActionStateData.fromPartial(object.sequenceUntilFailure)
      : undefined;
    message.sequencePretakeoff = (object.sequencePretakeoff !== undefined && object.sequencePretakeoff !== null)
      ? SequencePretakeoffActionStateData.fromPartial(object.sequencePretakeoff)
      : undefined;
    message.sequenceConfig = (object.sequenceConfig !== undefined && object.sequenceConfig !== null)
      ? SequenceConfigActionStateData.fromPartial(object.sequenceConfig)
      : undefined;
    message.waitForRtk = (object.waitForRtk !== undefined && object.waitForRtk !== null)
      ? WaitForRtkActionStateData.fromPartial(object.waitForRtk)
      : undefined;
    message.wingWaypointsCommand = (object.wingWaypointsCommand !== undefined && object.wingWaypointsCommand !== null)
      ? WingWaypointsCommandActionStateData.fromPartial(object.wingWaypointsCommand)
      : undefined;
    message.sendDynamicScenario = (object.sendDynamicScenario !== undefined && object.sendDynamicScenario !== null)
      ? SendDynamicScenarioActionStateData.fromPartial(object.sendDynamicScenario)
      : undefined;
    message.scoutAction = (object.scoutAction !== undefined && object.scoutAction !== null)
      ? ScoutActionActionStateData.fromPartial(object.scoutAction)
      : undefined;
    message.spoofTrackingDevice = (object.spoofTrackingDevice !== undefined && object.spoofTrackingDevice !== null)
      ? SpoofTrackingDeviceActionStateData.fromPartial(object.spoofTrackingDevice)
      : undefined;
    message.spoofDisturbanceAction =
      (object.spoofDisturbanceAction !== undefined && object.spoofDisturbanceAction !== null)
        ? SpoofDisturbanceActionStateData.fromPartial(object.spoofDisturbanceAction)
        : undefined;
    message.updateVehicleSettings =
      (object.updateVehicleSettings !== undefined && object.updateVehicleSettings !== null)
        ? UpdateVehicleSettingsActionStateData.fromPartial(object.updateVehicleSettings)
        : undefined;
    message.waitForVehicleStop = (object.waitForVehicleStop !== undefined && object.waitForVehicleStop !== null)
      ? WaitForVehicleStopActionStateData.fromPartial(object.waitForVehicleStop)
      : undefined;
    message.precomputedSubjectSpoofAction =
      (object.precomputedSubjectSpoofAction !== undefined && object.precomputedSubjectSpoofAction !== null)
        ? PrecomputedSubjectSpoofActionStateData.fromPartial(object.precomputedSubjectSpoofAction)
        : undefined;
    message.modifySimStateEstimation =
      (object.modifySimStateEstimation !== undefined && object.modifySimStateEstimation !== null)
        ? ModifySimStateEstimationActionStateData.fromPartial(object.modifySimStateEstimation)
        : undefined;
    message.acquireGps = (object.acquireGps !== undefined && object.acquireGps !== null)
      ? AcquireGpsActionStateData.fromPartial(object.acquireGps)
      : undefined;
    message.setFaultOverride = (object.setFaultOverride !== undefined && object.setFaultOverride !== null)
      ? SetFaultOverrideActionStateData.fromPartial(object.setFaultOverride)
      : undefined;
    message.eLand = (object.eLand !== undefined && object.eLand !== null)
      ? ELandActionStateData.fromPartial(object.eLand)
      : undefined;
    message.trajectoryInspect = (object.trajectoryInspect !== undefined && object.trajectoryInspect !== null)
      ? TrajectoryInspectActionStateData.fromPartial(object.trajectoryInspect)
      : undefined;
    message.toggleTargetPointExposure =
      (object.toggleTargetPointExposure !== undefined && object.toggleTargetPointExposure !== null)
        ? ToggleTargetPointExposureActionStateData.fromPartial(object.toggleTargetPointExposure)
        : undefined;
    message.toggleSemanticAim = (object.toggleSemanticAim !== undefined && object.toggleSemanticAim !== null)
      ? ToggleSemanticAimActionStateData.fromPartial(object.toggleSemanticAim)
      : undefined;
    message.spoofBatteryLevel = (object.spoofBatteryLevel !== undefined && object.spoofBatteryLevel !== null)
      ? SpoofBatteryLevelActionStateData.fromPartial(object.spoofBatteryLevel)
      : undefined;
    message.ncpgControl = (object.ncpgControl !== undefined && object.ncpgControl !== null)
      ? NcpgControlActionStateData.fromPartial(object.ncpgControl)
      : undefined;
    message.registerComplimentaryActions =
      (object.registerComplimentaryActions !== undefined && object.registerComplimentaryActions !== null)
        ? RegisterComplimentaryActionsActionStateData.fromPartial(object.registerComplimentaryActions)
        : undefined;
    message.trackInPlace = (object.trackInPlace !== undefined && object.trackInPlace !== null)
      ? TrackInPlaceActionStateData.fromPartial(object.trackInPlace)
      : undefined;
    message.globalGraphControl = (object.globalGraphControl !== undefined && object.globalGraphControl !== null)
      ? GlobalGraphControlActionStateData.fromPartial(object.globalGraphControl)
      : undefined;
    message.overrideGpsQuality = (object.overrideGpsQuality !== undefined && object.overrideGpsQuality !== null)
      ? OverrideGpsQualityActionStateData.fromPartial(object.overrideGpsQuality)
      : undefined;
    message.initGlobalMap = (object.initGlobalMap !== undefined && object.initGlobalMap !== null)
      ? InitGlobalMapActionStateData.fromPartial(object.initGlobalMap)
      : undefined;
    message.stopForPhotoInspect = (object.stopForPhotoInspect !== undefined && object.stopForPhotoInspect !== null)
      ? StopForPhotoInspectActionStateData.fromPartial(object.stopForPhotoInspect)
      : undefined;
    message.spoofInitialGpsHeading =
      (object.spoofInitialGpsHeading !== undefined && object.spoofInitialGpsHeading !== null)
        ? SpoofInitialGpsHeadingActionStateData.fromPartial(object.spoofInitialGpsHeading)
        : undefined;
    message.trackLandingPadRequest =
      (object.trackLandingPadRequest !== undefined && object.trackLandingPadRequest !== null)
        ? TrackLandingPadRequestActionStateData.fromPartial(object.trackLandingPadRequest)
        : undefined;
    message.apriltagSetId = (object.apriltagSetId !== undefined && object.apriltagSetId !== null)
      ? ApriltagSetIdActionStateData.fromPartial(object.apriltagSetId)
      : undefined;
    message.dockGpsEstimator = (object.dockGpsEstimator !== undefined && object.dockGpsEstimator !== null)
      ? DockGpsEstimatorActionStateData.fromPartial(object.dockGpsEstimator)
      : undefined;
    message.g47CommandOverride = (object.g47CommandOverride !== undefined && object.g47CommandOverride !== null)
      ? G47CommandOverrideActionStateData.fromPartial(object.g47CommandOverride)
      : undefined;
    message.requestTakeoffProfile =
      (object.requestTakeoffProfile !== undefined && object.requestTakeoffProfile !== null)
        ? RequestTakeoffProfileActionStateData.fromPartial(object.requestTakeoffProfile)
        : undefined;
    message.updateDockLocationAction =
      (object.updateDockLocationAction !== undefined && object.updateDockLocationAction !== null)
        ? UpdateDockLocationActionStateData.fromPartial(object.updateDockLocationAction)
        : undefined;
    message.setDesiredGpsSource = (object.setDesiredGpsSource !== undefined && object.setDesiredGpsSource !== null)
      ? SetDesiredGpsSourceActionStateData.fromPartial(object.setDesiredGpsSource)
      : undefined;
    message.spoofManualGps = (object.spoofManualGps !== undefined && object.spoofManualGps !== null)
      ? SpoofManualGpsActionStateData.fromPartial(object.spoofManualGps)
      : undefined;
    message.weatherAction = (object.weatherAction !== undefined && object.weatherAction !== null)
      ? WeatherActionStateData.fromPartial(object.weatherAction)
      : undefined;
    message.setZoom = (object.setZoom !== undefined && object.setZoom !== null)
      ? SetZoomActionStateData.fromPartial(object.setZoom)
      : undefined;
    message.missionPlannerServiceControl =
      (object.missionPlannerServiceControl !== undefined && object.missionPlannerServiceControl !== null)
        ? MissionPlannerServiceControlActionStateData.fromPartial(object.missionPlannerServiceControl)
        : undefined;
    message.spotlightAction = (object.spotlightAction !== undefined && object.spotlightAction !== null)
      ? SpotlightActionStateData.fromPartial(object.spotlightAction)
      : undefined;
    message.setCameraSettings = (object.setCameraSettings !== undefined && object.setCameraSettings !== null)
      ? SetCameraSettingsActionStateData.fromPartial(object.setCameraSettings)
      : undefined;
    message.parachuteControl = (object.parachuteControl !== undefined && object.parachuteControl !== null)
      ? ParachuteControlActionStateData.fromPartial(object.parachuteControl)
      : undefined;
    message.nightsenseAction = (object.nightsenseAction !== undefined && object.nightsenseAction !== null)
      ? NightsenseActionStateData.fromPartial(object.nightsenseAction)
      : undefined;
    message.spoofMultiDrone = (object.spoofMultiDrone !== undefined && object.spoofMultiDrone !== null)
      ? SpoofMultiDroneActionStateData.fromPartial(object.spoofMultiDrone)
      : undefined;
    message.setMovementCommand = (object.setMovementCommand !== undefined && object.setMovementCommand !== null)
      ? SetMovementCommandActionStateData.fromPartial(object.setMovementCommand)
      : undefined;
    message.spoofFlightEnvelopeLimits =
      (object.spoofFlightEnvelopeLimits !== undefined && object.spoofFlightEnvelopeLimits !== null)
        ? SpoofFlightEnvelopeLimitsActionStateData.fromPartial(object.spoofFlightEnvelopeLimits)
        : undefined;
    message.turntable = (object.turntable !== undefined && object.turntable !== null)
      ? TurntableActionStateData.fromPartial(object.turntable)
      : undefined;
    message.dancingDrone = (object.dancingDrone !== undefined && object.dancingDrone !== null)
      ? DancingDroneActionStateData.fromPartial(object.dancingDrone)
      : undefined;
    message.waitForPreciseFault = (object.waitForPreciseFault !== undefined && object.waitForPreciseFault !== null)
      ? WaitForPreciseFaultActionStateData.fromPartial(object.waitForPreciseFault)
      : undefined;
    message.dancingDroneSpline = (object.dancingDroneSpline !== undefined && object.dancingDroneSpline !== null)
      ? DancingDroneSplineActionStateData.fromPartial(object.dancingDroneSpline)
      : undefined;
    message.globalPlannerRequest = (object.globalPlannerRequest !== undefined && object.globalPlannerRequest !== null)
      ? GlobalPlannerRequestActionStateData.fromPartial(object.globalPlannerRequest)
      : undefined;
    message.toggleSubjectDetection =
      (object.toggleSubjectDetection !== undefined && object.toggleSubjectDetection !== null)
        ? ToggleSubjectDetectionActionStateData.fromPartial(object.toggleSubjectDetection)
        : undefined;
    message.spoofSubjectScenario = (object.spoofSubjectScenario !== undefined && object.spoofSubjectScenario !== null)
      ? SpoofSubjectScenarioActionStateData.fromPartial(object.spoofSubjectScenario)
      : undefined;
    message.setSubjectFollowerSettings =
      (object.setSubjectFollowerSettings !== undefined && object.setSubjectFollowerSettings !== null)
        ? SetSubjectFollowerSettingsActionStateData.fromPartial(object.setSubjectFollowerSettings)
        : undefined;
    message.geofenceConfig = (object.geofenceConfig !== undefined && object.geofenceConfig !== null)
      ? GeofenceConfigActionStateData.fromPartial(object.geofenceConfig)
      : undefined;
    message.setDesiredImuSource = (object.setDesiredImuSource !== undefined && object.setDesiredImuSource !== null)
      ? SetDesiredImuSourceActionStateData.fromPartial(object.setDesiredImuSource)
      : undefined;
    message.sendMotionCommand = (object.sendMotionCommand !== undefined && object.sendMotionCommand !== null)
      ? SendMotionCommandActionStateData.fromPartial(object.sendMotionCommand)
      : undefined;
    message.setGnssSolverQuality = (object.setGnssSolverQuality !== undefined && object.setGnssSolverQuality !== null)
      ? SetGnssSolverQualityActionStateData.fromPartial(object.setGnssSolverQuality)
      : undefined;
    message.spoofPhoneUiVariablesAction =
      (object.spoofPhoneUiVariablesAction !== undefined && object.spoofPhoneUiVariablesAction !== null)
        ? SpoofPhoneUiVariablesActionStateData.fromPartial(object.spoofPhoneUiVariablesAction)
        : undefined;
    message.playAudio = (object.playAudio !== undefined && object.playAudio !== null)
      ? PlayAudioActionStateData.fromPartial(object.playAudio)
      : undefined;
    return message;
  },
};

function createBaseFailedTakeoffSummary(): FailedTakeoffSummary {
  return { blockingFaults: [], flightPhase: 0, reason: 0 };
}

export const FailedTakeoffSummary = {
  encode(message: FailedTakeoffSummary, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    writer.uint32(10).fork();
    for (const v of message.blockingFaults) {
      writer.int32(v);
    }
    writer.ldelim();
    if (message.flightPhase !== 0) {
      writer.uint32(16).int32(message.flightPhase);
    }
    if (message.reason !== 0) {
      writer.uint32(24).int32(message.reason);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): FailedTakeoffSummary {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFailedTakeoffSummary();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag === 8) {
            message.blockingFaults.push(reader.int32() as any);

            continue;
          }

          if (tag === 10) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.blockingFaults.push(reader.int32() as any);
            }

            continue;
          }

          break;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.flightPhase = reader.int32() as any;
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.reason = reader.int32() as any;
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FailedTakeoffSummary {
    return {
      blockingFaults: globalThis.Array.isArray(object?.blockingFaults)
        ? object.blockingFaults.map((e: any) => vehicleFault_EnumFromJSON(e))
        : [],
      flightPhase: isSet(object.flightPhase) ? flightPhaseEnum_EnumFromJSON(object.flightPhase) : 0,
      reason: isSet(object.reason) ? failedTakeoffReason_EnumFromJSON(object.reason) : 0,
    };
  },

  toJSON(message: FailedTakeoffSummary): unknown {
    const obj: any = {};
    if (message.blockingFaults?.length) {
      obj.blockingFaults = message.blockingFaults.map((e) => vehicleFault_EnumToJSON(e));
    }
    if (message.flightPhase !== 0) {
      obj.flightPhase = flightPhaseEnum_EnumToJSON(message.flightPhase);
    }
    if (message.reason !== 0) {
      obj.reason = failedTakeoffReason_EnumToJSON(message.reason);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FailedTakeoffSummary>, I>>(base?: I): FailedTakeoffSummary {
    return FailedTakeoffSummary.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FailedTakeoffSummary>, I>>(object: I): FailedTakeoffSummary {
    const message = createBaseFailedTakeoffSummary();
    message.blockingFaults = object.blockingFaults?.map((e) => e) || [];
    message.flightPhase = object.flightPhase ?? 0;
    message.reason = object.reason ?? 0;
    return message;
  },
};

function createBaseFailedTakeoffReason(): FailedTakeoffReason {
  return {};
}

export const FailedTakeoffReason = {
  encode(_: FailedTakeoffReason, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): FailedTakeoffReason {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFailedTakeoffReason();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): FailedTakeoffReason {
    return {};
  },

  toJSON(_: FailedTakeoffReason): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<FailedTakeoffReason>, I>>(base?: I): FailedTakeoffReason {
    return FailedTakeoffReason.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FailedTakeoffReason>, I>>(_: I): FailedTakeoffReason {
    const message = createBaseFailedTakeoffReason();
    return message;
  },
};

function createBasePostMissionActionResultEnum(): PostMissionActionResultEnum {
  return {};
}

export const PostMissionActionResultEnum = {
  encode(_: PostMissionActionResultEnum, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): PostMissionActionResultEnum {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePostMissionActionResultEnum();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): PostMissionActionResultEnum {
    return {};
  },

  toJSON(_: PostMissionActionResultEnum): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<PostMissionActionResultEnum>, I>>(base?: I): PostMissionActionResultEnum {
    return PostMissionActionResultEnum.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PostMissionActionResultEnum>, I>>(_: I): PostMissionActionResultEnum {
    const message = createBasePostMissionActionResultEnum();
    return message;
  },
};

function createBaseResumableMissionState(): ResumableMissionState {
  return {
    stateSavedUtime: 0,
    missionExecutionUuid: undefined,
    missionSpecUuid: undefined,
    rootActionState: undefined,
  };
}

export const ResumableMissionState = {
  encode(message: ResumableMissionState, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.stateSavedUtime !== 0) {
      writer.uint32(8).uint64(message.stateSavedUtime);
    }
    if (message.missionExecutionUuid !== undefined) {
      Uuid.encode(message.missionExecutionUuid, writer.uint32(18).fork()).ldelim();
    }
    if (message.missionSpecUuid !== undefined) {
      Uuid.encode(message.missionSpecUuid, writer.uint32(26).fork()).ldelim();
    }
    if (message.rootActionState !== undefined) {
      ActionState.encode(message.rootActionState, writer.uint32(34).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ResumableMissionState {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseResumableMissionState();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.stateSavedUtime = longToNumber(reader.uint64() as Long);
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.missionExecutionUuid = Uuid.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.missionSpecUuid = Uuid.decode(reader, reader.uint32());
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.rootActionState = ActionState.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ResumableMissionState {
    return {
      stateSavedUtime: isSet(object.stateSavedUtime) ? globalThis.Number(object.stateSavedUtime) : 0,
      missionExecutionUuid: isSet(object.missionExecutionUuid) ? Uuid.fromJSON(object.missionExecutionUuid) : undefined,
      missionSpecUuid: isSet(object.missionSpecUuid) ? Uuid.fromJSON(object.missionSpecUuid) : undefined,
      rootActionState: isSet(object.rootActionState) ? ActionState.fromJSON(object.rootActionState) : undefined,
    };
  },

  toJSON(message: ResumableMissionState): unknown {
    const obj: any = {};
    if (message.stateSavedUtime !== 0) {
      obj.stateSavedUtime = Math.round(message.stateSavedUtime);
    }
    if (message.missionExecutionUuid !== undefined) {
      obj.missionExecutionUuid = Uuid.toJSON(message.missionExecutionUuid);
    }
    if (message.missionSpecUuid !== undefined) {
      obj.missionSpecUuid = Uuid.toJSON(message.missionSpecUuid);
    }
    if (message.rootActionState !== undefined) {
      obj.rootActionState = ActionState.toJSON(message.rootActionState);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ResumableMissionState>, I>>(base?: I): ResumableMissionState {
    return ResumableMissionState.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ResumableMissionState>, I>>(object: I): ResumableMissionState {
    const message = createBaseResumableMissionState();
    message.stateSavedUtime = object.stateSavedUtime ?? 0;
    message.missionExecutionUuid = (object.missionExecutionUuid !== undefined && object.missionExecutionUuid !== null)
      ? Uuid.fromPartial(object.missionExecutionUuid)
      : undefined;
    message.missionSpecUuid = (object.missionSpecUuid !== undefined && object.missionSpecUuid !== null)
      ? Uuid.fromPartial(object.missionSpecUuid)
      : undefined;
    message.rootActionState = (object.rootActionState !== undefined && object.rootActionState !== null)
      ? ActionState.fromPartial(object.rootActionState)
      : undefined;
    return message;
  },
};

function createBaseMissionResult(): MissionResult {
  return {
    utime: 0,
    executionUuid: "",
    startUclock: 0,
    endUclock: 0,
    scheduledMissionUuid: "",
    missionUuid: "",
    templateUuid: "",
    flightId: "",
    vehicleId: "",
    result: 0,
    errorString: "",
    actionResults: [],
    postMissionTaskRuntimeSeconds: 0,
    postMissionActionRuntimeSeconds: 0,
    failedTakeoffSummary: undefined,
    postMissionActionResult: 0,
    takeoffDockId: "",
    skipAlert: false,
    savedMissionStateToVehicle: false,
    resumeState: undefined,
    missionExecutionGroupUuid: "",
  };
}

export const MissionResult = {
  encode(message: MissionResult, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.utime !== 0) {
      writer.uint32(48).int64(message.utime);
    }
    if (message.executionUuid !== "") {
      writer.uint32(58).string(message.executionUuid);
    }
    if (message.startUclock !== 0) {
      writer.uint32(64).int64(message.startUclock);
    }
    if (message.endUclock !== 0) {
      writer.uint32(72).int64(message.endUclock);
    }
    if (message.scheduledMissionUuid !== "") {
      writer.uint32(82).string(message.scheduledMissionUuid);
    }
    if (message.missionUuid !== "") {
      writer.uint32(10).string(message.missionUuid);
    }
    if (message.templateUuid !== "") {
      writer.uint32(18).string(message.templateUuid);
    }
    if (message.flightId !== "") {
      writer.uint32(90).string(message.flightId);
    }
    if (message.vehicleId !== "") {
      writer.uint32(114).string(message.vehicleId);
    }
    if (message.result !== 0) {
      writer.uint32(24).int32(message.result);
    }
    if (message.errorString !== "") {
      writer.uint32(34).string(message.errorString);
    }
    for (const v of message.actionResults) {
      ActionResult.encode(v!, writer.uint32(42).fork()).ldelim();
    }
    if (message.postMissionTaskRuntimeSeconds !== 0) {
      writer.uint32(101).float(message.postMissionTaskRuntimeSeconds);
    }
    if (message.postMissionActionRuntimeSeconds !== 0) {
      writer.uint32(109).float(message.postMissionActionRuntimeSeconds);
    }
    if (message.failedTakeoffSummary !== undefined) {
      FailedTakeoffSummary.encode(message.failedTakeoffSummary, writer.uint32(122).fork()).ldelim();
    }
    if (message.postMissionActionResult !== 0) {
      writer.uint32(128).int32(message.postMissionActionResult);
    }
    if (message.takeoffDockId !== "") {
      writer.uint32(138).string(message.takeoffDockId);
    }
    if (message.skipAlert === true) {
      writer.uint32(144).bool(message.skipAlert);
    }
    if (message.savedMissionStateToVehicle === true) {
      writer.uint32(152).bool(message.savedMissionStateToVehicle);
    }
    if (message.resumeState !== undefined) {
      ResumableMissionState.encode(message.resumeState, writer.uint32(162).fork()).ldelim();
    }
    if (message.missionExecutionGroupUuid !== "") {
      writer.uint32(170).string(message.missionExecutionGroupUuid);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): MissionResult {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMissionResult();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 6:
          if (tag !== 48) {
            break;
          }

          message.utime = longToNumber(reader.int64() as Long);
          continue;
        case 7:
          if (tag !== 58) {
            break;
          }

          message.executionUuid = reader.string();
          continue;
        case 8:
          if (tag !== 64) {
            break;
          }

          message.startUclock = longToNumber(reader.int64() as Long);
          continue;
        case 9:
          if (tag !== 72) {
            break;
          }

          message.endUclock = longToNumber(reader.int64() as Long);
          continue;
        case 10:
          if (tag !== 82) {
            break;
          }

          message.scheduledMissionUuid = reader.string();
          continue;
        case 1:
          if (tag !== 10) {
            break;
          }

          message.missionUuid = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.templateUuid = reader.string();
          continue;
        case 11:
          if (tag !== 90) {
            break;
          }

          message.flightId = reader.string();
          continue;
        case 14:
          if (tag !== 114) {
            break;
          }

          message.vehicleId = reader.string();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.result = reader.int32() as any;
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.errorString = reader.string();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.actionResults.push(ActionResult.decode(reader, reader.uint32()));
          continue;
        case 12:
          if (tag !== 101) {
            break;
          }

          message.postMissionTaskRuntimeSeconds = reader.float();
          continue;
        case 13:
          if (tag !== 109) {
            break;
          }

          message.postMissionActionRuntimeSeconds = reader.float();
          continue;
        case 15:
          if (tag !== 122) {
            break;
          }

          message.failedTakeoffSummary = FailedTakeoffSummary.decode(reader, reader.uint32());
          continue;
        case 16:
          if (tag !== 128) {
            break;
          }

          message.postMissionActionResult = reader.int32() as any;
          continue;
        case 17:
          if (tag !== 138) {
            break;
          }

          message.takeoffDockId = reader.string();
          continue;
        case 18:
          if (tag !== 144) {
            break;
          }

          message.skipAlert = reader.bool();
          continue;
        case 19:
          if (tag !== 152) {
            break;
          }

          message.savedMissionStateToVehicle = reader.bool();
          continue;
        case 20:
          if (tag !== 162) {
            break;
          }

          message.resumeState = ResumableMissionState.decode(reader, reader.uint32());
          continue;
        case 21:
          if (tag !== 170) {
            break;
          }

          message.missionExecutionGroupUuid = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MissionResult {
    return {
      utime: isSet(object.utime) ? globalThis.Number(object.utime) : 0,
      executionUuid: isSet(object.executionUuid) ? globalThis.String(object.executionUuid) : "",
      startUclock: isSet(object.startUclock) ? globalThis.Number(object.startUclock) : 0,
      endUclock: isSet(object.endUclock) ? globalThis.Number(object.endUclock) : 0,
      scheduledMissionUuid: isSet(object.scheduledMissionUuid) ? globalThis.String(object.scheduledMissionUuid) : "",
      missionUuid: isSet(object.missionUuid) ? globalThis.String(object.missionUuid) : "",
      templateUuid: isSet(object.templateUuid) ? globalThis.String(object.templateUuid) : "",
      flightId: isSet(object.flightId) ? globalThis.String(object.flightId) : "",
      vehicleId: isSet(object.vehicleId) ? globalThis.String(object.vehicleId) : "",
      result: isSet(object.result) ? missionResult_ResultFromJSON(object.result) : 0,
      errorString: isSet(object.errorString) ? globalThis.String(object.errorString) : "",
      actionResults: globalThis.Array.isArray(object?.actionResults)
        ? object.actionResults.map((e: any) => ActionResult.fromJSON(e))
        : [],
      postMissionTaskRuntimeSeconds: isSet(object.postMissionTaskRuntimeSeconds)
        ? globalThis.Number(object.postMissionTaskRuntimeSeconds)
        : 0,
      postMissionActionRuntimeSeconds: isSet(object.postMissionActionRuntimeSeconds)
        ? globalThis.Number(object.postMissionActionRuntimeSeconds)
        : 0,
      failedTakeoffSummary: isSet(object.failedTakeoffSummary)
        ? FailedTakeoffSummary.fromJSON(object.failedTakeoffSummary)
        : undefined,
      postMissionActionResult: isSet(object.postMissionActionResult)
        ? postMissionActionResultEnum_EnumFromJSON(object.postMissionActionResult)
        : 0,
      takeoffDockId: isSet(object.takeoffDockId) ? globalThis.String(object.takeoffDockId) : "",
      skipAlert: isSet(object.skipAlert) ? globalThis.Boolean(object.skipAlert) : false,
      savedMissionStateToVehicle: isSet(object.savedMissionStateToVehicle)
        ? globalThis.Boolean(object.savedMissionStateToVehicle)
        : false,
      resumeState: isSet(object.resumeState) ? ResumableMissionState.fromJSON(object.resumeState) : undefined,
      missionExecutionGroupUuid: isSet(object.missionExecutionGroupUuid)
        ? globalThis.String(object.missionExecutionGroupUuid)
        : "",
    };
  },

  toJSON(message: MissionResult): unknown {
    const obj: any = {};
    if (message.utime !== 0) {
      obj.utime = Math.round(message.utime);
    }
    if (message.executionUuid !== "") {
      obj.executionUuid = message.executionUuid;
    }
    if (message.startUclock !== 0) {
      obj.startUclock = Math.round(message.startUclock);
    }
    if (message.endUclock !== 0) {
      obj.endUclock = Math.round(message.endUclock);
    }
    if (message.scheduledMissionUuid !== "") {
      obj.scheduledMissionUuid = message.scheduledMissionUuid;
    }
    if (message.missionUuid !== "") {
      obj.missionUuid = message.missionUuid;
    }
    if (message.templateUuid !== "") {
      obj.templateUuid = message.templateUuid;
    }
    if (message.flightId !== "") {
      obj.flightId = message.flightId;
    }
    if (message.vehicleId !== "") {
      obj.vehicleId = message.vehicleId;
    }
    if (message.result !== 0) {
      obj.result = missionResult_ResultToJSON(message.result);
    }
    if (message.errorString !== "") {
      obj.errorString = message.errorString;
    }
    if (message.actionResults?.length) {
      obj.actionResults = message.actionResults.map((e) => ActionResult.toJSON(e));
    }
    if (message.postMissionTaskRuntimeSeconds !== 0) {
      obj.postMissionTaskRuntimeSeconds = message.postMissionTaskRuntimeSeconds;
    }
    if (message.postMissionActionRuntimeSeconds !== 0) {
      obj.postMissionActionRuntimeSeconds = message.postMissionActionRuntimeSeconds;
    }
    if (message.failedTakeoffSummary !== undefined) {
      obj.failedTakeoffSummary = FailedTakeoffSummary.toJSON(message.failedTakeoffSummary);
    }
    if (message.postMissionActionResult !== 0) {
      obj.postMissionActionResult = postMissionActionResultEnum_EnumToJSON(message.postMissionActionResult);
    }
    if (message.takeoffDockId !== "") {
      obj.takeoffDockId = message.takeoffDockId;
    }
    if (message.skipAlert === true) {
      obj.skipAlert = message.skipAlert;
    }
    if (message.savedMissionStateToVehicle === true) {
      obj.savedMissionStateToVehicle = message.savedMissionStateToVehicle;
    }
    if (message.resumeState !== undefined) {
      obj.resumeState = ResumableMissionState.toJSON(message.resumeState);
    }
    if (message.missionExecutionGroupUuid !== "") {
      obj.missionExecutionGroupUuid = message.missionExecutionGroupUuid;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MissionResult>, I>>(base?: I): MissionResult {
    return MissionResult.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MissionResult>, I>>(object: I): MissionResult {
    const message = createBaseMissionResult();
    message.utime = object.utime ?? 0;
    message.executionUuid = object.executionUuid ?? "";
    message.startUclock = object.startUclock ?? 0;
    message.endUclock = object.endUclock ?? 0;
    message.scheduledMissionUuid = object.scheduledMissionUuid ?? "";
    message.missionUuid = object.missionUuid ?? "";
    message.templateUuid = object.templateUuid ?? "";
    message.flightId = object.flightId ?? "";
    message.vehicleId = object.vehicleId ?? "";
    message.result = object.result ?? 0;
    message.errorString = object.errorString ?? "";
    message.actionResults = object.actionResults?.map((e) => ActionResult.fromPartial(e)) || [];
    message.postMissionTaskRuntimeSeconds = object.postMissionTaskRuntimeSeconds ?? 0;
    message.postMissionActionRuntimeSeconds = object.postMissionActionRuntimeSeconds ?? 0;
    message.failedTakeoffSummary = (object.failedTakeoffSummary !== undefined && object.failedTakeoffSummary !== null)
      ? FailedTakeoffSummary.fromPartial(object.failedTakeoffSummary)
      : undefined;
    message.postMissionActionResult = object.postMissionActionResult ?? 0;
    message.takeoffDockId = object.takeoffDockId ?? "";
    message.skipAlert = object.skipAlert ?? false;
    message.savedMissionStateToVehicle = object.savedMissionStateToVehicle ?? false;
    message.resumeState = (object.resumeState !== undefined && object.resumeState !== null)
      ? ResumableMissionState.fromPartial(object.resumeState)
      : undefined;
    message.missionExecutionGroupUuid = object.missionExecutionGroupUuid ?? "";
    return message;
  },
};

function createBaseActionResult(): ActionResult {
  return {
    uuid: "",
    actionUuid: "",
    actionKey: "",
    message: "",
    startUclock: 0,
    endUclock: 0,
    startUtime: 0,
    endUtime: 0,
    debugJson: "",
    result: 0,
    errorCode: "",
    parentActionResultUuid: "",
    gotoGpsWaypoint: undefined,
    gotoNavWaypoint: undefined,
    takePhoto: undefined,
    surfaceScanSkill: undefined,
    startVideo: undefined,
    stopVideo: undefined,
    switchRecordingMode: undefined,
    timedWait: undefined,
    sequence: undefined,
    orbitPoiAction: undefined,
    takePanorama: undefined,
    keyframeSkill: undefined,
    gotoWaypoint: undefined,
    setObstacleAvoidance: undefined,
    initializeGps: undefined,
    subjectDetected: undefined,
    looper: undefined,
    withinDistance: undefined,
    unifiedFollowAction: undefined,
    inverter: undefined,
    togglePhotoIntervalMode: undefined,
    wifiScan: undefined,
    enableStrobeLights: undefined,
    disableStrobeLights: undefined,
    spoofJoysticksInputs: undefined,
    updateJoysticksSettings: undefined,
    updateShapeMap: undefined,
    spoofObstacle: undefined,
    dummyAction: undefined,
    testDesiredVelocityAction: undefined,
    testTrackTrajectory: undefined,
    atvSubjectSpoofAction: undefined,
    skiSubjectSpoofAction: undefined,
    setGimbalOrientation: undefined,
    parallel: undefined,
    sequenceUntilSuccess: undefined,
    sequenceUntilFailure: undefined,
    sequencePretakeoff: undefined,
    sequenceConfig: undefined,
    waitForRtk: undefined,
    wingWaypointsCommand: undefined,
    sendDynamicScenario: undefined,
    scoutAction: undefined,
    spoofTrackingDevice: undefined,
    spoofDisturbanceAction: undefined,
    updateVehicleSettings: undefined,
    waitForVehicleStop: undefined,
    precomputedSubjectSpoofAction: undefined,
    modifySimStateEstimation: undefined,
    gotoAndOrbitPoi: undefined,
    acquireGps: undefined,
    setFaultOverride: undefined,
    eLand: undefined,
    trajectoryInspect: undefined,
    toggleTargetPointExposure: undefined,
    toggleSemanticAim: undefined,
    spoofBatteryLevel: undefined,
    ncpgControl: undefined,
    registerComplimentaryActions: undefined,
    trackInPlace: undefined,
    globalGraphControl: undefined,
    overrideGpsQuality: undefined,
    initGlobalMap: undefined,
    stopForPhotoInspect: undefined,
    spoofInitialGpsHeading: undefined,
    trackLandingPadRequest: undefined,
    apriltagSetId: undefined,
    dockGpsEstimator: undefined,
    g47CommandOverride: undefined,
    requestTakeoffProfile: undefined,
    updateDockLocationAction: undefined,
    setDesiredGpsSource: undefined,
    spoofManualGps: undefined,
    weatherAction: undefined,
    setZoom: undefined,
    missionPlannerServiceControl: undefined,
    spotlightAction: undefined,
    setCameraSettings: undefined,
    parachuteControl: undefined,
    nightsenseAction: undefined,
    spoofMultiDrone: undefined,
    setMovementCommand: undefined,
    spoofFlightEnvelopeLimits: undefined,
    turntable: undefined,
    dancingDrone: undefined,
    waitForPreciseFault: undefined,
    dancingDroneSpline: undefined,
    globalPlannerRequest: undefined,
    toggleSubjectDetection: undefined,
    spoofSubjectScenario: undefined,
    setSubjectFollowerSettings: undefined,
    geofenceConfig: undefined,
    setDesiredImuSource: undefined,
    sendMotionCommand: undefined,
    setGnssSolverQuality: undefined,
    spoofPhoneUiVariablesAction: undefined,
    playAudio: undefined,
  };
}

export const ActionResult = {
  encode(message: ActionResult, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.uuid !== "") {
      writer.uint32(98).string(message.uuid);
    }
    if (message.actionUuid !== "") {
      writer.uint32(10).string(message.actionUuid);
    }
    if (message.actionKey !== "") {
      writer.uint32(74).string(message.actionKey);
    }
    if (message.message !== "") {
      writer.uint32(18).string(message.message);
    }
    if (message.startUclock !== 0) {
      writer.uint32(24).int64(message.startUclock);
    }
    if (message.endUclock !== 0) {
      writer.uint32(32).int64(message.endUclock);
    }
    if (message.startUtime !== 0) {
      writer.uint32(112).int64(message.startUtime);
    }
    if (message.endUtime !== 0) {
      writer.uint32(120).int64(message.endUtime);
    }
    if (message.debugJson !== "") {
      writer.uint32(58).string(message.debugJson);
    }
    if (message.result !== 0) {
      writer.uint32(80).int32(message.result);
    }
    if (message.errorCode !== "") {
      writer.uint32(90).string(message.errorCode);
    }
    if (message.parentActionResultUuid !== "") {
      writer.uint32(106).string(message.parentActionResultUuid);
    }
    if (message.gotoGpsWaypoint !== undefined) {
      GotoGpsWaypointResultData.encode(message.gotoGpsWaypoint, writer.uint32(818).fork()).ldelim();
    }
    if (message.gotoNavWaypoint !== undefined) {
      GotoNavWaypointResultData.encode(message.gotoNavWaypoint, writer.uint32(826).fork()).ldelim();
    }
    if (message.takePhoto !== undefined) {
      TakePhotoResultData.encode(message.takePhoto, writer.uint32(834).fork()).ldelim();
    }
    if (message.surfaceScanSkill !== undefined) {
      SurfaceScanResultData.encode(message.surfaceScanSkill, writer.uint32(842).fork()).ldelim();
    }
    if (message.startVideo !== undefined) {
      StartVideoResultData.encode(message.startVideo, writer.uint32(850).fork()).ldelim();
    }
    if (message.stopVideo !== undefined) {
      StopVideoResultData.encode(message.stopVideo, writer.uint32(858).fork()).ldelim();
    }
    if (message.switchRecordingMode !== undefined) {
      SwitchRecordingModeResultData.encode(message.switchRecordingMode, writer.uint32(866).fork()).ldelim();
    }
    if (message.timedWait !== undefined) {
      TimedWaitResultData.encode(message.timedWait, writer.uint32(874).fork()).ldelim();
    }
    if (message.sequence !== undefined) {
      SequenceResultData.encode(message.sequence, writer.uint32(882).fork()).ldelim();
    }
    if (message.orbitPoiAction !== undefined) {
      OrbitPoiResultData.encode(message.orbitPoiAction, writer.uint32(890).fork()).ldelim();
    }
    if (message.takePanorama !== undefined) {
      TakePanoramaResultData.encode(message.takePanorama, writer.uint32(898).fork()).ldelim();
    }
    if (message.keyframeSkill !== undefined) {
      KeyframeResultData.encode(message.keyframeSkill, writer.uint32(906).fork()).ldelim();
    }
    if (message.gotoWaypoint !== undefined) {
      GotoWaypointResultData.encode(message.gotoWaypoint, writer.uint32(914).fork()).ldelim();
    }
    if (message.setObstacleAvoidance !== undefined) {
      SetObstacleAvoidanceResultData.encode(message.setObstacleAvoidance, writer.uint32(922).fork()).ldelim();
    }
    if (message.initializeGps !== undefined) {
      InitializeGpsResultData.encode(message.initializeGps, writer.uint32(930).fork()).ldelim();
    }
    if (message.subjectDetected !== undefined) {
      SubjectDetectedResultData.encode(message.subjectDetected, writer.uint32(938).fork()).ldelim();
    }
    if (message.looper !== undefined) {
      LooperResultData.encode(message.looper, writer.uint32(946).fork()).ldelim();
    }
    if (message.withinDistance !== undefined) {
      WithinDistanceResultData.encode(message.withinDistance, writer.uint32(954).fork()).ldelim();
    }
    if (message.unifiedFollowAction !== undefined) {
      UnifiedFollowResultData.encode(message.unifiedFollowAction, writer.uint32(962).fork()).ldelim();
    }
    if (message.inverter !== undefined) {
      InverterResultData.encode(message.inverter, writer.uint32(970).fork()).ldelim();
    }
    if (message.togglePhotoIntervalMode !== undefined) {
      TogglePhotoIntervalModeResultData.encode(message.togglePhotoIntervalMode, writer.uint32(978).fork()).ldelim();
    }
    if (message.wifiScan !== undefined) {
      WifiScanResultData.encode(message.wifiScan, writer.uint32(986).fork()).ldelim();
    }
    if (message.enableStrobeLights !== undefined) {
      EnableStrobeLightsResultData.encode(message.enableStrobeLights, writer.uint32(994).fork()).ldelim();
    }
    if (message.disableStrobeLights !== undefined) {
      DisableStrobeLightsResultData.encode(message.disableStrobeLights, writer.uint32(1002).fork()).ldelim();
    }
    if (message.spoofJoysticksInputs !== undefined) {
      SpoofJoysticksInputsResultData.encode(message.spoofJoysticksInputs, writer.uint32(1010).fork()).ldelim();
    }
    if (message.updateJoysticksSettings !== undefined) {
      UpdateJoysticksSettingsResultData.encode(message.updateJoysticksSettings, writer.uint32(1018).fork()).ldelim();
    }
    if (message.updateShapeMap !== undefined) {
      UpdateShapeMapResultData.encode(message.updateShapeMap, writer.uint32(1026).fork()).ldelim();
    }
    if (message.spoofObstacle !== undefined) {
      SpoofObstacleResultData.encode(message.spoofObstacle, writer.uint32(1034).fork()).ldelim();
    }
    if (message.dummyAction !== undefined) {
      DummyResultData.encode(message.dummyAction, writer.uint32(1042).fork()).ldelim();
    }
    if (message.testDesiredVelocityAction !== undefined) {
      TestDesiredVelocityResultData.encode(message.testDesiredVelocityAction, writer.uint32(1050).fork()).ldelim();
    }
    if (message.testTrackTrajectory !== undefined) {
      TestTrackTrajectoryResultData.encode(message.testTrackTrajectory, writer.uint32(1058).fork()).ldelim();
    }
    if (message.atvSubjectSpoofAction !== undefined) {
      AtvSubjectSpoofResultData.encode(message.atvSubjectSpoofAction, writer.uint32(1066).fork()).ldelim();
    }
    if (message.skiSubjectSpoofAction !== undefined) {
      SkiSubjectSpoofResultData.encode(message.skiSubjectSpoofAction, writer.uint32(1074).fork()).ldelim();
    }
    if (message.setGimbalOrientation !== undefined) {
      SetGimbalOrientationResultData.encode(message.setGimbalOrientation, writer.uint32(1082).fork()).ldelim();
    }
    if (message.parallel !== undefined) {
      ParallelResultData.encode(message.parallel, writer.uint32(1090).fork()).ldelim();
    }
    if (message.sequenceUntilSuccess !== undefined) {
      SequenceUntilSuccessResultData.encode(message.sequenceUntilSuccess, writer.uint32(1098).fork()).ldelim();
    }
    if (message.sequenceUntilFailure !== undefined) {
      SequenceUntilFailureResultData.encode(message.sequenceUntilFailure, writer.uint32(1106).fork()).ldelim();
    }
    if (message.sequencePretakeoff !== undefined) {
      SequencePretakeoffResultData.encode(message.sequencePretakeoff, writer.uint32(1274).fork()).ldelim();
    }
    if (message.sequenceConfig !== undefined) {
      SequenceConfigResultData.encode(message.sequenceConfig, writer.uint32(1442).fork()).ldelim();
    }
    if (message.waitForRtk !== undefined) {
      WaitForRtkResultData.encode(message.waitForRtk, writer.uint32(1450).fork()).ldelim();
    }
    if (message.wingWaypointsCommand !== undefined) {
      WingWaypointsCommandResultData.encode(message.wingWaypointsCommand, writer.uint32(4002).fork()).ldelim();
    }
    if (message.sendDynamicScenario !== undefined) {
      SendDynamicScenarioResultData.encode(message.sendDynamicScenario, writer.uint32(4010).fork()).ldelim();
    }
    if (message.scoutAction !== undefined) {
      ScoutActionResultData.encode(message.scoutAction, writer.uint32(4018).fork()).ldelim();
    }
    if (message.spoofTrackingDevice !== undefined) {
      SpoofTrackingDeviceResultData.encode(message.spoofTrackingDevice, writer.uint32(4026).fork()).ldelim();
    }
    if (message.spoofDisturbanceAction !== undefined) {
      SpoofDisturbanceResultData.encode(message.spoofDisturbanceAction, writer.uint32(1114).fork()).ldelim();
    }
    if (message.updateVehicleSettings !== undefined) {
      UpdateVehicleSettingsResultData.encode(message.updateVehicleSettings, writer.uint32(1122).fork()).ldelim();
    }
    if (message.waitForVehicleStop !== undefined) {
      WaitForVehicleStopResultData.encode(message.waitForVehicleStop, writer.uint32(1130).fork()).ldelim();
    }
    if (message.precomputedSubjectSpoofAction !== undefined) {
      PrecomputedSubjectSpoofResultData.encode(message.precomputedSubjectSpoofAction, writer.uint32(1138).fork())
        .ldelim();
    }
    if (message.modifySimStateEstimation !== undefined) {
      ModifySimStateEstimationResultData.encode(message.modifySimStateEstimation, writer.uint32(1146).fork()).ldelim();
    }
    if (message.gotoAndOrbitPoi !== undefined) {
      GotoAndOrbitPoiResultData.encode(message.gotoAndOrbitPoi, writer.uint32(1154).fork()).ldelim();
    }
    if (message.acquireGps !== undefined) {
      AcquireGpsResultData.encode(message.acquireGps, writer.uint32(1162).fork()).ldelim();
    }
    if (message.setFaultOverride !== undefined) {
      SetFaultOverrideResultData.encode(message.setFaultOverride, writer.uint32(1170).fork()).ldelim();
    }
    if (message.eLand !== undefined) {
      ELandResultData.encode(message.eLand, writer.uint32(1178).fork()).ldelim();
    }
    if (message.trajectoryInspect !== undefined) {
      TrajectoryInspectResultData.encode(message.trajectoryInspect, writer.uint32(1186).fork()).ldelim();
    }
    if (message.toggleTargetPointExposure !== undefined) {
      ToggleTargetPointExposureResultData.encode(message.toggleTargetPointExposure, writer.uint32(1194).fork())
        .ldelim();
    }
    if (message.toggleSemanticAim !== undefined) {
      ToggleSemanticAimResultData.encode(message.toggleSemanticAim, writer.uint32(1202).fork()).ldelim();
    }
    if (message.spoofBatteryLevel !== undefined) {
      SpoofBatteryLevelResultData.encode(message.spoofBatteryLevel, writer.uint32(1210).fork()).ldelim();
    }
    if (message.ncpgControl !== undefined) {
      NcpgControlResultData.encode(message.ncpgControl, writer.uint32(1218).fork()).ldelim();
    }
    if (message.registerComplimentaryActions !== undefined) {
      RegisterComplimentaryActionsResultData.encode(message.registerComplimentaryActions, writer.uint32(1226).fork())
        .ldelim();
    }
    if (message.trackInPlace !== undefined) {
      TrackInPlaceResultData.encode(message.trackInPlace, writer.uint32(1234).fork()).ldelim();
    }
    if (message.globalGraphControl !== undefined) {
      GlobalGraphControlResultData.encode(message.globalGraphControl, writer.uint32(1242).fork()).ldelim();
    }
    if (message.overrideGpsQuality !== undefined) {
      OverrideGpsQualityResultData.encode(message.overrideGpsQuality, writer.uint32(1250).fork()).ldelim();
    }
    if (message.initGlobalMap !== undefined) {
      InitGlobalMapResultData.encode(message.initGlobalMap, writer.uint32(1258).fork()).ldelim();
    }
    if (message.stopForPhotoInspect !== undefined) {
      StopForPhotoInspectResultData.encode(message.stopForPhotoInspect, writer.uint32(1266).fork()).ldelim();
    }
    if (message.spoofInitialGpsHeading !== undefined) {
      SpoofInitialGpsHeadingResultData.encode(message.spoofInitialGpsHeading, writer.uint32(1282).fork()).ldelim();
    }
    if (message.trackLandingPadRequest !== undefined) {
      TrackLandingPadRequestResultData.encode(message.trackLandingPadRequest, writer.uint32(1290).fork()).ldelim();
    }
    if (message.apriltagSetId !== undefined) {
      ApriltagSetIdResultData.encode(message.apriltagSetId, writer.uint32(1298).fork()).ldelim();
    }
    if (message.dockGpsEstimator !== undefined) {
      DockGpsEstimatorResultData.encode(message.dockGpsEstimator, writer.uint32(1306).fork()).ldelim();
    }
    if (message.g47CommandOverride !== undefined) {
      G47CommandOverrideResultData.encode(message.g47CommandOverride, writer.uint32(1314).fork()).ldelim();
    }
    if (message.requestTakeoffProfile !== undefined) {
      RequestTakeoffProfileResultData.encode(message.requestTakeoffProfile, writer.uint32(1322).fork()).ldelim();
    }
    if (message.updateDockLocationAction !== undefined) {
      UpdateDockLocationActionResultData.encode(message.updateDockLocationAction, writer.uint32(1330).fork()).ldelim();
    }
    if (message.setDesiredGpsSource !== undefined) {
      SetDesiredGpsSourceResultData.encode(message.setDesiredGpsSource, writer.uint32(1338).fork()).ldelim();
    }
    if (message.spoofManualGps !== undefined) {
      SpoofManualGpsResultData.encode(message.spoofManualGps, writer.uint32(1346).fork()).ldelim();
    }
    if (message.weatherAction !== undefined) {
      WeatherActionResultData.encode(message.weatherAction, writer.uint32(1354).fork()).ldelim();
    }
    if (message.setZoom !== undefined) {
      SetZoomResultData.encode(message.setZoom, writer.uint32(1362).fork()).ldelim();
    }
    if (message.missionPlannerServiceControl !== undefined) {
      MissionPlannerServiceControlResultData.encode(message.missionPlannerServiceControl, writer.uint32(1370).fork())
        .ldelim();
    }
    if (message.spotlightAction !== undefined) {
      SpotlightActionResultData.encode(message.spotlightAction, writer.uint32(1378).fork()).ldelim();
    }
    if (message.setCameraSettings !== undefined) {
      SetCameraSettingsResultData.encode(message.setCameraSettings, writer.uint32(1386).fork()).ldelim();
    }
    if (message.parachuteControl !== undefined) {
      ParachuteControlResultData.encode(message.parachuteControl, writer.uint32(1394).fork()).ldelim();
    }
    if (message.nightsenseAction !== undefined) {
      NightsenseActionResultData.encode(message.nightsenseAction, writer.uint32(1402).fork()).ldelim();
    }
    if (message.spoofMultiDrone !== undefined) {
      SpoofMultiDroneResultData.encode(message.spoofMultiDrone, writer.uint32(1410).fork()).ldelim();
    }
    if (message.setMovementCommand !== undefined) {
      SetMovementCommandResultData.encode(message.setMovementCommand, writer.uint32(1418).fork()).ldelim();
    }
    if (message.spoofFlightEnvelopeLimits !== undefined) {
      SpoofFlightEnvelopeLimitsResultData.encode(message.spoofFlightEnvelopeLimits, writer.uint32(1426).fork())
        .ldelim();
    }
    if (message.turntable !== undefined) {
      TurntableResultData.encode(message.turntable, writer.uint32(1434).fork()).ldelim();
    }
    if (message.dancingDrone !== undefined) {
      DancingDroneResultData.encode(message.dancingDrone, writer.uint32(1458).fork()).ldelim();
    }
    if (message.waitForPreciseFault !== undefined) {
      WaitForPreciseFaultResultData.encode(message.waitForPreciseFault, writer.uint32(1466).fork()).ldelim();
    }
    if (message.dancingDroneSpline !== undefined) {
      DancingDroneSplineResultData.encode(message.dancingDroneSpline, writer.uint32(1474).fork()).ldelim();
    }
    if (message.globalPlannerRequest !== undefined) {
      GlobalPlannerRequestActionResultData.encode(message.globalPlannerRequest, writer.uint32(1482).fork()).ldelim();
    }
    if (message.toggleSubjectDetection !== undefined) {
      ToggleSubjectDetectionResultData.encode(message.toggleSubjectDetection, writer.uint32(1490).fork()).ldelim();
    }
    if (message.spoofSubjectScenario !== undefined) {
      SpoofSubjectScenarioResultData.encode(message.spoofSubjectScenario, writer.uint32(1498).fork()).ldelim();
    }
    if (message.setSubjectFollowerSettings !== undefined) {
      SetSubjectFollowerSettingsResultData.encode(message.setSubjectFollowerSettings, writer.uint32(1506).fork())
        .ldelim();
    }
    if (message.geofenceConfig !== undefined) {
      GeofenceConfigResultData.encode(message.geofenceConfig, writer.uint32(1514).fork()).ldelim();
    }
    if (message.setDesiredImuSource !== undefined) {
      SetDesiredImuSourceResultData.encode(message.setDesiredImuSource, writer.uint32(4034).fork()).ldelim();
    }
    if (message.sendMotionCommand !== undefined) {
      SendMotionCommandResultData.encode(message.sendMotionCommand, writer.uint32(4042).fork()).ldelim();
    }
    if (message.setGnssSolverQuality !== undefined) {
      SetGnssSolverQualityResultData.encode(message.setGnssSolverQuality, writer.uint32(1522).fork()).ldelim();
    }
    if (message.spoofPhoneUiVariablesAction !== undefined) {
      SpoofPhoneUiVariablesResultData.encode(message.spoofPhoneUiVariablesAction, writer.uint32(4050).fork()).ldelim();
    }
    if (message.playAudio !== undefined) {
      PlayAudioResultData.encode(message.playAudio, writer.uint32(1530).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ActionResult {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseActionResult();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 12:
          if (tag !== 98) {
            break;
          }

          message.uuid = reader.string();
          continue;
        case 1:
          if (tag !== 10) {
            break;
          }

          message.actionUuid = reader.string();
          continue;
        case 9:
          if (tag !== 74) {
            break;
          }

          message.actionKey = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.message = reader.string();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.startUclock = longToNumber(reader.int64() as Long);
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.endUclock = longToNumber(reader.int64() as Long);
          continue;
        case 14:
          if (tag !== 112) {
            break;
          }

          message.startUtime = longToNumber(reader.int64() as Long);
          continue;
        case 15:
          if (tag !== 120) {
            break;
          }

          message.endUtime = longToNumber(reader.int64() as Long);
          continue;
        case 7:
          if (tag !== 58) {
            break;
          }

          message.debugJson = reader.string();
          continue;
        case 10:
          if (tag !== 80) {
            break;
          }

          message.result = reader.int32() as any;
          continue;
        case 11:
          if (tag !== 90) {
            break;
          }

          message.errorCode = reader.string();
          continue;
        case 13:
          if (tag !== 106) {
            break;
          }

          message.parentActionResultUuid = reader.string();
          continue;
        case 102:
          if (tag !== 818) {
            break;
          }

          message.gotoGpsWaypoint = GotoGpsWaypointResultData.decode(reader, reader.uint32());
          continue;
        case 103:
          if (tag !== 826) {
            break;
          }

          message.gotoNavWaypoint = GotoNavWaypointResultData.decode(reader, reader.uint32());
          continue;
        case 104:
          if (tag !== 834) {
            break;
          }

          message.takePhoto = TakePhotoResultData.decode(reader, reader.uint32());
          continue;
        case 105:
          if (tag !== 842) {
            break;
          }

          message.surfaceScanSkill = SurfaceScanResultData.decode(reader, reader.uint32());
          continue;
        case 106:
          if (tag !== 850) {
            break;
          }

          message.startVideo = StartVideoResultData.decode(reader, reader.uint32());
          continue;
        case 107:
          if (tag !== 858) {
            break;
          }

          message.stopVideo = StopVideoResultData.decode(reader, reader.uint32());
          continue;
        case 108:
          if (tag !== 866) {
            break;
          }

          message.switchRecordingMode = SwitchRecordingModeResultData.decode(reader, reader.uint32());
          continue;
        case 109:
          if (tag !== 874) {
            break;
          }

          message.timedWait = TimedWaitResultData.decode(reader, reader.uint32());
          continue;
        case 110:
          if (tag !== 882) {
            break;
          }

          message.sequence = SequenceResultData.decode(reader, reader.uint32());
          continue;
        case 111:
          if (tag !== 890) {
            break;
          }

          message.orbitPoiAction = OrbitPoiResultData.decode(reader, reader.uint32());
          continue;
        case 112:
          if (tag !== 898) {
            break;
          }

          message.takePanorama = TakePanoramaResultData.decode(reader, reader.uint32());
          continue;
        case 113:
          if (tag !== 906) {
            break;
          }

          message.keyframeSkill = KeyframeResultData.decode(reader, reader.uint32());
          continue;
        case 114:
          if (tag !== 914) {
            break;
          }

          message.gotoWaypoint = GotoWaypointResultData.decode(reader, reader.uint32());
          continue;
        case 115:
          if (tag !== 922) {
            break;
          }

          message.setObstacleAvoidance = SetObstacleAvoidanceResultData.decode(reader, reader.uint32());
          continue;
        case 116:
          if (tag !== 930) {
            break;
          }

          message.initializeGps = InitializeGpsResultData.decode(reader, reader.uint32());
          continue;
        case 117:
          if (tag !== 938) {
            break;
          }

          message.subjectDetected = SubjectDetectedResultData.decode(reader, reader.uint32());
          continue;
        case 118:
          if (tag !== 946) {
            break;
          }

          message.looper = LooperResultData.decode(reader, reader.uint32());
          continue;
        case 119:
          if (tag !== 954) {
            break;
          }

          message.withinDistance = WithinDistanceResultData.decode(reader, reader.uint32());
          continue;
        case 120:
          if (tag !== 962) {
            break;
          }

          message.unifiedFollowAction = UnifiedFollowResultData.decode(reader, reader.uint32());
          continue;
        case 121:
          if (tag !== 970) {
            break;
          }

          message.inverter = InverterResultData.decode(reader, reader.uint32());
          continue;
        case 122:
          if (tag !== 978) {
            break;
          }

          message.togglePhotoIntervalMode = TogglePhotoIntervalModeResultData.decode(reader, reader.uint32());
          continue;
        case 123:
          if (tag !== 986) {
            break;
          }

          message.wifiScan = WifiScanResultData.decode(reader, reader.uint32());
          continue;
        case 124:
          if (tag !== 994) {
            break;
          }

          message.enableStrobeLights = EnableStrobeLightsResultData.decode(reader, reader.uint32());
          continue;
        case 125:
          if (tag !== 1002) {
            break;
          }

          message.disableStrobeLights = DisableStrobeLightsResultData.decode(reader, reader.uint32());
          continue;
        case 126:
          if (tag !== 1010) {
            break;
          }

          message.spoofJoysticksInputs = SpoofJoysticksInputsResultData.decode(reader, reader.uint32());
          continue;
        case 127:
          if (tag !== 1018) {
            break;
          }

          message.updateJoysticksSettings = UpdateJoysticksSettingsResultData.decode(reader, reader.uint32());
          continue;
        case 128:
          if (tag !== 1026) {
            break;
          }

          message.updateShapeMap = UpdateShapeMapResultData.decode(reader, reader.uint32());
          continue;
        case 129:
          if (tag !== 1034) {
            break;
          }

          message.spoofObstacle = SpoofObstacleResultData.decode(reader, reader.uint32());
          continue;
        case 130:
          if (tag !== 1042) {
            break;
          }

          message.dummyAction = DummyResultData.decode(reader, reader.uint32());
          continue;
        case 131:
          if (tag !== 1050) {
            break;
          }

          message.testDesiredVelocityAction = TestDesiredVelocityResultData.decode(reader, reader.uint32());
          continue;
        case 132:
          if (tag !== 1058) {
            break;
          }

          message.testTrackTrajectory = TestTrackTrajectoryResultData.decode(reader, reader.uint32());
          continue;
        case 133:
          if (tag !== 1066) {
            break;
          }

          message.atvSubjectSpoofAction = AtvSubjectSpoofResultData.decode(reader, reader.uint32());
          continue;
        case 134:
          if (tag !== 1074) {
            break;
          }

          message.skiSubjectSpoofAction = SkiSubjectSpoofResultData.decode(reader, reader.uint32());
          continue;
        case 135:
          if (tag !== 1082) {
            break;
          }

          message.setGimbalOrientation = SetGimbalOrientationResultData.decode(reader, reader.uint32());
          continue;
        case 136:
          if (tag !== 1090) {
            break;
          }

          message.parallel = ParallelResultData.decode(reader, reader.uint32());
          continue;
        case 137:
          if (tag !== 1098) {
            break;
          }

          message.sequenceUntilSuccess = SequenceUntilSuccessResultData.decode(reader, reader.uint32());
          continue;
        case 138:
          if (tag !== 1106) {
            break;
          }

          message.sequenceUntilFailure = SequenceUntilFailureResultData.decode(reader, reader.uint32());
          continue;
        case 159:
          if (tag !== 1274) {
            break;
          }

          message.sequencePretakeoff = SequencePretakeoffResultData.decode(reader, reader.uint32());
          continue;
        case 180:
          if (tag !== 1442) {
            break;
          }

          message.sequenceConfig = SequenceConfigResultData.decode(reader, reader.uint32());
          continue;
        case 181:
          if (tag !== 1450) {
            break;
          }

          message.waitForRtk = WaitForRtkResultData.decode(reader, reader.uint32());
          continue;
        case 500:
          if (tag !== 4002) {
            break;
          }

          message.wingWaypointsCommand = WingWaypointsCommandResultData.decode(reader, reader.uint32());
          continue;
        case 501:
          if (tag !== 4010) {
            break;
          }

          message.sendDynamicScenario = SendDynamicScenarioResultData.decode(reader, reader.uint32());
          continue;
        case 502:
          if (tag !== 4018) {
            break;
          }

          message.scoutAction = ScoutActionResultData.decode(reader, reader.uint32());
          continue;
        case 503:
          if (tag !== 4026) {
            break;
          }

          message.spoofTrackingDevice = SpoofTrackingDeviceResultData.decode(reader, reader.uint32());
          continue;
        case 139:
          if (tag !== 1114) {
            break;
          }

          message.spoofDisturbanceAction = SpoofDisturbanceResultData.decode(reader, reader.uint32());
          continue;
        case 140:
          if (tag !== 1122) {
            break;
          }

          message.updateVehicleSettings = UpdateVehicleSettingsResultData.decode(reader, reader.uint32());
          continue;
        case 141:
          if (tag !== 1130) {
            break;
          }

          message.waitForVehicleStop = WaitForVehicleStopResultData.decode(reader, reader.uint32());
          continue;
        case 142:
          if (tag !== 1138) {
            break;
          }

          message.precomputedSubjectSpoofAction = PrecomputedSubjectSpoofResultData.decode(reader, reader.uint32());
          continue;
        case 143:
          if (tag !== 1146) {
            break;
          }

          message.modifySimStateEstimation = ModifySimStateEstimationResultData.decode(reader, reader.uint32());
          continue;
        case 144:
          if (tag !== 1154) {
            break;
          }

          message.gotoAndOrbitPoi = GotoAndOrbitPoiResultData.decode(reader, reader.uint32());
          continue;
        case 145:
          if (tag !== 1162) {
            break;
          }

          message.acquireGps = AcquireGpsResultData.decode(reader, reader.uint32());
          continue;
        case 146:
          if (tag !== 1170) {
            break;
          }

          message.setFaultOverride = SetFaultOverrideResultData.decode(reader, reader.uint32());
          continue;
        case 147:
          if (tag !== 1178) {
            break;
          }

          message.eLand = ELandResultData.decode(reader, reader.uint32());
          continue;
        case 148:
          if (tag !== 1186) {
            break;
          }

          message.trajectoryInspect = TrajectoryInspectResultData.decode(reader, reader.uint32());
          continue;
        case 149:
          if (tag !== 1194) {
            break;
          }

          message.toggleTargetPointExposure = ToggleTargetPointExposureResultData.decode(reader, reader.uint32());
          continue;
        case 150:
          if (tag !== 1202) {
            break;
          }

          message.toggleSemanticAim = ToggleSemanticAimResultData.decode(reader, reader.uint32());
          continue;
        case 151:
          if (tag !== 1210) {
            break;
          }

          message.spoofBatteryLevel = SpoofBatteryLevelResultData.decode(reader, reader.uint32());
          continue;
        case 152:
          if (tag !== 1218) {
            break;
          }

          message.ncpgControl = NcpgControlResultData.decode(reader, reader.uint32());
          continue;
        case 153:
          if (tag !== 1226) {
            break;
          }

          message.registerComplimentaryActions = RegisterComplimentaryActionsResultData.decode(reader, reader.uint32());
          continue;
        case 154:
          if (tag !== 1234) {
            break;
          }

          message.trackInPlace = TrackInPlaceResultData.decode(reader, reader.uint32());
          continue;
        case 155:
          if (tag !== 1242) {
            break;
          }

          message.globalGraphControl = GlobalGraphControlResultData.decode(reader, reader.uint32());
          continue;
        case 156:
          if (tag !== 1250) {
            break;
          }

          message.overrideGpsQuality = OverrideGpsQualityResultData.decode(reader, reader.uint32());
          continue;
        case 157:
          if (tag !== 1258) {
            break;
          }

          message.initGlobalMap = InitGlobalMapResultData.decode(reader, reader.uint32());
          continue;
        case 158:
          if (tag !== 1266) {
            break;
          }

          message.stopForPhotoInspect = StopForPhotoInspectResultData.decode(reader, reader.uint32());
          continue;
        case 160:
          if (tag !== 1282) {
            break;
          }

          message.spoofInitialGpsHeading = SpoofInitialGpsHeadingResultData.decode(reader, reader.uint32());
          continue;
        case 161:
          if (tag !== 1290) {
            break;
          }

          message.trackLandingPadRequest = TrackLandingPadRequestResultData.decode(reader, reader.uint32());
          continue;
        case 162:
          if (tag !== 1298) {
            break;
          }

          message.apriltagSetId = ApriltagSetIdResultData.decode(reader, reader.uint32());
          continue;
        case 163:
          if (tag !== 1306) {
            break;
          }

          message.dockGpsEstimator = DockGpsEstimatorResultData.decode(reader, reader.uint32());
          continue;
        case 164:
          if (tag !== 1314) {
            break;
          }

          message.g47CommandOverride = G47CommandOverrideResultData.decode(reader, reader.uint32());
          continue;
        case 165:
          if (tag !== 1322) {
            break;
          }

          message.requestTakeoffProfile = RequestTakeoffProfileResultData.decode(reader, reader.uint32());
          continue;
        case 166:
          if (tag !== 1330) {
            break;
          }

          message.updateDockLocationAction = UpdateDockLocationActionResultData.decode(reader, reader.uint32());
          continue;
        case 167:
          if (tag !== 1338) {
            break;
          }

          message.setDesiredGpsSource = SetDesiredGpsSourceResultData.decode(reader, reader.uint32());
          continue;
        case 168:
          if (tag !== 1346) {
            break;
          }

          message.spoofManualGps = SpoofManualGpsResultData.decode(reader, reader.uint32());
          continue;
        case 169:
          if (tag !== 1354) {
            break;
          }

          message.weatherAction = WeatherActionResultData.decode(reader, reader.uint32());
          continue;
        case 170:
          if (tag !== 1362) {
            break;
          }

          message.setZoom = SetZoomResultData.decode(reader, reader.uint32());
          continue;
        case 171:
          if (tag !== 1370) {
            break;
          }

          message.missionPlannerServiceControl = MissionPlannerServiceControlResultData.decode(reader, reader.uint32());
          continue;
        case 172:
          if (tag !== 1378) {
            break;
          }

          message.spotlightAction = SpotlightActionResultData.decode(reader, reader.uint32());
          continue;
        case 173:
          if (tag !== 1386) {
            break;
          }

          message.setCameraSettings = SetCameraSettingsResultData.decode(reader, reader.uint32());
          continue;
        case 174:
          if (tag !== 1394) {
            break;
          }

          message.parachuteControl = ParachuteControlResultData.decode(reader, reader.uint32());
          continue;
        case 175:
          if (tag !== 1402) {
            break;
          }

          message.nightsenseAction = NightsenseActionResultData.decode(reader, reader.uint32());
          continue;
        case 176:
          if (tag !== 1410) {
            break;
          }

          message.spoofMultiDrone = SpoofMultiDroneResultData.decode(reader, reader.uint32());
          continue;
        case 177:
          if (tag !== 1418) {
            break;
          }

          message.setMovementCommand = SetMovementCommandResultData.decode(reader, reader.uint32());
          continue;
        case 178:
          if (tag !== 1426) {
            break;
          }

          message.spoofFlightEnvelopeLimits = SpoofFlightEnvelopeLimitsResultData.decode(reader, reader.uint32());
          continue;
        case 179:
          if (tag !== 1434) {
            break;
          }

          message.turntable = TurntableResultData.decode(reader, reader.uint32());
          continue;
        case 182:
          if (tag !== 1458) {
            break;
          }

          message.dancingDrone = DancingDroneResultData.decode(reader, reader.uint32());
          continue;
        case 183:
          if (tag !== 1466) {
            break;
          }

          message.waitForPreciseFault = WaitForPreciseFaultResultData.decode(reader, reader.uint32());
          continue;
        case 184:
          if (tag !== 1474) {
            break;
          }

          message.dancingDroneSpline = DancingDroneSplineResultData.decode(reader, reader.uint32());
          continue;
        case 185:
          if (tag !== 1482) {
            break;
          }

          message.globalPlannerRequest = GlobalPlannerRequestActionResultData.decode(reader, reader.uint32());
          continue;
        case 186:
          if (tag !== 1490) {
            break;
          }

          message.toggleSubjectDetection = ToggleSubjectDetectionResultData.decode(reader, reader.uint32());
          continue;
        case 187:
          if (tag !== 1498) {
            break;
          }

          message.spoofSubjectScenario = SpoofSubjectScenarioResultData.decode(reader, reader.uint32());
          continue;
        case 188:
          if (tag !== 1506) {
            break;
          }

          message.setSubjectFollowerSettings = SetSubjectFollowerSettingsResultData.decode(reader, reader.uint32());
          continue;
        case 189:
          if (tag !== 1514) {
            break;
          }

          message.geofenceConfig = GeofenceConfigResultData.decode(reader, reader.uint32());
          continue;
        case 504:
          if (tag !== 4034) {
            break;
          }

          message.setDesiredImuSource = SetDesiredImuSourceResultData.decode(reader, reader.uint32());
          continue;
        case 505:
          if (tag !== 4042) {
            break;
          }

          message.sendMotionCommand = SendMotionCommandResultData.decode(reader, reader.uint32());
          continue;
        case 190:
          if (tag !== 1522) {
            break;
          }

          message.setGnssSolverQuality = SetGnssSolverQualityResultData.decode(reader, reader.uint32());
          continue;
        case 506:
          if (tag !== 4050) {
            break;
          }

          message.spoofPhoneUiVariablesAction = SpoofPhoneUiVariablesResultData.decode(reader, reader.uint32());
          continue;
        case 191:
          if (tag !== 1530) {
            break;
          }

          message.playAudio = PlayAudioResultData.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ActionResult {
    return {
      uuid: isSet(object.uuid) ? globalThis.String(object.uuid) : "",
      actionUuid: isSet(object.actionUuid) ? globalThis.String(object.actionUuid) : "",
      actionKey: isSet(object.actionKey) ? globalThis.String(object.actionKey) : "",
      message: isSet(object.message) ? globalThis.String(object.message) : "",
      startUclock: isSet(object.startUclock) ? globalThis.Number(object.startUclock) : 0,
      endUclock: isSet(object.endUclock) ? globalThis.Number(object.endUclock) : 0,
      startUtime: isSet(object.startUtime) ? globalThis.Number(object.startUtime) : 0,
      endUtime: isSet(object.endUtime) ? globalThis.Number(object.endUtime) : 0,
      debugJson: isSet(object.debugJson) ? globalThis.String(object.debugJson) : "",
      result: isSet(object.result) ? actionResult_ResultFromJSON(object.result) : 0,
      errorCode: isSet(object.errorCode) ? globalThis.String(object.errorCode) : "",
      parentActionResultUuid: isSet(object.parentActionResultUuid)
        ? globalThis.String(object.parentActionResultUuid)
        : "",
      gotoGpsWaypoint: isSet(object.gotoGpsWaypoint)
        ? GotoGpsWaypointResultData.fromJSON(object.gotoGpsWaypoint)
        : undefined,
      gotoNavWaypoint: isSet(object.gotoNavWaypoint)
        ? GotoNavWaypointResultData.fromJSON(object.gotoNavWaypoint)
        : undefined,
      takePhoto: isSet(object.takePhoto) ? TakePhotoResultData.fromJSON(object.takePhoto) : undefined,
      surfaceScanSkill: isSet(object.surfaceScanSkill)
        ? SurfaceScanResultData.fromJSON(object.surfaceScanSkill)
        : undefined,
      startVideo: isSet(object.startVideo) ? StartVideoResultData.fromJSON(object.startVideo) : undefined,
      stopVideo: isSet(object.stopVideo) ? StopVideoResultData.fromJSON(object.stopVideo) : undefined,
      switchRecordingMode: isSet(object.switchRecordingMode)
        ? SwitchRecordingModeResultData.fromJSON(object.switchRecordingMode)
        : undefined,
      timedWait: isSet(object.timedWait) ? TimedWaitResultData.fromJSON(object.timedWait) : undefined,
      sequence: isSet(object.sequence) ? SequenceResultData.fromJSON(object.sequence) : undefined,
      orbitPoiAction: isSet(object.orbitPoiAction) ? OrbitPoiResultData.fromJSON(object.orbitPoiAction) : undefined,
      takePanorama: isSet(object.takePanorama) ? TakePanoramaResultData.fromJSON(object.takePanorama) : undefined,
      keyframeSkill: isSet(object.keyframeSkill) ? KeyframeResultData.fromJSON(object.keyframeSkill) : undefined,
      gotoWaypoint: isSet(object.gotoWaypoint) ? GotoWaypointResultData.fromJSON(object.gotoWaypoint) : undefined,
      setObstacleAvoidance: isSet(object.setObstacleAvoidance)
        ? SetObstacleAvoidanceResultData.fromJSON(object.setObstacleAvoidance)
        : undefined,
      initializeGps: isSet(object.initializeGps) ? InitializeGpsResultData.fromJSON(object.initializeGps) : undefined,
      subjectDetected: isSet(object.subjectDetected)
        ? SubjectDetectedResultData.fromJSON(object.subjectDetected)
        : undefined,
      looper: isSet(object.looper) ? LooperResultData.fromJSON(object.looper) : undefined,
      withinDistance: isSet(object.withinDistance)
        ? WithinDistanceResultData.fromJSON(object.withinDistance)
        : undefined,
      unifiedFollowAction: isSet(object.unifiedFollowAction)
        ? UnifiedFollowResultData.fromJSON(object.unifiedFollowAction)
        : undefined,
      inverter: isSet(object.inverter) ? InverterResultData.fromJSON(object.inverter) : undefined,
      togglePhotoIntervalMode: isSet(object.togglePhotoIntervalMode)
        ? TogglePhotoIntervalModeResultData.fromJSON(object.togglePhotoIntervalMode)
        : undefined,
      wifiScan: isSet(object.wifiScan) ? WifiScanResultData.fromJSON(object.wifiScan) : undefined,
      enableStrobeLights: isSet(object.enableStrobeLights)
        ? EnableStrobeLightsResultData.fromJSON(object.enableStrobeLights)
        : undefined,
      disableStrobeLights: isSet(object.disableStrobeLights)
        ? DisableStrobeLightsResultData.fromJSON(object.disableStrobeLights)
        : undefined,
      spoofJoysticksInputs: isSet(object.spoofJoysticksInputs)
        ? SpoofJoysticksInputsResultData.fromJSON(object.spoofJoysticksInputs)
        : undefined,
      updateJoysticksSettings: isSet(object.updateJoysticksSettings)
        ? UpdateJoysticksSettingsResultData.fromJSON(object.updateJoysticksSettings)
        : undefined,
      updateShapeMap: isSet(object.updateShapeMap)
        ? UpdateShapeMapResultData.fromJSON(object.updateShapeMap)
        : undefined,
      spoofObstacle: isSet(object.spoofObstacle) ? SpoofObstacleResultData.fromJSON(object.spoofObstacle) : undefined,
      dummyAction: isSet(object.dummyAction) ? DummyResultData.fromJSON(object.dummyAction) : undefined,
      testDesiredVelocityAction: isSet(object.testDesiredVelocityAction)
        ? TestDesiredVelocityResultData.fromJSON(object.testDesiredVelocityAction)
        : undefined,
      testTrackTrajectory: isSet(object.testTrackTrajectory)
        ? TestTrackTrajectoryResultData.fromJSON(object.testTrackTrajectory)
        : undefined,
      atvSubjectSpoofAction: isSet(object.atvSubjectSpoofAction)
        ? AtvSubjectSpoofResultData.fromJSON(object.atvSubjectSpoofAction)
        : undefined,
      skiSubjectSpoofAction: isSet(object.skiSubjectSpoofAction)
        ? SkiSubjectSpoofResultData.fromJSON(object.skiSubjectSpoofAction)
        : undefined,
      setGimbalOrientation: isSet(object.setGimbalOrientation)
        ? SetGimbalOrientationResultData.fromJSON(object.setGimbalOrientation)
        : undefined,
      parallel: isSet(object.parallel) ? ParallelResultData.fromJSON(object.parallel) : undefined,
      sequenceUntilSuccess: isSet(object.sequenceUntilSuccess)
        ? SequenceUntilSuccessResultData.fromJSON(object.sequenceUntilSuccess)
        : undefined,
      sequenceUntilFailure: isSet(object.sequenceUntilFailure)
        ? SequenceUntilFailureResultData.fromJSON(object.sequenceUntilFailure)
        : undefined,
      sequencePretakeoff: isSet(object.sequencePretakeoff)
        ? SequencePretakeoffResultData.fromJSON(object.sequencePretakeoff)
        : undefined,
      sequenceConfig: isSet(object.sequenceConfig)
        ? SequenceConfigResultData.fromJSON(object.sequenceConfig)
        : undefined,
      waitForRtk: isSet(object.waitForRtk) ? WaitForRtkResultData.fromJSON(object.waitForRtk) : undefined,
      wingWaypointsCommand: isSet(object.wingWaypointsCommand)
        ? WingWaypointsCommandResultData.fromJSON(object.wingWaypointsCommand)
        : undefined,
      sendDynamicScenario: isSet(object.sendDynamicScenario)
        ? SendDynamicScenarioResultData.fromJSON(object.sendDynamicScenario)
        : undefined,
      scoutAction: isSet(object.scoutAction) ? ScoutActionResultData.fromJSON(object.scoutAction) : undefined,
      spoofTrackingDevice: isSet(object.spoofTrackingDevice)
        ? SpoofTrackingDeviceResultData.fromJSON(object.spoofTrackingDevice)
        : undefined,
      spoofDisturbanceAction: isSet(object.spoofDisturbanceAction)
        ? SpoofDisturbanceResultData.fromJSON(object.spoofDisturbanceAction)
        : undefined,
      updateVehicleSettings: isSet(object.updateVehicleSettings)
        ? UpdateVehicleSettingsResultData.fromJSON(object.updateVehicleSettings)
        : undefined,
      waitForVehicleStop: isSet(object.waitForVehicleStop)
        ? WaitForVehicleStopResultData.fromJSON(object.waitForVehicleStop)
        : undefined,
      precomputedSubjectSpoofAction: isSet(object.precomputedSubjectSpoofAction)
        ? PrecomputedSubjectSpoofResultData.fromJSON(object.precomputedSubjectSpoofAction)
        : undefined,
      modifySimStateEstimation: isSet(object.modifySimStateEstimation)
        ? ModifySimStateEstimationResultData.fromJSON(object.modifySimStateEstimation)
        : undefined,
      gotoAndOrbitPoi: isSet(object.gotoAndOrbitPoi)
        ? GotoAndOrbitPoiResultData.fromJSON(object.gotoAndOrbitPoi)
        : undefined,
      acquireGps: isSet(object.acquireGps) ? AcquireGpsResultData.fromJSON(object.acquireGps) : undefined,
      setFaultOverride: isSet(object.setFaultOverride)
        ? SetFaultOverrideResultData.fromJSON(object.setFaultOverride)
        : undefined,
      eLand: isSet(object.eLand) ? ELandResultData.fromJSON(object.eLand) : undefined,
      trajectoryInspect: isSet(object.trajectoryInspect)
        ? TrajectoryInspectResultData.fromJSON(object.trajectoryInspect)
        : undefined,
      toggleTargetPointExposure: isSet(object.toggleTargetPointExposure)
        ? ToggleTargetPointExposureResultData.fromJSON(object.toggleTargetPointExposure)
        : undefined,
      toggleSemanticAim: isSet(object.toggleSemanticAim)
        ? ToggleSemanticAimResultData.fromJSON(object.toggleSemanticAim)
        : undefined,
      spoofBatteryLevel: isSet(object.spoofBatteryLevel)
        ? SpoofBatteryLevelResultData.fromJSON(object.spoofBatteryLevel)
        : undefined,
      ncpgControl: isSet(object.ncpgControl) ? NcpgControlResultData.fromJSON(object.ncpgControl) : undefined,
      registerComplimentaryActions: isSet(object.registerComplimentaryActions)
        ? RegisterComplimentaryActionsResultData.fromJSON(object.registerComplimentaryActions)
        : undefined,
      trackInPlace: isSet(object.trackInPlace) ? TrackInPlaceResultData.fromJSON(object.trackInPlace) : undefined,
      globalGraphControl: isSet(object.globalGraphControl)
        ? GlobalGraphControlResultData.fromJSON(object.globalGraphControl)
        : undefined,
      overrideGpsQuality: isSet(object.overrideGpsQuality)
        ? OverrideGpsQualityResultData.fromJSON(object.overrideGpsQuality)
        : undefined,
      initGlobalMap: isSet(object.initGlobalMap) ? InitGlobalMapResultData.fromJSON(object.initGlobalMap) : undefined,
      stopForPhotoInspect: isSet(object.stopForPhotoInspect)
        ? StopForPhotoInspectResultData.fromJSON(object.stopForPhotoInspect)
        : undefined,
      spoofInitialGpsHeading: isSet(object.spoofInitialGpsHeading)
        ? SpoofInitialGpsHeadingResultData.fromJSON(object.spoofInitialGpsHeading)
        : undefined,
      trackLandingPadRequest: isSet(object.trackLandingPadRequest)
        ? TrackLandingPadRequestResultData.fromJSON(object.trackLandingPadRequest)
        : undefined,
      apriltagSetId: isSet(object.apriltagSetId) ? ApriltagSetIdResultData.fromJSON(object.apriltagSetId) : undefined,
      dockGpsEstimator: isSet(object.dockGpsEstimator)
        ? DockGpsEstimatorResultData.fromJSON(object.dockGpsEstimator)
        : undefined,
      g47CommandOverride: isSet(object.g47CommandOverride)
        ? G47CommandOverrideResultData.fromJSON(object.g47CommandOverride)
        : undefined,
      requestTakeoffProfile: isSet(object.requestTakeoffProfile)
        ? RequestTakeoffProfileResultData.fromJSON(object.requestTakeoffProfile)
        : undefined,
      updateDockLocationAction: isSet(object.updateDockLocationAction)
        ? UpdateDockLocationActionResultData.fromJSON(object.updateDockLocationAction)
        : undefined,
      setDesiredGpsSource: isSet(object.setDesiredGpsSource)
        ? SetDesiredGpsSourceResultData.fromJSON(object.setDesiredGpsSource)
        : undefined,
      spoofManualGps: isSet(object.spoofManualGps)
        ? SpoofManualGpsResultData.fromJSON(object.spoofManualGps)
        : undefined,
      weatherAction: isSet(object.weatherAction) ? WeatherActionResultData.fromJSON(object.weatherAction) : undefined,
      setZoom: isSet(object.setZoom) ? SetZoomResultData.fromJSON(object.setZoom) : undefined,
      missionPlannerServiceControl: isSet(object.missionPlannerServiceControl)
        ? MissionPlannerServiceControlResultData.fromJSON(object.missionPlannerServiceControl)
        : undefined,
      spotlightAction: isSet(object.spotlightAction)
        ? SpotlightActionResultData.fromJSON(object.spotlightAction)
        : undefined,
      setCameraSettings: isSet(object.setCameraSettings)
        ? SetCameraSettingsResultData.fromJSON(object.setCameraSettings)
        : undefined,
      parachuteControl: isSet(object.parachuteControl)
        ? ParachuteControlResultData.fromJSON(object.parachuteControl)
        : undefined,
      nightsenseAction: isSet(object.nightsenseAction)
        ? NightsenseActionResultData.fromJSON(object.nightsenseAction)
        : undefined,
      spoofMultiDrone: isSet(object.spoofMultiDrone)
        ? SpoofMultiDroneResultData.fromJSON(object.spoofMultiDrone)
        : undefined,
      setMovementCommand: isSet(object.setMovementCommand)
        ? SetMovementCommandResultData.fromJSON(object.setMovementCommand)
        : undefined,
      spoofFlightEnvelopeLimits: isSet(object.spoofFlightEnvelopeLimits)
        ? SpoofFlightEnvelopeLimitsResultData.fromJSON(object.spoofFlightEnvelopeLimits)
        : undefined,
      turntable: isSet(object.turntable) ? TurntableResultData.fromJSON(object.turntable) : undefined,
      dancingDrone: isSet(object.dancingDrone) ? DancingDroneResultData.fromJSON(object.dancingDrone) : undefined,
      waitForPreciseFault: isSet(object.waitForPreciseFault)
        ? WaitForPreciseFaultResultData.fromJSON(object.waitForPreciseFault)
        : undefined,
      dancingDroneSpline: isSet(object.dancingDroneSpline)
        ? DancingDroneSplineResultData.fromJSON(object.dancingDroneSpline)
        : undefined,
      globalPlannerRequest: isSet(object.globalPlannerRequest)
        ? GlobalPlannerRequestActionResultData.fromJSON(object.globalPlannerRequest)
        : undefined,
      toggleSubjectDetection: isSet(object.toggleSubjectDetection)
        ? ToggleSubjectDetectionResultData.fromJSON(object.toggleSubjectDetection)
        : undefined,
      spoofSubjectScenario: isSet(object.spoofSubjectScenario)
        ? SpoofSubjectScenarioResultData.fromJSON(object.spoofSubjectScenario)
        : undefined,
      setSubjectFollowerSettings: isSet(object.setSubjectFollowerSettings)
        ? SetSubjectFollowerSettingsResultData.fromJSON(object.setSubjectFollowerSettings)
        : undefined,
      geofenceConfig: isSet(object.geofenceConfig)
        ? GeofenceConfigResultData.fromJSON(object.geofenceConfig)
        : undefined,
      setDesiredImuSource: isSet(object.setDesiredImuSource)
        ? SetDesiredImuSourceResultData.fromJSON(object.setDesiredImuSource)
        : undefined,
      sendMotionCommand: isSet(object.sendMotionCommand)
        ? SendMotionCommandResultData.fromJSON(object.sendMotionCommand)
        : undefined,
      setGnssSolverQuality: isSet(object.setGnssSolverQuality)
        ? SetGnssSolverQualityResultData.fromJSON(object.setGnssSolverQuality)
        : undefined,
      spoofPhoneUiVariablesAction: isSet(object.spoofPhoneUiVariablesAction)
        ? SpoofPhoneUiVariablesResultData.fromJSON(object.spoofPhoneUiVariablesAction)
        : undefined,
      playAudio: isSet(object.playAudio) ? PlayAudioResultData.fromJSON(object.playAudio) : undefined,
    };
  },

  toJSON(message: ActionResult): unknown {
    const obj: any = {};
    if (message.uuid !== "") {
      obj.uuid = message.uuid;
    }
    if (message.actionUuid !== "") {
      obj.actionUuid = message.actionUuid;
    }
    if (message.actionKey !== "") {
      obj.actionKey = message.actionKey;
    }
    if (message.message !== "") {
      obj.message = message.message;
    }
    if (message.startUclock !== 0) {
      obj.startUclock = Math.round(message.startUclock);
    }
    if (message.endUclock !== 0) {
      obj.endUclock = Math.round(message.endUclock);
    }
    if (message.startUtime !== 0) {
      obj.startUtime = Math.round(message.startUtime);
    }
    if (message.endUtime !== 0) {
      obj.endUtime = Math.round(message.endUtime);
    }
    if (message.debugJson !== "") {
      obj.debugJson = message.debugJson;
    }
    if (message.result !== 0) {
      obj.result = actionResult_ResultToJSON(message.result);
    }
    if (message.errorCode !== "") {
      obj.errorCode = message.errorCode;
    }
    if (message.parentActionResultUuid !== "") {
      obj.parentActionResultUuid = message.parentActionResultUuid;
    }
    if (message.gotoGpsWaypoint !== undefined) {
      obj.gotoGpsWaypoint = GotoGpsWaypointResultData.toJSON(message.gotoGpsWaypoint);
    }
    if (message.gotoNavWaypoint !== undefined) {
      obj.gotoNavWaypoint = GotoNavWaypointResultData.toJSON(message.gotoNavWaypoint);
    }
    if (message.takePhoto !== undefined) {
      obj.takePhoto = TakePhotoResultData.toJSON(message.takePhoto);
    }
    if (message.surfaceScanSkill !== undefined) {
      obj.surfaceScanSkill = SurfaceScanResultData.toJSON(message.surfaceScanSkill);
    }
    if (message.startVideo !== undefined) {
      obj.startVideo = StartVideoResultData.toJSON(message.startVideo);
    }
    if (message.stopVideo !== undefined) {
      obj.stopVideo = StopVideoResultData.toJSON(message.stopVideo);
    }
    if (message.switchRecordingMode !== undefined) {
      obj.switchRecordingMode = SwitchRecordingModeResultData.toJSON(message.switchRecordingMode);
    }
    if (message.timedWait !== undefined) {
      obj.timedWait = TimedWaitResultData.toJSON(message.timedWait);
    }
    if (message.sequence !== undefined) {
      obj.sequence = SequenceResultData.toJSON(message.sequence);
    }
    if (message.orbitPoiAction !== undefined) {
      obj.orbitPoiAction = OrbitPoiResultData.toJSON(message.orbitPoiAction);
    }
    if (message.takePanorama !== undefined) {
      obj.takePanorama = TakePanoramaResultData.toJSON(message.takePanorama);
    }
    if (message.keyframeSkill !== undefined) {
      obj.keyframeSkill = KeyframeResultData.toJSON(message.keyframeSkill);
    }
    if (message.gotoWaypoint !== undefined) {
      obj.gotoWaypoint = GotoWaypointResultData.toJSON(message.gotoWaypoint);
    }
    if (message.setObstacleAvoidance !== undefined) {
      obj.setObstacleAvoidance = SetObstacleAvoidanceResultData.toJSON(message.setObstacleAvoidance);
    }
    if (message.initializeGps !== undefined) {
      obj.initializeGps = InitializeGpsResultData.toJSON(message.initializeGps);
    }
    if (message.subjectDetected !== undefined) {
      obj.subjectDetected = SubjectDetectedResultData.toJSON(message.subjectDetected);
    }
    if (message.looper !== undefined) {
      obj.looper = LooperResultData.toJSON(message.looper);
    }
    if (message.withinDistance !== undefined) {
      obj.withinDistance = WithinDistanceResultData.toJSON(message.withinDistance);
    }
    if (message.unifiedFollowAction !== undefined) {
      obj.unifiedFollowAction = UnifiedFollowResultData.toJSON(message.unifiedFollowAction);
    }
    if (message.inverter !== undefined) {
      obj.inverter = InverterResultData.toJSON(message.inverter);
    }
    if (message.togglePhotoIntervalMode !== undefined) {
      obj.togglePhotoIntervalMode = TogglePhotoIntervalModeResultData.toJSON(message.togglePhotoIntervalMode);
    }
    if (message.wifiScan !== undefined) {
      obj.wifiScan = WifiScanResultData.toJSON(message.wifiScan);
    }
    if (message.enableStrobeLights !== undefined) {
      obj.enableStrobeLights = EnableStrobeLightsResultData.toJSON(message.enableStrobeLights);
    }
    if (message.disableStrobeLights !== undefined) {
      obj.disableStrobeLights = DisableStrobeLightsResultData.toJSON(message.disableStrobeLights);
    }
    if (message.spoofJoysticksInputs !== undefined) {
      obj.spoofJoysticksInputs = SpoofJoysticksInputsResultData.toJSON(message.spoofJoysticksInputs);
    }
    if (message.updateJoysticksSettings !== undefined) {
      obj.updateJoysticksSettings = UpdateJoysticksSettingsResultData.toJSON(message.updateJoysticksSettings);
    }
    if (message.updateShapeMap !== undefined) {
      obj.updateShapeMap = UpdateShapeMapResultData.toJSON(message.updateShapeMap);
    }
    if (message.spoofObstacle !== undefined) {
      obj.spoofObstacle = SpoofObstacleResultData.toJSON(message.spoofObstacle);
    }
    if (message.dummyAction !== undefined) {
      obj.dummyAction = DummyResultData.toJSON(message.dummyAction);
    }
    if (message.testDesiredVelocityAction !== undefined) {
      obj.testDesiredVelocityAction = TestDesiredVelocityResultData.toJSON(message.testDesiredVelocityAction);
    }
    if (message.testTrackTrajectory !== undefined) {
      obj.testTrackTrajectory = TestTrackTrajectoryResultData.toJSON(message.testTrackTrajectory);
    }
    if (message.atvSubjectSpoofAction !== undefined) {
      obj.atvSubjectSpoofAction = AtvSubjectSpoofResultData.toJSON(message.atvSubjectSpoofAction);
    }
    if (message.skiSubjectSpoofAction !== undefined) {
      obj.skiSubjectSpoofAction = SkiSubjectSpoofResultData.toJSON(message.skiSubjectSpoofAction);
    }
    if (message.setGimbalOrientation !== undefined) {
      obj.setGimbalOrientation = SetGimbalOrientationResultData.toJSON(message.setGimbalOrientation);
    }
    if (message.parallel !== undefined) {
      obj.parallel = ParallelResultData.toJSON(message.parallel);
    }
    if (message.sequenceUntilSuccess !== undefined) {
      obj.sequenceUntilSuccess = SequenceUntilSuccessResultData.toJSON(message.sequenceUntilSuccess);
    }
    if (message.sequenceUntilFailure !== undefined) {
      obj.sequenceUntilFailure = SequenceUntilFailureResultData.toJSON(message.sequenceUntilFailure);
    }
    if (message.sequencePretakeoff !== undefined) {
      obj.sequencePretakeoff = SequencePretakeoffResultData.toJSON(message.sequencePretakeoff);
    }
    if (message.sequenceConfig !== undefined) {
      obj.sequenceConfig = SequenceConfigResultData.toJSON(message.sequenceConfig);
    }
    if (message.waitForRtk !== undefined) {
      obj.waitForRtk = WaitForRtkResultData.toJSON(message.waitForRtk);
    }
    if (message.wingWaypointsCommand !== undefined) {
      obj.wingWaypointsCommand = WingWaypointsCommandResultData.toJSON(message.wingWaypointsCommand);
    }
    if (message.sendDynamicScenario !== undefined) {
      obj.sendDynamicScenario = SendDynamicScenarioResultData.toJSON(message.sendDynamicScenario);
    }
    if (message.scoutAction !== undefined) {
      obj.scoutAction = ScoutActionResultData.toJSON(message.scoutAction);
    }
    if (message.spoofTrackingDevice !== undefined) {
      obj.spoofTrackingDevice = SpoofTrackingDeviceResultData.toJSON(message.spoofTrackingDevice);
    }
    if (message.spoofDisturbanceAction !== undefined) {
      obj.spoofDisturbanceAction = SpoofDisturbanceResultData.toJSON(message.spoofDisturbanceAction);
    }
    if (message.updateVehicleSettings !== undefined) {
      obj.updateVehicleSettings = UpdateVehicleSettingsResultData.toJSON(message.updateVehicleSettings);
    }
    if (message.waitForVehicleStop !== undefined) {
      obj.waitForVehicleStop = WaitForVehicleStopResultData.toJSON(message.waitForVehicleStop);
    }
    if (message.precomputedSubjectSpoofAction !== undefined) {
      obj.precomputedSubjectSpoofAction = PrecomputedSubjectSpoofResultData.toJSON(
        message.precomputedSubjectSpoofAction,
      );
    }
    if (message.modifySimStateEstimation !== undefined) {
      obj.modifySimStateEstimation = ModifySimStateEstimationResultData.toJSON(message.modifySimStateEstimation);
    }
    if (message.gotoAndOrbitPoi !== undefined) {
      obj.gotoAndOrbitPoi = GotoAndOrbitPoiResultData.toJSON(message.gotoAndOrbitPoi);
    }
    if (message.acquireGps !== undefined) {
      obj.acquireGps = AcquireGpsResultData.toJSON(message.acquireGps);
    }
    if (message.setFaultOverride !== undefined) {
      obj.setFaultOverride = SetFaultOverrideResultData.toJSON(message.setFaultOverride);
    }
    if (message.eLand !== undefined) {
      obj.eLand = ELandResultData.toJSON(message.eLand);
    }
    if (message.trajectoryInspect !== undefined) {
      obj.trajectoryInspect = TrajectoryInspectResultData.toJSON(message.trajectoryInspect);
    }
    if (message.toggleTargetPointExposure !== undefined) {
      obj.toggleTargetPointExposure = ToggleTargetPointExposureResultData.toJSON(message.toggleTargetPointExposure);
    }
    if (message.toggleSemanticAim !== undefined) {
      obj.toggleSemanticAim = ToggleSemanticAimResultData.toJSON(message.toggleSemanticAim);
    }
    if (message.spoofBatteryLevel !== undefined) {
      obj.spoofBatteryLevel = SpoofBatteryLevelResultData.toJSON(message.spoofBatteryLevel);
    }
    if (message.ncpgControl !== undefined) {
      obj.ncpgControl = NcpgControlResultData.toJSON(message.ncpgControl);
    }
    if (message.registerComplimentaryActions !== undefined) {
      obj.registerComplimentaryActions = RegisterComplimentaryActionsResultData.toJSON(
        message.registerComplimentaryActions,
      );
    }
    if (message.trackInPlace !== undefined) {
      obj.trackInPlace = TrackInPlaceResultData.toJSON(message.trackInPlace);
    }
    if (message.globalGraphControl !== undefined) {
      obj.globalGraphControl = GlobalGraphControlResultData.toJSON(message.globalGraphControl);
    }
    if (message.overrideGpsQuality !== undefined) {
      obj.overrideGpsQuality = OverrideGpsQualityResultData.toJSON(message.overrideGpsQuality);
    }
    if (message.initGlobalMap !== undefined) {
      obj.initGlobalMap = InitGlobalMapResultData.toJSON(message.initGlobalMap);
    }
    if (message.stopForPhotoInspect !== undefined) {
      obj.stopForPhotoInspect = StopForPhotoInspectResultData.toJSON(message.stopForPhotoInspect);
    }
    if (message.spoofInitialGpsHeading !== undefined) {
      obj.spoofInitialGpsHeading = SpoofInitialGpsHeadingResultData.toJSON(message.spoofInitialGpsHeading);
    }
    if (message.trackLandingPadRequest !== undefined) {
      obj.trackLandingPadRequest = TrackLandingPadRequestResultData.toJSON(message.trackLandingPadRequest);
    }
    if (message.apriltagSetId !== undefined) {
      obj.apriltagSetId = ApriltagSetIdResultData.toJSON(message.apriltagSetId);
    }
    if (message.dockGpsEstimator !== undefined) {
      obj.dockGpsEstimator = DockGpsEstimatorResultData.toJSON(message.dockGpsEstimator);
    }
    if (message.g47CommandOverride !== undefined) {
      obj.g47CommandOverride = G47CommandOverrideResultData.toJSON(message.g47CommandOverride);
    }
    if (message.requestTakeoffProfile !== undefined) {
      obj.requestTakeoffProfile = RequestTakeoffProfileResultData.toJSON(message.requestTakeoffProfile);
    }
    if (message.updateDockLocationAction !== undefined) {
      obj.updateDockLocationAction = UpdateDockLocationActionResultData.toJSON(message.updateDockLocationAction);
    }
    if (message.setDesiredGpsSource !== undefined) {
      obj.setDesiredGpsSource = SetDesiredGpsSourceResultData.toJSON(message.setDesiredGpsSource);
    }
    if (message.spoofManualGps !== undefined) {
      obj.spoofManualGps = SpoofManualGpsResultData.toJSON(message.spoofManualGps);
    }
    if (message.weatherAction !== undefined) {
      obj.weatherAction = WeatherActionResultData.toJSON(message.weatherAction);
    }
    if (message.setZoom !== undefined) {
      obj.setZoom = SetZoomResultData.toJSON(message.setZoom);
    }
    if (message.missionPlannerServiceControl !== undefined) {
      obj.missionPlannerServiceControl = MissionPlannerServiceControlResultData.toJSON(
        message.missionPlannerServiceControl,
      );
    }
    if (message.spotlightAction !== undefined) {
      obj.spotlightAction = SpotlightActionResultData.toJSON(message.spotlightAction);
    }
    if (message.setCameraSettings !== undefined) {
      obj.setCameraSettings = SetCameraSettingsResultData.toJSON(message.setCameraSettings);
    }
    if (message.parachuteControl !== undefined) {
      obj.parachuteControl = ParachuteControlResultData.toJSON(message.parachuteControl);
    }
    if (message.nightsenseAction !== undefined) {
      obj.nightsenseAction = NightsenseActionResultData.toJSON(message.nightsenseAction);
    }
    if (message.spoofMultiDrone !== undefined) {
      obj.spoofMultiDrone = SpoofMultiDroneResultData.toJSON(message.spoofMultiDrone);
    }
    if (message.setMovementCommand !== undefined) {
      obj.setMovementCommand = SetMovementCommandResultData.toJSON(message.setMovementCommand);
    }
    if (message.spoofFlightEnvelopeLimits !== undefined) {
      obj.spoofFlightEnvelopeLimits = SpoofFlightEnvelopeLimitsResultData.toJSON(message.spoofFlightEnvelopeLimits);
    }
    if (message.turntable !== undefined) {
      obj.turntable = TurntableResultData.toJSON(message.turntable);
    }
    if (message.dancingDrone !== undefined) {
      obj.dancingDrone = DancingDroneResultData.toJSON(message.dancingDrone);
    }
    if (message.waitForPreciseFault !== undefined) {
      obj.waitForPreciseFault = WaitForPreciseFaultResultData.toJSON(message.waitForPreciseFault);
    }
    if (message.dancingDroneSpline !== undefined) {
      obj.dancingDroneSpline = DancingDroneSplineResultData.toJSON(message.dancingDroneSpline);
    }
    if (message.globalPlannerRequest !== undefined) {
      obj.globalPlannerRequest = GlobalPlannerRequestActionResultData.toJSON(message.globalPlannerRequest);
    }
    if (message.toggleSubjectDetection !== undefined) {
      obj.toggleSubjectDetection = ToggleSubjectDetectionResultData.toJSON(message.toggleSubjectDetection);
    }
    if (message.spoofSubjectScenario !== undefined) {
      obj.spoofSubjectScenario = SpoofSubjectScenarioResultData.toJSON(message.spoofSubjectScenario);
    }
    if (message.setSubjectFollowerSettings !== undefined) {
      obj.setSubjectFollowerSettings = SetSubjectFollowerSettingsResultData.toJSON(message.setSubjectFollowerSettings);
    }
    if (message.geofenceConfig !== undefined) {
      obj.geofenceConfig = GeofenceConfigResultData.toJSON(message.geofenceConfig);
    }
    if (message.setDesiredImuSource !== undefined) {
      obj.setDesiredImuSource = SetDesiredImuSourceResultData.toJSON(message.setDesiredImuSource);
    }
    if (message.sendMotionCommand !== undefined) {
      obj.sendMotionCommand = SendMotionCommandResultData.toJSON(message.sendMotionCommand);
    }
    if (message.setGnssSolverQuality !== undefined) {
      obj.setGnssSolverQuality = SetGnssSolverQualityResultData.toJSON(message.setGnssSolverQuality);
    }
    if (message.spoofPhoneUiVariablesAction !== undefined) {
      obj.spoofPhoneUiVariablesAction = SpoofPhoneUiVariablesResultData.toJSON(message.spoofPhoneUiVariablesAction);
    }
    if (message.playAudio !== undefined) {
      obj.playAudio = PlayAudioResultData.toJSON(message.playAudio);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ActionResult>, I>>(base?: I): ActionResult {
    return ActionResult.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ActionResult>, I>>(object: I): ActionResult {
    const message = createBaseActionResult();
    message.uuid = object.uuid ?? "";
    message.actionUuid = object.actionUuid ?? "";
    message.actionKey = object.actionKey ?? "";
    message.message = object.message ?? "";
    message.startUclock = object.startUclock ?? 0;
    message.endUclock = object.endUclock ?? 0;
    message.startUtime = object.startUtime ?? 0;
    message.endUtime = object.endUtime ?? 0;
    message.debugJson = object.debugJson ?? "";
    message.result = object.result ?? 0;
    message.errorCode = object.errorCode ?? "";
    message.parentActionResultUuid = object.parentActionResultUuid ?? "";
    message.gotoGpsWaypoint = (object.gotoGpsWaypoint !== undefined && object.gotoGpsWaypoint !== null)
      ? GotoGpsWaypointResultData.fromPartial(object.gotoGpsWaypoint)
      : undefined;
    message.gotoNavWaypoint = (object.gotoNavWaypoint !== undefined && object.gotoNavWaypoint !== null)
      ? GotoNavWaypointResultData.fromPartial(object.gotoNavWaypoint)
      : undefined;
    message.takePhoto = (object.takePhoto !== undefined && object.takePhoto !== null)
      ? TakePhotoResultData.fromPartial(object.takePhoto)
      : undefined;
    message.surfaceScanSkill = (object.surfaceScanSkill !== undefined && object.surfaceScanSkill !== null)
      ? SurfaceScanResultData.fromPartial(object.surfaceScanSkill)
      : undefined;
    message.startVideo = (object.startVideo !== undefined && object.startVideo !== null)
      ? StartVideoResultData.fromPartial(object.startVideo)
      : undefined;
    message.stopVideo = (object.stopVideo !== undefined && object.stopVideo !== null)
      ? StopVideoResultData.fromPartial(object.stopVideo)
      : undefined;
    message.switchRecordingMode = (object.switchRecordingMode !== undefined && object.switchRecordingMode !== null)
      ? SwitchRecordingModeResultData.fromPartial(object.switchRecordingMode)
      : undefined;
    message.timedWait = (object.timedWait !== undefined && object.timedWait !== null)
      ? TimedWaitResultData.fromPartial(object.timedWait)
      : undefined;
    message.sequence = (object.sequence !== undefined && object.sequence !== null)
      ? SequenceResultData.fromPartial(object.sequence)
      : undefined;
    message.orbitPoiAction = (object.orbitPoiAction !== undefined && object.orbitPoiAction !== null)
      ? OrbitPoiResultData.fromPartial(object.orbitPoiAction)
      : undefined;
    message.takePanorama = (object.takePanorama !== undefined && object.takePanorama !== null)
      ? TakePanoramaResultData.fromPartial(object.takePanorama)
      : undefined;
    message.keyframeSkill = (object.keyframeSkill !== undefined && object.keyframeSkill !== null)
      ? KeyframeResultData.fromPartial(object.keyframeSkill)
      : undefined;
    message.gotoWaypoint = (object.gotoWaypoint !== undefined && object.gotoWaypoint !== null)
      ? GotoWaypointResultData.fromPartial(object.gotoWaypoint)
      : undefined;
    message.setObstacleAvoidance = (object.setObstacleAvoidance !== undefined && object.setObstacleAvoidance !== null)
      ? SetObstacleAvoidanceResultData.fromPartial(object.setObstacleAvoidance)
      : undefined;
    message.initializeGps = (object.initializeGps !== undefined && object.initializeGps !== null)
      ? InitializeGpsResultData.fromPartial(object.initializeGps)
      : undefined;
    message.subjectDetected = (object.subjectDetected !== undefined && object.subjectDetected !== null)
      ? SubjectDetectedResultData.fromPartial(object.subjectDetected)
      : undefined;
    message.looper = (object.looper !== undefined && object.looper !== null)
      ? LooperResultData.fromPartial(object.looper)
      : undefined;
    message.withinDistance = (object.withinDistance !== undefined && object.withinDistance !== null)
      ? WithinDistanceResultData.fromPartial(object.withinDistance)
      : undefined;
    message.unifiedFollowAction = (object.unifiedFollowAction !== undefined && object.unifiedFollowAction !== null)
      ? UnifiedFollowResultData.fromPartial(object.unifiedFollowAction)
      : undefined;
    message.inverter = (object.inverter !== undefined && object.inverter !== null)
      ? InverterResultData.fromPartial(object.inverter)
      : undefined;
    message.togglePhotoIntervalMode =
      (object.togglePhotoIntervalMode !== undefined && object.togglePhotoIntervalMode !== null)
        ? TogglePhotoIntervalModeResultData.fromPartial(object.togglePhotoIntervalMode)
        : undefined;
    message.wifiScan = (object.wifiScan !== undefined && object.wifiScan !== null)
      ? WifiScanResultData.fromPartial(object.wifiScan)
      : undefined;
    message.enableStrobeLights = (object.enableStrobeLights !== undefined && object.enableStrobeLights !== null)
      ? EnableStrobeLightsResultData.fromPartial(object.enableStrobeLights)
      : undefined;
    message.disableStrobeLights = (object.disableStrobeLights !== undefined && object.disableStrobeLights !== null)
      ? DisableStrobeLightsResultData.fromPartial(object.disableStrobeLights)
      : undefined;
    message.spoofJoysticksInputs = (object.spoofJoysticksInputs !== undefined && object.spoofJoysticksInputs !== null)
      ? SpoofJoysticksInputsResultData.fromPartial(object.spoofJoysticksInputs)
      : undefined;
    message.updateJoysticksSettings =
      (object.updateJoysticksSettings !== undefined && object.updateJoysticksSettings !== null)
        ? UpdateJoysticksSettingsResultData.fromPartial(object.updateJoysticksSettings)
        : undefined;
    message.updateShapeMap = (object.updateShapeMap !== undefined && object.updateShapeMap !== null)
      ? UpdateShapeMapResultData.fromPartial(object.updateShapeMap)
      : undefined;
    message.spoofObstacle = (object.spoofObstacle !== undefined && object.spoofObstacle !== null)
      ? SpoofObstacleResultData.fromPartial(object.spoofObstacle)
      : undefined;
    message.dummyAction = (object.dummyAction !== undefined && object.dummyAction !== null)
      ? DummyResultData.fromPartial(object.dummyAction)
      : undefined;
    message.testDesiredVelocityAction =
      (object.testDesiredVelocityAction !== undefined && object.testDesiredVelocityAction !== null)
        ? TestDesiredVelocityResultData.fromPartial(object.testDesiredVelocityAction)
        : undefined;
    message.testTrackTrajectory = (object.testTrackTrajectory !== undefined && object.testTrackTrajectory !== null)
      ? TestTrackTrajectoryResultData.fromPartial(object.testTrackTrajectory)
      : undefined;
    message.atvSubjectSpoofAction =
      (object.atvSubjectSpoofAction !== undefined && object.atvSubjectSpoofAction !== null)
        ? AtvSubjectSpoofResultData.fromPartial(object.atvSubjectSpoofAction)
        : undefined;
    message.skiSubjectSpoofAction =
      (object.skiSubjectSpoofAction !== undefined && object.skiSubjectSpoofAction !== null)
        ? SkiSubjectSpoofResultData.fromPartial(object.skiSubjectSpoofAction)
        : undefined;
    message.setGimbalOrientation = (object.setGimbalOrientation !== undefined && object.setGimbalOrientation !== null)
      ? SetGimbalOrientationResultData.fromPartial(object.setGimbalOrientation)
      : undefined;
    message.parallel = (object.parallel !== undefined && object.parallel !== null)
      ? ParallelResultData.fromPartial(object.parallel)
      : undefined;
    message.sequenceUntilSuccess = (object.sequenceUntilSuccess !== undefined && object.sequenceUntilSuccess !== null)
      ? SequenceUntilSuccessResultData.fromPartial(object.sequenceUntilSuccess)
      : undefined;
    message.sequenceUntilFailure = (object.sequenceUntilFailure !== undefined && object.sequenceUntilFailure !== null)
      ? SequenceUntilFailureResultData.fromPartial(object.sequenceUntilFailure)
      : undefined;
    message.sequencePretakeoff = (object.sequencePretakeoff !== undefined && object.sequencePretakeoff !== null)
      ? SequencePretakeoffResultData.fromPartial(object.sequencePretakeoff)
      : undefined;
    message.sequenceConfig = (object.sequenceConfig !== undefined && object.sequenceConfig !== null)
      ? SequenceConfigResultData.fromPartial(object.sequenceConfig)
      : undefined;
    message.waitForRtk = (object.waitForRtk !== undefined && object.waitForRtk !== null)
      ? WaitForRtkResultData.fromPartial(object.waitForRtk)
      : undefined;
    message.wingWaypointsCommand = (object.wingWaypointsCommand !== undefined && object.wingWaypointsCommand !== null)
      ? WingWaypointsCommandResultData.fromPartial(object.wingWaypointsCommand)
      : undefined;
    message.sendDynamicScenario = (object.sendDynamicScenario !== undefined && object.sendDynamicScenario !== null)
      ? SendDynamicScenarioResultData.fromPartial(object.sendDynamicScenario)
      : undefined;
    message.scoutAction = (object.scoutAction !== undefined && object.scoutAction !== null)
      ? ScoutActionResultData.fromPartial(object.scoutAction)
      : undefined;
    message.spoofTrackingDevice = (object.spoofTrackingDevice !== undefined && object.spoofTrackingDevice !== null)
      ? SpoofTrackingDeviceResultData.fromPartial(object.spoofTrackingDevice)
      : undefined;
    message.spoofDisturbanceAction =
      (object.spoofDisturbanceAction !== undefined && object.spoofDisturbanceAction !== null)
        ? SpoofDisturbanceResultData.fromPartial(object.spoofDisturbanceAction)
        : undefined;
    message.updateVehicleSettings =
      (object.updateVehicleSettings !== undefined && object.updateVehicleSettings !== null)
        ? UpdateVehicleSettingsResultData.fromPartial(object.updateVehicleSettings)
        : undefined;
    message.waitForVehicleStop = (object.waitForVehicleStop !== undefined && object.waitForVehicleStop !== null)
      ? WaitForVehicleStopResultData.fromPartial(object.waitForVehicleStop)
      : undefined;
    message.precomputedSubjectSpoofAction =
      (object.precomputedSubjectSpoofAction !== undefined && object.precomputedSubjectSpoofAction !== null)
        ? PrecomputedSubjectSpoofResultData.fromPartial(object.precomputedSubjectSpoofAction)
        : undefined;
    message.modifySimStateEstimation =
      (object.modifySimStateEstimation !== undefined && object.modifySimStateEstimation !== null)
        ? ModifySimStateEstimationResultData.fromPartial(object.modifySimStateEstimation)
        : undefined;
    message.gotoAndOrbitPoi = (object.gotoAndOrbitPoi !== undefined && object.gotoAndOrbitPoi !== null)
      ? GotoAndOrbitPoiResultData.fromPartial(object.gotoAndOrbitPoi)
      : undefined;
    message.acquireGps = (object.acquireGps !== undefined && object.acquireGps !== null)
      ? AcquireGpsResultData.fromPartial(object.acquireGps)
      : undefined;
    message.setFaultOverride = (object.setFaultOverride !== undefined && object.setFaultOverride !== null)
      ? SetFaultOverrideResultData.fromPartial(object.setFaultOverride)
      : undefined;
    message.eLand = (object.eLand !== undefined && object.eLand !== null)
      ? ELandResultData.fromPartial(object.eLand)
      : undefined;
    message.trajectoryInspect = (object.trajectoryInspect !== undefined && object.trajectoryInspect !== null)
      ? TrajectoryInspectResultData.fromPartial(object.trajectoryInspect)
      : undefined;
    message.toggleTargetPointExposure =
      (object.toggleTargetPointExposure !== undefined && object.toggleTargetPointExposure !== null)
        ? ToggleTargetPointExposureResultData.fromPartial(object.toggleTargetPointExposure)
        : undefined;
    message.toggleSemanticAim = (object.toggleSemanticAim !== undefined && object.toggleSemanticAim !== null)
      ? ToggleSemanticAimResultData.fromPartial(object.toggleSemanticAim)
      : undefined;
    message.spoofBatteryLevel = (object.spoofBatteryLevel !== undefined && object.spoofBatteryLevel !== null)
      ? SpoofBatteryLevelResultData.fromPartial(object.spoofBatteryLevel)
      : undefined;
    message.ncpgControl = (object.ncpgControl !== undefined && object.ncpgControl !== null)
      ? NcpgControlResultData.fromPartial(object.ncpgControl)
      : undefined;
    message.registerComplimentaryActions =
      (object.registerComplimentaryActions !== undefined && object.registerComplimentaryActions !== null)
        ? RegisterComplimentaryActionsResultData.fromPartial(object.registerComplimentaryActions)
        : undefined;
    message.trackInPlace = (object.trackInPlace !== undefined && object.trackInPlace !== null)
      ? TrackInPlaceResultData.fromPartial(object.trackInPlace)
      : undefined;
    message.globalGraphControl = (object.globalGraphControl !== undefined && object.globalGraphControl !== null)
      ? GlobalGraphControlResultData.fromPartial(object.globalGraphControl)
      : undefined;
    message.overrideGpsQuality = (object.overrideGpsQuality !== undefined && object.overrideGpsQuality !== null)
      ? OverrideGpsQualityResultData.fromPartial(object.overrideGpsQuality)
      : undefined;
    message.initGlobalMap = (object.initGlobalMap !== undefined && object.initGlobalMap !== null)
      ? InitGlobalMapResultData.fromPartial(object.initGlobalMap)
      : undefined;
    message.stopForPhotoInspect = (object.stopForPhotoInspect !== undefined && object.stopForPhotoInspect !== null)
      ? StopForPhotoInspectResultData.fromPartial(object.stopForPhotoInspect)
      : undefined;
    message.spoofInitialGpsHeading =
      (object.spoofInitialGpsHeading !== undefined && object.spoofInitialGpsHeading !== null)
        ? SpoofInitialGpsHeadingResultData.fromPartial(object.spoofInitialGpsHeading)
        : undefined;
    message.trackLandingPadRequest =
      (object.trackLandingPadRequest !== undefined && object.trackLandingPadRequest !== null)
        ? TrackLandingPadRequestResultData.fromPartial(object.trackLandingPadRequest)
        : undefined;
    message.apriltagSetId = (object.apriltagSetId !== undefined && object.apriltagSetId !== null)
      ? ApriltagSetIdResultData.fromPartial(object.apriltagSetId)
      : undefined;
    message.dockGpsEstimator = (object.dockGpsEstimator !== undefined && object.dockGpsEstimator !== null)
      ? DockGpsEstimatorResultData.fromPartial(object.dockGpsEstimator)
      : undefined;
    message.g47CommandOverride = (object.g47CommandOverride !== undefined && object.g47CommandOverride !== null)
      ? G47CommandOverrideResultData.fromPartial(object.g47CommandOverride)
      : undefined;
    message.requestTakeoffProfile =
      (object.requestTakeoffProfile !== undefined && object.requestTakeoffProfile !== null)
        ? RequestTakeoffProfileResultData.fromPartial(object.requestTakeoffProfile)
        : undefined;
    message.updateDockLocationAction =
      (object.updateDockLocationAction !== undefined && object.updateDockLocationAction !== null)
        ? UpdateDockLocationActionResultData.fromPartial(object.updateDockLocationAction)
        : undefined;
    message.setDesiredGpsSource = (object.setDesiredGpsSource !== undefined && object.setDesiredGpsSource !== null)
      ? SetDesiredGpsSourceResultData.fromPartial(object.setDesiredGpsSource)
      : undefined;
    message.spoofManualGps = (object.spoofManualGps !== undefined && object.spoofManualGps !== null)
      ? SpoofManualGpsResultData.fromPartial(object.spoofManualGps)
      : undefined;
    message.weatherAction = (object.weatherAction !== undefined && object.weatherAction !== null)
      ? WeatherActionResultData.fromPartial(object.weatherAction)
      : undefined;
    message.setZoom = (object.setZoom !== undefined && object.setZoom !== null)
      ? SetZoomResultData.fromPartial(object.setZoom)
      : undefined;
    message.missionPlannerServiceControl =
      (object.missionPlannerServiceControl !== undefined && object.missionPlannerServiceControl !== null)
        ? MissionPlannerServiceControlResultData.fromPartial(object.missionPlannerServiceControl)
        : undefined;
    message.spotlightAction = (object.spotlightAction !== undefined && object.spotlightAction !== null)
      ? SpotlightActionResultData.fromPartial(object.spotlightAction)
      : undefined;
    message.setCameraSettings = (object.setCameraSettings !== undefined && object.setCameraSettings !== null)
      ? SetCameraSettingsResultData.fromPartial(object.setCameraSettings)
      : undefined;
    message.parachuteControl = (object.parachuteControl !== undefined && object.parachuteControl !== null)
      ? ParachuteControlResultData.fromPartial(object.parachuteControl)
      : undefined;
    message.nightsenseAction = (object.nightsenseAction !== undefined && object.nightsenseAction !== null)
      ? NightsenseActionResultData.fromPartial(object.nightsenseAction)
      : undefined;
    message.spoofMultiDrone = (object.spoofMultiDrone !== undefined && object.spoofMultiDrone !== null)
      ? SpoofMultiDroneResultData.fromPartial(object.spoofMultiDrone)
      : undefined;
    message.setMovementCommand = (object.setMovementCommand !== undefined && object.setMovementCommand !== null)
      ? SetMovementCommandResultData.fromPartial(object.setMovementCommand)
      : undefined;
    message.spoofFlightEnvelopeLimits =
      (object.spoofFlightEnvelopeLimits !== undefined && object.spoofFlightEnvelopeLimits !== null)
        ? SpoofFlightEnvelopeLimitsResultData.fromPartial(object.spoofFlightEnvelopeLimits)
        : undefined;
    message.turntable = (object.turntable !== undefined && object.turntable !== null)
      ? TurntableResultData.fromPartial(object.turntable)
      : undefined;
    message.dancingDrone = (object.dancingDrone !== undefined && object.dancingDrone !== null)
      ? DancingDroneResultData.fromPartial(object.dancingDrone)
      : undefined;
    message.waitForPreciseFault = (object.waitForPreciseFault !== undefined && object.waitForPreciseFault !== null)
      ? WaitForPreciseFaultResultData.fromPartial(object.waitForPreciseFault)
      : undefined;
    message.dancingDroneSpline = (object.dancingDroneSpline !== undefined && object.dancingDroneSpline !== null)
      ? DancingDroneSplineResultData.fromPartial(object.dancingDroneSpline)
      : undefined;
    message.globalPlannerRequest = (object.globalPlannerRequest !== undefined && object.globalPlannerRequest !== null)
      ? GlobalPlannerRequestActionResultData.fromPartial(object.globalPlannerRequest)
      : undefined;
    message.toggleSubjectDetection =
      (object.toggleSubjectDetection !== undefined && object.toggleSubjectDetection !== null)
        ? ToggleSubjectDetectionResultData.fromPartial(object.toggleSubjectDetection)
        : undefined;
    message.spoofSubjectScenario = (object.spoofSubjectScenario !== undefined && object.spoofSubjectScenario !== null)
      ? SpoofSubjectScenarioResultData.fromPartial(object.spoofSubjectScenario)
      : undefined;
    message.setSubjectFollowerSettings =
      (object.setSubjectFollowerSettings !== undefined && object.setSubjectFollowerSettings !== null)
        ? SetSubjectFollowerSettingsResultData.fromPartial(object.setSubjectFollowerSettings)
        : undefined;
    message.geofenceConfig = (object.geofenceConfig !== undefined && object.geofenceConfig !== null)
      ? GeofenceConfigResultData.fromPartial(object.geofenceConfig)
      : undefined;
    message.setDesiredImuSource = (object.setDesiredImuSource !== undefined && object.setDesiredImuSource !== null)
      ? SetDesiredImuSourceResultData.fromPartial(object.setDesiredImuSource)
      : undefined;
    message.sendMotionCommand = (object.sendMotionCommand !== undefined && object.sendMotionCommand !== null)
      ? SendMotionCommandResultData.fromPartial(object.sendMotionCommand)
      : undefined;
    message.setGnssSolverQuality = (object.setGnssSolverQuality !== undefined && object.setGnssSolverQuality !== null)
      ? SetGnssSolverQualityResultData.fromPartial(object.setGnssSolverQuality)
      : undefined;
    message.spoofPhoneUiVariablesAction =
      (object.spoofPhoneUiVariablesAction !== undefined && object.spoofPhoneUiVariablesAction !== null)
        ? SpoofPhoneUiVariablesResultData.fromPartial(object.spoofPhoneUiVariablesAction)
        : undefined;
    message.playAudio = (object.playAudio !== undefined && object.playAudio !== null)
      ? PlayAudioResultData.fromPartial(object.playAudio)
      : undefined;
    return message;
  },
};

function createBaseVehicleSupportedActions(): VehicleSupportedActions {
  return { actionKeysArgs: {} };
}

export const VehicleSupportedActions = {
  encode(message: VehicleSupportedActions, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    Object.entries(message.actionKeysArgs).forEach(([key, value]) => {
      VehicleSupportedActions_ActionKeysArgsEntry.encode({ key: key as any, value }, writer.uint32(10).fork()).ldelim();
    });
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): VehicleSupportedActions {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVehicleSupportedActions();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          const entry1 = VehicleSupportedActions_ActionKeysArgsEntry.decode(reader, reader.uint32());
          if (entry1.value !== undefined) {
            message.actionKeysArgs[entry1.key] = entry1.value;
          }
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VehicleSupportedActions {
    return {
      actionKeysArgs: isObject(object.actionKeysArgs)
        ? Object.entries(object.actionKeysArgs).reduce<{ [key: string]: ActionArgs }>((acc, [key, value]) => {
          acc[key] = ActionArgs.fromJSON(value);
          return acc;
        }, {})
        : {},
    };
  },

  toJSON(message: VehicleSupportedActions): unknown {
    const obj: any = {};
    if (message.actionKeysArgs) {
      const entries = Object.entries(message.actionKeysArgs);
      if (entries.length > 0) {
        obj.actionKeysArgs = {};
        entries.forEach(([k, v]) => {
          obj.actionKeysArgs[k] = ActionArgs.toJSON(v);
        });
      }
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<VehicleSupportedActions>, I>>(base?: I): VehicleSupportedActions {
    return VehicleSupportedActions.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<VehicleSupportedActions>, I>>(object: I): VehicleSupportedActions {
    const message = createBaseVehicleSupportedActions();
    message.actionKeysArgs = Object.entries(object.actionKeysArgs ?? {}).reduce<{ [key: string]: ActionArgs }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = ActionArgs.fromPartial(value);
        }
        return acc;
      },
      {},
    );
    return message;
  },
};

function createBaseVehicleSupportedActions_ActionKeysArgsEntry(): VehicleSupportedActions_ActionKeysArgsEntry {
  return { key: "", value: undefined };
}

export const VehicleSupportedActions_ActionKeysArgsEntry = {
  encode(message: VehicleSupportedActions_ActionKeysArgsEntry, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      ActionArgs.encode(message.value, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): VehicleSupportedActions_ActionKeysArgsEntry {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVehicleSupportedActions_ActionKeysArgsEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.value = ActionArgs.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VehicleSupportedActions_ActionKeysArgsEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? ActionArgs.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: VehicleSupportedActions_ActionKeysArgsEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== undefined) {
      obj.value = ActionArgs.toJSON(message.value);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<VehicleSupportedActions_ActionKeysArgsEntry>, I>>(
    base?: I,
  ): VehicleSupportedActions_ActionKeysArgsEntry {
    return VehicleSupportedActions_ActionKeysArgsEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<VehicleSupportedActions_ActionKeysArgsEntry>, I>>(
    object: I,
  ): VehicleSupportedActions_ActionKeysArgsEntry {
    const message = createBaseVehicleSupportedActions_ActionKeysArgsEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? ActionArgs.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBaseMissionTemplate(): MissionTemplate {
  return { uuid: "", displayName: "", actions: [], templateVersion: "" };
}

export const MissionTemplate = {
  encode(message: MissionTemplate, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.uuid !== "") {
      writer.uint32(10).string(message.uuid);
    }
    if (message.displayName !== "") {
      writer.uint32(18).string(message.displayName);
    }
    for (const v of message.actions) {
      Action.encode(v!, writer.uint32(26).fork()).ldelim();
    }
    if (message.templateVersion !== "") {
      writer.uint32(34).string(message.templateVersion);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): MissionTemplate {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMissionTemplate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.uuid = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.displayName = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.actions.push(Action.decode(reader, reader.uint32()));
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.templateVersion = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MissionTemplate {
    return {
      uuid: isSet(object.uuid) ? globalThis.String(object.uuid) : "",
      displayName: isSet(object.displayName) ? globalThis.String(object.displayName) : "",
      actions: globalThis.Array.isArray(object?.actions) ? object.actions.map((e: any) => Action.fromJSON(e)) : [],
      templateVersion: isSet(object.templateVersion) ? globalThis.String(object.templateVersion) : "",
    };
  },

  toJSON(message: MissionTemplate): unknown {
    const obj: any = {};
    if (message.uuid !== "") {
      obj.uuid = message.uuid;
    }
    if (message.displayName !== "") {
      obj.displayName = message.displayName;
    }
    if (message.actions?.length) {
      obj.actions = message.actions.map((e) => Action.toJSON(e));
    }
    if (message.templateVersion !== "") {
      obj.templateVersion = message.templateVersion;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MissionTemplate>, I>>(base?: I): MissionTemplate {
    return MissionTemplate.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MissionTemplate>, I>>(object: I): MissionTemplate {
    const message = createBaseMissionTemplate();
    message.uuid = object.uuid ?? "";
    message.displayName = object.displayName ?? "";
    message.actions = object.actions?.map((e) => Action.fromPartial(e)) || [];
    message.templateVersion = object.templateVersion ?? "";
    return message;
  },
};

function createBaseSequenceActionArgs(): SequenceActionArgs {
  return { name: "", actions: [], hideReverseUi: false };
}

export const SequenceActionArgs = {
  encode(message: SequenceActionArgs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    for (const v of message.actions) {
      Action.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    if (message.hideReverseUi === true) {
      writer.uint32(24).bool(message.hideReverseUi);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SequenceActionArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSequenceActionArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2:
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        case 1:
          if (tag !== 10) {
            break;
          }

          message.actions.push(Action.decode(reader, reader.uint32()));
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.hideReverseUi = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SequenceActionArgs {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      actions: globalThis.Array.isArray(object?.actions) ? object.actions.map((e: any) => Action.fromJSON(e)) : [],
      hideReverseUi: isSet(object.hideReverseUi) ? globalThis.Boolean(object.hideReverseUi) : false,
    };
  },

  toJSON(message: SequenceActionArgs): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.actions?.length) {
      obj.actions = message.actions.map((e) => Action.toJSON(e));
    }
    if (message.hideReverseUi === true) {
      obj.hideReverseUi = message.hideReverseUi;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SequenceActionArgs>, I>>(base?: I): SequenceActionArgs {
    return SequenceActionArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SequenceActionArgs>, I>>(object: I): SequenceActionArgs {
    const message = createBaseSequenceActionArgs();
    message.name = object.name ?? "";
    message.actions = object.actions?.map((e) => Action.fromPartial(e)) || [];
    message.hideReverseUi = object.hideReverseUi ?? false;
    return message;
  },
};

function createBaseSequenceActionStateData(): SequenceActionStateData {
  return { currentActionState: undefined, currentActionIndex: 0 };
}

export const SequenceActionStateData = {
  encode(message: SequenceActionStateData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.currentActionState !== undefined) {
      ActionState.encode(message.currentActionState, writer.uint32(10).fork()).ldelim();
    }
    if (message.currentActionIndex !== 0) {
      writer.uint32(16).int32(message.currentActionIndex);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SequenceActionStateData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSequenceActionStateData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.currentActionState = ActionState.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.currentActionIndex = reader.int32();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SequenceActionStateData {
    return {
      currentActionState: isSet(object.currentActionState)
        ? ActionState.fromJSON(object.currentActionState)
        : undefined,
      currentActionIndex: isSet(object.currentActionIndex) ? globalThis.Number(object.currentActionIndex) : 0,
    };
  },

  toJSON(message: SequenceActionStateData): unknown {
    const obj: any = {};
    if (message.currentActionState !== undefined) {
      obj.currentActionState = ActionState.toJSON(message.currentActionState);
    }
    if (message.currentActionIndex !== 0) {
      obj.currentActionIndex = Math.round(message.currentActionIndex);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SequenceActionStateData>, I>>(base?: I): SequenceActionStateData {
    return SequenceActionStateData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SequenceActionStateData>, I>>(object: I): SequenceActionStateData {
    const message = createBaseSequenceActionStateData();
    message.currentActionState = (object.currentActionState !== undefined && object.currentActionState !== null)
      ? ActionState.fromPartial(object.currentActionState)
      : undefined;
    message.currentActionIndex = object.currentActionIndex ?? 0;
    return message;
  },
};

function createBaseSequenceUntilFailureActionStateData(): SequenceUntilFailureActionStateData {
  return { currentActionState: undefined, currentActionIndex: 0 };
}

export const SequenceUntilFailureActionStateData = {
  encode(message: SequenceUntilFailureActionStateData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.currentActionState !== undefined) {
      ActionState.encode(message.currentActionState, writer.uint32(10).fork()).ldelim();
    }
    if (message.currentActionIndex !== 0) {
      writer.uint32(16).int32(message.currentActionIndex);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SequenceUntilFailureActionStateData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSequenceUntilFailureActionStateData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.currentActionState = ActionState.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.currentActionIndex = reader.int32();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SequenceUntilFailureActionStateData {
    return {
      currentActionState: isSet(object.currentActionState)
        ? ActionState.fromJSON(object.currentActionState)
        : undefined,
      currentActionIndex: isSet(object.currentActionIndex) ? globalThis.Number(object.currentActionIndex) : 0,
    };
  },

  toJSON(message: SequenceUntilFailureActionStateData): unknown {
    const obj: any = {};
    if (message.currentActionState !== undefined) {
      obj.currentActionState = ActionState.toJSON(message.currentActionState);
    }
    if (message.currentActionIndex !== 0) {
      obj.currentActionIndex = Math.round(message.currentActionIndex);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SequenceUntilFailureActionStateData>, I>>(
    base?: I,
  ): SequenceUntilFailureActionStateData {
    return SequenceUntilFailureActionStateData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SequenceUntilFailureActionStateData>, I>>(
    object: I,
  ): SequenceUntilFailureActionStateData {
    const message = createBaseSequenceUntilFailureActionStateData();
    message.currentActionState = (object.currentActionState !== undefined && object.currentActionState !== null)
      ? ActionState.fromPartial(object.currentActionState)
      : undefined;
    message.currentActionIndex = object.currentActionIndex ?? 0;
    return message;
  },
};

function createBaseSequenceUntilSuccessActionStateData(): SequenceUntilSuccessActionStateData {
  return { currentActionState: undefined, currentActionIndex: 0 };
}

export const SequenceUntilSuccessActionStateData = {
  encode(message: SequenceUntilSuccessActionStateData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.currentActionState !== undefined) {
      ActionState.encode(message.currentActionState, writer.uint32(10).fork()).ldelim();
    }
    if (message.currentActionIndex !== 0) {
      writer.uint32(16).int32(message.currentActionIndex);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SequenceUntilSuccessActionStateData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSequenceUntilSuccessActionStateData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.currentActionState = ActionState.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.currentActionIndex = reader.int32();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SequenceUntilSuccessActionStateData {
    return {
      currentActionState: isSet(object.currentActionState)
        ? ActionState.fromJSON(object.currentActionState)
        : undefined,
      currentActionIndex: isSet(object.currentActionIndex) ? globalThis.Number(object.currentActionIndex) : 0,
    };
  },

  toJSON(message: SequenceUntilSuccessActionStateData): unknown {
    const obj: any = {};
    if (message.currentActionState !== undefined) {
      obj.currentActionState = ActionState.toJSON(message.currentActionState);
    }
    if (message.currentActionIndex !== 0) {
      obj.currentActionIndex = Math.round(message.currentActionIndex);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SequenceUntilSuccessActionStateData>, I>>(
    base?: I,
  ): SequenceUntilSuccessActionStateData {
    return SequenceUntilSuccessActionStateData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SequenceUntilSuccessActionStateData>, I>>(
    object: I,
  ): SequenceUntilSuccessActionStateData {
    const message = createBaseSequenceUntilSuccessActionStateData();
    message.currentActionState = (object.currentActionState !== undefined && object.currentActionState !== null)
      ? ActionState.fromPartial(object.currentActionState)
      : undefined;
    message.currentActionIndex = object.currentActionIndex ?? 0;
    return message;
  },
};

function createBaseSequencePretakeoffActionStateData(): SequencePretakeoffActionStateData {
  return { currentActionState: undefined, currentActionIndex: 0 };
}

export const SequencePretakeoffActionStateData = {
  encode(message: SequencePretakeoffActionStateData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.currentActionState !== undefined) {
      ActionState.encode(message.currentActionState, writer.uint32(10).fork()).ldelim();
    }
    if (message.currentActionIndex !== 0) {
      writer.uint32(16).int32(message.currentActionIndex);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SequencePretakeoffActionStateData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSequencePretakeoffActionStateData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.currentActionState = ActionState.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.currentActionIndex = reader.int32();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SequencePretakeoffActionStateData {
    return {
      currentActionState: isSet(object.currentActionState)
        ? ActionState.fromJSON(object.currentActionState)
        : undefined,
      currentActionIndex: isSet(object.currentActionIndex) ? globalThis.Number(object.currentActionIndex) : 0,
    };
  },

  toJSON(message: SequencePretakeoffActionStateData): unknown {
    const obj: any = {};
    if (message.currentActionState !== undefined) {
      obj.currentActionState = ActionState.toJSON(message.currentActionState);
    }
    if (message.currentActionIndex !== 0) {
      obj.currentActionIndex = Math.round(message.currentActionIndex);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SequencePretakeoffActionStateData>, I>>(
    base?: I,
  ): SequencePretakeoffActionStateData {
    return SequencePretakeoffActionStateData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SequencePretakeoffActionStateData>, I>>(
    object: I,
  ): SequencePretakeoffActionStateData {
    const message = createBaseSequencePretakeoffActionStateData();
    message.currentActionState = (object.currentActionState !== undefined && object.currentActionState !== null)
      ? ActionState.fromPartial(object.currentActionState)
      : undefined;
    message.currentActionIndex = object.currentActionIndex ?? 0;
    return message;
  },
};

function createBaseSequenceConfigActionStateData(): SequenceConfigActionStateData {
  return { currentActionState: undefined, currentActionIndex: 0 };
}

export const SequenceConfigActionStateData = {
  encode(message: SequenceConfigActionStateData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.currentActionState !== undefined) {
      ActionState.encode(message.currentActionState, writer.uint32(10).fork()).ldelim();
    }
    if (message.currentActionIndex !== 0) {
      writer.uint32(16).int32(message.currentActionIndex);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SequenceConfigActionStateData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSequenceConfigActionStateData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.currentActionState = ActionState.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.currentActionIndex = reader.int32();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SequenceConfigActionStateData {
    return {
      currentActionState: isSet(object.currentActionState)
        ? ActionState.fromJSON(object.currentActionState)
        : undefined,
      currentActionIndex: isSet(object.currentActionIndex) ? globalThis.Number(object.currentActionIndex) : 0,
    };
  },

  toJSON(message: SequenceConfigActionStateData): unknown {
    const obj: any = {};
    if (message.currentActionState !== undefined) {
      obj.currentActionState = ActionState.toJSON(message.currentActionState);
    }
    if (message.currentActionIndex !== 0) {
      obj.currentActionIndex = Math.round(message.currentActionIndex);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SequenceConfigActionStateData>, I>>(base?: I): SequenceConfigActionStateData {
    return SequenceConfigActionStateData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SequenceConfigActionStateData>, I>>(
    object: I,
  ): SequenceConfigActionStateData {
    const message = createBaseSequenceConfigActionStateData();
    message.currentActionState = (object.currentActionState !== undefined && object.currentActionState !== null)
      ? ActionState.fromPartial(object.currentActionState)
      : undefined;
    message.currentActionIndex = object.currentActionIndex ?? 0;
    return message;
  },
};

function createBaseGotoAndOrbitPoiActionStateData(): GotoAndOrbitPoiActionStateData {
  return { sequenceState: undefined };
}

export const GotoAndOrbitPoiActionStateData = {
  encode(message: GotoAndOrbitPoiActionStateData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.sequenceState !== undefined) {
      SequenceActionStateData.encode(message.sequenceState, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GotoAndOrbitPoiActionStateData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGotoAndOrbitPoiActionStateData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.sequenceState = SequenceActionStateData.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GotoAndOrbitPoiActionStateData {
    return {
      sequenceState: isSet(object.sequenceState) ? SequenceActionStateData.fromJSON(object.sequenceState) : undefined,
    };
  },

  toJSON(message: GotoAndOrbitPoiActionStateData): unknown {
    const obj: any = {};
    if (message.sequenceState !== undefined) {
      obj.sequenceState = SequenceActionStateData.toJSON(message.sequenceState);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GotoAndOrbitPoiActionStateData>, I>>(base?: I): GotoAndOrbitPoiActionStateData {
    return GotoAndOrbitPoiActionStateData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GotoAndOrbitPoiActionStateData>, I>>(
    object: I,
  ): GotoAndOrbitPoiActionStateData {
    const message = createBaseGotoAndOrbitPoiActionStateData();
    message.sequenceState = (object.sequenceState !== undefined && object.sequenceState !== null)
      ? SequenceActionStateData.fromPartial(object.sequenceState)
      : undefined;
    return message;
  },
};

function createBaseLooperActionArgs(): LooperActionArgs {
  return { type: 0, name: "", maxLoops: 0, action: undefined };
}

export const LooperActionArgs = {
  encode(message: LooperActionArgs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.type !== 0) {
      writer.uint32(8).int32(message.type);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.maxLoops !== 0) {
      writer.uint32(24).int64(message.maxLoops);
    }
    if (message.action !== undefined) {
      Action.encode(message.action, writer.uint32(34).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): LooperActionArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLooperActionArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.maxLoops = longToNumber(reader.int64() as Long);
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.action = Action.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LooperActionArgs {
    return {
      type: isSet(object.type) ? controlNodeTypeEnum_EnumFromJSON(object.type) : 0,
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      maxLoops: isSet(object.maxLoops) ? globalThis.Number(object.maxLoops) : 0,
      action: isSet(object.action) ? Action.fromJSON(object.action) : undefined,
    };
  },

  toJSON(message: LooperActionArgs): unknown {
    const obj: any = {};
    if (message.type !== 0) {
      obj.type = controlNodeTypeEnum_EnumToJSON(message.type);
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.maxLoops !== 0) {
      obj.maxLoops = Math.round(message.maxLoops);
    }
    if (message.action !== undefined) {
      obj.action = Action.toJSON(message.action);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LooperActionArgs>, I>>(base?: I): LooperActionArgs {
    return LooperActionArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LooperActionArgs>, I>>(object: I): LooperActionArgs {
    const message = createBaseLooperActionArgs();
    message.type = object.type ?? 0;
    message.name = object.name ?? "";
    message.maxLoops = object.maxLoops ?? 0;
    message.action = (object.action !== undefined && object.action !== null)
      ? Action.fromPartial(object.action)
      : undefined;
    return message;
  },
};

function createBaseInverterActionArgs(): InverterActionArgs {
  return { action: undefined };
}

export const InverterActionArgs = {
  encode(message: InverterActionArgs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.action !== undefined) {
      Action.encode(message.action, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): InverterActionArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInverterActionArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.action = Action.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): InverterActionArgs {
    return { action: isSet(object.action) ? Action.fromJSON(object.action) : undefined };
  },

  toJSON(message: InverterActionArgs): unknown {
    const obj: any = {};
    if (message.action !== undefined) {
      obj.action = Action.toJSON(message.action);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<InverterActionArgs>, I>>(base?: I): InverterActionArgs {
    return InverterActionArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<InverterActionArgs>, I>>(object: I): InverterActionArgs {
    const message = createBaseInverterActionArgs();
    message.action = (object.action !== undefined && object.action !== null)
      ? Action.fromPartial(object.action)
      : undefined;
    return message;
  },
};

function createBaseEnableStrobeLightsActionArgs(): EnableStrobeLightsActionArgs {
  return { noArgs: false };
}

export const EnableStrobeLightsActionArgs = {
  encode(message: EnableStrobeLightsActionArgs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.noArgs === true) {
      writer.uint32(8).bool(message.noArgs);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): EnableStrobeLightsActionArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEnableStrobeLightsActionArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.noArgs = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EnableStrobeLightsActionArgs {
    return { noArgs: isSet(object.noArgs) ? globalThis.Boolean(object.noArgs) : false };
  },

  toJSON(message: EnableStrobeLightsActionArgs): unknown {
    const obj: any = {};
    if (message.noArgs === true) {
      obj.noArgs = message.noArgs;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<EnableStrobeLightsActionArgs>, I>>(base?: I): EnableStrobeLightsActionArgs {
    return EnableStrobeLightsActionArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<EnableStrobeLightsActionArgs>, I>>(object: I): EnableStrobeLightsActionArgs {
    const message = createBaseEnableStrobeLightsActionArgs();
    message.noArgs = object.noArgs ?? false;
    return message;
  },
};

function createBaseDisableStrobeLightsActionArgs(): DisableStrobeLightsActionArgs {
  return { noArgs: false };
}

export const DisableStrobeLightsActionArgs = {
  encode(message: DisableStrobeLightsActionArgs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.noArgs === true) {
      writer.uint32(8).bool(message.noArgs);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): DisableStrobeLightsActionArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDisableStrobeLightsActionArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.noArgs = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DisableStrobeLightsActionArgs {
    return { noArgs: isSet(object.noArgs) ? globalThis.Boolean(object.noArgs) : false };
  },

  toJSON(message: DisableStrobeLightsActionArgs): unknown {
    const obj: any = {};
    if (message.noArgs === true) {
      obj.noArgs = message.noArgs;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DisableStrobeLightsActionArgs>, I>>(base?: I): DisableStrobeLightsActionArgs {
    return DisableStrobeLightsActionArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DisableStrobeLightsActionArgs>, I>>(
    object: I,
  ): DisableStrobeLightsActionArgs {
    const message = createBaseDisableStrobeLightsActionArgs();
    message.noArgs = object.noArgs ?? false;
    return message;
  },
};

function createBaseEnableStrobeLightsResultData(): EnableStrobeLightsResultData {
  return {};
}

export const EnableStrobeLightsResultData = {
  encode(_: EnableStrobeLightsResultData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): EnableStrobeLightsResultData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEnableStrobeLightsResultData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): EnableStrobeLightsResultData {
    return {};
  },

  toJSON(_: EnableStrobeLightsResultData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<EnableStrobeLightsResultData>, I>>(base?: I): EnableStrobeLightsResultData {
    return EnableStrobeLightsResultData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<EnableStrobeLightsResultData>, I>>(_: I): EnableStrobeLightsResultData {
    const message = createBaseEnableStrobeLightsResultData();
    return message;
  },
};

function createBaseDisableStrobeLightsResultData(): DisableStrobeLightsResultData {
  return {};
}

export const DisableStrobeLightsResultData = {
  encode(_: DisableStrobeLightsResultData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): DisableStrobeLightsResultData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDisableStrobeLightsResultData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): DisableStrobeLightsResultData {
    return {};
  },

  toJSON(_: DisableStrobeLightsResultData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<DisableStrobeLightsResultData>, I>>(base?: I): DisableStrobeLightsResultData {
    return DisableStrobeLightsResultData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DisableStrobeLightsResultData>, I>>(_: I): DisableStrobeLightsResultData {
    const message = createBaseDisableStrobeLightsResultData();
    return message;
  },
};

function createBaseEnableStrobeLightsActionStateData(): EnableStrobeLightsActionStateData {
  return {};
}

export const EnableStrobeLightsActionStateData = {
  encode(_: EnableStrobeLightsActionStateData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): EnableStrobeLightsActionStateData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEnableStrobeLightsActionStateData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): EnableStrobeLightsActionStateData {
    return {};
  },

  toJSON(_: EnableStrobeLightsActionStateData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<EnableStrobeLightsActionStateData>, I>>(
    base?: I,
  ): EnableStrobeLightsActionStateData {
    return EnableStrobeLightsActionStateData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<EnableStrobeLightsActionStateData>, I>>(
    _: I,
  ): EnableStrobeLightsActionStateData {
    const message = createBaseEnableStrobeLightsActionStateData();
    return message;
  },
};

function createBaseDisableStrobeLightsActionStateData(): DisableStrobeLightsActionStateData {
  return {};
}

export const DisableStrobeLightsActionStateData = {
  encode(_: DisableStrobeLightsActionStateData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): DisableStrobeLightsActionStateData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDisableStrobeLightsActionStateData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): DisableStrobeLightsActionStateData {
    return {};
  },

  toJSON(_: DisableStrobeLightsActionStateData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<DisableStrobeLightsActionStateData>, I>>(
    base?: I,
  ): DisableStrobeLightsActionStateData {
    return DisableStrobeLightsActionStateData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DisableStrobeLightsActionStateData>, I>>(
    _: I,
  ): DisableStrobeLightsActionStateData {
    const message = createBaseDisableStrobeLightsActionStateData();
    return message;
  },
};

function createBaseNcpgWaypointInfo(): NcpgWaypointInfo {
  return { waypoint: undefined, poseId: undefined, defaultNavTReferencePose: undefined };
}

export const NcpgWaypointInfo = {
  encode(message: NcpgWaypointInfo, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.waypoint !== undefined) {
      Waypoint.encode(message.waypoint, writer.uint32(10).fork()).ldelim();
    }
    if (message.poseId !== undefined) {
      PoseIdPb.encode(message.poseId, writer.uint32(18).fork()).ldelim();
    }
    if (message.defaultNavTReferencePose !== undefined) {
      TransPb.encode(message.defaultNavTReferencePose, writer.uint32(26).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): NcpgWaypointInfo {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseNcpgWaypointInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.waypoint = Waypoint.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.poseId = PoseIdPb.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.defaultNavTReferencePose = TransPb.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): NcpgWaypointInfo {
    return {
      waypoint: isSet(object.waypoint) ? Waypoint.fromJSON(object.waypoint) : undefined,
      poseId: isSet(object.poseId) ? PoseIdPb.fromJSON(object.poseId) : undefined,
      defaultNavTReferencePose: isSet(object.defaultNavTReferencePose)
        ? TransPb.fromJSON(object.defaultNavTReferencePose)
        : undefined,
    };
  },

  toJSON(message: NcpgWaypointInfo): unknown {
    const obj: any = {};
    if (message.waypoint !== undefined) {
      obj.waypoint = Waypoint.toJSON(message.waypoint);
    }
    if (message.poseId !== undefined) {
      obj.poseId = PoseIdPb.toJSON(message.poseId);
    }
    if (message.defaultNavTReferencePose !== undefined) {
      obj.defaultNavTReferencePose = TransPb.toJSON(message.defaultNavTReferencePose);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<NcpgWaypointInfo>, I>>(base?: I): NcpgWaypointInfo {
    return NcpgWaypointInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<NcpgWaypointInfo>, I>>(object: I): NcpgWaypointInfo {
    const message = createBaseNcpgWaypointInfo();
    message.waypoint = (object.waypoint !== undefined && object.waypoint !== null)
      ? Waypoint.fromPartial(object.waypoint)
      : undefined;
    message.poseId = (object.poseId !== undefined && object.poseId !== null)
      ? PoseIdPb.fromPartial(object.poseId)
      : undefined;
    message.defaultNavTReferencePose =
      (object.defaultNavTReferencePose !== undefined && object.defaultNavTReferencePose !== null)
        ? TransPb.fromPartial(object.defaultNavTReferencePose)
        : undefined;
    return message;
  },
};

function createBaseNcpgWaypointsRequest(): NcpgWaypointsRequest {
  return { utime: 0, ncpgWaypointInfos: [] };
}

export const NcpgWaypointsRequest = {
  encode(message: NcpgWaypointsRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.utime !== 0) {
      writer.uint32(8).int64(message.utime);
    }
    for (const v of message.ncpgWaypointInfos) {
      NcpgWaypointInfo.encode(v!, writer.uint32(26).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): NcpgWaypointsRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseNcpgWaypointsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.utime = longToNumber(reader.int64() as Long);
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.ncpgWaypointInfos.push(NcpgWaypointInfo.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): NcpgWaypointsRequest {
    return {
      utime: isSet(object.utime) ? globalThis.Number(object.utime) : 0,
      ncpgWaypointInfos: globalThis.Array.isArray(object?.ncpgWaypointInfos)
        ? object.ncpgWaypointInfos.map((e: any) => NcpgWaypointInfo.fromJSON(e))
        : [],
    };
  },

  toJSON(message: NcpgWaypointsRequest): unknown {
    const obj: any = {};
    if (message.utime !== 0) {
      obj.utime = Math.round(message.utime);
    }
    if (message.ncpgWaypointInfos?.length) {
      obj.ncpgWaypointInfos = message.ncpgWaypointInfos.map((e) => NcpgWaypointInfo.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<NcpgWaypointsRequest>, I>>(base?: I): NcpgWaypointsRequest {
    return NcpgWaypointsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<NcpgWaypointsRequest>, I>>(object: I): NcpgWaypointsRequest {
    const message = createBaseNcpgWaypointsRequest();
    message.utime = object.utime ?? 0;
    message.ncpgWaypointInfos = object.ncpgWaypointInfos?.map((e) => NcpgWaypointInfo.fromPartial(e)) || [];
    return message;
  },
};

function createBaseConvertMissionWithNCPGInfoIntoSiteMissionResultCode(): ConvertMissionWithNCPGInfoIntoSiteMissionResultCode {
  return {};
}

export const ConvertMissionWithNCPGInfoIntoSiteMissionResultCode = {
  encode(_: ConvertMissionWithNCPGInfoIntoSiteMissionResultCode, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ConvertMissionWithNCPGInfoIntoSiteMissionResultCode {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseConvertMissionWithNCPGInfoIntoSiteMissionResultCode();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): ConvertMissionWithNCPGInfoIntoSiteMissionResultCode {
    return {};
  },

  toJSON(_: ConvertMissionWithNCPGInfoIntoSiteMissionResultCode): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<ConvertMissionWithNCPGInfoIntoSiteMissionResultCode>, I>>(
    base?: I,
  ): ConvertMissionWithNCPGInfoIntoSiteMissionResultCode {
    return ConvertMissionWithNCPGInfoIntoSiteMissionResultCode.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ConvertMissionWithNCPGInfoIntoSiteMissionResultCode>, I>>(
    _: I,
  ): ConvertMissionWithNCPGInfoIntoSiteMissionResultCode {
    const message = createBaseConvertMissionWithNCPGInfoIntoSiteMissionResultCode();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(long: Long): number {
  if (long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  return long.toNumber();
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isObject(value: any): boolean {
  return typeof value === "object" && value !== null;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
